// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../webfonts/fa-v4compatibility.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../webfonts/fa-v4compatibility.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
    font-family: var(--fa-style-family, "Font Awesome 6 Free");
    font-weight: var(--fa-style, 900)
}

.fa,
.fa-brands,
.fa-regular,
.fa-solid,
.fab,
.far,
.fas {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: var(--fa-display, inline-block);
    font-style: normal;
    font-variant: normal;
    line-height: 1;
    text-rendering: auto
}

.fa-brands:before,
.fa-regular:before,
.fa-solid:before,
.fa:before,
.fab:before,
.far:before,
.fas:before {
    content: var(--fa)
}

.fa-classic,
.fa-regular,
.fa-solid,
.far,
.fas {
    font-family: "Font Awesome 6 Free"
}

.fa-brands,
.fab {
    font-family: "Font Awesome 6 Brands"
}

.fa-1x {
    font-size: 1em
}

.fa-2x {
    font-size: 2em
}

.fa-3x {
    font-size: 3em
}

.fa-4x {
    font-size: 4em
}

.fa-5x {
    font-size: 5em
}

.fa-6x {
    font-size: 6em
}

.fa-7x {
    font-size: 7em
}

.fa-8x {
    font-size: 8em
}

.fa-9x {
    font-size: 9em
}

.fa-10x {
    font-size: 10em
}

.fa-2xs {
    font-size: .625em;
    line-height: .1em;
    vertical-align: .225em
}

.fa-xs {
    font-size: .75em;
    line-height: .08333em;
    vertical-align: .125em
}

.fa-sm {
    font-size: .875em;
    line-height: .07143em;
    vertical-align: .05357em
}

.fa-lg {
    font-size: 1.25em;
    line-height: .05em;
    vertical-align: -.075em
}

.fa-xl {
    font-size: 1.5em;
    line-height: .04167em;
    vertical-align: -.125em
}

.fa-2xl {
    font-size: 2em;
    line-height: .03125em;
    vertical-align: -.1875em
}

.fa-fw {
    text-align: center;
    width: 1.25em
}

.fa-ul {
    list-style-type: none;
    margin-left: var(--fa-li-margin, 2.5em);
    padding-left: 0
}

.fa-ul>li {
    position: relative
}

.fa-li {
    left: calc(var(--fa-li-width, 2em)*-1);
    position: absolute;
    text-align: center;
    width: var(--fa-li-width, 2em);
    line-height: inherit
}

.fa-border {
    border-radius: var(--fa-border-radius, .1em);
    border: var(--fa-border-width, .08em) var(--fa-border-style, solid) var(--fa-border-color, #eee);
    padding: var(--fa-border-padding, .2em .25em .15em)
}

.fa-pull-left {
    float: left;
    margin-right: var(--fa-pull-margin, .3em)
}

.fa-pull-right {
    float: right;
    margin-left: var(--fa-pull-margin, .3em)
}

.fa-beat {
    animation-name: fa-beat;
    animation-delay: var(--fa-animation-delay, 0s);
    animation-direction: var(--fa-animation-direction, normal);
    animation-duration: var(--fa-animation-duration, 1s);
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, ease-in-out)
}

.fa-bounce {
    animation-name: fa-bounce;
    animation-delay: var(--fa-animation-delay, 0s);
    animation-direction: var(--fa-animation-direction, normal);
    animation-duration: var(--fa-animation-duration, 1s);
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, cubic-bezier(.28, .84, .42, 1))
}

.fa-fade {
    animation-name: fa-fade;
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, cubic-bezier(.4, 0, .6, 1))
}

.fa-beat-fade,
.fa-fade {
    animation-delay: var(--fa-animation-delay, 0s);
    animation-direction: var(--fa-animation-direction, normal);
    animation-duration: var(--fa-animation-duration, 1s)
}

.fa-beat-fade {
    animation-name: fa-beat-fade;
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, cubic-bezier(.4, 0, .6, 1))
}

.fa-flip {
    animation-name: fa-flip;
    animation-delay: var(--fa-animation-delay, 0s);
    animation-direction: var(--fa-animation-direction, normal);
    animation-duration: var(--fa-animation-duration, 1s);
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, ease-in-out)
}

.fa-shake {
    animation-name: fa-shake;
    animation-duration: var(--fa-animation-duration, 1s);
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, linear)
}

.fa-shake,
.fa-spin {
    animation-delay: var(--fa-animation-delay, 0s);
    animation-direction: var(--fa-animation-direction, normal)
}

.fa-spin {
    animation-name: fa-spin;
    animation-duration: var(--fa-animation-duration, 2s);
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, linear)
}

.fa-spin-reverse {
    --fa-animation-direction: reverse
}

.fa-pulse,
.fa-spin-pulse {
    animation-name: fa-spin;
    animation-direction: var(--fa-animation-direction, normal);
    animation-duration: var(--fa-animation-duration, 1s);
    animation-iteration-count: var(--fa-animation-iteration-count, infinite);
    animation-timing-function: var(--fa-animation-timing, steps(8))
}

@media (prefers-reduced-motion:reduce) {

    .fa-beat,
    .fa-beat-fade,
    .fa-bounce,
    .fa-fade,
    .fa-flip,
    .fa-pulse,
    .fa-shake,
    .fa-spin,
    .fa-spin-pulse {
        animation-delay: -1ms;
        animation-duration: 1ms;
        animation-iteration-count: 1;
        transition-delay: 0s;
        transition-duration: 0s
    }
}

@keyframes fa-beat {

    0%,
    90% {
        transform: scale(1)
    }

    45% {
        transform: scale(var(--fa-beat-scale, 1.25))
    }
}

@keyframes fa-bounce {
    0% {
        transform: scale(1) translateY(0)
    }

    10% {
        transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, .9)) translateY(0)
    }

    30% {
        transform: scale(var(--fa-bounce-jump-scale-x, .9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -.5em))
    }

    50% {
        transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, .95)) translateY(0)
    }

    57% {
        transform: scale(1) translateY(var(--fa-bounce-rebound, -.125em))
    }

    64% {
        transform: scale(1) translateY(0)
    }

    to {
        transform: scale(1) translateY(0)
    }
}

@keyframes fa-fade {
    50% {
        opacity: var(--fa-fade-opacity, .4)
    }
}

@keyframes fa-beat-fade {

    0%,
    to {
        opacity: var(--fa-beat-fade-opacity, .4);
        transform: scale(1)
    }

    50% {
        opacity: 1;
        transform: scale(var(--fa-beat-fade-scale, 1.125))
    }
}

@keyframes fa-flip {
    50% {
        transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg))
    }
}

@keyframes fa-shake {
    0% {
        transform: rotate(-15deg)
    }

    4% {
        transform: rotate(15deg)
    }

    8%,
    24% {
        transform: rotate(-18deg)
    }

    12%,
    28% {
        transform: rotate(18deg)
    }

    16% {
        transform: rotate(-22deg)
    }

    20% {
        transform: rotate(22deg)
    }

    32% {
        transform: rotate(-12deg)
    }

    36% {
        transform: rotate(12deg)
    }

    40%,
    to {
        transform: rotate(0deg)
    }
}

@keyframes fa-spin {
    0% {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(1turn)
    }
}

.fa-rotate-90 {
    transform: rotate(90deg)
}

.fa-rotate-180 {
    transform: rotate(180deg)
}

.fa-rotate-270 {
    transform: rotate(270deg)
}

.fa-flip-horizontal {
    transform: scaleX(-1)
}

.fa-flip-vertical {
    transform: scaleY(-1)
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
    transform: scale(-1)
}

.fa-rotate-by {
    transform: rotate(var(--fa-rotate-angle, 0))
}

.fa-stack {
    display: inline-block;
    height: 2em;
    line-height: 2em;
    position: relative;
    vertical-align: middle;
    width: 2.5em
}

.fa-stack-1x,
.fa-stack-2x {
    left: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: var(--fa-stack-z-index, auto)
}

.fa-stack-1x {
    line-height: inherit
}

.fa-stack-2x {
    font-size: 2em
}

.fa-inverse {
    color: var(--fa-inverse, #fff)
}

.fa-0 {
    --fa: "\\30";
    --fa--fa: "\\30\\30"
}

.fa-1 {
    --fa: "\\31";
    --fa--fa: "\\31\\31"
}

.fa-2 {
    --fa: "\\32";
    --fa--fa: "\\32\\32"
}

.fa-3 {
    --fa: "\\33";
    --fa--fa: "\\33\\33"
}

.fa-4 {
    --fa: "\\34";
    --fa--fa: "\\34\\34"
}

.fa-5 {
    --fa: "\\35";
    --fa--fa: "\\35\\35"
}

.fa-6 {
    --fa: "\\36";
    --fa--fa: "\\36\\36"
}

.fa-7 {
    --fa: "\\37";
    --fa--fa: "\\37\\37"
}

.fa-8 {
    --fa: "\\38";
    --fa--fa: "\\38\\38"
}

.fa-9 {
    --fa: "\\39";
    --fa--fa: "\\39\\39"
}

.fa-fill-drip {
    --fa: "\\f576";
    --fa--fa: "\\f576\\f576"
}

.fa-arrows-to-circle {
    --fa: "\\e4bd";
    --fa--fa: "\\e4bd\\e4bd"
}

.fa-chevron-circle-right,
.fa-circle-chevron-right {
    --fa: "\\f138";
    --fa--fa: "\\f138\\f138"
}

.fa-at {
    --fa: "\\40";
    --fa--fa: "\\40\\40"
}

.fa-trash-alt,
.fa-trash-can {
    --fa: "\\f2ed";
    --fa--fa: "\\f2ed\\f2ed"
}

.fa-text-height {
    --fa: "\\f034";
    --fa--fa: "\\f034\\f034"
}

.fa-user-times,
.fa-user-xmark {
    --fa: "\\f235";
    --fa--fa: "\\f235\\f235"
}

.fa-stethoscope {
    --fa: "\\f0f1";
    --fa--fa: "\\f0f1\\f0f1"
}

.fa-comment-alt,
.fa-message {
    --fa: "\\f27a";
    --fa--fa: "\\f27a\\f27a"
}

.fa-info {
    --fa: "\\f129";
    --fa--fa: "\\f129\\f129"
}

.fa-compress-alt,
.fa-down-left-and-up-right-to-center {
    --fa: "\\f422";
    --fa--fa: "\\f422\\f422"
}

.fa-explosion {
    --fa: "\\e4e9";
    --fa--fa: "\\e4e9\\e4e9"
}

.fa-file-alt,
.fa-file-lines,
.fa-file-text {
    --fa: "\\f15c";
    --fa--fa: "\\f15c\\f15c"
}

.fa-wave-square {
    --fa: "\\f83e";
    --fa--fa: "\\f83e\\f83e"
}

.fa-ring {
    --fa: "\\f70b";
    --fa--fa: "\\f70b\\f70b"
}

.fa-building-un {
    --fa: "\\e4d9";
    --fa--fa: "\\e4d9\\e4d9"
}

.fa-dice-three {
    --fa: "\\f527";
    --fa--fa: "\\f527\\f527"
}

.fa-calendar-alt,
.fa-calendar-days {
    --fa: "\\f073";
    --fa--fa: "\\f073\\f073"
}

.fa-anchor-circle-check {
    --fa: "\\e4aa";
    --fa--fa: "\\e4aa\\e4aa"
}

.fa-building-circle-arrow-right {
    --fa: "\\e4d1";
    --fa--fa: "\\e4d1\\e4d1"
}

.fa-volleyball,
.fa-volleyball-ball {
    --fa: "\\f45f";
    --fa--fa: "\\f45f\\f45f"
}

.fa-arrows-up-to-line {
    --fa: "\\e4c2";
    --fa--fa: "\\e4c2\\e4c2"
}

.fa-sort-desc,
.fa-sort-down {
    --fa: "\\f0dd";
    --fa--fa: "\\f0dd\\f0dd"
}

.fa-circle-minus,
.fa-minus-circle {
    --fa: "\\f056";
    --fa--fa: "\\f056\\f056"
}

.fa-door-open {
    --fa: "\\f52b";
    --fa--fa: "\\f52b\\f52b"
}

.fa-right-from-bracket,
.fa-sign-out-alt {
    --fa: "\\f2f5";
    --fa--fa: "\\f2f5\\f2f5"
}

.fa-atom {
    --fa: "\\f5d2";
    --fa--fa: "\\f5d2\\f5d2"
}

.fa-soap {
    --fa: "\\e06e";
    --fa--fa: "\\e06e\\e06e"
}

.fa-heart-music-camera-bolt,
.fa-icons {
    --fa: "\\f86d";
    --fa--fa: "\\f86d\\f86d"
}

.fa-microphone-alt-slash,
.fa-microphone-lines-slash {
    --fa: "\\f539";
    --fa--fa: "\\f539\\f539"
}

.fa-bridge-circle-check {
    --fa: "\\e4c9";
    --fa--fa: "\\e4c9\\e4c9"
}

.fa-pump-medical {
    --fa: "\\e06a";
    --fa--fa: "\\e06a\\e06a"
}

.fa-fingerprint {
    --fa: "\\f577";
    --fa--fa: "\\f577\\f577"
}

.fa-hand-point-right {
    --fa: "\\f0a4";
    --fa--fa: "\\f0a4\\f0a4"
}

.fa-magnifying-glass-location,
.fa-search-location {
    --fa: "\\f689";
    --fa--fa: "\\f689\\f689"
}

.fa-forward-step,
.fa-step-forward {
    --fa: "\\f051";
    --fa--fa: "\\f051\\f051"
}

.fa-face-smile-beam,
.fa-smile-beam {
    --fa: "\\f5b8";
    --fa--fa: "\\f5b8\\f5b8"
}

.fa-flag-checkered {
    --fa: "\\f11e";
    --fa--fa: "\\f11e\\f11e"
}

.fa-football,
.fa-football-ball {
    --fa: "\\f44e";
    --fa--fa: "\\f44e\\f44e"
}

.fa-school-circle-exclamation {
    --fa: "\\e56c";
    --fa--fa: "\\e56c\\e56c"
}

.fa-crop {
    --fa: "\\f125";
    --fa--fa: "\\f125\\f125"
}

.fa-angle-double-down,
.fa-angles-down {
    --fa: "\\f103";
    --fa--fa: "\\f103\\f103"
}

.fa-users-rectangle {
    --fa: "\\e594";
    --fa--fa: "\\e594\\e594"
}

.fa-people-roof {
    --fa: "\\e537";
    --fa--fa: "\\e537\\e537"
}

.fa-people-line {
    --fa: "\\e534";
    --fa--fa: "\\e534\\e534"
}

.fa-beer,
.fa-beer-mug-empty {
    --fa: "\\f0fc";
    --fa--fa: "\\f0fc\\f0fc"
}

.fa-diagram-predecessor {
    --fa: "\\e477";
    --fa--fa: "\\e477\\e477"
}

.fa-arrow-up-long,
.fa-long-arrow-up {
    --fa: "\\f176";
    --fa--fa: "\\f176\\f176"
}

.fa-burn,
.fa-fire-flame-simple {
    --fa: "\\f46a";
    --fa--fa: "\\f46a\\f46a"
}

.fa-male,
.fa-person {
    --fa: "\\f183";
    --fa--fa: "\\f183\\f183"
}

.fa-laptop {
    --fa: "\\f109";
    --fa--fa: "\\f109\\f109"
}

.fa-file-csv {
    --fa: "\\f6dd";
    --fa--fa: "\\f6dd\\f6dd"
}

.fa-menorah {
    --fa: "\\f676";
    --fa--fa: "\\f676\\f676"
}

.fa-truck-plane {
    --fa: "\\e58f";
    --fa--fa: "\\e58f\\e58f"
}

.fa-record-vinyl {
    --fa: "\\f8d9";
    --fa--fa: "\\f8d9\\f8d9"
}

.fa-face-grin-stars,
.fa-grin-stars {
    --fa: "\\f587";
    --fa--fa: "\\f587\\f587"
}

.fa-bong {
    --fa: "\\f55c";
    --fa--fa: "\\f55c\\f55c"
}

.fa-pastafarianism,
.fa-spaghetti-monster-flying {
    --fa: "\\f67b";
    --fa--fa: "\\f67b\\f67b"
}

.fa-arrow-down-up-across-line {
    --fa: "\\e4af";
    --fa--fa: "\\e4af\\e4af"
}

.fa-spoon,
.fa-utensil-spoon {
    --fa: "\\f2e5";
    --fa--fa: "\\f2e5\\f2e5"
}

.fa-jar-wheat {
    --fa: "\\e517";
    --fa--fa: "\\e517\\e517"
}

.fa-envelopes-bulk,
.fa-mail-bulk {
    --fa: "\\f674";
    --fa--fa: "\\f674\\f674"
}

.fa-file-circle-exclamation {
    --fa: "\\e4eb";
    --fa--fa: "\\e4eb\\e4eb"
}

.fa-circle-h,
.fa-hospital-symbol {
    --fa: "\\f47e";
    --fa--fa: "\\f47e\\f47e"
}

.fa-pager {
    --fa: "\\f815";
    --fa--fa: "\\f815\\f815"
}

.fa-address-book,
.fa-contact-book {
    --fa: "\\f2b9";
    --fa--fa: "\\f2b9\\f2b9"
}

.fa-strikethrough {
    --fa: "\\f0cc";
    --fa--fa: "\\f0cc\\f0cc"
}

.fa-k {
    --fa: "\\4b";
    --fa--fa: "\\4b\\4b"
}

.fa-landmark-flag {
    --fa: "\\e51c";
    --fa--fa: "\\e51c\\e51c"
}

.fa-pencil,
.fa-pencil-alt {
    --fa: "\\f303";
    --fa--fa: "\\f303\\f303"
}

.fa-backward {
    --fa: "\\f04a";
    --fa--fa: "\\f04a\\f04a"
}

.fa-caret-right {
    --fa: "\\f0da";
    --fa--fa: "\\f0da\\f0da"
}

.fa-comments {
    --fa: "\\f086";
    --fa--fa: "\\f086\\f086"
}

.fa-file-clipboard,
.fa-paste {
    --fa: "\\f0ea";
    --fa--fa: "\\f0ea\\f0ea"
}

.fa-code-pull-request {
    --fa: "\\e13c";
    --fa--fa: "\\e13c\\e13c"
}

.fa-clipboard-list {
    --fa: "\\f46d";
    --fa--fa: "\\f46d\\f46d"
}

.fa-truck-loading,
.fa-truck-ramp-box {
    --fa: "\\f4de";
    --fa--fa: "\\f4de\\f4de"
}

.fa-user-check {
    --fa: "\\f4fc";
    --fa--fa: "\\f4fc\\f4fc"
}

.fa-vial-virus {
    --fa: "\\e597";
    --fa--fa: "\\e597\\e597"
}

.fa-sheet-plastic {
    --fa: "\\e571";
    --fa--fa: "\\e571\\e571"
}

.fa-blog {
    --fa: "\\f781";
    --fa--fa: "\\f781\\f781"
}

.fa-user-ninja {
    --fa: "\\f504";
    --fa--fa: "\\f504\\f504"
}

.fa-person-arrow-up-from-line {
    --fa: "\\e539";
    --fa--fa: "\\e539\\e539"
}

.fa-scroll-torah,
.fa-torah {
    --fa: "\\f6a0";
    --fa--fa: "\\f6a0\\f6a0"
}

.fa-broom-ball,
.fa-quidditch,
.fa-quidditch-broom-ball {
    --fa: "\\f458";
    --fa--fa: "\\f458\\f458"
}

.fa-toggle-off {
    --fa: "\\f204";
    --fa--fa: "\\f204\\f204"
}

.fa-archive,
.fa-box-archive {
    --fa: "\\f187";
    --fa--fa: "\\f187\\f187"
}

.fa-person-drowning {
    --fa: "\\e545";
    --fa--fa: "\\e545\\e545"
}

.fa-arrow-down-9-1,
.fa-sort-numeric-desc,
.fa-sort-numeric-down-alt {
    --fa: "\\f886";
    --fa--fa: "\\f886\\f886"
}

.fa-face-grin-tongue-squint,
.fa-grin-tongue-squint {
    --fa: "\\f58a";
    --fa--fa: "\\f58a\\f58a"
}

.fa-spray-can {
    --fa: "\\f5bd";
    --fa--fa: "\\f5bd\\f5bd"
}

.fa-truck-monster {
    --fa: "\\f63b";
    --fa--fa: "\\f63b\\f63b"
}

.fa-w {
    --fa: "\\57";
    --fa--fa: "\\57\\57"
}

.fa-earth-africa,
.fa-globe-africa {
    --fa: "\\f57c";
    --fa--fa: "\\f57c\\f57c"
}

.fa-rainbow {
    --fa: "\\f75b";
    --fa--fa: "\\f75b\\f75b"
}

.fa-circle-notch {
    --fa: "\\f1ce";
    --fa--fa: "\\f1ce\\f1ce"
}

.fa-tablet-alt,
.fa-tablet-screen-button {
    --fa: "\\f3fa";
    --fa--fa: "\\f3fa\\f3fa"
}

.fa-paw {
    --fa: "\\f1b0";
    --fa--fa: "\\f1b0\\f1b0"
}

.fa-cloud {
    --fa: "\\f0c2";
    --fa--fa: "\\f0c2\\f0c2"
}

.fa-trowel-bricks {
    --fa: "\\e58a";
    --fa--fa: "\\e58a\\e58a"
}

.fa-face-flushed,
.fa-flushed {
    --fa: "\\f579";
    --fa--fa: "\\f579\\f579"
}

.fa-hospital-user {
    --fa: "\\f80d";
    --fa--fa: "\\f80d\\f80d"
}

.fa-tent-arrow-left-right {
    --fa: "\\e57f";
    --fa--fa: "\\e57f\\e57f"
}

.fa-gavel,
.fa-legal {
    --fa: "\\f0e3";
    --fa--fa: "\\f0e3\\f0e3"
}

.fa-binoculars {
    --fa: "\\f1e5";
    --fa--fa: "\\f1e5\\f1e5"
}

.fa-microphone-slash {
    --fa: "\\f131";
    --fa--fa: "\\f131\\f131"
}

.fa-box-tissue {
    --fa: "\\e05b";
    --fa--fa: "\\e05b\\e05b"
}

.fa-motorcycle {
    --fa: "\\f21c";
    --fa--fa: "\\f21c\\f21c"
}

.fa-bell-concierge,
.fa-concierge-bell {
    --fa: "\\f562";
    --fa--fa: "\\f562\\f562"
}

.fa-pen-ruler,
.fa-pencil-ruler {
    --fa: "\\f5ae";
    --fa--fa: "\\f5ae\\f5ae"
}

.fa-people-arrows,
.fa-people-arrows-left-right {
    --fa: "\\e068";
    --fa--fa: "\\e068\\e068"
}

.fa-mars-and-venus-burst {
    --fa: "\\e523";
    --fa--fa: "\\e523\\e523"
}

.fa-caret-square-right,
.fa-square-caret-right {
    --fa: "\\f152";
    --fa--fa: "\\f152\\f152"
}

.fa-cut,
.fa-scissors {
    --fa: "\\f0c4";
    --fa--fa: "\\f0c4\\f0c4"
}

.fa-sun-plant-wilt {
    --fa: "\\e57a";
    --fa--fa: "\\e57a\\e57a"
}

.fa-toilets-portable {
    --fa: "\\e584";
    --fa--fa: "\\e584\\e584"
}

.fa-hockey-puck {
    --fa: "\\f453";
    --fa--fa: "\\f453\\f453"
}

.fa-table {
    --fa: "\\f0ce";
    --fa--fa: "\\f0ce\\f0ce"
}

.fa-magnifying-glass-arrow-right {
    --fa: "\\e521";
    --fa--fa: "\\e521\\e521"
}

.fa-digital-tachograph,
.fa-tachograph-digital {
    --fa: "\\f566";
    --fa--fa: "\\f566\\f566"
}

.fa-users-slash {
    --fa: "\\e073";
    --fa--fa: "\\e073\\e073"
}

.fa-clover {
    --fa: "\\e139";
    --fa--fa: "\\e139\\e139"
}

.fa-mail-reply,
.fa-reply {
    --fa: "\\f3e5";
    --fa--fa: "\\f3e5\\f3e5"
}

.fa-star-and-crescent {
    --fa: "\\f699";
    --fa--fa: "\\f699\\f699"
}

.fa-house-fire {
    --fa: "\\e50c";
    --fa--fa: "\\e50c\\e50c"
}

.fa-minus-square,
.fa-square-minus {
    --fa: "\\f146";
    --fa--fa: "\\f146\\f146"
}

.fa-helicopter {
    --fa: "\\f533";
    --fa--fa: "\\f533\\f533"
}

.fa-compass {
    --fa: "\\f14e";
    --fa--fa: "\\f14e\\f14e"
}

.fa-caret-square-down,
.fa-square-caret-down {
    --fa: "\\f150";
    --fa--fa: "\\f150\\f150"
}

.fa-file-circle-question {
    --fa: "\\e4ef";
    --fa--fa: "\\e4ef\\e4ef"
}

.fa-laptop-code {
    --fa: "\\f5fc";
    --fa--fa: "\\f5fc\\f5fc"
}

.fa-swatchbook {
    --fa: "\\f5c3";
    --fa--fa: "\\f5c3\\f5c3"
}

.fa-prescription-bottle {
    --fa: "\\f485";
    --fa--fa: "\\f485\\f485"
}

.fa-bars,
.fa-navicon {
    --fa: "\\f0c9";
    --fa--fa: "\\f0c9\\f0c9"
}

.fa-people-group {
    --fa: "\\e533";
    --fa--fa: "\\e533\\e533"
}

.fa-hourglass-3,
.fa-hourglass-end {
    --fa: "\\f253";
    --fa--fa: "\\f253\\f253"
}

.fa-heart-broken,
.fa-heart-crack {
    --fa: "\\f7a9";
    --fa--fa: "\\f7a9\\f7a9"
}

.fa-external-link-square-alt,
.fa-square-up-right {
    --fa: "\\f360";
    --fa--fa: "\\f360\\f360"
}

.fa-face-kiss-beam,
.fa-kiss-beam {
    --fa: "\\f597";
    --fa--fa: "\\f597\\f597"
}

.fa-film {
    --fa: "\\f008";
    --fa--fa: "\\f008\\f008"
}

.fa-ruler-horizontal {
    --fa: "\\f547";
    --fa--fa: "\\f547\\f547"
}

.fa-people-robbery {
    --fa: "\\e536";
    --fa--fa: "\\e536\\e536"
}

.fa-lightbulb {
    --fa: "\\f0eb";
    --fa--fa: "\\f0eb\\f0eb"
}

.fa-caret-left {
    --fa: "\\f0d9";
    --fa--fa: "\\f0d9\\f0d9"
}

.fa-circle-exclamation,
.fa-exclamation-circle {
    --fa: "\\f06a";
    --fa--fa: "\\f06a\\f06a"
}

.fa-school-circle-xmark {
    --fa: "\\e56d";
    --fa--fa: "\\e56d\\e56d"
}

.fa-arrow-right-from-bracket,
.fa-sign-out {
    --fa: "\\f08b";
    --fa--fa: "\\f08b\\f08b"
}

.fa-chevron-circle-down,
.fa-circle-chevron-down {
    --fa: "\\f13a";
    --fa--fa: "\\f13a\\f13a"
}

.fa-unlock-alt,
.fa-unlock-keyhole {
    --fa: "\\f13e";
    --fa--fa: "\\f13e\\f13e"
}

.fa-cloud-showers-heavy {
    --fa: "\\f740";
    --fa--fa: "\\f740\\f740"
}

.fa-headphones-alt,
.fa-headphones-simple {
    --fa: "\\f58f";
    --fa--fa: "\\f58f\\f58f"
}

.fa-sitemap {
    --fa: "\\f0e8";
    --fa--fa: "\\f0e8\\f0e8"
}

.fa-circle-dollar-to-slot,
.fa-donate {
    --fa: "\\f4b9";
    --fa--fa: "\\f4b9\\f4b9"
}

.fa-memory {
    --fa: "\\f538";
    --fa--fa: "\\f538\\f538"
}

.fa-road-spikes {
    --fa: "\\e568";
    --fa--fa: "\\e568\\e568"
}

.fa-fire-burner {
    --fa: "\\e4f1";
    --fa--fa: "\\e4f1\\e4f1"
}

.fa-flag {
    --fa: "\\f024";
    --fa--fa: "\\f024\\f024"
}

.fa-hanukiah {
    --fa: "\\f6e6";
    --fa--fa: "\\f6e6\\f6e6"
}

.fa-feather {
    --fa: "\\f52d";
    --fa--fa: "\\f52d\\f52d"
}

.fa-volume-down,
.fa-volume-low {
    --fa: "\\f027";
    --fa--fa: "\\f027\\f027"
}

.fa-comment-slash {
    --fa: "\\f4b3";
    --fa--fa: "\\f4b3\\f4b3"
}

.fa-cloud-sun-rain {
    --fa: "\\f743";
    --fa--fa: "\\f743\\f743"
}

.fa-compress {
    --fa: "\\f066";
    --fa--fa: "\\f066\\f066"
}

.fa-wheat-alt,
.fa-wheat-awn {
    --fa: "\\e2cd";
    --fa--fa: "\\e2cd\\e2cd"
}

.fa-ankh {
    --fa: "\\f644";
    --fa--fa: "\\f644\\f644"
}

.fa-hands-holding-child {
    --fa: "\\e4fa";
    --fa--fa: "\\e4fa\\e4fa"
}

.fa-asterisk {
    --fa: "\\2a";
    --fa--fa: "\\2a\\2a"
}

.fa-check-square,
.fa-square-check {
    --fa: "\\f14a";
    --fa--fa: "\\f14a\\f14a"
}

.fa-peseta-sign {
    --fa: "\\e221";
    --fa--fa: "\\e221\\e221"
}

.fa-header,
.fa-heading {
    --fa: "\\f1dc";
    --fa--fa: "\\f1dc\\f1dc"
}

.fa-ghost {
    --fa: "\\f6e2";
    --fa--fa: "\\f6e2\\f6e2"
}

.fa-list,
.fa-list-squares {
    --fa: "\\f03a";
    --fa--fa: "\\f03a\\f03a"
}

.fa-phone-square-alt,
.fa-square-phone-flip {
    --fa: "\\f87b";
    --fa--fa: "\\f87b\\f87b"
}

.fa-cart-plus {
    --fa: "\\f217";
    --fa--fa: "\\f217\\f217"
}

.fa-gamepad {
    --fa: "\\f11b";
    --fa--fa: "\\f11b\\f11b"
}

.fa-circle-dot,
.fa-dot-circle {
    --fa: "\\f192";
    --fa--fa: "\\f192\\f192"
}

.fa-dizzy,
.fa-face-dizzy {
    --fa: "\\f567";
    --fa--fa: "\\f567\\f567"
}

.fa-egg {
    --fa: "\\f7fb";
    --fa--fa: "\\f7fb\\f7fb"
}

.fa-house-medical-circle-xmark {
    --fa: "\\e513";
    --fa--fa: "\\e513\\e513"
}

.fa-campground {
    --fa: "\\f6bb";
    --fa--fa: "\\f6bb\\f6bb"
}

.fa-folder-plus {
    --fa: "\\f65e";
    --fa--fa: "\\f65e\\f65e"
}

.fa-futbol,
.fa-futbol-ball,
.fa-soccer-ball {
    --fa: "\\f1e3";
    --fa--fa: "\\f1e3\\f1e3"
}

.fa-paint-brush,
.fa-paintbrush {
    --fa: "\\f1fc";
    --fa--fa: "\\f1fc\\f1fc"
}

.fa-lock {
    --fa: "\\f023";
    --fa--fa: "\\f023\\f023"
}

.fa-gas-pump {
    --fa: "\\f52f";
    --fa--fa: "\\f52f\\f52f"
}

.fa-hot-tub,
.fa-hot-tub-person {
    --fa: "\\f593";
    --fa--fa: "\\f593\\f593"
}

.fa-map-location,
.fa-map-marked {
    --fa: "\\f59f";
    --fa--fa: "\\f59f\\f59f"
}

.fa-house-flood-water {
    --fa: "\\e50e";
    --fa--fa: "\\e50e\\e50e"
}

.fa-tree {
    --fa: "\\f1bb";
    --fa--fa: "\\f1bb\\f1bb"
}

.fa-bridge-lock {
    --fa: "\\e4cc";
    --fa--fa: "\\e4cc\\e4cc"
}

.fa-sack-dollar {
    --fa: "\\f81d";
    --fa--fa: "\\f81d\\f81d"
}

.fa-edit,
.fa-pen-to-square {
    --fa: "\\f044";
    --fa--fa: "\\f044\\f044"
}

.fa-car-side {
    --fa: "\\f5e4";
    --fa--fa: "\\f5e4\\f5e4"
}

.fa-share-alt,
.fa-share-nodes {
    --fa: "\\f1e0";
    --fa--fa: "\\f1e0\\f1e0"
}

.fa-heart-circle-minus {
    --fa: "\\e4ff";
    --fa--fa: "\\e4ff\\e4ff"
}

.fa-hourglass-2,
.fa-hourglass-half {
    --fa: "\\f252";
    --fa--fa: "\\f252\\f252"
}

.fa-microscope {
    --fa: "\\f610";
    --fa--fa: "\\f610\\f610"
}

.fa-sink {
    --fa: "\\e06d";
    --fa--fa: "\\e06d\\e06d"
}

.fa-bag-shopping,
.fa-shopping-bag {
    --fa: "\\f290";
    --fa--fa: "\\f290\\f290"
}

.fa-arrow-down-z-a,
.fa-sort-alpha-desc,
.fa-sort-alpha-down-alt {
    --fa: "\\f881";
    --fa--fa: "\\f881\\f881"
}

.fa-mitten {
    --fa: "\\f7b5";
    --fa--fa: "\\f7b5\\f7b5"
}

.fa-person-rays {
    --fa: "\\e54d";
    --fa--fa: "\\e54d\\e54d"
}

.fa-users {
    --fa: "\\f0c0";
    --fa--fa: "\\f0c0\\f0c0"
}

.fa-eye-slash {
    --fa: "\\f070";
    --fa--fa: "\\f070\\f070"
}

.fa-flask-vial {
    --fa: "\\e4f3";
    --fa--fa: "\\e4f3\\e4f3"
}

.fa-hand,
.fa-hand-paper {
    --fa: "\\f256";
    --fa--fa: "\\f256\\f256"
}

.fa-om {
    --fa: "\\f679";
    --fa--fa: "\\f679\\f679"
}

.fa-worm {
    --fa: "\\e599";
    --fa--fa: "\\e599\\e599"
}

.fa-house-circle-xmark {
    --fa: "\\e50b";
    --fa--fa: "\\e50b\\e50b"
}

.fa-plug {
    --fa: "\\f1e6";
    --fa--fa: "\\f1e6\\f1e6"
}

.fa-chevron-up {
    --fa: "\\f077";
    --fa--fa: "\\f077\\f077"
}

.fa-hand-spock {
    --fa: "\\f259";
    --fa--fa: "\\f259\\f259"
}

.fa-stopwatch {
    --fa: "\\f2f2";
    --fa--fa: "\\f2f2\\f2f2"
}

.fa-face-kiss,
.fa-kiss {
    --fa: "\\f596";
    --fa--fa: "\\f596\\f596"
}

.fa-bridge-circle-xmark {
    --fa: "\\e4cb";
    --fa--fa: "\\e4cb\\e4cb"
}

.fa-face-grin-tongue,
.fa-grin-tongue {
    --fa: "\\f589";
    --fa--fa: "\\f589\\f589"
}

.fa-chess-bishop {
    --fa: "\\f43a";
    --fa--fa: "\\f43a\\f43a"
}

.fa-face-grin-wink,
.fa-grin-wink {
    --fa: "\\f58c";
    --fa--fa: "\\f58c\\f58c"
}

.fa-deaf,
.fa-deafness,
.fa-ear-deaf,
.fa-hard-of-hearing {
    --fa: "\\f2a4";
    --fa--fa: "\\f2a4\\f2a4"
}

.fa-road-circle-check {
    --fa: "\\e564";
    --fa--fa: "\\e564\\e564"
}

.fa-dice-five {
    --fa: "\\f523";
    --fa--fa: "\\f523\\f523"
}

.fa-rss-square,
.fa-square-rss {
    --fa: "\\f143";
    --fa--fa: "\\f143\\f143"
}

.fa-land-mine-on {
    --fa: "\\e51b";
    --fa--fa: "\\e51b\\e51b"
}

.fa-i-cursor {
    --fa: "\\f246";
    --fa--fa: "\\f246\\f246"
}

.fa-stamp {
    --fa: "\\f5bf";
    --fa--fa: "\\f5bf\\f5bf"
}

.fa-stairs {
    --fa: "\\e289";
    --fa--fa: "\\e289\\e289"
}

.fa-i {
    --fa: "\\49";
    --fa--fa: "\\49\\49"
}

.fa-hryvnia,
.fa-hryvnia-sign {
    --fa: "\\f6f2";
    --fa--fa: "\\f6f2\\f6f2"
}

.fa-pills {
    --fa: "\\f484";
    --fa--fa: "\\f484\\f484"
}

.fa-face-grin-wide,
.fa-grin-alt {
    --fa: "\\f581";
    --fa--fa: "\\f581\\f581"
}

.fa-tooth {
    --fa: "\\f5c9";
    --fa--fa: "\\f5c9\\f5c9"
}

.fa-v {
    --fa: "\\56";
    --fa--fa: "\\56\\56"
}

.fa-bangladeshi-taka-sign {
    --fa: "\\e2e6";
    --fa--fa: "\\e2e6\\e2e6"
}

.fa-bicycle {
    --fa: "\\f206";
    --fa--fa: "\\f206\\f206"
}

.fa-rod-asclepius,
.fa-rod-snake,
.fa-staff-aesculapius,
.fa-staff-snake {
    --fa: "\\e579";
    --fa--fa: "\\e579\\e579"
}

.fa-head-side-cough-slash {
    --fa: "\\e062";
    --fa--fa: "\\e062\\e062"
}

.fa-ambulance,
.fa-truck-medical {
    --fa: "\\f0f9";
    --fa--fa: "\\f0f9\\f0f9"
}

.fa-wheat-awn-circle-exclamation {
    --fa: "\\e598";
    --fa--fa: "\\e598\\e598"
}

.fa-snowman {
    --fa: "\\f7d0";
    --fa--fa: "\\f7d0\\f7d0"
}

.fa-mortar-pestle {
    --fa: "\\f5a7";
    --fa--fa: "\\f5a7\\f5a7"
}

.fa-road-barrier {
    --fa: "\\e562";
    --fa--fa: "\\e562\\e562"
}

.fa-school {
    --fa: "\\f549";
    --fa--fa: "\\f549\\f549"
}

.fa-igloo {
    --fa: "\\f7ae";
    --fa--fa: "\\f7ae\\f7ae"
}

.fa-joint {
    --fa: "\\f595";
    --fa--fa: "\\f595\\f595"
}

.fa-angle-right {
    --fa: "\\f105";
    --fa--fa: "\\f105\\f105"
}

.fa-horse {
    --fa: "\\f6f0";
    --fa--fa: "\\f6f0\\f6f0"
}

.fa-q {
    --fa: "\\51";
    --fa--fa: "\\51\\51"
}

.fa-g {
    --fa: "\\47";
    --fa--fa: "\\47\\47"
}

.fa-notes-medical {
    --fa: "\\f481";
    --fa--fa: "\\f481\\f481"
}

.fa-temperature-2,
.fa-temperature-half,
.fa-thermometer-2,
.fa-thermometer-half {
    --fa: "\\f2c9";
    --fa--fa: "\\f2c9\\f2c9"
}

.fa-dong-sign {
    --fa: "\\e169";
    --fa--fa: "\\e169\\e169"
}

.fa-capsules {
    --fa: "\\f46b";
    --fa--fa: "\\f46b\\f46b"
}

.fa-poo-bolt,
.fa-poo-storm {
    --fa: "\\f75a";
    --fa--fa: "\\f75a\\f75a"
}

.fa-face-frown-open,
.fa-frown-open {
    --fa: "\\f57a";
    --fa--fa: "\\f57a\\f57a"
}

.fa-hand-point-up {
    --fa: "\\f0a6";
    --fa--fa: "\\f0a6\\f0a6"
}

.fa-money-bill {
    --fa: "\\f0d6";
    --fa--fa: "\\f0d6\\f0d6"
}

.fa-bookmark {
    --fa: "\\f02e";
    --fa--fa: "\\f02e\\f02e"
}

.fa-align-justify {
    --fa: "\\f039";
    --fa--fa: "\\f039\\f039"
}

.fa-umbrella-beach {
    --fa: "\\f5ca";
    --fa--fa: "\\f5ca\\f5ca"
}

.fa-helmet-un {
    --fa: "\\e503";
    --fa--fa: "\\e503\\e503"
}

.fa-bullseye {
    --fa: "\\f140";
    --fa--fa: "\\f140\\f140"
}

.fa-bacon {
    --fa: "\\f7e5";
    --fa--fa: "\\f7e5\\f7e5"
}

.fa-hand-point-down {
    --fa: "\\f0a7";
    --fa--fa: "\\f0a7\\f0a7"
}

.fa-arrow-up-from-bracket {
    --fa: "\\e09a";
    --fa--fa: "\\e09a\\e09a"
}

.fa-folder,
.fa-folder-blank {
    --fa: "\\f07b";
    --fa--fa: "\\f07b\\f07b"
}

.fa-file-medical-alt,
.fa-file-waveform {
    --fa: "\\f478";
    --fa--fa: "\\f478\\f478"
}

.fa-radiation {
    --fa: "\\f7b9";
    --fa--fa: "\\f7b9\\f7b9"
}

.fa-chart-simple {
    --fa: "\\e473";
    --fa--fa: "\\e473\\e473"
}

.fa-mars-stroke {
    --fa: "\\f229";
    --fa--fa: "\\f229\\f229"
}

.fa-vial {
    --fa: "\\f492";
    --fa--fa: "\\f492\\f492"
}

.fa-dashboard,
.fa-gauge,
.fa-gauge-med,
.fa-tachometer-alt-average {
    --fa: "\\f624";
    --fa--fa: "\\f624\\f624"
}

.fa-magic-wand-sparkles,
.fa-wand-magic-sparkles {
    --fa: "\\e2ca";
    --fa--fa: "\\e2ca\\e2ca"
}

.fa-e {
    --fa: "\\45";
    --fa--fa: "\\45\\45"
}

.fa-pen-alt,
.fa-pen-clip {
    --fa: "\\f305";
    --fa--fa: "\\f305\\f305"
}

.fa-bridge-circle-exclamation {
    --fa: "\\e4ca";
    --fa--fa: "\\e4ca\\e4ca"
}

.fa-user {
    --fa: "\\f007";
    --fa--fa: "\\f007\\f007"
}

.fa-school-circle-check {
    --fa: "\\e56b";
    --fa--fa: "\\e56b\\e56b"
}

.fa-dumpster {
    --fa: "\\f793";
    --fa--fa: "\\f793\\f793"
}

.fa-shuttle-van,
.fa-van-shuttle {
    --fa: "\\f5b6";
    --fa--fa: "\\f5b6\\f5b6"
}

.fa-building-user {
    --fa: "\\e4da";
    --fa--fa: "\\e4da\\e4da"
}

.fa-caret-square-left,
.fa-square-caret-left {
    --fa: "\\f191";
    --fa--fa: "\\f191\\f191"
}

.fa-highlighter {
    --fa: "\\f591";
    --fa--fa: "\\f591\\f591"
}

.fa-key {
    --fa: "\\f084";
    --fa--fa: "\\f084\\f084"
}

.fa-bullhorn {
    --fa: "\\f0a1";
    --fa--fa: "\\f0a1\\f0a1"
}

.fa-globe {
    --fa: "\\f0ac";
    --fa--fa: "\\f0ac\\f0ac"
}

.fa-synagogue {
    --fa: "\\f69b";
    --fa--fa: "\\f69b\\f69b"
}

.fa-person-half-dress {
    --fa: "\\e548";
    --fa--fa: "\\e548\\e548"
}

.fa-road-bridge {
    --fa: "\\e563";
    --fa--fa: "\\e563\\e563"
}

.fa-location-arrow {
    --fa: "\\f124";
    --fa--fa: "\\f124\\f124"
}

.fa-c {
    --fa: "\\43";
    --fa--fa: "\\43\\43"
}

.fa-tablet-button {
    --fa: "\\f10a";
    --fa--fa: "\\f10a\\f10a"
}

.fa-building-lock {
    --fa: "\\e4d6";
    --fa--fa: "\\e4d6\\e4d6"
}

.fa-pizza-slice {
    --fa: "\\f818";
    --fa--fa: "\\f818\\f818"
}

.fa-money-bill-wave {
    --fa: "\\f53a";
    --fa--fa: "\\f53a\\f53a"
}

.fa-area-chart,
.fa-chart-area {
    --fa: "\\f1fe";
    --fa--fa: "\\f1fe\\f1fe"
}

.fa-house-flag {
    --fa: "\\e50d";
    --fa--fa: "\\e50d\\e50d"
}

.fa-person-circle-minus {
    --fa: "\\e540";
    --fa--fa: "\\e540\\e540"
}

.fa-ban,
.fa-cancel {
    --fa: "\\f05e";
    --fa--fa: "\\f05e\\f05e"
}

.fa-camera-rotate {
    --fa: "\\e0d8";
    --fa--fa: "\\e0d8\\e0d8"
}

.fa-air-freshener,
.fa-spray-can-sparkles {
    --fa: "\\f5d0";
    --fa--fa: "\\f5d0\\f5d0"
}

.fa-star {
    --fa: "\\f005";
    --fa--fa: "\\f005\\f005"
}

.fa-repeat {
    --fa: "\\f363";
    --fa--fa: "\\f363\\f363"
}

.fa-cross {
    --fa: "\\f654";
    --fa--fa: "\\f654\\f654"
}

.fa-box {
    --fa: "\\f466";
    --fa--fa: "\\f466\\f466"
}

.fa-venus-mars {
    --fa: "\\f228";
    --fa--fa: "\\f228\\f228"
}

.fa-arrow-pointer,
.fa-mouse-pointer {
    --fa: "\\f245";
    --fa--fa: "\\f245\\f245"
}

.fa-expand-arrows-alt,
.fa-maximize {
    --fa: "\\f31e";
    --fa--fa: "\\f31e\\f31e"
}

.fa-charging-station {
    --fa: "\\f5e7";
    --fa--fa: "\\f5e7\\f5e7"
}

.fa-shapes,
.fa-triangle-circle-square {
    --fa: "\\f61f";
    --fa--fa: "\\f61f\\f61f"
}

.fa-random,
.fa-shuffle {
    --fa: "\\f074";
    --fa--fa: "\\f074\\f074"
}

.fa-person-running,
.fa-running {
    --fa: "\\f70c";
    --fa--fa: "\\f70c\\f70c"
}

.fa-mobile-retro {
    --fa: "\\e527";
    --fa--fa: "\\e527\\e527"
}

.fa-grip-lines-vertical {
    --fa: "\\f7a5";
    --fa--fa: "\\f7a5\\f7a5"
}

.fa-spider {
    --fa: "\\f717";
    --fa--fa: "\\f717\\f717"
}

.fa-hands-bound {
    --fa: "\\e4f9";
    --fa--fa: "\\e4f9\\e4f9"
}

.fa-file-invoice-dollar {
    --fa: "\\f571";
    --fa--fa: "\\f571\\f571"
}

.fa-plane-circle-exclamation {
    --fa: "\\e556";
    --fa--fa: "\\e556\\e556"
}

.fa-x-ray {
    --fa: "\\f497";
    --fa--fa: "\\f497\\f497"
}

.fa-spell-check {
    --fa: "\\f891";
    --fa--fa: "\\f891\\f891"
}

.fa-slash {
    --fa: "\\f715";
    --fa--fa: "\\f715\\f715"
}

.fa-computer-mouse,
.fa-mouse {
    --fa: "\\f8cc";
    --fa--fa: "\\f8cc\\f8cc"
}

.fa-arrow-right-to-bracket,
.fa-sign-in {
    --fa: "\\f090";
    --fa--fa: "\\f090\\f090"
}

.fa-shop-slash,
.fa-store-alt-slash {
    --fa: "\\e070";
    --fa--fa: "\\e070\\e070"
}

.fa-server {
    --fa: "\\f233";
    --fa--fa: "\\f233\\f233"
}

.fa-virus-covid-slash {
    --fa: "\\e4a9";
    --fa--fa: "\\e4a9\\e4a9"
}

.fa-shop-lock {
    --fa: "\\e4a5";
    --fa--fa: "\\e4a5\\e4a5"
}

.fa-hourglass-1,
.fa-hourglass-start {
    --fa: "\\f251";
    --fa--fa: "\\f251\\f251"
}

.fa-blender-phone {
    --fa: "\\f6b6";
    --fa--fa: "\\f6b6\\f6b6"
}

.fa-building-wheat {
    --fa: "\\e4db";
    --fa--fa: "\\e4db\\e4db"
}

.fa-person-breastfeeding {
    --fa: "\\e53a";
    --fa--fa: "\\e53a\\e53a"
}

.fa-right-to-bracket,
.fa-sign-in-alt {
    --fa: "\\f2f6";
    --fa--fa: "\\f2f6\\f2f6"
}

.fa-venus {
    --fa: "\\f221";
    --fa--fa: "\\f221\\f221"
}

.fa-passport {
    --fa: "\\f5ab";
    --fa--fa: "\\f5ab\\f5ab"
}

.fa-thumb-tack-slash,
.fa-thumbtack-slash {
    --fa: "\\e68f";
    --fa--fa: "\\e68f\\e68f"
}

.fa-heart-pulse,
.fa-heartbeat {
    --fa: "\\f21e";
    --fa--fa: "\\f21e\\f21e"
}

.fa-people-carry,
.fa-people-carry-box {
    --fa: "\\f4ce";
    --fa--fa: "\\f4ce\\f4ce"
}

.fa-temperature-high {
    --fa: "\\f769";
    --fa--fa: "\\f769\\f769"
}

.fa-microchip {
    --fa: "\\f2db";
    --fa--fa: "\\f2db\\f2db"
}

.fa-crown {
    --fa: "\\f521";
    --fa--fa: "\\f521\\f521"
}

.fa-weight-hanging {
    --fa: "\\f5cd";
    --fa--fa: "\\f5cd\\f5cd"
}

.fa-xmarks-lines {
    --fa: "\\e59a";
    --fa--fa: "\\e59a\\e59a"
}

.fa-file-prescription {
    --fa: "\\f572";
    --fa--fa: "\\f572\\f572"
}

.fa-weight,
.fa-weight-scale {
    --fa: "\\f496";
    --fa--fa: "\\f496\\f496"
}

.fa-user-friends,
.fa-user-group {
    --fa: "\\f500";
    --fa--fa: "\\f500\\f500"
}

.fa-arrow-up-a-z,
.fa-sort-alpha-up {
    --fa: "\\f15e";
    --fa--fa: "\\f15e\\f15e"
}

.fa-chess-knight {
    --fa: "\\f441";
    --fa--fa: "\\f441\\f441"
}

.fa-face-laugh-squint,
.fa-laugh-squint {
    --fa: "\\f59b";
    --fa--fa: "\\f59b\\f59b"
}

.fa-wheelchair {
    --fa: "\\f193";
    --fa--fa: "\\f193\\f193"
}

.fa-arrow-circle-up,
.fa-circle-arrow-up {
    --fa: "\\f0aa";
    --fa--fa: "\\f0aa\\f0aa"
}

.fa-toggle-on {
    --fa: "\\f205";
    --fa--fa: "\\f205\\f205"
}

.fa-person-walking,
.fa-walking {
    --fa: "\\f554";
    --fa--fa: "\\f554\\f554"
}

.fa-l {
    --fa: "\\4c";
    --fa--fa: "\\4c\\4c"
}

.fa-fire {
    --fa: "\\f06d";
    --fa--fa: "\\f06d\\f06d"
}

.fa-bed-pulse,
.fa-procedures {
    --fa: "\\f487";
    --fa--fa: "\\f487\\f487"
}

.fa-shuttle-space,
.fa-space-shuttle {
    --fa: "\\f197";
    --fa--fa: "\\f197\\f197"
}

.fa-face-laugh,
.fa-laugh {
    --fa: "\\f599";
    --fa--fa: "\\f599\\f599"
}

.fa-folder-open {
    --fa: "\\f07c";
    --fa--fa: "\\f07c\\f07c"
}

.fa-heart-circle-plus {
    --fa: "\\e500";
    --fa--fa: "\\e500\\e500"
}

.fa-code-fork {
    --fa: "\\e13b";
    --fa--fa: "\\e13b\\e13b"
}

.fa-city {
    --fa: "\\f64f";
    --fa--fa: "\\f64f\\f64f"
}

.fa-microphone-alt,
.fa-microphone-lines {
    --fa: "\\f3c9";
    --fa--fa: "\\f3c9\\f3c9"
}

.fa-pepper-hot {
    --fa: "\\f816";
    --fa--fa: "\\f816\\f816"
}

.fa-unlock {
    --fa: "\\f09c";
    --fa--fa: "\\f09c\\f09c"
}

.fa-colon-sign {
    --fa: "\\e140";
    --fa--fa: "\\e140\\e140"
}

.fa-headset {
    --fa: "\\f590";
    --fa--fa: "\\f590\\f590"
}

.fa-store-slash {
    --fa: "\\e071";
    --fa--fa: "\\e071\\e071"
}

.fa-road-circle-xmark {
    --fa: "\\e566";
    --fa--fa: "\\e566\\e566"
}

.fa-user-minus {
    --fa: "\\f503";
    --fa--fa: "\\f503\\f503"
}

.fa-mars-stroke-up,
.fa-mars-stroke-v {
    --fa: "\\f22a";
    --fa--fa: "\\f22a\\f22a"
}

.fa-champagne-glasses,
.fa-glass-cheers {
    --fa: "\\f79f";
    --fa--fa: "\\f79f\\f79f"
}

.fa-clipboard {
    --fa: "\\f328";
    --fa--fa: "\\f328\\f328"
}

.fa-house-circle-exclamation {
    --fa: "\\e50a";
    --fa--fa: "\\e50a\\e50a"
}

.fa-file-arrow-up,
.fa-file-upload {
    --fa: "\\f574";
    --fa--fa: "\\f574\\f574"
}

.fa-wifi,
.fa-wifi-3,
.fa-wifi-strong {
    --fa: "\\f1eb";
    --fa--fa: "\\f1eb\\f1eb"
}

.fa-bath,
.fa-bathtub {
    --fa: "\\f2cd";
    --fa--fa: "\\f2cd\\f2cd"
}

.fa-underline {
    --fa: "\\f0cd";
    --fa--fa: "\\f0cd\\f0cd"
}

.fa-user-edit,
.fa-user-pen {
    --fa: "\\f4ff";
    --fa--fa: "\\f4ff\\f4ff"
}

.fa-signature {
    --fa: "\\f5b7";
    --fa--fa: "\\f5b7\\f5b7"
}

.fa-stroopwafel {
    --fa: "\\f551";
    --fa--fa: "\\f551\\f551"
}

.fa-bold {
    --fa: "\\f032";
    --fa--fa: "\\f032\\f032"
}

.fa-anchor-lock {
    --fa: "\\e4ad";
    --fa--fa: "\\e4ad\\e4ad"
}

.fa-building-ngo {
    --fa: "\\e4d7";
    --fa--fa: "\\e4d7\\e4d7"
}

.fa-manat-sign {
    --fa: "\\e1d5";
    --fa--fa: "\\e1d5\\e1d5"
}

.fa-not-equal {
    --fa: "\\f53e";
    --fa--fa: "\\f53e\\f53e"
}

.fa-border-style,
.fa-border-top-left {
    --fa: "\\f853";
    --fa--fa: "\\f853\\f853"
}

.fa-map-location-dot,
.fa-map-marked-alt {
    --fa: "\\f5a0";
    --fa--fa: "\\f5a0\\f5a0"
}

.fa-jedi {
    --fa: "\\f669";
    --fa--fa: "\\f669\\f669"
}

.fa-poll,
.fa-square-poll-vertical {
    --fa: "\\f681";
    --fa--fa: "\\f681\\f681"
}

.fa-mug-hot {
    --fa: "\\f7b6";
    --fa--fa: "\\f7b6\\f7b6"
}

.fa-battery-car,
.fa-car-battery {
    --fa: "\\f5df";
    --fa--fa: "\\f5df\\f5df"
}

.fa-gift {
    --fa: "\\f06b";
    --fa--fa: "\\f06b\\f06b"
}

.fa-dice-two {
    --fa: "\\f528";
    --fa--fa: "\\f528\\f528"
}

.fa-chess-queen {
    --fa: "\\f445";
    --fa--fa: "\\f445\\f445"
}

.fa-glasses {
    --fa: "\\f530";
    --fa--fa: "\\f530\\f530"
}

.fa-chess-board {
    --fa: "\\f43c";
    --fa--fa: "\\f43c\\f43c"
}

.fa-building-circle-check {
    --fa: "\\e4d2";
    --fa--fa: "\\e4d2\\e4d2"
}

.fa-person-chalkboard {
    --fa: "\\e53d";
    --fa--fa: "\\e53d\\e53d"
}

.fa-mars-stroke-h,
.fa-mars-stroke-right {
    --fa: "\\f22b";
    --fa--fa: "\\f22b\\f22b"
}

.fa-hand-back-fist,
.fa-hand-rock {
    --fa: "\\f255";
    --fa--fa: "\\f255\\f255"
}

.fa-caret-square-up,
.fa-square-caret-up {
    --fa: "\\f151";
    --fa--fa: "\\f151\\f151"
}

.fa-cloud-showers-water {
    --fa: "\\e4e4";
    --fa--fa: "\\e4e4\\e4e4"
}

.fa-bar-chart,
.fa-chart-bar {
    --fa: "\\f080";
    --fa--fa: "\\f080\\f080"
}

.fa-hands-bubbles,
.fa-hands-wash {
    --fa: "\\e05e";
    --fa--fa: "\\e05e\\e05e"
}

.fa-less-than-equal {
    --fa: "\\f537";
    --fa--fa: "\\f537\\f537"
}

.fa-train {
    --fa: "\\f238";
    --fa--fa: "\\f238\\f238"
}

.fa-eye-low-vision,
.fa-low-vision {
    --fa: "\\f2a8";
    --fa--fa: "\\f2a8\\f2a8"
}

.fa-crow {
    --fa: "\\f520";
    --fa--fa: "\\f520\\f520"
}

.fa-sailboat {
    --fa: "\\e445";
    --fa--fa: "\\e445\\e445"
}

.fa-window-restore {
    --fa: "\\f2d2";
    --fa--fa: "\\f2d2\\f2d2"
}

.fa-plus-square,
.fa-square-plus {
    --fa: "\\f0fe";
    --fa--fa: "\\f0fe\\f0fe"
}

.fa-torii-gate {
    --fa: "\\f6a1";
    --fa--fa: "\\f6a1\\f6a1"
}

.fa-frog {
    --fa: "\\f52e";
    --fa--fa: "\\f52e\\f52e"
}

.fa-bucket {
    --fa: "\\e4cf";
    --fa--fa: "\\e4cf\\e4cf"
}

.fa-image {
    --fa: "\\f03e";
    --fa--fa: "\\f03e\\f03e"
}

.fa-microphone {
    --fa: "\\f130";
    --fa--fa: "\\f130\\f130"
}

.fa-cow {
    --fa: "\\f6c8";
    --fa--fa: "\\f6c8\\f6c8"
}

.fa-caret-up {
    --fa: "\\f0d8";
    --fa--fa: "\\f0d8\\f0d8"
}

.fa-screwdriver {
    --fa: "\\f54a";
    --fa--fa: "\\f54a\\f54a"
}

.fa-folder-closed {
    --fa: "\\e185";
    --fa--fa: "\\e185\\e185"
}

.fa-house-tsunami {
    --fa: "\\e515";
    --fa--fa: "\\e515\\e515"
}

.fa-square-nfi {
    --fa: "\\e576";
    --fa--fa: "\\e576\\e576"
}

.fa-arrow-up-from-ground-water {
    --fa: "\\e4b5";
    --fa--fa: "\\e4b5\\e4b5"
}

.fa-glass-martini-alt,
.fa-martini-glass {
    --fa: "\\f57b";
    --fa--fa: "\\f57b\\f57b"
}

.fa-square-binary {
    --fa: "\\e69b";
    --fa--fa: "\\e69b\\e69b"
}

.fa-rotate-back,
.fa-rotate-backward,
.fa-rotate-left,
.fa-undo-alt {
    --fa: "\\f2ea";
    --fa--fa: "\\f2ea\\f2ea"
}

.fa-columns,
.fa-table-columns {
    --fa: "\\f0db";
    --fa--fa: "\\f0db\\f0db"
}

.fa-lemon {
    --fa: "\\f094";
    --fa--fa: "\\f094\\f094"
}

.fa-head-side-mask {
    --fa: "\\e063";
    --fa--fa: "\\e063\\e063"
}

.fa-handshake {
    --fa: "\\f2b5";
    --fa--fa: "\\f2b5\\f2b5"
}

.fa-gem {
    --fa: "\\f3a5";
    --fa--fa: "\\f3a5\\f3a5"
}

.fa-dolly,
.fa-dolly-box {
    --fa: "\\f472";
    --fa--fa: "\\f472\\f472"
}

.fa-smoking {
    --fa: "\\f48d";
    --fa--fa: "\\f48d\\f48d"
}

.fa-compress-arrows-alt,
.fa-minimize {
    --fa: "\\f78c";
    --fa--fa: "\\f78c\\f78c"
}

.fa-monument {
    --fa: "\\f5a6";
    --fa--fa: "\\f5a6\\f5a6"
}

.fa-snowplow {
    --fa: "\\f7d2";
    --fa--fa: "\\f7d2\\f7d2"
}

.fa-angle-double-right,
.fa-angles-right {
    --fa: "\\f101";
    --fa--fa: "\\f101\\f101"
}

.fa-cannabis {
    --fa: "\\f55f";
    --fa--fa: "\\f55f\\f55f"
}

.fa-circle-play,
.fa-play-circle {
    --fa: "\\f144";
    --fa--fa: "\\f144\\f144"
}

.fa-tablets {
    --fa: "\\f490";
    --fa--fa: "\\f490\\f490"
}

.fa-ethernet {
    --fa: "\\f796";
    --fa--fa: "\\f796\\f796"
}

.fa-eur,
.fa-euro,
.fa-euro-sign {
    --fa: "\\f153";
    --fa--fa: "\\f153\\f153"
}

.fa-chair {
    --fa: "\\f6c0";
    --fa--fa: "\\f6c0\\f6c0"
}

.fa-check-circle,
.fa-circle-check {
    --fa: "\\f058";
    --fa--fa: "\\f058\\f058"
}

.fa-circle-stop,
.fa-stop-circle {
    --fa: "\\f28d";
    --fa--fa: "\\f28d\\f28d"
}

.fa-compass-drafting,
.fa-drafting-compass {
    --fa: "\\f568";
    --fa--fa: "\\f568\\f568"
}

.fa-plate-wheat {
    --fa: "\\e55a";
    --fa--fa: "\\e55a\\e55a"
}

.fa-icicles {
    --fa: "\\f7ad";
    --fa--fa: "\\f7ad\\f7ad"
}

.fa-person-shelter {
    --fa: "\\e54f";
    --fa--fa: "\\e54f\\e54f"
}

.fa-neuter {
    --fa: "\\f22c";
    --fa--fa: "\\f22c\\f22c"
}

.fa-id-badge {
    --fa: "\\f2c1";
    --fa--fa: "\\f2c1\\f2c1"
}

.fa-marker {
    --fa: "\\f5a1";
    --fa--fa: "\\f5a1\\f5a1"
}

.fa-face-laugh-beam,
.fa-laugh-beam {
    --fa: "\\f59a";
    --fa--fa: "\\f59a\\f59a"
}

.fa-helicopter-symbol {
    --fa: "\\e502";
    --fa--fa: "\\e502\\e502"
}

.fa-universal-access {
    --fa: "\\f29a";
    --fa--fa: "\\f29a\\f29a"
}

.fa-chevron-circle-up,
.fa-circle-chevron-up {
    --fa: "\\f139";
    --fa--fa: "\\f139\\f139"
}

.fa-lari-sign {
    --fa: "\\e1c8";
    --fa--fa: "\\e1c8\\e1c8"
}

.fa-volcano {
    --fa: "\\f770";
    --fa--fa: "\\f770\\f770"
}

.fa-person-walking-dashed-line-arrow-right {
    --fa: "\\e553";
    --fa--fa: "\\e553\\e553"
}

.fa-gbp,
.fa-pound-sign,
.fa-sterling-sign {
    --fa: "\\f154";
    --fa--fa: "\\f154\\f154"
}

.fa-viruses {
    --fa: "\\e076";
    --fa--fa: "\\e076\\e076"
}

.fa-square-person-confined {
    --fa: "\\e577";
    --fa--fa: "\\e577\\e577"
}

.fa-user-tie {
    --fa: "\\f508";
    --fa--fa: "\\f508\\f508"
}

.fa-arrow-down-long,
.fa-long-arrow-down {
    --fa: "\\f175";
    --fa--fa: "\\f175\\f175"
}

.fa-tent-arrow-down-to-line {
    --fa: "\\e57e";
    --fa--fa: "\\e57e\\e57e"
}

.fa-certificate {
    --fa: "\\f0a3";
    --fa--fa: "\\f0a3\\f0a3"
}

.fa-mail-reply-all,
.fa-reply-all {
    --fa: "\\f122";
    --fa--fa: "\\f122\\f122"
}

.fa-suitcase {
    --fa: "\\f0f2";
    --fa--fa: "\\f0f2\\f0f2"
}

.fa-person-skating,
.fa-skating {
    --fa: "\\f7c5";
    --fa--fa: "\\f7c5\\f7c5"
}

.fa-filter-circle-dollar,
.fa-funnel-dollar {
    --fa: "\\f662";
    --fa--fa: "\\f662\\f662"
}

.fa-camera-retro {
    --fa: "\\f083";
    --fa--fa: "\\f083\\f083"
}

.fa-arrow-circle-down,
.fa-circle-arrow-down {
    --fa: "\\f0ab";
    --fa--fa: "\\f0ab\\f0ab"
}

.fa-arrow-right-to-file,
.fa-file-import {
    --fa: "\\f56f";
    --fa--fa: "\\f56f\\f56f"
}

.fa-external-link-square,
.fa-square-arrow-up-right {
    --fa: "\\f14c";
    --fa--fa: "\\f14c\\f14c"
}

.fa-box-open {
    --fa: "\\f49e";
    --fa--fa: "\\f49e\\f49e"
}

.fa-scroll {
    --fa: "\\f70e";
    --fa--fa: "\\f70e\\f70e"
}

.fa-spa {
    --fa: "\\f5bb";
    --fa--fa: "\\f5bb\\f5bb"
}

.fa-location-pin-lock {
    --fa: "\\e51f";
    --fa--fa: "\\e51f\\e51f"
}

.fa-pause {
    --fa: "\\f04c";
    --fa--fa: "\\f04c\\f04c"
}

.fa-hill-avalanche {
    --fa: "\\e507";
    --fa--fa: "\\e507\\e507"
}

.fa-temperature-0,
.fa-temperature-empty,
.fa-thermometer-0,
.fa-thermometer-empty {
    --fa: "\\f2cb";
    --fa--fa: "\\f2cb\\f2cb"
}

.fa-bomb {
    --fa: "\\f1e2";
    --fa--fa: "\\f1e2\\f1e2"
}

.fa-registered {
    --fa: "\\f25d";
    --fa--fa: "\\f25d\\f25d"
}

.fa-address-card,
.fa-contact-card,
.fa-vcard {
    --fa: "\\f2bb";
    --fa--fa: "\\f2bb\\f2bb"
}

.fa-balance-scale-right,
.fa-scale-unbalanced-flip {
    --fa: "\\f516";
    --fa--fa: "\\f516\\f516"
}

.fa-subscript {
    --fa: "\\f12c";
    --fa--fa: "\\f12c\\f12c"
}

.fa-diamond-turn-right,
.fa-directions {
    --fa: "\\f5eb";
    --fa--fa: "\\f5eb\\f5eb"
}

.fa-burst {
    --fa: "\\e4dc";
    --fa--fa: "\\e4dc\\e4dc"
}

.fa-house-laptop,
.fa-laptop-house {
    --fa: "\\e066";
    --fa--fa: "\\e066\\e066"
}

.fa-face-tired,
.fa-tired {
    --fa: "\\f5c8";
    --fa--fa: "\\f5c8\\f5c8"
}

.fa-money-bills {
    --fa: "\\e1f3";
    --fa--fa: "\\e1f3\\e1f3"
}

.fa-smog {
    --fa: "\\f75f";
    --fa--fa: "\\f75f\\f75f"
}

.fa-crutch {
    --fa: "\\f7f7";
    --fa--fa: "\\f7f7\\f7f7"
}

.fa-cloud-arrow-up,
.fa-cloud-upload,
.fa-cloud-upload-alt {
    --fa: "\\f0ee";
    --fa--fa: "\\f0ee\\f0ee"
}

.fa-palette {
    --fa: "\\f53f";
    --fa--fa: "\\f53f\\f53f"
}

.fa-arrows-turn-right {
    --fa: "\\e4c0";
    --fa--fa: "\\e4c0\\e4c0"
}

.fa-vest {
    --fa: "\\e085";
    --fa--fa: "\\e085\\e085"
}

.fa-ferry {
    --fa: "\\e4ea";
    --fa--fa: "\\e4ea\\e4ea"
}

.fa-arrows-down-to-people {
    --fa: "\\e4b9";
    --fa--fa: "\\e4b9\\e4b9"
}

.fa-seedling,
.fa-sprout {
    --fa: "\\f4d8";
    --fa--fa: "\\f4d8\\f4d8"
}

.fa-arrows-alt-h,
.fa-left-right {
    --fa: "\\f337";
    --fa--fa: "\\f337\\f337"
}

.fa-boxes-packing {
    --fa: "\\e4c7";
    --fa--fa: "\\e4c7\\e4c7"
}

.fa-arrow-circle-left,
.fa-circle-arrow-left {
    --fa: "\\f0a8";
    --fa--fa: "\\f0a8\\f0a8"
}

.fa-group-arrows-rotate {
    --fa: "\\e4f6";
    --fa--fa: "\\e4f6\\e4f6"
}

.fa-bowl-food {
    --fa: "\\e4c6";
    --fa--fa: "\\e4c6\\e4c6"
}

.fa-candy-cane {
    --fa: "\\f786";
    --fa--fa: "\\f786\\f786"
}

.fa-arrow-down-wide-short,
.fa-sort-amount-asc,
.fa-sort-amount-down {
    --fa: "\\f160";
    --fa--fa: "\\f160\\f160"
}

.fa-cloud-bolt,
.fa-thunderstorm {
    --fa: "\\f76c";
    --fa--fa: "\\f76c\\f76c"
}

.fa-remove-format,
.fa-text-slash {
    --fa: "\\f87d";
    --fa--fa: "\\f87d\\f87d"
}

.fa-face-smile-wink,
.fa-smile-wink {
    --fa: "\\f4da";
    --fa--fa: "\\f4da\\f4da"
}

.fa-file-word {
    --fa: "\\f1c2";
    --fa--fa: "\\f1c2\\f1c2"
}

.fa-file-powerpoint {
    --fa: "\\f1c4";
    --fa--fa: "\\f1c4\\f1c4"
}

.fa-arrows-h,
.fa-arrows-left-right {
    --fa: "\\f07e";
    --fa--fa: "\\f07e\\f07e"
}

.fa-house-lock {
    --fa: "\\e510";
    --fa--fa: "\\e510\\e510"
}

.fa-cloud-arrow-down,
.fa-cloud-download,
.fa-cloud-download-alt {
    --fa: "\\f0ed";
    --fa--fa: "\\f0ed\\f0ed"
}

.fa-children {
    --fa: "\\e4e1";
    --fa--fa: "\\e4e1\\e4e1"
}

.fa-blackboard,
.fa-chalkboard {
    --fa: "\\f51b";
    --fa--fa: "\\f51b\\f51b"
}

.fa-user-alt-slash,
.fa-user-large-slash {
    --fa: "\\f4fa";
    --fa--fa: "\\f4fa\\f4fa"
}

.fa-envelope-open {
    --fa: "\\f2b6";
    --fa--fa: "\\f2b6\\f2b6"
}

.fa-handshake-alt-slash,
.fa-handshake-simple-slash {
    --fa: "\\e05f";
    --fa--fa: "\\e05f\\e05f"
}

.fa-mattress-pillow {
    --fa: "\\e525";
    --fa--fa: "\\e525\\e525"
}

.fa-guarani-sign {
    --fa: "\\e19a";
    --fa--fa: "\\e19a\\e19a"
}

.fa-arrows-rotate,
.fa-refresh,
.fa-sync {
    --fa: "\\f021";
    --fa--fa: "\\f021\\f021"
}

.fa-fire-extinguisher {
    --fa: "\\f134";
    --fa--fa: "\\f134\\f134"
}

.fa-cruzeiro-sign {
    --fa: "\\e152";
    --fa--fa: "\\e152\\e152"
}

.fa-greater-than-equal {
    --fa: "\\f532";
    --fa--fa: "\\f532\\f532"
}

.fa-shield-alt,
.fa-shield-halved {
    --fa: "\\f3ed";
    --fa--fa: "\\f3ed\\f3ed"
}

.fa-atlas,
.fa-book-atlas {
    --fa: "\\f558";
    --fa--fa: "\\f558\\f558"
}

.fa-virus {
    --fa: "\\e074";
    --fa--fa: "\\e074\\e074"
}

.fa-envelope-circle-check {
    --fa: "\\e4e8";
    --fa--fa: "\\e4e8\\e4e8"
}

.fa-layer-group {
    --fa: "\\f5fd";
    --fa--fa: "\\f5fd\\f5fd"
}

.fa-arrows-to-dot {
    --fa: "\\e4be";
    --fa--fa: "\\e4be\\e4be"
}

.fa-archway {
    --fa: "\\f557";
    --fa--fa: "\\f557\\f557"
}

.fa-heart-circle-check {
    --fa: "\\e4fd";
    --fa--fa: "\\e4fd\\e4fd"
}

.fa-house-chimney-crack,
.fa-house-damage {
    --fa: "\\f6f1";
    --fa--fa: "\\f6f1\\f6f1"
}

.fa-file-archive,
.fa-file-zipper {
    --fa: "\\f1c6";
    --fa--fa: "\\f1c6\\f1c6"
}

.fa-square {
    --fa: "\\f0c8";
    --fa--fa: "\\f0c8\\f0c8"
}

.fa-glass-martini,
.fa-martini-glass-empty {
    --fa: "\\f000";
    --fa--fa: "\\f000\\f000"
}

.fa-couch {
    --fa: "\\f4b8";
    --fa--fa: "\\f4b8\\f4b8"
}

.fa-cedi-sign {
    --fa: "\\e0df";
    --fa--fa: "\\e0df\\e0df"
}

.fa-italic {
    --fa: "\\f033";
    --fa--fa: "\\f033\\f033"
}

.fa-table-cells-column-lock {
    --fa: "\\e678";
    --fa--fa: "\\e678\\e678"
}

.fa-church {
    --fa: "\\f51d";
    --fa--fa: "\\f51d\\f51d"
}

.fa-comments-dollar {
    --fa: "\\f653";
    --fa--fa: "\\f653\\f653"
}

.fa-democrat {
    --fa: "\\f747";
    --fa--fa: "\\f747\\f747"
}

.fa-z {
    --fa: "\\5a";
    --fa--fa: "\\5a\\5a"
}

.fa-person-skiing,
.fa-skiing {
    --fa: "\\f7c9";
    --fa--fa: "\\f7c9\\f7c9"
}

.fa-road-lock {
    --fa: "\\e567";
    --fa--fa: "\\e567\\e567"
}

.fa-a {
    --fa: "\\41";
    --fa--fa: "\\41\\41"
}

.fa-temperature-arrow-down,
.fa-temperature-down {
    --fa: "\\e03f";
    --fa--fa: "\\e03f\\e03f"
}

.fa-feather-alt,
.fa-feather-pointed {
    --fa: "\\f56b";
    --fa--fa: "\\f56b\\f56b"
}

.fa-p {
    --fa: "\\50";
    --fa--fa: "\\50\\50"
}

.fa-snowflake {
    --fa: "\\f2dc";
    --fa--fa: "\\f2dc\\f2dc"
}

.fa-newspaper {
    --fa: "\\f1ea";
    --fa--fa: "\\f1ea\\f1ea"
}

.fa-ad,
.fa-rectangle-ad {
    --fa: "\\f641";
    --fa--fa: "\\f641\\f641"
}

.fa-arrow-circle-right,
.fa-circle-arrow-right {
    --fa: "\\f0a9";
    --fa--fa: "\\f0a9\\f0a9"
}

.fa-filter-circle-xmark {
    --fa: "\\e17b";
    --fa--fa: "\\e17b\\e17b"
}

.fa-locust {
    --fa: "\\e520";
    --fa--fa: "\\e520\\e520"
}

.fa-sort,
.fa-unsorted {
    --fa: "\\f0dc";
    --fa--fa: "\\f0dc\\f0dc"
}

.fa-list-1-2,
.fa-list-numeric,
.fa-list-ol {
    --fa: "\\f0cb";
    --fa--fa: "\\f0cb\\f0cb"
}

.fa-person-dress-burst {
    --fa: "\\e544";
    --fa--fa: "\\e544\\e544"
}

.fa-money-check-alt,
.fa-money-check-dollar {
    --fa: "\\f53d";
    --fa--fa: "\\f53d\\f53d"
}

.fa-vector-square {
    --fa: "\\f5cb";
    --fa--fa: "\\f5cb\\f5cb"
}

.fa-bread-slice {
    --fa: "\\f7ec";
    --fa--fa: "\\f7ec\\f7ec"
}

.fa-language {
    --fa: "\\f1ab";
    --fa--fa: "\\f1ab\\f1ab"
}

.fa-face-kiss-wink-heart,
.fa-kiss-wink-heart {
    --fa: "\\f598";
    --fa--fa: "\\f598\\f598"
}

.fa-filter {
    --fa: "\\f0b0";
    --fa--fa: "\\f0b0\\f0b0"
}

.fa-question {
    --fa: "\\3f";
    --fa--fa: "\\3f\\3f"
}

.fa-file-signature {
    --fa: "\\f573";
    --fa--fa: "\\f573\\f573"
}

.fa-arrows-alt,
.fa-up-down-left-right {
    --fa: "\\f0b2";
    --fa--fa: "\\f0b2\\f0b2"
}

.fa-house-chimney-user {
    --fa: "\\e065";
    --fa--fa: "\\e065\\e065"
}

.fa-hand-holding-heart {
    --fa: "\\f4be";
    --fa--fa: "\\f4be\\f4be"
}

.fa-puzzle-piece {
    --fa: "\\f12e";
    --fa--fa: "\\f12e\\f12e"
}

.fa-money-check {
    --fa: "\\f53c";
    --fa--fa: "\\f53c\\f53c"
}

.fa-star-half-alt,
.fa-star-half-stroke {
    --fa: "\\f5c0";
    --fa--fa: "\\f5c0\\f5c0"
}

.fa-code {
    --fa: "\\f121";
    --fa--fa: "\\f121\\f121"
}

.fa-glass-whiskey,
.fa-whiskey-glass {
    --fa: "\\f7a0";
    --fa--fa: "\\f7a0\\f7a0"
}

.fa-building-circle-exclamation {
    --fa: "\\e4d3";
    --fa--fa: "\\e4d3\\e4d3"
}

.fa-magnifying-glass-chart {
    --fa: "\\e522";
    --fa--fa: "\\e522\\e522"
}

.fa-arrow-up-right-from-square,
.fa-external-link {
    --fa: "\\f08e";
    --fa--fa: "\\f08e\\f08e"
}

.fa-cubes-stacked {
    --fa: "\\e4e6";
    --fa--fa: "\\e4e6\\e4e6"
}

.fa-krw,
.fa-won,
.fa-won-sign {
    --fa: "\\f159";
    --fa--fa: "\\f159\\f159"
}

.fa-virus-covid {
    --fa: "\\e4a8";
    --fa--fa: "\\e4a8\\e4a8"
}

.fa-austral-sign {
    --fa: "\\e0a9";
    --fa--fa: "\\e0a9\\e0a9"
}

.fa-f {
    --fa: "\\46";
    --fa--fa: "\\46\\46"
}

.fa-leaf {
    --fa: "\\f06c";
    --fa--fa: "\\f06c\\f06c"
}

.fa-road {
    --fa: "\\f018";
    --fa--fa: "\\f018\\f018"
}

.fa-cab,
.fa-taxi {
    --fa: "\\f1ba";
    --fa--fa: "\\f1ba\\f1ba"
}

.fa-person-circle-plus {
    --fa: "\\e541";
    --fa--fa: "\\e541\\e541"
}

.fa-chart-pie,
.fa-pie-chart {
    --fa: "\\f200";
    --fa--fa: "\\f200\\f200"
}

.fa-bolt-lightning {
    --fa: "\\e0b7";
    --fa--fa: "\\e0b7\\e0b7"
}

.fa-sack-xmark {
    --fa: "\\e56a";
    --fa--fa: "\\e56a\\e56a"
}

.fa-file-excel {
    --fa: "\\f1c3";
    --fa--fa: "\\f1c3\\f1c3"
}

.fa-file-contract {
    --fa: "\\f56c";
    --fa--fa: "\\f56c\\f56c"
}

.fa-fish-fins {
    --fa: "\\e4f2";
    --fa--fa: "\\e4f2\\e4f2"
}

.fa-building-flag {
    --fa: "\\e4d5";
    --fa--fa: "\\e4d5\\e4d5"
}

.fa-face-grin-beam,
.fa-grin-beam {
    --fa: "\\f582";
    --fa--fa: "\\f582\\f582"
}

.fa-object-ungroup {
    --fa: "\\f248";
    --fa--fa: "\\f248\\f248"
}

.fa-poop {
    --fa: "\\f619";
    --fa--fa: "\\f619\\f619"
}

.fa-location-pin,
.fa-map-marker {
    --fa: "\\f041";
    --fa--fa: "\\f041\\f041"
}

.fa-kaaba {
    --fa: "\\f66b";
    --fa--fa: "\\f66b\\f66b"
}

.fa-toilet-paper {
    --fa: "\\f71e";
    --fa--fa: "\\f71e\\f71e"
}

.fa-hard-hat,
.fa-hat-hard,
.fa-helmet-safety {
    --fa: "\\f807";
    --fa--fa: "\\f807\\f807"
}

.fa-eject {
    --fa: "\\f052";
    --fa--fa: "\\f052\\f052"
}

.fa-arrow-alt-circle-right,
.fa-circle-right {
    --fa: "\\f35a";
    --fa--fa: "\\f35a\\f35a"
}

.fa-plane-circle-check {
    --fa: "\\e555";
    --fa--fa: "\\e555\\e555"
}

.fa-face-rolling-eyes,
.fa-meh-rolling-eyes {
    --fa: "\\f5a5";
    --fa--fa: "\\f5a5\\f5a5"
}

.fa-object-group {
    --fa: "\\f247";
    --fa--fa: "\\f247\\f247"
}

.fa-chart-line,
.fa-line-chart {
    --fa: "\\f201";
    --fa--fa: "\\f201\\f201"
}

.fa-mask-ventilator {
    --fa: "\\e524";
    --fa--fa: "\\e524\\e524"
}

.fa-arrow-right {
    --fa: "\\f061";
    --fa--fa: "\\f061\\f061"
}

.fa-map-signs,
.fa-signs-post {
    --fa: "\\f277";
    --fa--fa: "\\f277\\f277"
}

.fa-cash-register {
    --fa: "\\f788";
    --fa--fa: "\\f788\\f788"
}

.fa-person-circle-question {
    --fa: "\\e542";
    --fa--fa: "\\e542\\e542"
}

.fa-h {
    --fa: "\\48";
    --fa--fa: "\\48\\48"
}

.fa-tarp {
    --fa: "\\e57b";
    --fa--fa: "\\e57b\\e57b"
}

.fa-screwdriver-wrench,
.fa-tools {
    --fa: "\\f7d9";
    --fa--fa: "\\f7d9\\f7d9"
}

.fa-arrows-to-eye {
    --fa: "\\e4bf";
    --fa--fa: "\\e4bf\\e4bf"
}

.fa-plug-circle-bolt {
    --fa: "\\e55b";
    --fa--fa: "\\e55b\\e55b"
}

.fa-heart {
    --fa: "\\f004";
    --fa--fa: "\\f004\\f004"
}

.fa-mars-and-venus {
    --fa: "\\f224";
    --fa--fa: "\\f224\\f224"
}

.fa-home-user,
.fa-house-user {
    --fa: "\\e1b0";
    --fa--fa: "\\e1b0\\e1b0"
}

.fa-dumpster-fire {
    --fa: "\\f794";
    --fa--fa: "\\f794\\f794"
}

.fa-house-crack {
    --fa: "\\e3b1";
    --fa--fa: "\\e3b1\\e3b1"
}

.fa-cocktail,
.fa-martini-glass-citrus {
    --fa: "\\f561";
    --fa--fa: "\\f561\\f561"
}

.fa-face-surprise,
.fa-surprise {
    --fa: "\\f5c2";
    --fa--fa: "\\f5c2\\f5c2"
}

.fa-bottle-water {
    --fa: "\\e4c5";
    --fa--fa: "\\e4c5\\e4c5"
}

.fa-circle-pause,
.fa-pause-circle {
    --fa: "\\f28b";
    --fa--fa: "\\f28b\\f28b"
}

.fa-toilet-paper-slash {
    --fa: "\\e072";
    --fa--fa: "\\e072\\e072"
}

.fa-apple-alt,
.fa-apple-whole {
    --fa: "\\f5d1";
    --fa--fa: "\\f5d1\\f5d1"
}

.fa-kitchen-set {
    --fa: "\\e51a";
    --fa--fa: "\\e51a\\e51a"
}

.fa-r {
    --fa: "\\52";
    --fa--fa: "\\52\\52"
}

.fa-temperature-1,
.fa-temperature-quarter,
.fa-thermometer-1,
.fa-thermometer-quarter {
    --fa: "\\f2ca";
    --fa--fa: "\\f2ca\\f2ca"
}

.fa-cube {
    --fa: "\\f1b2";
    --fa--fa: "\\f1b2\\f1b2"
}

.fa-bitcoin-sign {
    --fa: "\\e0b4";
    --fa--fa: "\\e0b4\\e0b4"
}

.fa-shield-dog {
    --fa: "\\e573";
    --fa--fa: "\\e573\\e573"
}

.fa-solar-panel {
    --fa: "\\f5ba";
    --fa--fa: "\\f5ba\\f5ba"
}

.fa-lock-open {
    --fa: "\\f3c1";
    --fa--fa: "\\f3c1\\f3c1"
}

.fa-elevator {
    --fa: "\\e16d";
    --fa--fa: "\\e16d\\e16d"
}

.fa-money-bill-transfer {
    --fa: "\\e528";
    --fa--fa: "\\e528\\e528"
}

.fa-money-bill-trend-up {
    --fa: "\\e529";
    --fa--fa: "\\e529\\e529"
}

.fa-house-flood-water-circle-arrow-right {
    --fa: "\\e50f";
    --fa--fa: "\\e50f\\e50f"
}

.fa-poll-h,
.fa-square-poll-horizontal {
    --fa: "\\f682";
    --fa--fa: "\\f682\\f682"
}

.fa-circle {
    --fa: "\\f111";
    --fa--fa: "\\f111\\f111"
}

.fa-backward-fast,
.fa-fast-backward {
    --fa: "\\f049";
    --fa--fa: "\\f049\\f049"
}

.fa-recycle {
    --fa: "\\f1b8";
    --fa--fa: "\\f1b8\\f1b8"
}

.fa-user-astronaut {
    --fa: "\\f4fb";
    --fa--fa: "\\f4fb\\f4fb"
}

.fa-plane-slash {
    --fa: "\\e069";
    --fa--fa: "\\e069\\e069"
}

.fa-trademark {
    --fa: "\\f25c";
    --fa--fa: "\\f25c\\f25c"
}

.fa-basketball,
.fa-basketball-ball {
    --fa: "\\f434";
    --fa--fa: "\\f434\\f434"
}

.fa-satellite-dish {
    --fa: "\\f7c0";
    --fa--fa: "\\f7c0\\f7c0"
}

.fa-arrow-alt-circle-up,
.fa-circle-up {
    --fa: "\\f35b";
    --fa--fa: "\\f35b\\f35b"
}

.fa-mobile-alt,
.fa-mobile-screen-button {
    --fa: "\\f3cd";
    --fa--fa: "\\f3cd\\f3cd"
}

.fa-volume-high,
.fa-volume-up {
    --fa: "\\f028";
    --fa--fa: "\\f028\\f028"
}

.fa-users-rays {
    --fa: "\\e593";
    --fa--fa: "\\e593\\e593"
}

.fa-wallet {
    --fa: "\\f555";
    --fa--fa: "\\f555\\f555"
}

.fa-clipboard-check {
    --fa: "\\f46c";
    --fa--fa: "\\f46c\\f46c"
}

.fa-file-audio {
    --fa: "\\f1c7";
    --fa--fa: "\\f1c7\\f1c7"
}

.fa-burger,
.fa-hamburger {
    --fa: "\\f805";
    --fa--fa: "\\f805\\f805"
}

.fa-wrench {
    --fa: "\\f0ad";
    --fa--fa: "\\f0ad\\f0ad"
}

.fa-bugs {
    --fa: "\\e4d0";
    --fa--fa: "\\e4d0\\e4d0"
}

.fa-rupee,
.fa-rupee-sign {
    --fa: "\\f156";
    --fa--fa: "\\f156\\f156"
}

.fa-file-image {
    --fa: "\\f1c5";
    --fa--fa: "\\f1c5\\f1c5"
}

.fa-circle-question,
.fa-question-circle {
    --fa: "\\f059";
    --fa--fa: "\\f059\\f059"
}

.fa-plane-departure {
    --fa: "\\f5b0";
    --fa--fa: "\\f5b0\\f5b0"
}

.fa-handshake-slash {
    --fa: "\\e060";
    --fa--fa: "\\e060\\e060"
}

.fa-book-bookmark {
    --fa: "\\e0bb";
    --fa--fa: "\\e0bb\\e0bb"
}

.fa-code-branch {
    --fa: "\\f126";
    --fa--fa: "\\f126\\f126"
}

.fa-hat-cowboy {
    --fa: "\\f8c0";
    --fa--fa: "\\f8c0\\f8c0"
}

.fa-bridge {
    --fa: "\\e4c8";
    --fa--fa: "\\e4c8\\e4c8"
}

.fa-phone-alt,
.fa-phone-flip {
    --fa: "\\f879";
    --fa--fa: "\\f879\\f879"
}

.fa-truck-front {
    --fa: "\\e2b7";
    --fa--fa: "\\e2b7\\e2b7"
}

.fa-cat {
    --fa: "\\f6be";
    --fa--fa: "\\f6be\\f6be"
}

.fa-anchor-circle-exclamation {
    --fa: "\\e4ab";
    --fa--fa: "\\e4ab\\e4ab"
}

.fa-truck-field {
    --fa: "\\e58d";
    --fa--fa: "\\e58d\\e58d"
}

.fa-route {
    --fa: "\\f4d7";
    --fa--fa: "\\f4d7\\f4d7"
}

.fa-clipboard-question {
    --fa: "\\e4e3";
    --fa--fa: "\\e4e3\\e4e3"
}

.fa-panorama {
    --fa: "\\e209";
    --fa--fa: "\\e209\\e209"
}

.fa-comment-medical {
    --fa: "\\f7f5";
    --fa--fa: "\\f7f5\\f7f5"
}

.fa-teeth-open {
    --fa: "\\f62f";
    --fa--fa: "\\f62f\\f62f"
}

.fa-file-circle-minus {
    --fa: "\\e4ed";
    --fa--fa: "\\e4ed\\e4ed"
}

.fa-tags {
    --fa: "\\f02c";
    --fa--fa: "\\f02c\\f02c"
}

.fa-wine-glass {
    --fa: "\\f4e3";
    --fa--fa: "\\f4e3\\f4e3"
}

.fa-fast-forward,
.fa-forward-fast {
    --fa: "\\f050";
    --fa--fa: "\\f050\\f050"
}

.fa-face-meh-blank,
.fa-meh-blank {
    --fa: "\\f5a4";
    --fa--fa: "\\f5a4\\f5a4"
}

.fa-parking,
.fa-square-parking {
    --fa: "\\f540";
    --fa--fa: "\\f540\\f540"
}

.fa-house-signal {
    --fa: "\\e012";
    --fa--fa: "\\e012\\e012"
}

.fa-bars-progress,
.fa-tasks-alt {
    --fa: "\\f828";
    --fa--fa: "\\f828\\f828"
}

.fa-faucet-drip {
    --fa: "\\e006";
    --fa--fa: "\\e006\\e006"
}

.fa-cart-flatbed,
.fa-dolly-flatbed {
    --fa: "\\f474";
    --fa--fa: "\\f474\\f474"
}

.fa-ban-smoking,
.fa-smoking-ban {
    --fa: "\\f54d";
    --fa--fa: "\\f54d\\f54d"
}

.fa-terminal {
    --fa: "\\f120";
    --fa--fa: "\\f120\\f120"
}

.fa-mobile-button {
    --fa: "\\f10b";
    --fa--fa: "\\f10b\\f10b"
}

.fa-house-medical-flag {
    --fa: "\\e514";
    --fa--fa: "\\e514\\e514"
}

.fa-basket-shopping,
.fa-shopping-basket {
    --fa: "\\f291";
    --fa--fa: "\\f291\\f291"
}

.fa-tape {
    --fa: "\\f4db";
    --fa--fa: "\\f4db\\f4db"
}

.fa-bus-alt,
.fa-bus-simple {
    --fa: "\\f55e";
    --fa--fa: "\\f55e\\f55e"
}

.fa-eye {
    --fa: "\\f06e";
    --fa--fa: "\\f06e\\f06e"
}

.fa-face-sad-cry,
.fa-sad-cry {
    --fa: "\\f5b3";
    --fa--fa: "\\f5b3\\f5b3"
}

.fa-audio-description {
    --fa: "\\f29e";
    --fa--fa: "\\f29e\\f29e"
}

.fa-person-military-to-person {
    --fa: "\\e54c";
    --fa--fa: "\\e54c\\e54c"
}

.fa-file-shield {
    --fa: "\\e4f0";
    --fa--fa: "\\e4f0\\e4f0"
}

.fa-user-slash {
    --fa: "\\f506";
    --fa--fa: "\\f506\\f506"
}

.fa-pen {
    --fa: "\\f304";
    --fa--fa: "\\f304\\f304"
}

.fa-tower-observation {
    --fa: "\\e586";
    --fa--fa: "\\e586\\e586"
}

.fa-file-code {
    --fa: "\\f1c9";
    --fa--fa: "\\f1c9\\f1c9"
}

.fa-signal,
.fa-signal-5,
.fa-signal-perfect {
    --fa: "\\f012";
    --fa--fa: "\\f012\\f012"
}

.fa-bus {
    --fa: "\\f207";
    --fa--fa: "\\f207\\f207"
}

.fa-heart-circle-xmark {
    --fa: "\\e501";
    --fa--fa: "\\e501\\e501"
}

.fa-home-lg,
.fa-house-chimney {
    --fa: "\\e3af";
    --fa--fa: "\\e3af\\e3af"
}

.fa-window-maximize {
    --fa: "\\f2d0";
    --fa--fa: "\\f2d0\\f2d0"
}

.fa-face-frown,
.fa-frown {
    --fa: "\\f119";
    --fa--fa: "\\f119\\f119"
}

.fa-prescription {
    --fa: "\\f5b1";
    --fa--fa: "\\f5b1\\f5b1"
}

.fa-shop,
.fa-store-alt {
    --fa: "\\f54f";
    --fa--fa: "\\f54f\\f54f"
}

.fa-floppy-disk,
.fa-save {
    --fa: "\\f0c7";
    --fa--fa: "\\f0c7\\f0c7"
}

.fa-vihara {
    --fa: "\\f6a7";
    --fa--fa: "\\f6a7\\f6a7"
}

.fa-balance-scale-left,
.fa-scale-unbalanced {
    --fa: "\\f515";
    --fa--fa: "\\f515\\f515"
}

.fa-sort-asc,
.fa-sort-up {
    --fa: "\\f0de";
    --fa--fa: "\\f0de\\f0de"
}

.fa-comment-dots,
.fa-commenting {
    --fa: "\\f4ad";
    --fa--fa: "\\f4ad\\f4ad"
}

.fa-plant-wilt {
    --fa: "\\e5aa";
    --fa--fa: "\\e5aa\\e5aa"
}

.fa-diamond {
    --fa: "\\f219";
    --fa--fa: "\\f219\\f219"
}

.fa-face-grin-squint,
.fa-grin-squint {
    --fa: "\\f585";
    --fa--fa: "\\f585\\f585"
}

.fa-hand-holding-dollar,
.fa-hand-holding-usd {
    --fa: "\\f4c0";
    --fa--fa: "\\f4c0\\f4c0"
}

.fa-chart-diagram {
    --fa: "\\e695";
    --fa--fa: "\\e695\\e695"
}

.fa-bacterium {
    --fa: "\\e05a";
    --fa--fa: "\\e05a\\e05a"
}

.fa-hand-pointer {
    --fa: "\\f25a";
    --fa--fa: "\\f25a\\f25a"
}

.fa-drum-steelpan {
    --fa: "\\f56a";
    --fa--fa: "\\f56a\\f56a"
}

.fa-hand-scissors {
    --fa: "\\f257";
    --fa--fa: "\\f257\\f257"
}

.fa-hands-praying,
.fa-praying-hands {
    --fa: "\\f684";
    --fa--fa: "\\f684\\f684"
}

.fa-arrow-right-rotate,
.fa-arrow-rotate-forward,
.fa-arrow-rotate-right,
.fa-redo {
    --fa: "\\f01e";
    --fa--fa: "\\f01e\\f01e"
}

.fa-biohazard {
    --fa: "\\f780";
    --fa--fa: "\\f780\\f780"
}

.fa-location,
.fa-location-crosshairs {
    --fa: "\\f601";
    --fa--fa: "\\f601\\f601"
}

.fa-mars-double {
    --fa: "\\f227";
    --fa--fa: "\\f227\\f227"
}

.fa-child-dress {
    --fa: "\\e59c";
    --fa--fa: "\\e59c\\e59c"
}

.fa-users-between-lines {
    --fa: "\\e591";
    --fa--fa: "\\e591\\e591"
}

.fa-lungs-virus {
    --fa: "\\e067";
    --fa--fa: "\\e067\\e067"
}

.fa-face-grin-tears,
.fa-grin-tears {
    --fa: "\\f588";
    --fa--fa: "\\f588\\f588"
}

.fa-phone {
    --fa: "\\f095";
    --fa--fa: "\\f095\\f095"
}

.fa-calendar-times,
.fa-calendar-xmark {
    --fa: "\\f273";
    --fa--fa: "\\f273\\f273"
}

.fa-child-reaching {
    --fa: "\\e59d";
    --fa--fa: "\\e59d\\e59d"
}

.fa-head-side-virus {
    --fa: "\\e064";
    --fa--fa: "\\e064\\e064"
}

.fa-user-cog,
.fa-user-gear {
    --fa: "\\f4fe";
    --fa--fa: "\\f4fe\\f4fe"
}

.fa-arrow-up-1-9,
.fa-sort-numeric-up {
    --fa: "\\f163";
    --fa--fa: "\\f163\\f163"
}

.fa-door-closed {
    --fa: "\\f52a";
    --fa--fa: "\\f52a\\f52a"
}

.fa-shield-virus {
    --fa: "\\e06c";
    --fa--fa: "\\e06c\\e06c"
}

.fa-dice-six {
    --fa: "\\f526";
    --fa--fa: "\\f526\\f526"
}

.fa-mosquito-net {
    --fa: "\\e52c";
    --fa--fa: "\\e52c\\e52c"
}

.fa-file-fragment {
    --fa: "\\e697";
    --fa--fa: "\\e697\\e697"
}

.fa-bridge-water {
    --fa: "\\e4ce";
    --fa--fa: "\\e4ce\\e4ce"
}

.fa-person-booth {
    --fa: "\\f756";
    --fa--fa: "\\f756\\f756"
}

.fa-text-width {
    --fa: "\\f035";
    --fa--fa: "\\f035\\f035"
}

.fa-hat-wizard {
    --fa: "\\f6e8";
    --fa--fa: "\\f6e8\\f6e8"
}

.fa-pen-fancy {
    --fa: "\\f5ac";
    --fa--fa: "\\f5ac\\f5ac"
}

.fa-digging,
.fa-person-digging {
    --fa: "\\f85e";
    --fa--fa: "\\f85e\\f85e"
}

.fa-trash {
    --fa: "\\f1f8";
    --fa--fa: "\\f1f8\\f1f8"
}

.fa-gauge-simple,
.fa-gauge-simple-med,
.fa-tachometer-average {
    --fa: "\\f629";
    --fa--fa: "\\f629\\f629"
}

.fa-book-medical {
    --fa: "\\f7e6";
    --fa--fa: "\\f7e6\\f7e6"
}

.fa-poo {
    --fa: "\\f2fe";
    --fa--fa: "\\f2fe\\f2fe"
}

.fa-quote-right,
.fa-quote-right-alt {
    --fa: "\\f10e";
    --fa--fa: "\\f10e\\f10e"
}

.fa-shirt,
.fa-t-shirt,
.fa-tshirt {
    --fa: "\\f553";
    --fa--fa: "\\f553\\f553"
}

.fa-cubes {
    --fa: "\\f1b3";
    --fa--fa: "\\f1b3\\f1b3"
}

.fa-divide {
    --fa: "\\f529";
    --fa--fa: "\\f529\\f529"
}

.fa-tenge,
.fa-tenge-sign {
    --fa: "\\f7d7";
    --fa--fa: "\\f7d7\\f7d7"
}

.fa-headphones {
    --fa: "\\f025";
    --fa--fa: "\\f025\\f025"
}

.fa-hands-holding {
    --fa: "\\f4c2";
    --fa--fa: "\\f4c2\\f4c2"
}

.fa-hands-clapping {
    --fa: "\\e1a8";
    --fa--fa: "\\e1a8\\e1a8"
}

.fa-republican {
    --fa: "\\f75e";
    --fa--fa: "\\f75e\\f75e"
}

.fa-arrow-left {
    --fa: "\\f060";
    --fa--fa: "\\f060\\f060"
}

.fa-person-circle-xmark {
    --fa: "\\e543";
    --fa--fa: "\\e543\\e543"
}

.fa-ruler {
    --fa: "\\f545";
    --fa--fa: "\\f545\\f545"
}

.fa-align-left {
    --fa: "\\f036";
    --fa--fa: "\\f036\\f036"
}

.fa-dice-d6 {
    --fa: "\\f6d1";
    --fa--fa: "\\f6d1\\f6d1"
}

.fa-restroom {
    --fa: "\\f7bd";
    --fa--fa: "\\f7bd\\f7bd"
}

.fa-j {
    --fa: "\\4a";
    --fa--fa: "\\4a\\4a"
}

.fa-users-viewfinder {
    --fa: "\\e595";
    --fa--fa: "\\e595\\e595"
}

.fa-file-video {
    --fa: "\\f1c8";
    --fa--fa: "\\f1c8\\f1c8"
}

.fa-external-link-alt,
.fa-up-right-from-square {
    --fa: "\\f35d";
    --fa--fa: "\\f35d\\f35d"
}

.fa-table-cells,
.fa-th {
    --fa: "\\f00a";
    --fa--fa: "\\f00a\\f00a"
}

.fa-file-pdf {
    --fa: "\\f1c1";
    --fa--fa: "\\f1c1\\f1c1"
}

.fa-bible,
.fa-book-bible {
    --fa: "\\f647";
    --fa--fa: "\\f647\\f647"
}

.fa-o {
    --fa: "\\4f";
    --fa--fa: "\\4f\\4f"
}

.fa-medkit,
.fa-suitcase-medical {
    --fa: "\\f0fa";
    --fa--fa: "\\f0fa\\f0fa"
}

.fa-user-secret {
    --fa: "\\f21b";
    --fa--fa: "\\f21b\\f21b"
}

.fa-otter {
    --fa: "\\f700";
    --fa--fa: "\\f700\\f700"
}

.fa-female,
.fa-person-dress {
    --fa: "\\f182";
    --fa--fa: "\\f182\\f182"
}

.fa-comment-dollar {
    --fa: "\\f651";
    --fa--fa: "\\f651\\f651"
}

.fa-briefcase-clock,
.fa-business-time {
    --fa: "\\f64a";
    --fa--fa: "\\f64a\\f64a"
}

.fa-table-cells-large,
.fa-th-large {
    --fa: "\\f009";
    --fa--fa: "\\f009\\f009"
}

.fa-book-tanakh,
.fa-tanakh {
    --fa: "\\f827";
    --fa--fa: "\\f827\\f827"
}

.fa-phone-volume,
.fa-volume-control-phone {
    --fa: "\\f2a0";
    --fa--fa: "\\f2a0\\f2a0"
}

.fa-hat-cowboy-side {
    --fa: "\\f8c1";
    --fa--fa: "\\f8c1\\f8c1"
}

.fa-clipboard-user {
    --fa: "\\f7f3";
    --fa--fa: "\\f7f3\\f7f3"
}

.fa-child {
    --fa: "\\f1ae";
    --fa--fa: "\\f1ae\\f1ae"
}

.fa-lira-sign {
    --fa: "\\f195";
    --fa--fa: "\\f195\\f195"
}

.fa-satellite {
    --fa: "\\f7bf";
    --fa--fa: "\\f7bf\\f7bf"
}

.fa-plane-lock {
    --fa: "\\e558";
    --fa--fa: "\\e558\\e558"
}

.fa-tag {
    --fa: "\\f02b";
    --fa--fa: "\\f02b\\f02b"
}

.fa-comment {
    --fa: "\\f075";
    --fa--fa: "\\f075\\f075"
}

.fa-birthday-cake,
.fa-cake,
.fa-cake-candles {
    --fa: "\\f1fd";
    --fa--fa: "\\f1fd\\f1fd"
}

.fa-envelope {
    --fa: "\\f0e0";
    --fa--fa: "\\f0e0\\f0e0"
}

.fa-angle-double-up,
.fa-angles-up {
    --fa: "\\f102";
    --fa--fa: "\\f102\\f102"
}

.fa-paperclip {
    --fa: "\\f0c6";
    --fa--fa: "\\f0c6\\f0c6"
}

.fa-arrow-right-to-city {
    --fa: "\\e4b3";
    --fa--fa: "\\e4b3\\e4b3"
}

.fa-ribbon {
    --fa: "\\f4d6";
    --fa--fa: "\\f4d6\\f4d6"
}

.fa-lungs {
    --fa: "\\f604";
    --fa--fa: "\\f604\\f604"
}

.fa-arrow-up-9-1,
.fa-sort-numeric-up-alt {
    --fa: "\\f887";
    --fa--fa: "\\f887\\f887"
}

.fa-litecoin-sign {
    --fa: "\\e1d3";
    --fa--fa: "\\e1d3\\e1d3"
}

.fa-border-none {
    --fa: "\\f850";
    --fa--fa: "\\f850\\f850"
}

.fa-circle-nodes {
    --fa: "\\e4e2";
    --fa--fa: "\\e4e2\\e4e2"
}

.fa-parachute-box {
    --fa: "\\f4cd";
    --fa--fa: "\\f4cd\\f4cd"
}

.fa-indent {
    --fa: "\\f03c";
    --fa--fa: "\\f03c\\f03c"
}

.fa-truck-field-un {
    --fa: "\\e58e";
    --fa--fa: "\\e58e\\e58e"
}

.fa-hourglass,
.fa-hourglass-empty {
    --fa: "\\f254";
    --fa--fa: "\\f254\\f254"
}

.fa-mountain {
    --fa: "\\f6fc";
    --fa--fa: "\\f6fc\\f6fc"
}

.fa-user-doctor,
.fa-user-md {
    --fa: "\\f0f0";
    --fa--fa: "\\f0f0\\f0f0"
}

.fa-circle-info,
.fa-info-circle {
    --fa: "\\f05a";
    --fa--fa: "\\f05a\\f05a"
}

.fa-cloud-meatball {
    --fa: "\\f73b";
    --fa--fa: "\\f73b\\f73b"
}

.fa-camera,
.fa-camera-alt {
    --fa: "\\f030";
    --fa--fa: "\\f030\\f030"
}

.fa-square-virus {
    --fa: "\\e578";
    --fa--fa: "\\e578\\e578"
}

.fa-meteor {
    --fa: "\\f753";
    --fa--fa: "\\f753\\f753"
}

.fa-car-on {
    --fa: "\\e4dd";
    --fa--fa: "\\e4dd\\e4dd"
}

.fa-sleigh {
    --fa: "\\f7cc";
    --fa--fa: "\\f7cc\\f7cc"
}

.fa-arrow-down-1-9,
.fa-sort-numeric-asc,
.fa-sort-numeric-down {
    --fa: "\\f162";
    --fa--fa: "\\f162\\f162"
}

.fa-hand-holding-droplet,
.fa-hand-holding-water {
    --fa: "\\f4c1";
    --fa--fa: "\\f4c1\\f4c1"
}

.fa-water {
    --fa: "\\f773";
    --fa--fa: "\\f773\\f773"
}

.fa-calendar-check {
    --fa: "\\f274";
    --fa--fa: "\\f274\\f274"
}

.fa-braille {
    --fa: "\\f2a1";
    --fa--fa: "\\f2a1\\f2a1"
}

.fa-prescription-bottle-alt,
.fa-prescription-bottle-medical {
    --fa: "\\f486";
    --fa--fa: "\\f486\\f486"
}

.fa-landmark {
    --fa: "\\f66f";
    --fa--fa: "\\f66f\\f66f"
}

.fa-truck {
    --fa: "\\f0d1";
    --fa--fa: "\\f0d1\\f0d1"
}

.fa-crosshairs {
    --fa: "\\f05b";
    --fa--fa: "\\f05b\\f05b"
}

.fa-person-cane {
    --fa: "\\e53c";
    --fa--fa: "\\e53c\\e53c"
}

.fa-tent {
    --fa: "\\e57d";
    --fa--fa: "\\e57d\\e57d"
}

.fa-vest-patches {
    --fa: "\\e086";
    --fa--fa: "\\e086\\e086"
}

.fa-check-double {
    --fa: "\\f560";
    --fa--fa: "\\f560\\f560"
}

.fa-arrow-down-a-z,
.fa-sort-alpha-asc,
.fa-sort-alpha-down {
    --fa: "\\f15d";
    --fa--fa: "\\f15d\\f15d"
}

.fa-money-bill-wheat {
    --fa: "\\e52a";
    --fa--fa: "\\e52a\\e52a"
}

.fa-cookie {
    --fa: "\\f563";
    --fa--fa: "\\f563\\f563"
}

.fa-arrow-left-rotate,
.fa-arrow-rotate-back,
.fa-arrow-rotate-backward,
.fa-arrow-rotate-left,
.fa-undo {
    --fa: "\\f0e2";
    --fa--fa: "\\f0e2\\f0e2"
}

.fa-hard-drive,
.fa-hdd {
    --fa: "\\f0a0";
    --fa--fa: "\\f0a0\\f0a0"
}

.fa-face-grin-squint-tears,
.fa-grin-squint-tears {
    --fa: "\\f586";
    --fa--fa: "\\f586\\f586"
}

.fa-dumbbell {
    --fa: "\\f44b";
    --fa--fa: "\\f44b\\f44b"
}

.fa-list-alt,
.fa-rectangle-list {
    --fa: "\\f022";
    --fa--fa: "\\f022\\f022"
}

.fa-tarp-droplet {
    --fa: "\\e57c";
    --fa--fa: "\\e57c\\e57c"
}

.fa-house-medical-circle-check {
    --fa: "\\e511";
    --fa--fa: "\\e511\\e511"
}

.fa-person-skiing-nordic,
.fa-skiing-nordic {
    --fa: "\\f7ca";
    --fa--fa: "\\f7ca\\f7ca"
}

.fa-calendar-plus {
    --fa: "\\f271";
    --fa--fa: "\\f271\\f271"
}

.fa-plane-arrival {
    --fa: "\\f5af";
    --fa--fa: "\\f5af\\f5af"
}

.fa-arrow-alt-circle-left,
.fa-circle-left {
    --fa: "\\f359";
    --fa--fa: "\\f359\\f359"
}

.fa-subway,
.fa-train-subway {
    --fa: "\\f239";
    --fa--fa: "\\f239\\f239"
}

.fa-chart-gantt {
    --fa: "\\e0e4";
    --fa--fa: "\\e0e4\\e0e4"
}

.fa-indian-rupee,
.fa-indian-rupee-sign,
.fa-inr {
    --fa: "\\e1bc";
    --fa--fa: "\\e1bc\\e1bc"
}

.fa-crop-alt,
.fa-crop-simple {
    --fa: "\\f565";
    --fa--fa: "\\f565\\f565"
}

.fa-money-bill-1,
.fa-money-bill-alt {
    --fa: "\\f3d1";
    --fa--fa: "\\f3d1\\f3d1"
}

.fa-left-long,
.fa-long-arrow-alt-left {
    --fa: "\\f30a";
    --fa--fa: "\\f30a\\f30a"
}

.fa-dna {
    --fa: "\\f471";
    --fa--fa: "\\f471\\f471"
}

.fa-virus-slash {
    --fa: "\\e075";
    --fa--fa: "\\e075\\e075"
}

.fa-minus,
.fa-subtract {
    --fa: "\\f068";
    --fa--fa: "\\f068\\f068"
}

.fa-chess {
    --fa: "\\f439";
    --fa--fa: "\\f439\\f439"
}

.fa-arrow-left-long,
.fa-long-arrow-left {
    --fa: "\\f177";
    --fa--fa: "\\f177\\f177"
}

.fa-plug-circle-check {
    --fa: "\\e55c";
    --fa--fa: "\\e55c\\e55c"
}

.fa-street-view {
    --fa: "\\f21d";
    --fa--fa: "\\f21d\\f21d"
}

.fa-franc-sign {
    --fa: "\\e18f";
    --fa--fa: "\\e18f\\e18f"
}

.fa-volume-off {
    --fa: "\\f026";
    --fa--fa: "\\f026\\f026"
}

.fa-american-sign-language-interpreting,
.fa-asl-interpreting,
.fa-hands-american-sign-language-interpreting,
.fa-hands-asl-interpreting {
    --fa: "\\f2a3";
    --fa--fa: "\\f2a3\\f2a3"
}

.fa-cog,
.fa-gear {
    --fa: "\\f013";
    --fa--fa: "\\f013\\f013"
}

.fa-droplet-slash,
.fa-tint-slash {
    --fa: "\\f5c7";
    --fa--fa: "\\f5c7\\f5c7"
}

.fa-mosque {
    --fa: "\\f678";
    --fa--fa: "\\f678\\f678"
}

.fa-mosquito {
    --fa: "\\e52b";
    --fa--fa: "\\e52b\\e52b"
}

.fa-star-of-david {
    --fa: "\\f69a";
    --fa--fa: "\\f69a\\f69a"
}

.fa-person-military-rifle {
    --fa: "\\e54b";
    --fa--fa: "\\e54b\\e54b"
}

.fa-cart-shopping,
.fa-shopping-cart {
    --fa: "\\f07a";
    --fa--fa: "\\f07a\\f07a"
}

.fa-vials {
    --fa: "\\f493";
    --fa--fa: "\\f493\\f493"
}

.fa-plug-circle-plus {
    --fa: "\\e55f";
    --fa--fa: "\\e55f\\e55f"
}

.fa-place-of-worship {
    --fa: "\\f67f";
    --fa--fa: "\\f67f\\f67f"
}

.fa-grip-vertical {
    --fa: "\\f58e";
    --fa--fa: "\\f58e\\f58e"
}

.fa-hexagon-nodes {
    --fa: "\\e699";
    --fa--fa: "\\e699\\e699"
}

.fa-arrow-turn-up,
.fa-level-up {
    --fa: "\\f148";
    --fa--fa: "\\f148\\f148"
}

.fa-u {
    --fa: "\\55";
    --fa--fa: "\\55\\55"
}

.fa-square-root-alt,
.fa-square-root-variable {
    --fa: "\\f698";
    --fa--fa: "\\f698\\f698"
}

.fa-clock,
.fa-clock-four {
    --fa: "\\f017";
    --fa--fa: "\\f017\\f017"
}

.fa-backward-step,
.fa-step-backward {
    --fa: "\\f048";
    --fa--fa: "\\f048\\f048"
}

.fa-pallet {
    --fa: "\\f482";
    --fa--fa: "\\f482\\f482"
}

.fa-faucet {
    --fa: "\\e005";
    --fa--fa: "\\e005\\e005"
}

.fa-baseball-bat-ball {
    --fa: "\\f432";
    --fa--fa: "\\f432\\f432"
}

.fa-s {
    --fa: "\\53";
    --fa--fa: "\\53\\53"
}

.fa-timeline {
    --fa: "\\e29c";
    --fa--fa: "\\e29c\\e29c"
}

.fa-keyboard {
    --fa: "\\f11c";
    --fa--fa: "\\f11c\\f11c"
}

.fa-caret-down {
    --fa: "\\f0d7";
    --fa--fa: "\\f0d7\\f0d7"
}

.fa-clinic-medical,
.fa-house-chimney-medical {
    --fa: "\\f7f2";
    --fa--fa: "\\f7f2\\f7f2"
}

.fa-temperature-3,
.fa-temperature-three-quarters,
.fa-thermometer-3,
.fa-thermometer-three-quarters {
    --fa: "\\f2c8";
    --fa--fa: "\\f2c8\\f2c8"
}

.fa-mobile-android-alt,
.fa-mobile-screen {
    --fa: "\\f3cf";
    --fa--fa: "\\f3cf\\f3cf"
}

.fa-plane-up {
    --fa: "\\e22d";
    --fa--fa: "\\e22d\\e22d"
}

.fa-piggy-bank {
    --fa: "\\f4d3";
    --fa--fa: "\\f4d3\\f4d3"
}

.fa-battery-3,
.fa-battery-half {
    --fa: "\\f242";
    --fa--fa: "\\f242\\f242"
}

.fa-mountain-city {
    --fa: "\\e52e";
    --fa--fa: "\\e52e\\e52e"
}

.fa-coins {
    --fa: "\\f51e";
    --fa--fa: "\\f51e\\f51e"
}

.fa-khanda {
    --fa: "\\f66d";
    --fa--fa: "\\f66d\\f66d"
}

.fa-sliders,
.fa-sliders-h {
    --fa: "\\f1de";
    --fa--fa: "\\f1de\\f1de"
}

.fa-folder-tree {
    --fa: "\\f802";
    --fa--fa: "\\f802\\f802"
}

.fa-network-wired {
    --fa: "\\f6ff";
    --fa--fa: "\\f6ff\\f6ff"
}

.fa-map-pin {
    --fa: "\\f276";
    --fa--fa: "\\f276\\f276"
}

.fa-hamsa {
    --fa: "\\f665";
    --fa--fa: "\\f665\\f665"
}

.fa-cent-sign {
    --fa: "\\e3f5";
    --fa--fa: "\\e3f5\\e3f5"
}

.fa-flask {
    --fa: "\\f0c3";
    --fa--fa: "\\f0c3\\f0c3"
}

.fa-person-pregnant {
    --fa: "\\e31e";
    --fa--fa: "\\e31e\\e31e"
}

.fa-wand-sparkles {
    --fa: "\\f72b";
    --fa--fa: "\\f72b\\f72b"
}

.fa-ellipsis-v,
.fa-ellipsis-vertical {
    --fa: "\\f142";
    --fa--fa: "\\f142\\f142"
}

.fa-ticket {
    --fa: "\\f145";
    --fa--fa: "\\f145\\f145"
}

.fa-power-off {
    --fa: "\\f011";
    --fa--fa: "\\f011\\f011"
}

.fa-long-arrow-alt-right,
.fa-right-long {
    --fa: "\\f30b";
    --fa--fa: "\\f30b\\f30b"
}

.fa-flag-usa {
    --fa: "\\f74d";
    --fa--fa: "\\f74d\\f74d"
}

.fa-laptop-file {
    --fa: "\\e51d";
    --fa--fa: "\\e51d\\e51d"
}

.fa-teletype,
.fa-tty {
    --fa: "\\f1e4";
    --fa--fa: "\\f1e4\\f1e4"
}

.fa-diagram-next {
    --fa: "\\e476";
    --fa--fa: "\\e476\\e476"
}

.fa-person-rifle {
    --fa: "\\e54e";
    --fa--fa: "\\e54e\\e54e"
}

.fa-house-medical-circle-exclamation {
    --fa: "\\e512";
    --fa--fa: "\\e512\\e512"
}

.fa-closed-captioning {
    --fa: "\\f20a";
    --fa--fa: "\\f20a\\f20a"
}

.fa-hiking,
.fa-person-hiking {
    --fa: "\\f6ec";
    --fa--fa: "\\f6ec\\f6ec"
}

.fa-venus-double {
    --fa: "\\f226";
    --fa--fa: "\\f226\\f226"
}

.fa-images {
    --fa: "\\f302";
    --fa--fa: "\\f302\\f302"
}

.fa-calculator {
    --fa: "\\f1ec";
    --fa--fa: "\\f1ec\\f1ec"
}

.fa-people-pulling {
    --fa: "\\e535";
    --fa--fa: "\\e535\\e535"
}

.fa-n {
    --fa: "\\4e";
    --fa--fa: "\\4e\\4e"
}

.fa-cable-car,
.fa-tram {
    --fa: "\\f7da";
    --fa--fa: "\\f7da\\f7da"
}

.fa-cloud-rain {
    --fa: "\\f73d";
    --fa--fa: "\\f73d\\f73d"
}

.fa-building-circle-xmark {
    --fa: "\\e4d4";
    --fa--fa: "\\e4d4\\e4d4"
}

.fa-ship {
    --fa: "\\f21a";
    --fa--fa: "\\f21a\\f21a"
}

.fa-arrows-down-to-line {
    --fa: "\\e4b8";
    --fa--fa: "\\e4b8\\e4b8"
}

.fa-download {
    --fa: "\\f019";
    --fa--fa: "\\f019\\f019"
}

.fa-face-grin,
.fa-grin {
    --fa: "\\f580";
    --fa--fa: "\\f580\\f580"
}

.fa-backspace,
.fa-delete-left {
    --fa: "\\f55a";
    --fa--fa: "\\f55a\\f55a"
}

.fa-eye-dropper,
.fa-eye-dropper-empty,
.fa-eyedropper {
    --fa: "\\f1fb";
    --fa--fa: "\\f1fb\\f1fb"
}

.fa-file-circle-check {
    --fa: "\\e5a0";
    --fa--fa: "\\e5a0\\e5a0"
}

.fa-forward {
    --fa: "\\f04e";
    --fa--fa: "\\f04e\\f04e"
}

.fa-mobile,
.fa-mobile-android,
.fa-mobile-phone {
    --fa: "\\f3ce";
    --fa--fa: "\\f3ce\\f3ce"
}

.fa-face-meh,
.fa-meh {
    --fa: "\\f11a";
    --fa--fa: "\\f11a\\f11a"
}

.fa-align-center {
    --fa: "\\f037";
    --fa--fa: "\\f037\\f037"
}

.fa-book-dead,
.fa-book-skull {
    --fa: "\\f6b7";
    --fa--fa: "\\f6b7\\f6b7"
}

.fa-drivers-license,
.fa-id-card {
    --fa: "\\f2c2";
    --fa--fa: "\\f2c2\\f2c2"
}

.fa-dedent,
.fa-outdent {
    --fa: "\\f03b";
    --fa--fa: "\\f03b\\f03b"
}

.fa-heart-circle-exclamation {
    --fa: "\\e4fe";
    --fa--fa: "\\e4fe\\e4fe"
}

.fa-home,
.fa-home-alt,
.fa-home-lg-alt,
.fa-house {
    --fa: "\\f015";
    --fa--fa: "\\f015\\f015"
}

.fa-calendar-week {
    --fa: "\\f784";
    --fa--fa: "\\f784\\f784"
}

.fa-laptop-medical {
    --fa: "\\f812";
    --fa--fa: "\\f812\\f812"
}

.fa-b {
    --fa: "\\42";
    --fa--fa: "\\42\\42"
}

.fa-file-medical {
    --fa: "\\f477";
    --fa--fa: "\\f477\\f477"
}

.fa-dice-one {
    --fa: "\\f525";
    --fa--fa: "\\f525\\f525"
}

.fa-kiwi-bird {
    --fa: "\\f535";
    --fa--fa: "\\f535\\f535"
}

.fa-arrow-right-arrow-left,
.fa-exchange {
    --fa: "\\f0ec";
    --fa--fa: "\\f0ec\\f0ec"
}

.fa-redo-alt,
.fa-rotate-forward,
.fa-rotate-right {
    --fa: "\\f2f9";
    --fa--fa: "\\f2f9\\f2f9"
}

.fa-cutlery,
.fa-utensils {
    --fa: "\\f2e7";
    --fa--fa: "\\f2e7\\f2e7"
}

.fa-arrow-up-wide-short,
.fa-sort-amount-up {
    --fa: "\\f161";
    --fa--fa: "\\f161\\f161"
}

.fa-mill-sign {
    --fa: "\\e1ed";
    --fa--fa: "\\e1ed\\e1ed"
}

.fa-bowl-rice {
    --fa: "\\e2eb";
    --fa--fa: "\\e2eb\\e2eb"
}

.fa-skull {
    --fa: "\\f54c";
    --fa--fa: "\\f54c\\f54c"
}

.fa-broadcast-tower,
.fa-tower-broadcast {
    --fa: "\\f519";
    --fa--fa: "\\f519\\f519"
}

.fa-truck-pickup {
    --fa: "\\f63c";
    --fa--fa: "\\f63c\\f63c"
}

.fa-long-arrow-alt-up,
.fa-up-long {
    --fa: "\\f30c";
    --fa--fa: "\\f30c\\f30c"
}

.fa-stop {
    --fa: "\\f04d";
    --fa--fa: "\\f04d\\f04d"
}

.fa-code-merge {
    --fa: "\\f387";
    --fa--fa: "\\f387\\f387"
}

.fa-upload {
    --fa: "\\f093";
    --fa--fa: "\\f093\\f093"
}

.fa-hurricane {
    --fa: "\\f751";
    --fa--fa: "\\f751\\f751"
}

.fa-mound {
    --fa: "\\e52d";
    --fa--fa: "\\e52d\\e52d"
}

.fa-toilet-portable {
    --fa: "\\e583";
    --fa--fa: "\\e583\\e583"
}

.fa-compact-disc {
    --fa: "\\f51f";
    --fa--fa: "\\f51f\\f51f"
}

.fa-file-arrow-down,
.fa-file-download {
    --fa: "\\f56d";
    --fa--fa: "\\f56d\\f56d"
}

.fa-caravan {
    --fa: "\\f8ff";
    --fa--fa: "\\f8ff\\f8ff"
}

.fa-shield-cat {
    --fa: "\\e572";
    --fa--fa: "\\e572\\e572"
}

.fa-bolt,
.fa-zap {
    --fa: "\\f0e7";
    --fa--fa: "\\f0e7\\f0e7"
}

.fa-glass-water {
    --fa: "\\e4f4";
    --fa--fa: "\\e4f4\\e4f4"
}

.fa-oil-well {
    --fa: "\\e532";
    --fa--fa: "\\e532\\e532"
}

.fa-vault {
    --fa: "\\e2c5";
    --fa--fa: "\\e2c5\\e2c5"
}

.fa-mars {
    --fa: "\\f222";
    --fa--fa: "\\f222\\f222"
}

.fa-toilet {
    --fa: "\\f7d8";
    --fa--fa: "\\f7d8\\f7d8"
}

.fa-plane-circle-xmark {
    --fa: "\\e557";
    --fa--fa: "\\e557\\e557"
}

.fa-cny,
.fa-jpy,
.fa-rmb,
.fa-yen,
.fa-yen-sign {
    --fa: "\\f157";
    --fa--fa: "\\f157\\f157"
}

.fa-rouble,
.fa-rub,
.fa-ruble,
.fa-ruble-sign {
    --fa: "\\f158";
    --fa--fa: "\\f158\\f158"
}

.fa-sun {
    --fa: "\\f185";
    --fa--fa: "\\f185\\f185"
}

.fa-guitar {
    --fa: "\\f7a6";
    --fa--fa: "\\f7a6\\f7a6"
}

.fa-face-laugh-wink,
.fa-laugh-wink {
    --fa: "\\f59c";
    --fa--fa: "\\f59c\\f59c"
}

.fa-horse-head {
    --fa: "\\f7ab";
    --fa--fa: "\\f7ab\\f7ab"
}

.fa-bore-hole {
    --fa: "\\e4c3";
    --fa--fa: "\\e4c3\\e4c3"
}

.fa-industry {
    --fa: "\\f275";
    --fa--fa: "\\f275\\f275"
}

.fa-arrow-alt-circle-down,
.fa-circle-down {
    --fa: "\\f358";
    --fa--fa: "\\f358\\f358"
}

.fa-arrows-turn-to-dots {
    --fa: "\\e4c1";
    --fa--fa: "\\e4c1\\e4c1"
}

.fa-florin-sign {
    --fa: "\\e184";
    --fa--fa: "\\e184\\e184"
}

.fa-arrow-down-short-wide,
.fa-sort-amount-desc,
.fa-sort-amount-down-alt {
    --fa: "\\f884";
    --fa--fa: "\\f884\\f884"
}

.fa-less-than {
    --fa: "\\3c";
    --fa--fa: "\\3c\\3c"
}

.fa-angle-down {
    --fa: "\\f107";
    --fa--fa: "\\f107\\f107"
}

.fa-car-tunnel {
    --fa: "\\e4de";
    --fa--fa: "\\e4de\\e4de"
}

.fa-head-side-cough {
    --fa: "\\e061";
    --fa--fa: "\\e061\\e061"
}

.fa-grip-lines {
    --fa: "\\f7a4";
    --fa--fa: "\\f7a4\\f7a4"
}

.fa-thumbs-down {
    --fa: "\\f165";
    --fa--fa: "\\f165\\f165"
}

.fa-user-lock {
    --fa: "\\f502";
    --fa--fa: "\\f502\\f502"
}

.fa-arrow-right-long,
.fa-long-arrow-right {
    --fa: "\\f178";
    --fa--fa: "\\f178\\f178"
}

.fa-anchor-circle-xmark {
    --fa: "\\e4ac";
    --fa--fa: "\\e4ac\\e4ac"
}

.fa-ellipsis,
.fa-ellipsis-h {
    --fa: "\\f141";
    --fa--fa: "\\f141\\f141"
}

.fa-chess-pawn {
    --fa: "\\f443";
    --fa--fa: "\\f443\\f443"
}

.fa-first-aid,
.fa-kit-medical {
    --fa: "\\f479";
    --fa--fa: "\\f479\\f479"
}

.fa-person-through-window {
    --fa: "\\e5a9";
    --fa--fa: "\\e5a9\\e5a9"
}

.fa-toolbox {
    --fa: "\\f552";
    --fa--fa: "\\f552\\f552"
}

.fa-hands-holding-circle {
    --fa: "\\e4fb";
    --fa--fa: "\\e4fb\\e4fb"
}

.fa-bug {
    --fa: "\\f188";
    --fa--fa: "\\f188\\f188"
}

.fa-credit-card,
.fa-credit-card-alt {
    --fa: "\\f09d";
    --fa--fa: "\\f09d\\f09d"
}

.fa-automobile,
.fa-car {
    --fa: "\\f1b9";
    --fa--fa: "\\f1b9\\f1b9"
}

.fa-hand-holding-hand {
    --fa: "\\e4f7";
    --fa--fa: "\\e4f7\\e4f7"
}

.fa-book-open-reader,
.fa-book-reader {
    --fa: "\\f5da";
    --fa--fa: "\\f5da\\f5da"
}

.fa-mountain-sun {
    --fa: "\\e52f";
    --fa--fa: "\\e52f\\e52f"
}

.fa-arrows-left-right-to-line {
    --fa: "\\e4ba";
    --fa--fa: "\\e4ba\\e4ba"
}

.fa-dice-d20 {
    --fa: "\\f6cf";
    --fa--fa: "\\f6cf\\f6cf"
}

.fa-truck-droplet {
    --fa: "\\e58c";
    --fa--fa: "\\e58c\\e58c"
}

.fa-file-circle-xmark {
    --fa: "\\e5a1";
    --fa--fa: "\\e5a1\\e5a1"
}

.fa-temperature-arrow-up,
.fa-temperature-up {
    --fa: "\\e040";
    --fa--fa: "\\e040\\e040"
}

.fa-medal {
    --fa: "\\f5a2";
    --fa--fa: "\\f5a2\\f5a2"
}

.fa-bed {
    --fa: "\\f236";
    --fa--fa: "\\f236\\f236"
}

.fa-h-square,
.fa-square-h {
    --fa: "\\f0fd";
    --fa--fa: "\\f0fd\\f0fd"
}

.fa-podcast {
    --fa: "\\f2ce";
    --fa--fa: "\\f2ce\\f2ce"
}

.fa-temperature-4,
.fa-temperature-full,
.fa-thermometer-4,
.fa-thermometer-full {
    --fa: "\\f2c7";
    --fa--fa: "\\f2c7\\f2c7"
}

.fa-bell {
    --fa: "\\f0f3";
    --fa--fa: "\\f0f3\\f0f3"
}

.fa-superscript {
    --fa: "\\f12b";
    --fa--fa: "\\f12b\\f12b"
}

.fa-plug-circle-xmark {
    --fa: "\\e560";
    --fa--fa: "\\e560\\e560"
}

.fa-star-of-life {
    --fa: "\\f621";
    --fa--fa: "\\f621\\f621"
}

.fa-phone-slash {
    --fa: "\\f3dd";
    --fa--fa: "\\f3dd\\f3dd"
}

.fa-paint-roller {
    --fa: "\\f5aa";
    --fa--fa: "\\f5aa\\f5aa"
}

.fa-hands-helping,
.fa-handshake-angle {
    --fa: "\\f4c4";
    --fa--fa: "\\f4c4\\f4c4"
}

.fa-location-dot,
.fa-map-marker-alt {
    --fa: "\\f3c5";
    --fa--fa: "\\f3c5\\f3c5"
}

.fa-file {
    --fa: "\\f15b";
    --fa--fa: "\\f15b\\f15b"
}

.fa-greater-than {
    --fa: "\\3e";
    --fa--fa: "\\3e\\3e"
}

.fa-person-swimming,
.fa-swimmer {
    --fa: "\\f5c4";
    --fa--fa: "\\f5c4\\f5c4"
}

.fa-arrow-down {
    --fa: "\\f063";
    --fa--fa: "\\f063\\f063"
}

.fa-droplet,
.fa-tint {
    --fa: "\\f043";
    --fa--fa: "\\f043\\f043"
}

.fa-eraser {
    --fa: "\\f12d";
    --fa--fa: "\\f12d\\f12d"
}

.fa-earth,
.fa-earth-america,
.fa-earth-americas,
.fa-globe-americas {
    --fa: "\\f57d";
    --fa--fa: "\\f57d\\f57d"
}

.fa-person-burst {
    --fa: "\\e53b";
    --fa--fa: "\\e53b\\e53b"
}

.fa-dove {
    --fa: "\\f4ba";
    --fa--fa: "\\f4ba\\f4ba"
}

.fa-battery-0,
.fa-battery-empty {
    --fa: "\\f244";
    --fa--fa: "\\f244\\f244"
}

.fa-socks {
    --fa: "\\f696";
    --fa--fa: "\\f696\\f696"
}

.fa-inbox {
    --fa: "\\f01c";
    --fa--fa: "\\f01c\\f01c"
}

.fa-section {
    --fa: "\\e447";
    --fa--fa: "\\e447\\e447"
}

.fa-gauge-high,
.fa-tachometer-alt,
.fa-tachometer-alt-fast {
    --fa: "\\f625";
    --fa--fa: "\\f625\\f625"
}

.fa-envelope-open-text {
    --fa: "\\f658";
    --fa--fa: "\\f658\\f658"
}

.fa-hospital,
.fa-hospital-alt,
.fa-hospital-wide {
    --fa: "\\f0f8";
    --fa--fa: "\\f0f8\\f0f8"
}

.fa-wine-bottle {
    --fa: "\\f72f";
    --fa--fa: "\\f72f\\f72f"
}

.fa-chess-rook {
    --fa: "\\f447";
    --fa--fa: "\\f447\\f447"
}

.fa-bars-staggered,
.fa-reorder,
.fa-stream {
    --fa: "\\f550";
    --fa--fa: "\\f550\\f550"
}

.fa-dharmachakra {
    --fa: "\\f655";
    --fa--fa: "\\f655\\f655"
}

.fa-hotdog {
    --fa: "\\f80f";
    --fa--fa: "\\f80f\\f80f"
}

.fa-blind,
.fa-person-walking-with-cane {
    --fa: "\\f29d";
    --fa--fa: "\\f29d\\f29d"
}

.fa-drum {
    --fa: "\\f569";
    --fa--fa: "\\f569\\f569"
}

.fa-ice-cream {
    --fa: "\\f810";
    --fa--fa: "\\f810\\f810"
}

.fa-heart-circle-bolt {
    --fa: "\\e4fc";
    --fa--fa: "\\e4fc\\e4fc"
}

.fa-fax {
    --fa: "\\f1ac";
    --fa--fa: "\\f1ac\\f1ac"
}

.fa-paragraph {
    --fa: "\\f1dd";
    --fa--fa: "\\f1dd\\f1dd"
}

.fa-check-to-slot,
.fa-vote-yea {
    --fa: "\\f772";
    --fa--fa: "\\f772\\f772"
}

.fa-star-half {
    --fa: "\\f089";
    --fa--fa: "\\f089\\f089"
}

.fa-boxes,
.fa-boxes-alt,
.fa-boxes-stacked {
    --fa: "\\f468";
    --fa--fa: "\\f468\\f468"
}

.fa-chain,
.fa-link {
    --fa: "\\f0c1";
    --fa--fa: "\\f0c1\\f0c1"
}

.fa-assistive-listening-systems,
.fa-ear-listen {
    --fa: "\\f2a2";
    --fa--fa: "\\f2a2\\f2a2"
}

.fa-tree-city {
    --fa: "\\e587";
    --fa--fa: "\\e587\\e587"
}

.fa-play {
    --fa: "\\f04b";
    --fa--fa: "\\f04b\\f04b"
}

.fa-font {
    --fa: "\\f031";
    --fa--fa: "\\f031\\f031"
}

.fa-table-cells-row-lock {
    --fa: "\\e67a";
    --fa--fa: "\\e67a\\e67a"
}

.fa-rupiah-sign {
    --fa: "\\e23d";
    --fa--fa: "\\e23d\\e23d"
}

.fa-magnifying-glass,
.fa-search {
    --fa: "\\f002";
    --fa--fa: "\\f002\\f002"
}

.fa-ping-pong-paddle-ball,
.fa-table-tennis,
.fa-table-tennis-paddle-ball {
    --fa: "\\f45d";
    --fa--fa: "\\f45d\\f45d"
}

.fa-diagnoses,
.fa-person-dots-from-line {
    --fa: "\\f470";
    --fa--fa: "\\f470\\f470"
}

.fa-trash-can-arrow-up,
.fa-trash-restore-alt {
    --fa: "\\f82a";
    --fa--fa: "\\f82a\\f82a"
}

.fa-naira-sign {
    --fa: "\\e1f6";
    --fa--fa: "\\e1f6\\e1f6"
}

.fa-cart-arrow-down {
    --fa: "\\f218";
    --fa--fa: "\\f218\\f218"
}

.fa-walkie-talkie {
    --fa: "\\f8ef";
    --fa--fa: "\\f8ef\\f8ef"
}

.fa-file-edit,
.fa-file-pen {
    --fa: "\\f31c";
    --fa--fa: "\\f31c\\f31c"
}

.fa-receipt {
    --fa: "\\f543";
    --fa--fa: "\\f543\\f543"
}

.fa-pen-square,
.fa-pencil-square,
.fa-square-pen {
    --fa: "\\f14b";
    --fa--fa: "\\f14b\\f14b"
}

.fa-suitcase-rolling {
    --fa: "\\f5c1";
    --fa--fa: "\\f5c1\\f5c1"
}

.fa-person-circle-exclamation {
    --fa: "\\e53f";
    --fa--fa: "\\e53f\\e53f"
}

.fa-chevron-down {
    --fa: "\\f078";
    --fa--fa: "\\f078\\f078"
}

.fa-battery,
.fa-battery-5,
.fa-battery-full {
    --fa: "\\f240";
    --fa--fa: "\\f240\\f240"
}

.fa-skull-crossbones {
    --fa: "\\f714";
    --fa--fa: "\\f714\\f714"
}

.fa-code-compare {
    --fa: "\\e13a";
    --fa--fa: "\\e13a\\e13a"
}

.fa-list-dots,
.fa-list-ul {
    --fa: "\\f0ca";
    --fa--fa: "\\f0ca\\f0ca"
}

.fa-school-lock {
    --fa: "\\e56f";
    --fa--fa: "\\e56f\\e56f"
}

.fa-tower-cell {
    --fa: "\\e585";
    --fa--fa: "\\e585\\e585"
}

.fa-down-long,
.fa-long-arrow-alt-down {
    --fa: "\\f309";
    --fa--fa: "\\f309\\f309"
}

.fa-ranking-star {
    --fa: "\\e561";
    --fa--fa: "\\e561\\e561"
}

.fa-chess-king {
    --fa: "\\f43f";
    --fa--fa: "\\f43f\\f43f"
}

.fa-person-harassing {
    --fa: "\\e549";
    --fa--fa: "\\e549\\e549"
}

.fa-brazilian-real-sign {
    --fa: "\\e46c";
    --fa--fa: "\\e46c\\e46c"
}

.fa-landmark-alt,
.fa-landmark-dome {
    --fa: "\\f752";
    --fa--fa: "\\f752\\f752"
}

.fa-arrow-up {
    --fa: "\\f062";
    --fa--fa: "\\f062\\f062"
}

.fa-television,
.fa-tv,
.fa-tv-alt {
    --fa: "\\f26c";
    --fa--fa: "\\f26c\\f26c"
}

.fa-shrimp {
    --fa: "\\e448";
    --fa--fa: "\\e448\\e448"
}

.fa-list-check,
.fa-tasks {
    --fa: "\\f0ae";
    --fa--fa: "\\f0ae\\f0ae"
}

.fa-jug-detergent {
    --fa: "\\e519";
    --fa--fa: "\\e519\\e519"
}

.fa-circle-user,
.fa-user-circle {
    --fa: "\\f2bd";
    --fa--fa: "\\f2bd\\f2bd"
}

.fa-user-shield {
    --fa: "\\f505";
    --fa--fa: "\\f505\\f505"
}

.fa-wind {
    --fa: "\\f72e";
    --fa--fa: "\\f72e\\f72e"
}

.fa-car-burst,
.fa-car-crash {
    --fa: "\\f5e1";
    --fa--fa: "\\f5e1\\f5e1"
}

.fa-y {
    --fa: "\\59";
    --fa--fa: "\\59\\59"
}

.fa-person-snowboarding,
.fa-snowboarding {
    --fa: "\\f7ce";
    --fa--fa: "\\f7ce\\f7ce"
}

.fa-shipping-fast,
.fa-truck-fast {
    --fa: "\\f48b";
    --fa--fa: "\\f48b\\f48b"
}

.fa-fish {
    --fa: "\\f578";
    --fa--fa: "\\f578\\f578"
}

.fa-user-graduate {
    --fa: "\\f501";
    --fa--fa: "\\f501\\f501"
}

.fa-adjust,
.fa-circle-half-stroke {
    --fa: "\\f042";
    --fa--fa: "\\f042\\f042"
}

.fa-clapperboard {
    --fa: "\\e131";
    --fa--fa: "\\e131\\e131"
}

.fa-circle-radiation,
.fa-radiation-alt {
    --fa: "\\f7ba";
    --fa--fa: "\\f7ba\\f7ba"
}

.fa-baseball,
.fa-baseball-ball {
    --fa: "\\f433";
    --fa--fa: "\\f433\\f433"
}

.fa-jet-fighter-up {
    --fa: "\\e518";
    --fa--fa: "\\e518\\e518"
}

.fa-diagram-project,
.fa-project-diagram {
    --fa: "\\f542";
    --fa--fa: "\\f542\\f542"
}

.fa-copy {
    --fa: "\\f0c5";
    --fa--fa: "\\f0c5\\f0c5"
}

.fa-volume-mute,
.fa-volume-times,
.fa-volume-xmark {
    --fa: "\\f6a9";
    --fa--fa: "\\f6a9\\f6a9"
}

.fa-hand-sparkles {
    --fa: "\\e05d";
    --fa--fa: "\\e05d\\e05d"
}

.fa-grip,
.fa-grip-horizontal {
    --fa: "\\f58d";
    --fa--fa: "\\f58d\\f58d"
}

.fa-share-from-square,
.fa-share-square {
    --fa: "\\f14d";
    --fa--fa: "\\f14d\\f14d"
}

.fa-child-combatant,
.fa-child-rifle {
    --fa: "\\e4e0";
    --fa--fa: "\\e4e0\\e4e0"
}

.fa-gun {
    --fa: "\\e19b";
    --fa--fa: "\\e19b\\e19b"
}

.fa-phone-square,
.fa-square-phone {
    --fa: "\\f098";
    --fa--fa: "\\f098\\f098"
}

.fa-add,
.fa-plus {
    --fa: "\\2b";
    --fa--fa: "\\2b\\2b"
}

.fa-expand {
    --fa: "\\f065";
    --fa--fa: "\\f065\\f065"
}

.fa-computer {
    --fa: "\\e4e5";
    --fa--fa: "\\e4e5\\e4e5"
}

.fa-close,
.fa-multiply,
.fa-remove,
.fa-times,
.fa-xmark {
    --fa: "\\f00d";
    --fa--fa: "\\f00d\\f00d"
}

.fa-arrows,
.fa-arrows-up-down-left-right {
    --fa: "\\f047";
    --fa--fa: "\\f047\\f047"
}

.fa-chalkboard-teacher,
.fa-chalkboard-user {
    --fa: "\\f51c";
    --fa--fa: "\\f51c\\f51c"
}

.fa-peso-sign {
    --fa: "\\e222";
    --fa--fa: "\\e222\\e222"
}

.fa-building-shield {
    --fa: "\\e4d8";
    --fa--fa: "\\e4d8\\e4d8"
}

.fa-baby {
    --fa: "\\f77c";
    --fa--fa: "\\f77c\\f77c"
}

.fa-users-line {
    --fa: "\\e592";
    --fa--fa: "\\e592\\e592"
}

.fa-quote-left,
.fa-quote-left-alt {
    --fa: "\\f10d";
    --fa--fa: "\\f10d\\f10d"
}

.fa-tractor {
    --fa: "\\f722";
    --fa--fa: "\\f722\\f722"
}

.fa-trash-arrow-up,
.fa-trash-restore {
    --fa: "\\f829";
    --fa--fa: "\\f829\\f829"
}

.fa-arrow-down-up-lock {
    --fa: "\\e4b0";
    --fa--fa: "\\e4b0\\e4b0"
}

.fa-lines-leaning {
    --fa: "\\e51e";
    --fa--fa: "\\e51e\\e51e"
}

.fa-ruler-combined {
    --fa: "\\f546";
    --fa--fa: "\\f546\\f546"
}

.fa-copyright {
    --fa: "\\f1f9";
    --fa--fa: "\\f1f9\\f1f9"
}

.fa-equals {
    --fa: "\\3d";
    --fa--fa: "\\3d\\3d"
}

.fa-blender {
    --fa: "\\f517";
    --fa--fa: "\\f517\\f517"
}

.fa-teeth {
    --fa: "\\f62e";
    --fa--fa: "\\f62e\\f62e"
}

.fa-ils,
.fa-shekel,
.fa-shekel-sign,
.fa-sheqel,
.fa-sheqel-sign {
    --fa: "\\f20b";
    --fa--fa: "\\f20b\\f20b"
}

.fa-map {
    --fa: "\\f279";
    --fa--fa: "\\f279\\f279"
}

.fa-rocket {
    --fa: "\\f135";
    --fa--fa: "\\f135\\f135"
}

.fa-photo-film,
.fa-photo-video {
    --fa: "\\f87c";
    --fa--fa: "\\f87c\\f87c"
}

.fa-folder-minus {
    --fa: "\\f65d";
    --fa--fa: "\\f65d\\f65d"
}

.fa-hexagon-nodes-bolt {
    --fa: "\\e69a";
    --fa--fa: "\\e69a\\e69a"
}

.fa-store {
    --fa: "\\f54e";
    --fa--fa: "\\f54e\\f54e"
}

.fa-arrow-trend-up {
    --fa: "\\e098";
    --fa--fa: "\\e098\\e098"
}

.fa-plug-circle-minus {
    --fa: "\\e55e";
    --fa--fa: "\\e55e\\e55e"
}

.fa-sign,
.fa-sign-hanging {
    --fa: "\\f4d9";
    --fa--fa: "\\f4d9\\f4d9"
}

.fa-bezier-curve {
    --fa: "\\f55b";
    --fa--fa: "\\f55b\\f55b"
}

.fa-bell-slash {
    --fa: "\\f1f6";
    --fa--fa: "\\f1f6\\f1f6"
}

.fa-tablet,
.fa-tablet-android {
    --fa: "\\f3fb";
    --fa--fa: "\\f3fb\\f3fb"
}

.fa-school-flag {
    --fa: "\\e56e";
    --fa--fa: "\\e56e\\e56e"
}

.fa-fill {
    --fa: "\\f575";
    --fa--fa: "\\f575\\f575"
}

.fa-angle-up {
    --fa: "\\f106";
    --fa--fa: "\\f106\\f106"
}

.fa-drumstick-bite {
    --fa: "\\f6d7";
    --fa--fa: "\\f6d7\\f6d7"
}

.fa-holly-berry {
    --fa: "\\f7aa";
    --fa--fa: "\\f7aa\\f7aa"
}

.fa-chevron-left {
    --fa: "\\f053";
    --fa--fa: "\\f053\\f053"
}

.fa-bacteria {
    --fa: "\\e059";
    --fa--fa: "\\e059\\e059"
}

.fa-hand-lizard {
    --fa: "\\f258";
    --fa--fa: "\\f258\\f258"
}

.fa-notdef {
    --fa: "\\e1fe";
    --fa--fa: "\\e1fe\\e1fe"
}

.fa-disease {
    --fa: "\\f7fa";
    --fa--fa: "\\f7fa\\f7fa"
}

.fa-briefcase-medical {
    --fa: "\\f469";
    --fa--fa: "\\f469\\f469"
}

.fa-genderless {
    --fa: "\\f22d";
    --fa--fa: "\\f22d\\f22d"
}

.fa-chevron-right {
    --fa: "\\f054";
    --fa--fa: "\\f054\\f054"
}

.fa-retweet {
    --fa: "\\f079";
    --fa--fa: "\\f079\\f079"
}

.fa-car-alt,
.fa-car-rear {
    --fa: "\\f5de";
    --fa--fa: "\\f5de\\f5de"
}

.fa-pump-soap {
    --fa: "\\e06b";
    --fa--fa: "\\e06b\\e06b"
}

.fa-video-slash {
    --fa: "\\f4e2";
    --fa--fa: "\\f4e2\\f4e2"
}

.fa-battery-2,
.fa-battery-quarter {
    --fa: "\\f243";
    --fa--fa: "\\f243\\f243"
}

.fa-radio {
    --fa: "\\f8d7";
    --fa--fa: "\\f8d7\\f8d7"
}

.fa-baby-carriage,
.fa-carriage-baby {
    --fa: "\\f77d";
    --fa--fa: "\\f77d\\f77d"
}

.fa-traffic-light {
    --fa: "\\f637";
    --fa--fa: "\\f637\\f637"
}

.fa-thermometer {
    --fa: "\\f491";
    --fa--fa: "\\f491\\f491"
}

.fa-vr-cardboard {
    --fa: "\\f729";
    --fa--fa: "\\f729\\f729"
}

.fa-hand-middle-finger {
    --fa: "\\f806";
    --fa--fa: "\\f806\\f806"
}

.fa-percent,
.fa-percentage {
    --fa: "\\25";
    --fa--fa: "\\25\\25"
}

.fa-truck-moving {
    --fa: "\\f4df";
    --fa--fa: "\\f4df\\f4df"
}

.fa-glass-water-droplet {
    --fa: "\\e4f5";
    --fa--fa: "\\e4f5\\e4f5"
}

.fa-display {
    --fa: "\\e163";
    --fa--fa: "\\e163\\e163"
}

.fa-face-smile,
.fa-smile {
    --fa: "\\f118";
    --fa--fa: "\\f118\\f118"
}

.fa-thumb-tack,
.fa-thumbtack {
    --fa: "\\f08d";
    --fa--fa: "\\f08d\\f08d"
}

.fa-trophy {
    --fa: "\\f091";
    --fa--fa: "\\f091\\f091"
}

.fa-person-praying,
.fa-pray {
    --fa: "\\f683";
    --fa--fa: "\\f683\\f683"
}

.fa-hammer {
    --fa: "\\f6e3";
    --fa--fa: "\\f6e3\\f6e3"
}

.fa-hand-peace {
    --fa: "\\f25b";
    --fa--fa: "\\f25b\\f25b"
}

.fa-rotate,
.fa-sync-alt {
    --fa: "\\f2f1";
    --fa--fa: "\\f2f1\\f2f1"
}

.fa-spinner {
    --fa: "\\f110";
    --fa--fa: "\\f110\\f110"
}

.fa-robot {
    --fa: "\\f544";
    --fa--fa: "\\f544\\f544"
}

.fa-peace {
    --fa: "\\f67c";
    --fa--fa: "\\f67c\\f67c"
}

.fa-cogs,
.fa-gears {
    --fa: "\\f085";
    --fa--fa: "\\f085\\f085"
}

.fa-warehouse {
    --fa: "\\f494";
    --fa--fa: "\\f494\\f494"
}

.fa-arrow-up-right-dots {
    --fa: "\\e4b7";
    --fa--fa: "\\e4b7\\e4b7"
}

.fa-splotch {
    --fa: "\\f5bc";
    --fa--fa: "\\f5bc\\f5bc"
}

.fa-face-grin-hearts,
.fa-grin-hearts {
    --fa: "\\f584";
    --fa--fa: "\\f584\\f584"
}

.fa-dice-four {
    --fa: "\\f524";
    --fa--fa: "\\f524\\f524"
}

.fa-sim-card {
    --fa: "\\f7c4";
    --fa--fa: "\\f7c4\\f7c4"
}

.fa-transgender,
.fa-transgender-alt {
    --fa: "\\f225";
    --fa--fa: "\\f225\\f225"
}

.fa-mercury {
    --fa: "\\f223";
    --fa--fa: "\\f223\\f223"
}

.fa-arrow-turn-down,
.fa-level-down {
    --fa: "\\f149";
    --fa--fa: "\\f149\\f149"
}

.fa-person-falling-burst {
    --fa: "\\e547";
    --fa--fa: "\\e547\\e547"
}

.fa-award {
    --fa: "\\f559";
    --fa--fa: "\\f559\\f559"
}

.fa-ticket-alt,
.fa-ticket-simple {
    --fa: "\\f3ff";
    --fa--fa: "\\f3ff\\f3ff"
}

.fa-building {
    --fa: "\\f1ad";
    --fa--fa: "\\f1ad\\f1ad"
}

.fa-angle-double-left,
.fa-angles-left {
    --fa: "\\f100";
    --fa--fa: "\\f100\\f100"
}

.fa-qrcode {
    --fa: "\\f029";
    --fa--fa: "\\f029\\f029"
}

.fa-clock-rotate-left,
.fa-history {
    --fa: "\\f1da";
    --fa--fa: "\\f1da\\f1da"
}

.fa-face-grin-beam-sweat,
.fa-grin-beam-sweat {
    --fa: "\\f583";
    --fa--fa: "\\f583\\f583"
}

.fa-arrow-right-from-file,
.fa-file-export {
    --fa: "\\f56e";
    --fa--fa: "\\f56e\\f56e"
}

.fa-shield,
.fa-shield-blank {
    --fa: "\\f132";
    --fa--fa: "\\f132\\f132"
}

.fa-arrow-up-short-wide,
.fa-sort-amount-up-alt {
    --fa: "\\f885";
    --fa--fa: "\\f885\\f885"
}

.fa-comment-nodes {
    --fa: "\\e696";
    --fa--fa: "\\e696\\e696"
}

.fa-house-medical {
    --fa: "\\e3b2";
    --fa--fa: "\\e3b2\\e3b2"
}

.fa-golf-ball,
.fa-golf-ball-tee {
    --fa: "\\f450";
    --fa--fa: "\\f450\\f450"
}

.fa-chevron-circle-left,
.fa-circle-chevron-left {
    --fa: "\\f137";
    --fa--fa: "\\f137\\f137"
}

.fa-house-chimney-window {
    --fa: "\\e00d";
    --fa--fa: "\\e00d\\e00d"
}

.fa-pen-nib {
    --fa: "\\f5ad";
    --fa--fa: "\\f5ad\\f5ad"
}

.fa-tent-arrow-turn-left {
    --fa: "\\e580";
    --fa--fa: "\\e580\\e580"
}

.fa-tents {
    --fa: "\\e582";
    --fa--fa: "\\e582\\e582"
}

.fa-magic,
.fa-wand-magic {
    --fa: "\\f0d0";
    --fa--fa: "\\f0d0\\f0d0"
}

.fa-dog {
    --fa: "\\f6d3";
    --fa--fa: "\\f6d3\\f6d3"
}

.fa-carrot {
    --fa: "\\f787";
    --fa--fa: "\\f787\\f787"
}

.fa-moon {
    --fa: "\\f186";
    --fa--fa: "\\f186\\f186"
}

.fa-wine-glass-alt,
.fa-wine-glass-empty {
    --fa: "\\f5ce";
    --fa--fa: "\\f5ce\\f5ce"
}

.fa-cheese {
    --fa: "\\f7ef";
    --fa--fa: "\\f7ef\\f7ef"
}

.fa-yin-yang {
    --fa: "\\f6ad";
    --fa--fa: "\\f6ad\\f6ad"
}

.fa-music {
    --fa: "\\f001";
    --fa--fa: "\\f001\\f001"
}

.fa-code-commit {
    --fa: "\\f386";
    --fa--fa: "\\f386\\f386"
}

.fa-temperature-low {
    --fa: "\\f76b";
    --fa--fa: "\\f76b\\f76b"
}

.fa-biking,
.fa-person-biking {
    --fa: "\\f84a";
    --fa--fa: "\\f84a\\f84a"
}

.fa-broom {
    --fa: "\\f51a";
    --fa--fa: "\\f51a\\f51a"
}

.fa-shield-heart {
    --fa: "\\e574";
    --fa--fa: "\\e574\\e574"
}

.fa-gopuram {
    --fa: "\\f664";
    --fa--fa: "\\f664\\f664"
}

.fa-earth-oceania,
.fa-globe-oceania {
    --fa: "\\e47b";
    --fa--fa: "\\e47b\\e47b"
}

.fa-square-xmark,
.fa-times-square,
.fa-xmark-square {
    --fa: "\\f2d3";
    --fa--fa: "\\f2d3\\f2d3"
}

.fa-hashtag {
    --fa: "\\23";
    --fa--fa: "\\23\\23"
}

.fa-expand-alt,
.fa-up-right-and-down-left-from-center {
    --fa: "\\f424";
    --fa--fa: "\\f424\\f424"
}

.fa-oil-can {
    --fa: "\\f613";
    --fa--fa: "\\f613\\f613"
}

.fa-t {
    --fa: "\\54";
    --fa--fa: "\\54\\54"
}

.fa-hippo {
    --fa: "\\f6ed";
    --fa--fa: "\\f6ed\\f6ed"
}

.fa-chart-column {
    --fa: "\\e0e3";
    --fa--fa: "\\e0e3\\e0e3"
}

.fa-infinity {
    --fa: "\\f534";
    --fa--fa: "\\f534\\f534"
}

.fa-vial-circle-check {
    --fa: "\\e596";
    --fa--fa: "\\e596\\e596"
}

.fa-person-arrow-down-to-line {
    --fa: "\\e538";
    --fa--fa: "\\e538\\e538"
}

.fa-voicemail {
    --fa: "\\f897";
    --fa--fa: "\\f897\\f897"
}

.fa-fan {
    --fa: "\\f863";
    --fa--fa: "\\f863\\f863"
}

.fa-person-walking-luggage {
    --fa: "\\e554";
    --fa--fa: "\\e554\\e554"
}

.fa-arrows-alt-v,
.fa-up-down {
    --fa: "\\f338";
    --fa--fa: "\\f338\\f338"
}

.fa-cloud-moon-rain {
    --fa: "\\f73c";
    --fa--fa: "\\f73c\\f73c"
}

.fa-calendar {
    --fa: "\\f133";
    --fa--fa: "\\f133\\f133"
}

.fa-trailer {
    --fa: "\\e041";
    --fa--fa: "\\e041\\e041"
}

.fa-bahai,
.fa-haykal {
    --fa: "\\f666";
    --fa--fa: "\\f666\\f666"
}

.fa-sd-card {
    --fa: "\\f7c2";
    --fa--fa: "\\f7c2\\f7c2"
}

.fa-dragon {
    --fa: "\\f6d5";
    --fa--fa: "\\f6d5\\f6d5"
}

.fa-shoe-prints {
    --fa: "\\f54b";
    --fa--fa: "\\f54b\\f54b"
}

.fa-circle-plus,
.fa-plus-circle {
    --fa: "\\f055";
    --fa--fa: "\\f055\\f055"
}

.fa-face-grin-tongue-wink,
.fa-grin-tongue-wink {
    --fa: "\\f58b";
    --fa--fa: "\\f58b\\f58b"
}

.fa-hand-holding {
    --fa: "\\f4bd";
    --fa--fa: "\\f4bd\\f4bd"
}

.fa-plug-circle-exclamation {
    --fa: "\\e55d";
    --fa--fa: "\\e55d\\e55d"
}

.fa-chain-broken,
.fa-chain-slash,
.fa-link-slash,
.fa-unlink {
    --fa: "\\f127";
    --fa--fa: "\\f127\\f127"
}

.fa-clone {
    --fa: "\\f24d";
    --fa--fa: "\\f24d\\f24d"
}

.fa-person-walking-arrow-loop-left {
    --fa: "\\e551";
    --fa--fa: "\\e551\\e551"
}

.fa-arrow-up-z-a,
.fa-sort-alpha-up-alt {
    --fa: "\\f882";
    --fa--fa: "\\f882\\f882"
}

.fa-fire-alt,
.fa-fire-flame-curved {
    --fa: "\\f7e4";
    --fa--fa: "\\f7e4\\f7e4"
}

.fa-tornado {
    --fa: "\\f76f";
    --fa--fa: "\\f76f\\f76f"
}

.fa-file-circle-plus {
    --fa: "\\e494";
    --fa--fa: "\\e494\\e494"
}

.fa-book-quran,
.fa-quran {
    --fa: "\\f687";
    --fa--fa: "\\f687\\f687"
}

.fa-anchor {
    --fa: "\\f13d";
    --fa--fa: "\\f13d\\f13d"
}

.fa-border-all {
    --fa: "\\f84c";
    --fa--fa: "\\f84c\\f84c"
}

.fa-angry,
.fa-face-angry {
    --fa: "\\f556";
    --fa--fa: "\\f556\\f556"
}

.fa-cookie-bite {
    --fa: "\\f564";
    --fa--fa: "\\f564\\f564"
}

.fa-arrow-trend-down {
    --fa: "\\e097";
    --fa--fa: "\\e097\\e097"
}

.fa-feed,
.fa-rss {
    --fa: "\\f09e";
    --fa--fa: "\\f09e\\f09e"
}

.fa-draw-polygon {
    --fa: "\\f5ee";
    --fa--fa: "\\f5ee\\f5ee"
}

.fa-balance-scale,
.fa-scale-balanced {
    --fa: "\\f24e";
    --fa--fa: "\\f24e\\f24e"
}

.fa-gauge-simple-high,
.fa-tachometer,
.fa-tachometer-fast {
    --fa: "\\f62a";
    --fa--fa: "\\f62a\\f62a"
}

.fa-shower {
    --fa: "\\f2cc";
    --fa--fa: "\\f2cc\\f2cc"
}

.fa-desktop,
.fa-desktop-alt {
    --fa: "\\f390";
    --fa--fa: "\\f390\\f390"
}

.fa-m {
    --fa: "\\4d";
    --fa--fa: "\\4d\\4d"
}

.fa-table-list,
.fa-th-list {
    --fa: "\\f00b";
    --fa--fa: "\\f00b\\f00b"
}

.fa-comment-sms,
.fa-sms {
    --fa: "\\f7cd";
    --fa--fa: "\\f7cd\\f7cd"
}

.fa-book {
    --fa: "\\f02d";
    --fa--fa: "\\f02d\\f02d"
}

.fa-user-plus {
    --fa: "\\f234";
    --fa--fa: "\\f234\\f234"
}

.fa-check {
    --fa: "\\f00c";
    --fa--fa: "\\f00c\\f00c"
}

.fa-battery-4,
.fa-battery-three-quarters {
    --fa: "\\f241";
    --fa--fa: "\\f241\\f241"
}

.fa-house-circle-check {
    --fa: "\\e509";
    --fa--fa: "\\e509\\e509"
}

.fa-angle-left {
    --fa: "\\f104";
    --fa--fa: "\\f104\\f104"
}

.fa-diagram-successor {
    --fa: "\\e47a";
    --fa--fa: "\\e47a\\e47a"
}

.fa-truck-arrow-right {
    --fa: "\\e58b";
    --fa--fa: "\\e58b\\e58b"
}

.fa-arrows-split-up-and-left {
    --fa: "\\e4bc";
    --fa--fa: "\\e4bc\\e4bc"
}

.fa-fist-raised,
.fa-hand-fist {
    --fa: "\\f6de";
    --fa--fa: "\\f6de\\f6de"
}

.fa-cloud-moon {
    --fa: "\\f6c3";
    --fa--fa: "\\f6c3\\f6c3"
}

.fa-briefcase {
    --fa: "\\f0b1";
    --fa--fa: "\\f0b1\\f0b1"
}

.fa-person-falling {
    --fa: "\\e546";
    --fa--fa: "\\e546\\e546"
}

.fa-image-portrait,
.fa-portrait {
    --fa: "\\f3e0";
    --fa--fa: "\\f3e0\\f3e0"
}

.fa-user-tag {
    --fa: "\\f507";
    --fa--fa: "\\f507\\f507"
}

.fa-rug {
    --fa: "\\e569";
    --fa--fa: "\\e569\\e569"
}

.fa-earth-europe,
.fa-globe-europe {
    --fa: "\\f7a2";
    --fa--fa: "\\f7a2\\f7a2"
}

.fa-cart-flatbed-suitcase,
.fa-luggage-cart {
    --fa: "\\f59d";
    --fa--fa: "\\f59d\\f59d"
}

.fa-rectangle-times,
.fa-rectangle-xmark,
.fa-times-rectangle,
.fa-window-close {
    --fa: "\\f410";
    --fa--fa: "\\f410\\f410"
}

.fa-baht-sign {
    --fa: "\\e0ac";
    --fa--fa: "\\e0ac\\e0ac"
}

.fa-book-open {
    --fa: "\\f518";
    --fa--fa: "\\f518\\f518"
}

.fa-book-journal-whills,
.fa-journal-whills {
    --fa: "\\f66a";
    --fa--fa: "\\f66a\\f66a"
}

.fa-handcuffs {
    --fa: "\\e4f8";
    --fa--fa: "\\e4f8\\e4f8"
}

.fa-exclamation-triangle,
.fa-triangle-exclamation,
.fa-warning {
    --fa: "\\f071";
    --fa--fa: "\\f071\\f071"
}

.fa-database {
    --fa: "\\f1c0";
    --fa--fa: "\\f1c0\\f1c0"
}

.fa-mail-forward,
.fa-share {
    --fa: "\\f064";
    --fa--fa: "\\f064\\f064"
}

.fa-bottle-droplet {
    --fa: "\\e4c4";
    --fa--fa: "\\e4c4\\e4c4"
}

.fa-mask-face {
    --fa: "\\e1d7";
    --fa--fa: "\\e1d7\\e1d7"
}

.fa-hill-rockslide {
    --fa: "\\e508";
    --fa--fa: "\\e508\\e508"
}

.fa-exchange-alt,
.fa-right-left {
    --fa: "\\f362";
    --fa--fa: "\\f362\\f362"
}

.fa-paper-plane {
    --fa: "\\f1d8";
    --fa--fa: "\\f1d8\\f1d8"
}

.fa-road-circle-exclamation {
    --fa: "\\e565";
    --fa--fa: "\\e565\\e565"
}

.fa-dungeon {
    --fa: "\\f6d9";
    --fa--fa: "\\f6d9\\f6d9"
}

.fa-align-right {
    --fa: "\\f038";
    --fa--fa: "\\f038\\f038"
}

.fa-money-bill-1-wave,
.fa-money-bill-wave-alt {
    --fa: "\\f53b";
    --fa--fa: "\\f53b\\f53b"
}

.fa-life-ring {
    --fa: "\\f1cd";
    --fa--fa: "\\f1cd\\f1cd"
}

.fa-hands,
.fa-sign-language,
.fa-signing {
    --fa: "\\f2a7";
    --fa--fa: "\\f2a7\\f2a7"
}

.fa-calendar-day {
    --fa: "\\f783";
    --fa--fa: "\\f783\\f783"
}

.fa-ladder-water,
.fa-swimming-pool,
.fa-water-ladder {
    --fa: "\\f5c5";
    --fa--fa: "\\f5c5\\f5c5"
}

.fa-arrows-up-down,
.fa-arrows-v {
    --fa: "\\f07d";
    --fa--fa: "\\f07d\\f07d"
}

.fa-face-grimace,
.fa-grimace {
    --fa: "\\f57f";
    --fa--fa: "\\f57f\\f57f"
}

.fa-wheelchair-alt,
.fa-wheelchair-move {
    --fa: "\\e2ce";
    --fa--fa: "\\e2ce\\e2ce"
}

.fa-level-down-alt,
.fa-turn-down {
    --fa: "\\f3be";
    --fa--fa: "\\f3be\\f3be"
}

.fa-person-walking-arrow-right {
    --fa: "\\e552";
    --fa--fa: "\\e552\\e552"
}

.fa-envelope-square,
.fa-square-envelope {
    --fa: "\\f199";
    --fa--fa: "\\f199\\f199"
}

.fa-dice {
    --fa: "\\f522";
    --fa--fa: "\\f522\\f522"
}

.fa-bowling-ball {
    --fa: "\\f436";
    --fa--fa: "\\f436\\f436"
}

.fa-brain {
    --fa: "\\f5dc";
    --fa--fa: "\\f5dc\\f5dc"
}

.fa-band-aid,
.fa-bandage {
    --fa: "\\f462";
    --fa--fa: "\\f462\\f462"
}

.fa-calendar-minus {
    --fa: "\\f272";
    --fa--fa: "\\f272\\f272"
}

.fa-circle-xmark,
.fa-times-circle,
.fa-xmark-circle {
    --fa: "\\f057";
    --fa--fa: "\\f057\\f057"
}

.fa-gifts {
    --fa: "\\f79c";
    --fa--fa: "\\f79c\\f79c"
}

.fa-hotel {
    --fa: "\\f594";
    --fa--fa: "\\f594\\f594"
}

.fa-earth-asia,
.fa-globe-asia {
    --fa: "\\f57e";
    --fa--fa: "\\f57e\\f57e"
}

.fa-id-card-alt,
.fa-id-card-clip {
    --fa: "\\f47f";
    --fa--fa: "\\f47f\\f47f"
}

.fa-magnifying-glass-plus,
.fa-search-plus {
    --fa: "\\f00e";
    --fa--fa: "\\f00e\\f00e"
}

.fa-thumbs-up {
    --fa: "\\f164";
    --fa--fa: "\\f164\\f164"
}

.fa-user-clock {
    --fa: "\\f4fd";
    --fa--fa: "\\f4fd\\f4fd"
}

.fa-allergies,
.fa-hand-dots {
    --fa: "\\f461";
    --fa--fa: "\\f461\\f461"
}

.fa-file-invoice {
    --fa: "\\f570";
    --fa--fa: "\\f570\\f570"
}

.fa-window-minimize {
    --fa: "\\f2d1";
    --fa--fa: "\\f2d1\\f2d1"
}

.fa-coffee,
.fa-mug-saucer {
    --fa: "\\f0f4";
    --fa--fa: "\\f0f4\\f0f4"
}

.fa-brush {
    --fa: "\\f55d";
    --fa--fa: "\\f55d\\f55d"
}

.fa-file-half-dashed {
    --fa: "\\e698";
    --fa--fa: "\\e698\\e698"
}

.fa-mask {
    --fa: "\\f6fa";
    --fa--fa: "\\f6fa\\f6fa"
}

.fa-magnifying-glass-minus,
.fa-search-minus {
    --fa: "\\f010";
    --fa--fa: "\\f010\\f010"
}

.fa-ruler-vertical {
    --fa: "\\f548";
    --fa--fa: "\\f548\\f548"
}

.fa-user-alt,
.fa-user-large {
    --fa: "\\f406";
    --fa--fa: "\\f406\\f406"
}

.fa-train-tram {
    --fa: "\\e5b4";
    --fa--fa: "\\e5b4\\e5b4"
}

.fa-user-nurse {
    --fa: "\\f82f";
    --fa--fa: "\\f82f\\f82f"
}

.fa-syringe {
    --fa: "\\f48e";
    --fa--fa: "\\f48e\\f48e"
}

.fa-cloud-sun {
    --fa: "\\f6c4";
    --fa--fa: "\\f6c4\\f6c4"
}

.fa-stopwatch-20 {
    --fa: "\\e06f";
    --fa--fa: "\\e06f\\e06f"
}

.fa-square-full {
    --fa: "\\f45c";
    --fa--fa: "\\f45c\\f45c"
}

.fa-magnet {
    --fa: "\\f076";
    --fa--fa: "\\f076\\f076"
}

.fa-jar {
    --fa: "\\e516";
    --fa--fa: "\\e516\\e516"
}

.fa-note-sticky,
.fa-sticky-note {
    --fa: "\\f249";
    --fa--fa: "\\f249\\f249"
}

.fa-bug-slash {
    --fa: "\\e490";
    --fa--fa: "\\e490\\e490"
}

.fa-arrow-up-from-water-pump {
    --fa: "\\e4b6";
    --fa--fa: "\\e4b6\\e4b6"
}

.fa-bone {
    --fa: "\\f5d7";
    --fa--fa: "\\f5d7\\f5d7"
}

.fa-table-cells-row-unlock {
    --fa: "\\e691";
    --fa--fa: "\\e691\\e691"
}

.fa-user-injured {
    --fa: "\\f728";
    --fa--fa: "\\f728\\f728"
}

.fa-face-sad-tear,
.fa-sad-tear {
    --fa: "\\f5b4";
    --fa--fa: "\\f5b4\\f5b4"
}

.fa-plane {
    --fa: "\\f072";
    --fa--fa: "\\f072\\f072"
}

.fa-tent-arrows-down {
    --fa: "\\e581";
    --fa--fa: "\\e581\\e581"
}

.fa-exclamation {
    --fa: "\\21";
    --fa--fa: "\\21\\21"
}

.fa-arrows-spin {
    --fa: "\\e4bb";
    --fa--fa: "\\e4bb\\e4bb"
}

.fa-print {
    --fa: "\\f02f";
    --fa--fa: "\\f02f\\f02f"
}

.fa-try,
.fa-turkish-lira,
.fa-turkish-lira-sign {
    --fa: "\\e2bb";
    --fa--fa: "\\e2bb\\e2bb"
}

.fa-dollar,
.fa-dollar-sign,
.fa-usd {
    --fa: "\\24";
    --fa--fa: "\\24\\24"
}

.fa-x {
    --fa: "\\58";
    --fa--fa: "\\58\\58"
}

.fa-magnifying-glass-dollar,
.fa-search-dollar {
    --fa: "\\f688";
    --fa--fa: "\\f688\\f688"
}

.fa-users-cog,
.fa-users-gear {
    --fa: "\\f509";
    --fa--fa: "\\f509\\f509"
}

.fa-person-military-pointing {
    --fa: "\\e54a";
    --fa--fa: "\\e54a\\e54a"
}

.fa-bank,
.fa-building-columns,
.fa-institution,
.fa-museum,
.fa-university {
    --fa: "\\f19c";
    --fa--fa: "\\f19c\\f19c"
}

.fa-umbrella {
    --fa: "\\f0e9";
    --fa--fa: "\\f0e9\\f0e9"
}

.fa-trowel {
    --fa: "\\e589";
    --fa--fa: "\\e589\\e589"
}

.fa-d {
    --fa: "\\44";
    --fa--fa: "\\44\\44"
}

.fa-stapler {
    --fa: "\\e5af";
    --fa--fa: "\\e5af\\e5af"
}

.fa-masks-theater,
.fa-theater-masks {
    --fa: "\\f630";
    --fa--fa: "\\f630\\f630"
}

.fa-kip-sign {
    --fa: "\\e1c4";
    --fa--fa: "\\e1c4\\e1c4"
}

.fa-hand-point-left {
    --fa: "\\f0a5";
    --fa--fa: "\\f0a5\\f0a5"
}

.fa-handshake-alt,
.fa-handshake-simple {
    --fa: "\\f4c6";
    --fa--fa: "\\f4c6\\f4c6"
}

.fa-fighter-jet,
.fa-jet-fighter {
    --fa: "\\f0fb";
    --fa--fa: "\\f0fb\\f0fb"
}

.fa-share-alt-square,
.fa-square-share-nodes {
    --fa: "\\f1e1";
    --fa--fa: "\\f1e1\\f1e1"
}

.fa-barcode {
    --fa: "\\f02a";
    --fa--fa: "\\f02a\\f02a"
}

.fa-plus-minus {
    --fa: "\\e43c";
    --fa--fa: "\\e43c\\e43c"
}

.fa-video,
.fa-video-camera {
    --fa: "\\f03d";
    --fa--fa: "\\f03d\\f03d"
}

.fa-graduation-cap,
.fa-mortar-board {
    --fa: "\\f19d";
    --fa--fa: "\\f19d\\f19d"
}

.fa-hand-holding-medical {
    --fa: "\\e05c";
    --fa--fa: "\\e05c\\e05c"
}

.fa-person-circle-check {
    --fa: "\\e53e";
    --fa--fa: "\\e53e\\e53e"
}

.fa-level-up-alt,
.fa-turn-up {
    --fa: "\\f3bf";
    --fa--fa: "\\f3bf\\f3bf"
}

.fa-sr-only,
.fa-sr-only-focusable:not(:focus),
.sr-only,
.sr-only-focusable:not(:focus) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0
}

:host,
:root {
    --fa-style-family-brands: "Font Awesome 6 Brands";
    --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands"
}

@font-face {
    font-family: "Font Awesome 6 Brands";
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype")
}

.fa-brands,
.fab {
    font-weight: 400
}

.fa-monero {
    --fa: "\\f3d0"
}

.fa-hooli {
    --fa: "\\f427"
}

.fa-yelp {
    --fa: "\\f1e9"
}

.fa-cc-visa {
    --fa: "\\f1f0"
}

.fa-lastfm {
    --fa: "\\f202"
}

.fa-shopware {
    --fa: "\\f5b5"
}

.fa-creative-commons-nc {
    --fa: "\\f4e8"
}

.fa-aws {
    --fa: "\\f375"
}

.fa-redhat {
    --fa: "\\f7bc"
}

.fa-yoast {
    --fa: "\\f2b1"
}

.fa-cloudflare {
    --fa: "\\e07d"
}

.fa-ups {
    --fa: "\\f7e0"
}

.fa-pixiv {
    --fa: "\\e640"
}

.fa-wpexplorer {
    --fa: "\\f2de"
}

.fa-dyalog {
    --fa: "\\f399"
}

.fa-bity {
    --fa: "\\f37a"
}

.fa-stackpath {
    --fa: "\\f842"
}

.fa-buysellads {
    --fa: "\\f20d"
}

.fa-first-order {
    --fa: "\\f2b0"
}

.fa-modx {
    --fa: "\\f285"
}

.fa-guilded {
    --fa: "\\e07e"
}

.fa-vnv {
    --fa: "\\f40b"
}

.fa-js-square,
.fa-square-js {
    --fa: "\\f3b9"
}

.fa-microsoft {
    --fa: "\\f3ca"
}

.fa-qq {
    --fa: "\\f1d6"
}

.fa-orcid {
    --fa: "\\f8d2"
}

.fa-java {
    --fa: "\\f4e4"
}

.fa-invision {
    --fa: "\\f7b0"
}

.fa-creative-commons-pd-alt {
    --fa: "\\f4ed"
}

.fa-centercode {
    --fa: "\\f380"
}

.fa-glide-g {
    --fa: "\\f2a6"
}

.fa-drupal {
    --fa: "\\f1a9"
}

.fa-jxl {
    --fa: "\\e67b"
}

.fa-dart-lang {
    --fa: "\\e693"
}

.fa-hire-a-helper {
    --fa: "\\f3b0"
}

.fa-creative-commons-by {
    --fa: "\\f4e7"
}

.fa-unity {
    --fa: "\\e049"
}

.fa-whmcs {
    --fa: "\\f40d"
}

.fa-rocketchat {
    --fa: "\\f3e8"
}

.fa-vk {
    --fa: "\\f189"
}

.fa-untappd {
    --fa: "\\f405"
}

.fa-mailchimp {
    --fa: "\\f59e"
}

.fa-css3-alt {
    --fa: "\\f38b"
}

.fa-reddit-square,
.fa-square-reddit {
    --fa: "\\f1a2"
}

.fa-vimeo-v {
    --fa: "\\f27d"
}

.fa-contao {
    --fa: "\\f26d"
}

.fa-square-font-awesome {
    --fa: "\\e5ad"
}

.fa-deskpro {
    --fa: "\\f38f"
}

.fa-brave {
    --fa: "\\e63c"
}

.fa-sistrix {
    --fa: "\\f3ee"
}

.fa-instagram-square,
.fa-square-instagram {
    --fa: "\\e055"
}

.fa-battle-net {
    --fa: "\\f835"
}

.fa-the-red-yeti {
    --fa: "\\f69d"
}

.fa-hacker-news-square,
.fa-square-hacker-news {
    --fa: "\\f3af"
}

.fa-edge {
    --fa: "\\f282"
}

.fa-threads {
    --fa: "\\e618"
}

.fa-napster {
    --fa: "\\f3d2"
}

.fa-snapchat-square,
.fa-square-snapchat {
    --fa: "\\f2ad"
}

.fa-google-plus-g {
    --fa: "\\f0d5"
}

.fa-artstation {
    --fa: "\\f77a"
}

.fa-markdown {
    --fa: "\\f60f"
}

.fa-sourcetree {
    --fa: "\\f7d3"
}

.fa-google-plus {
    --fa: "\\f2b3"
}

.fa-diaspora {
    --fa: "\\f791"
}

.fa-foursquare {
    --fa: "\\f180"
}

.fa-stack-overflow {
    --fa: "\\f16c"
}

.fa-github-alt {
    --fa: "\\f113"
}

.fa-phoenix-squadron {
    --fa: "\\f511"
}

.fa-pagelines {
    --fa: "\\f18c"
}

.fa-algolia {
    --fa: "\\f36c"
}

.fa-red-river {
    --fa: "\\f3e3"
}

.fa-creative-commons-sa {
    --fa: "\\f4ef"
}

.fa-safari {
    --fa: "\\f267"
}

.fa-google {
    --fa: "\\f1a0"
}

.fa-font-awesome-alt,
.fa-square-font-awesome-stroke {
    --fa: "\\f35c"
}

.fa-atlassian {
    --fa: "\\f77b"
}

.fa-linkedin-in {
    --fa: "\\f0e1"
}

.fa-digital-ocean {
    --fa: "\\f391"
}

.fa-nimblr {
    --fa: "\\f5a8"
}

.fa-chromecast {
    --fa: "\\f838"
}

.fa-evernote {
    --fa: "\\f839"
}

.fa-hacker-news {
    --fa: "\\f1d4"
}

.fa-creative-commons-sampling {
    --fa: "\\f4f0"
}

.fa-adversal {
    --fa: "\\f36a"
}

.fa-creative-commons {
    --fa: "\\f25e"
}

.fa-watchman-monitoring {
    --fa: "\\e087"
}

.fa-fonticons {
    --fa: "\\f280"
}

.fa-weixin {
    --fa: "\\f1d7"
}

.fa-shirtsinbulk {
    --fa: "\\f214"
}

.fa-codepen {
    --fa: "\\f1cb"
}

.fa-git-alt {
    --fa: "\\f841"
}

.fa-lyft {
    --fa: "\\f3c3"
}

.fa-rev {
    --fa: "\\f5b2"
}

.fa-windows {
    --fa: "\\f17a"
}

.fa-wizards-of-the-coast {
    --fa: "\\f730"
}

.fa-square-viadeo,
.fa-viadeo-square {
    --fa: "\\f2aa"
}

.fa-meetup {
    --fa: "\\f2e0"
}

.fa-centos {
    --fa: "\\f789"
}

.fa-adn {
    --fa: "\\f170"
}

.fa-cloudsmith {
    --fa: "\\f384"
}

.fa-opensuse {
    --fa: "\\e62b"
}

.fa-pied-piper-alt {
    --fa: "\\f1a8"
}

.fa-dribbble-square,
.fa-square-dribbble {
    --fa: "\\f397"
}

.fa-codiepie {
    --fa: "\\f284"
}

.fa-node {
    --fa: "\\f419"
}

.fa-mix {
    --fa: "\\f3cb"
}

.fa-steam {
    --fa: "\\f1b6"
}

.fa-cc-apple-pay {
    --fa: "\\f416"
}

.fa-scribd {
    --fa: "\\f28a"
}

.fa-debian {
    --fa: "\\e60b"
}

.fa-openid {
    --fa: "\\f19b"
}

.fa-instalod {
    --fa: "\\e081"
}

.fa-files-pinwheel {
    --fa: "\\e69f"
}

.fa-expeditedssl {
    --fa: "\\f23e"
}

.fa-sellcast {
    --fa: "\\f2da"
}

.fa-square-twitter,
.fa-twitter-square {
    --fa: "\\f081"
}

.fa-r-project {
    --fa: "\\f4f7"
}

.fa-delicious {
    --fa: "\\f1a5"
}

.fa-freebsd {
    --fa: "\\f3a4"
}

.fa-vuejs {
    --fa: "\\f41f"
}

.fa-accusoft {
    --fa: "\\f369"
}

.fa-ioxhost {
    --fa: "\\f208"
}

.fa-fonticons-fi {
    --fa: "\\f3a2"
}

.fa-app-store {
    --fa: "\\f36f"
}

.fa-cc-mastercard {
    --fa: "\\f1f1"
}

.fa-itunes-note {
    --fa: "\\f3b5"
}

.fa-golang {
    --fa: "\\e40f"
}

.fa-kickstarter,
.fa-square-kickstarter {
    --fa: "\\f3bb"
}

.fa-grav {
    --fa: "\\f2d6"
}

.fa-weibo {
    --fa: "\\f18a"
}

.fa-uncharted {
    --fa: "\\e084"
}

.fa-firstdraft {
    --fa: "\\f3a1"
}

.fa-square-youtube,
.fa-youtube-square {
    --fa: "\\f431"
}

.fa-wikipedia-w {
    --fa: "\\f266"
}

.fa-rendact,
.fa-wpressr {
    --fa: "\\f3e4"
}

.fa-angellist {
    --fa: "\\f209"
}

.fa-galactic-republic {
    --fa: "\\f50c"
}

.fa-nfc-directional {
    --fa: "\\e530"
}

.fa-skype {
    --fa: "\\f17e"
}

.fa-joget {
    --fa: "\\f3b7"
}

.fa-fedora {
    --fa: "\\f798"
}

.fa-stripe-s {
    --fa: "\\f42a"
}

.fa-meta {
    --fa: "\\e49b"
}

.fa-laravel {
    --fa: "\\f3bd"
}

.fa-hotjar {
    --fa: "\\f3b1"
}

.fa-bluetooth-b {
    --fa: "\\f294"
}

.fa-square-letterboxd {
    --fa: "\\e62e"
}

.fa-sticker-mule {
    --fa: "\\f3f7"
}

.fa-creative-commons-zero {
    --fa: "\\f4f3"
}

.fa-hips {
    --fa: "\\f452"
}

.fa-css {
    --fa: "\\e6a2"
}

.fa-behance {
    --fa: "\\f1b4"
}

.fa-reddit {
    --fa: "\\f1a1"
}

.fa-discord {
    --fa: "\\f392"
}

.fa-chrome {
    --fa: "\\f268"
}

.fa-app-store-ios {
    --fa: "\\f370"
}

.fa-cc-discover {
    --fa: "\\f1f2"
}

.fa-wpbeginner {
    --fa: "\\f297"
}

.fa-confluence {
    --fa: "\\f78d"
}

.fa-shoelace {
    --fa: "\\e60c"
}

.fa-mdb {
    --fa: "\\f8ca"
}

.fa-dochub {
    --fa: "\\f394"
}

.fa-accessible-icon {
    --fa: "\\f368"
}

.fa-ebay {
    --fa: "\\f4f4"
}

.fa-amazon {
    --fa: "\\f270"
}

.fa-unsplash {
    --fa: "\\e07c"
}

.fa-yarn {
    --fa: "\\f7e3"
}

.fa-square-steam,
.fa-steam-square {
    --fa: "\\f1b7"
}

.fa-500px {
    --fa: "\\f26e"
}

.fa-square-vimeo,
.fa-vimeo-square {
    --fa: "\\f194"
}

.fa-asymmetrik {
    --fa: "\\f372"
}

.fa-font-awesome,
.fa-font-awesome-flag,
.fa-font-awesome-logo-full {
    --fa: "\\f2b4"
}

.fa-gratipay {
    --fa: "\\f184"
}

.fa-apple {
    --fa: "\\f179"
}

.fa-hive {
    --fa: "\\e07f"
}

.fa-gitkraken {
    --fa: "\\f3a6"
}

.fa-keybase {
    --fa: "\\f4f5"
}

.fa-apple-pay {
    --fa: "\\f415"
}

.fa-padlet {
    --fa: "\\e4a0"
}

.fa-amazon-pay {
    --fa: "\\f42c"
}

.fa-github-square,
.fa-square-github {
    --fa: "\\f092"
}

.fa-stumbleupon {
    --fa: "\\f1a4"
}

.fa-fedex {
    --fa: "\\f797"
}

.fa-phoenix-framework {
    --fa: "\\f3dc"
}

.fa-shopify {
    --fa: "\\e057"
}

.fa-neos {
    --fa: "\\f612"
}

.fa-square-threads {
    --fa: "\\e619"
}

.fa-hackerrank {
    --fa: "\\f5f7"
}

.fa-researchgate {
    --fa: "\\f4f8"
}

.fa-swift {
    --fa: "\\f8e1"
}

.fa-angular {
    --fa: "\\f420"
}

.fa-speakap {
    --fa: "\\f3f3"
}

.fa-angrycreative {
    --fa: "\\f36e"
}

.fa-y-combinator {
    --fa: "\\f23b"
}

.fa-empire {
    --fa: "\\f1d1"
}

.fa-envira {
    --fa: "\\f299"
}

.fa-google-scholar {
    --fa: "\\e63b"
}

.fa-gitlab-square,
.fa-square-gitlab {
    --fa: "\\e5ae"
}

.fa-studiovinari {
    --fa: "\\f3f8"
}

.fa-pied-piper {
    --fa: "\\f2ae"
}

.fa-wordpress {
    --fa: "\\f19a"
}

.fa-product-hunt {
    --fa: "\\f288"
}

.fa-firefox {
    --fa: "\\f269"
}

.fa-linode {
    --fa: "\\f2b8"
}

.fa-goodreads {
    --fa: "\\f3a8"
}

.fa-odnoklassniki-square,
.fa-square-odnoklassniki {
    --fa: "\\f264"
}

.fa-jsfiddle {
    --fa: "\\f1cc"
}

.fa-sith {
    --fa: "\\f512"
}

.fa-themeisle {
    --fa: "\\f2b2"
}

.fa-page4 {
    --fa: "\\f3d7"
}

.fa-hashnode {
    --fa: "\\e499"
}

.fa-react {
    --fa: "\\f41b"
}

.fa-cc-paypal {
    --fa: "\\f1f4"
}

.fa-squarespace {
    --fa: "\\f5be"
}

.fa-cc-stripe {
    --fa: "\\f1f5"
}

.fa-creative-commons-share {
    --fa: "\\f4f2"
}

.fa-bitcoin {
    --fa: "\\f379"
}

.fa-keycdn {
    --fa: "\\f3ba"
}

.fa-opera {
    --fa: "\\f26a"
}

.fa-itch-io {
    --fa: "\\f83a"
}

.fa-umbraco {
    --fa: "\\f8e8"
}

.fa-galactic-senate {
    --fa: "\\f50d"
}

.fa-ubuntu {
    --fa: "\\f7df"
}

.fa-draft2digital {
    --fa: "\\f396"
}

.fa-stripe {
    --fa: "\\f429"
}

.fa-houzz {
    --fa: "\\f27c"
}

.fa-gg {
    --fa: "\\f260"
}

.fa-dhl {
    --fa: "\\f790"
}

.fa-pinterest-square,
.fa-square-pinterest {
    --fa: "\\f0d3"
}

.fa-xing {
    --fa: "\\f168"
}

.fa-blackberry {
    --fa: "\\f37b"
}

.fa-creative-commons-pd {
    --fa: "\\f4ec"
}

.fa-playstation {
    --fa: "\\f3df"
}

.fa-quinscape {
    --fa: "\\f459"
}

.fa-less {
    --fa: "\\f41d"
}

.fa-blogger-b {
    --fa: "\\f37d"
}

.fa-opencart {
    --fa: "\\f23d"
}

.fa-vine {
    --fa: "\\f1ca"
}

.fa-signal-messenger {
    --fa: "\\e663"
}

.fa-paypal {
    --fa: "\\f1ed"
}

.fa-gitlab {
    --fa: "\\f296"
}

.fa-typo3 {
    --fa: "\\f42b"
}

.fa-reddit-alien {
    --fa: "\\f281"
}

.fa-yahoo {
    --fa: "\\f19e"
}

.fa-dailymotion {
    --fa: "\\e052"
}

.fa-affiliatetheme {
    --fa: "\\f36b"
}

.fa-pied-piper-pp {
    --fa: "\\f1a7"
}

.fa-bootstrap {
    --fa: "\\f836"
}

.fa-odnoklassniki {
    --fa: "\\f263"
}

.fa-nfc-symbol {
    --fa: "\\e531"
}

.fa-mintbit {
    --fa: "\\e62f"
}

.fa-ethereum {
    --fa: "\\f42e"
}

.fa-speaker-deck {
    --fa: "\\f83c"
}

.fa-creative-commons-nc-eu {
    --fa: "\\f4e9"
}

.fa-patreon {
    --fa: "\\f3d9"
}

.fa-avianex {
    --fa: "\\f374"
}

.fa-ello {
    --fa: "\\f5f1"
}

.fa-gofore {
    --fa: "\\f3a7"
}

.fa-bimobject {
    --fa: "\\f378"
}

.fa-brave-reverse {
    --fa: "\\e63d"
}

.fa-facebook-f {
    --fa: "\\f39e"
}

.fa-google-plus-square,
.fa-square-google-plus {
    --fa: "\\f0d4"
}

.fa-web-awesome {
    --fa: "\\e682"
}

.fa-mandalorian {
    --fa: "\\f50f"
}

.fa-first-order-alt {
    --fa: "\\f50a"
}

.fa-osi {
    --fa: "\\f41a"
}

.fa-google-wallet {
    --fa: "\\f1ee"
}

.fa-d-and-d-beyond {
    --fa: "\\f6ca"
}

.fa-periscope {
    --fa: "\\f3da"
}

.fa-fulcrum {
    --fa: "\\f50b"
}

.fa-cloudscale {
    --fa: "\\f383"
}

.fa-forumbee {
    --fa: "\\f211"
}

.fa-mizuni {
    --fa: "\\f3cc"
}

.fa-schlix {
    --fa: "\\f3ea"
}

.fa-square-xing,
.fa-xing-square {
    --fa: "\\f169"
}

.fa-bandcamp {
    --fa: "\\f2d5"
}

.fa-wpforms {
    --fa: "\\f298"
}

.fa-cloudversify {
    --fa: "\\f385"
}

.fa-usps {
    --fa: "\\f7e1"
}

.fa-megaport {
    --fa: "\\f5a3"
}

.fa-magento {
    --fa: "\\f3c4"
}

.fa-spotify {
    --fa: "\\f1bc"
}

.fa-optin-monster {
    --fa: "\\f23c"
}

.fa-fly {
    --fa: "\\f417"
}

.fa-square-bluesky {
    --fa: "\\e6a3"
}

.fa-aviato {
    --fa: "\\f421"
}

.fa-itunes {
    --fa: "\\f3b4"
}

.fa-cuttlefish {
    --fa: "\\f38c"
}

.fa-blogger {
    --fa: "\\f37c"
}

.fa-flickr {
    --fa: "\\f16e"
}

.fa-viber {
    --fa: "\\f409"
}

.fa-soundcloud {
    --fa: "\\f1be"
}

.fa-digg {
    --fa: "\\f1a6"
}

.fa-tencent-weibo {
    --fa: "\\f1d5"
}

.fa-letterboxd {
    --fa: "\\e62d"
}

.fa-symfony {
    --fa: "\\f83d"
}

.fa-maxcdn {
    --fa: "\\f136"
}

.fa-etsy {
    --fa: "\\f2d7"
}

.fa-facebook-messenger {
    --fa: "\\f39f"
}

.fa-audible {
    --fa: "\\f373"
}

.fa-think-peaks {
    --fa: "\\f731"
}

.fa-bilibili {
    --fa: "\\e3d9"
}

.fa-erlang {
    --fa: "\\f39d"
}

.fa-x-twitter {
    --fa: "\\e61b"
}

.fa-cotton-bureau {
    --fa: "\\f89e"
}

.fa-dashcube {
    --fa: "\\f210"
}

.fa-42-group,
.fa-innosoft {
    --fa: "\\e080"
}

.fa-stack-exchange {
    --fa: "\\f18d"
}

.fa-elementor {
    --fa: "\\f430"
}

.fa-pied-piper-square,
.fa-square-pied-piper {
    --fa: "\\e01e"
}

.fa-creative-commons-nd {
    --fa: "\\f4eb"
}

.fa-palfed {
    --fa: "\\f3d8"
}

.fa-superpowers {
    --fa: "\\f2dd"
}

.fa-resolving {
    --fa: "\\f3e7"
}

.fa-xbox {
    --fa: "\\f412"
}

.fa-square-web-awesome-stroke {
    --fa: "\\e684"
}

.fa-searchengin {
    --fa: "\\f3eb"
}

.fa-tiktok {
    --fa: "\\e07b"
}

.fa-facebook-square,
.fa-square-facebook {
    --fa: "\\f082"
}

.fa-renren {
    --fa: "\\f18b"
}

.fa-linux {
    --fa: "\\f17c"
}

.fa-glide {
    --fa: "\\f2a5"
}

.fa-linkedin {
    --fa: "\\f08c"
}

.fa-hubspot {
    --fa: "\\f3b2"
}

.fa-deploydog {
    --fa: "\\f38e"
}

.fa-twitch {
    --fa: "\\f1e8"
}

.fa-flutter {
    --fa: "\\e694"
}

.fa-ravelry {
    --fa: "\\f2d9"
}

.fa-mixer {
    --fa: "\\e056"
}

.fa-lastfm-square,
.fa-square-lastfm {
    --fa: "\\f203"
}

.fa-vimeo {
    --fa: "\\f40a"
}

.fa-mendeley {
    --fa: "\\f7b3"
}

.fa-uniregistry {
    --fa: "\\f404"
}

.fa-figma {
    --fa: "\\f799"
}

.fa-creative-commons-remix {
    --fa: "\\f4ee"
}

.fa-cc-amazon-pay {
    --fa: "\\f42d"
}

.fa-dropbox {
    --fa: "\\f16b"
}

.fa-instagram {
    --fa: "\\f16d"
}

.fa-cmplid {
    --fa: "\\e360"
}

.fa-upwork {
    --fa: "\\e641"
}

.fa-facebook {
    --fa: "\\f09a"
}

.fa-gripfire {
    --fa: "\\f3ac"
}

.fa-jedi-order {
    --fa: "\\f50e"
}

.fa-uikit {
    --fa: "\\f403"
}

.fa-fort-awesome-alt {
    --fa: "\\f3a3"
}

.fa-phabricator {
    --fa: "\\f3db"
}

.fa-ussunnah {
    --fa: "\\f407"
}

.fa-earlybirds {
    --fa: "\\f39a"
}

.fa-trade-federation {
    --fa: "\\f513"
}

.fa-autoprefixer {
    --fa: "\\f41c"
}

.fa-whatsapp {
    --fa: "\\f232"
}

.fa-square-upwork {
    --fa: "\\e67c"
}

.fa-slideshare {
    --fa: "\\f1e7"
}

.fa-google-play {
    --fa: "\\f3ab"
}

.fa-viadeo {
    --fa: "\\f2a9"
}

.fa-line {
    --fa: "\\f3c0"
}

.fa-google-drive {
    --fa: "\\f3aa"
}

.fa-servicestack {
    --fa: "\\f3ec"
}

.fa-simplybuilt {
    --fa: "\\f215"
}

.fa-bitbucket {
    --fa: "\\f171"
}

.fa-imdb {
    --fa: "\\f2d8"
}

.fa-deezer {
    --fa: "\\e077"
}

.fa-raspberry-pi {
    --fa: "\\f7bb"
}

.fa-jira {
    --fa: "\\f7b1"
}

.fa-docker {
    --fa: "\\f395"
}

.fa-screenpal {
    --fa: "\\e570"
}

.fa-bluetooth {
    --fa: "\\f293"
}

.fa-gitter {
    --fa: "\\f426"
}

.fa-d-and-d {
    --fa: "\\f38d"
}

.fa-microblog {
    --fa: "\\e01a"
}

.fa-cc-diners-club {
    --fa: "\\f24c"
}

.fa-gg-circle {
    --fa: "\\f261"
}

.fa-pied-piper-hat {
    --fa: "\\f4e5"
}

.fa-kickstarter-k {
    --fa: "\\f3bc"
}

.fa-yandex {
    --fa: "\\f413"
}

.fa-readme {
    --fa: "\\f4d5"
}

.fa-html5 {
    --fa: "\\f13b"
}

.fa-sellsy {
    --fa: "\\f213"
}

.fa-square-web-awesome {
    --fa: "\\e683"
}

.fa-sass {
    --fa: "\\f41e"
}

.fa-wirsindhandwerk,
.fa-wsh {
    --fa: "\\e2d0"
}

.fa-buromobelexperte {
    --fa: "\\f37f"
}

.fa-salesforce {
    --fa: "\\f83b"
}

.fa-octopus-deploy {
    --fa: "\\e082"
}

.fa-medapps {
    --fa: "\\f3c6"
}

.fa-ns8 {
    --fa: "\\f3d5"
}

.fa-pinterest-p {
    --fa: "\\f231"
}

.fa-apper {
    --fa: "\\f371"
}

.fa-fort-awesome {
    --fa: "\\f286"
}

.fa-waze {
    --fa: "\\f83f"
}

.fa-bluesky {
    --fa: "\\e671"
}

.fa-cc-jcb {
    --fa: "\\f24b"
}

.fa-snapchat,
.fa-snapchat-ghost {
    --fa: "\\f2ab"
}

.fa-fantasy-flight-games {
    --fa: "\\f6dc"
}

.fa-rust {
    --fa: "\\e07a"
}

.fa-wix {
    --fa: "\\f5cf"
}

.fa-behance-square,
.fa-square-behance {
    --fa: "\\f1b5"
}

.fa-supple {
    --fa: "\\f3f9"
}

.fa-webflow {
    --fa: "\\e65c"
}

.fa-rebel {
    --fa: "\\f1d0"
}

.fa-css3 {
    --fa: "\\f13c"
}

.fa-staylinked {
    --fa: "\\f3f5"
}

.fa-kaggle {
    --fa: "\\f5fa"
}

.fa-space-awesome {
    --fa: "\\e5ac"
}

.fa-deviantart {
    --fa: "\\f1bd"
}

.fa-cpanel {
    --fa: "\\f388"
}

.fa-goodreads-g {
    --fa: "\\f3a9"
}

.fa-git-square,
.fa-square-git {
    --fa: "\\f1d2"
}

.fa-square-tumblr,
.fa-tumblr-square {
    --fa: "\\f174"
}

.fa-trello {
    --fa: "\\f181"
}

.fa-creative-commons-nc-jp {
    --fa: "\\f4ea"
}

.fa-get-pocket {
    --fa: "\\f265"
}

.fa-perbyte {
    --fa: "\\e083"
}

.fa-grunt {
    --fa: "\\f3ad"
}

.fa-weebly {
    --fa: "\\f5cc"
}

.fa-connectdevelop {
    --fa: "\\f20e"
}

.fa-leanpub {
    --fa: "\\f212"
}

.fa-black-tie {
    --fa: "\\f27e"
}

.fa-themeco {
    --fa: "\\f5c6"
}

.fa-python {
    --fa: "\\f3e2"
}

.fa-android {
    --fa: "\\f17b"
}

.fa-bots {
    --fa: "\\e340"
}

.fa-free-code-camp {
    --fa: "\\f2c5"
}

.fa-hornbill {
    --fa: "\\f592"
}

.fa-js {
    --fa: "\\f3b8"
}

.fa-ideal {
    --fa: "\\e013"
}

.fa-git {
    --fa: "\\f1d3"
}

.fa-dev {
    --fa: "\\f6cc"
}

.fa-sketch {
    --fa: "\\f7c6"
}

.fa-yandex-international {
    --fa: "\\f414"
}

.fa-cc-amex {
    --fa: "\\f1f3"
}

.fa-uber {
    --fa: "\\f402"
}

.fa-github {
    --fa: "\\f09b"
}

.fa-php {
    --fa: "\\f457"
}

.fa-alipay {
    --fa: "\\f642"
}

.fa-youtube {
    --fa: "\\f167"
}

.fa-skyatlas {
    --fa: "\\f216"
}

.fa-firefox-browser {
    --fa: "\\e007"
}

.fa-replyd {
    --fa: "\\f3e6"
}

.fa-suse {
    --fa: "\\f7d6"
}

.fa-jenkins {
    --fa: "\\f3b6"
}

.fa-twitter {
    --fa: "\\f099"
}

.fa-rockrms {
    --fa: "\\f3e9"
}

.fa-pinterest {
    --fa: "\\f0d2"
}

.fa-buffer {
    --fa: "\\f837"
}

.fa-npm {
    --fa: "\\f3d4"
}

.fa-yammer {
    --fa: "\\f840"
}

.fa-btc {
    --fa: "\\f15a"
}

.fa-dribbble {
    --fa: "\\f17d"
}

.fa-stumbleupon-circle {
    --fa: "\\f1a3"
}

.fa-internet-explorer {
    --fa: "\\f26b"
}

.fa-stubber {
    --fa: "\\e5c7"
}

.fa-telegram,
.fa-telegram-plane {
    --fa: "\\f2c6"
}

.fa-old-republic {
    --fa: "\\f510"
}

.fa-odysee {
    --fa: "\\e5c6"
}

.fa-square-whatsapp,
.fa-whatsapp-square {
    --fa: "\\f40c"
}

.fa-node-js {
    --fa: "\\f3d3"
}

.fa-edge-legacy {
    --fa: "\\e078"
}

.fa-slack,
.fa-slack-hash {
    --fa: "\\f198"
}

.fa-medrt {
    --fa: "\\f3c8"
}

.fa-usb {
    --fa: "\\f287"
}

.fa-tumblr {
    --fa: "\\f173"
}

.fa-vaadin {
    --fa: "\\f408"
}

.fa-quora {
    --fa: "\\f2c4"
}

.fa-square-x-twitter {
    --fa: "\\e61a"
}

.fa-reacteurope {
    --fa: "\\f75d"
}

.fa-medium,
.fa-medium-m {
    --fa: "\\f23a"
}

.fa-amilia {
    --fa: "\\f36d"
}

.fa-mixcloud {
    --fa: "\\f289"
}

.fa-flipboard {
    --fa: "\\f44d"
}

.fa-viacoin {
    --fa: "\\f237"
}

.fa-critical-role {
    --fa: "\\f6c9"
}

.fa-sitrox {
    --fa: "\\e44a"
}

.fa-discourse {
    --fa: "\\f393"
}

.fa-joomla {
    --fa: "\\f1aa"
}

.fa-mastodon {
    --fa: "\\f4f6"
}

.fa-airbnb {
    --fa: "\\f834"
}

.fa-wolf-pack-battalion {
    --fa: "\\f514"
}

.fa-buy-n-large {
    --fa: "\\f8a6"
}

.fa-gulp {
    --fa: "\\f3ae"
}

.fa-creative-commons-sampling-plus {
    --fa: "\\f4f1"
}

.fa-strava {
    --fa: "\\f428"
}

.fa-ember {
    --fa: "\\f423"
}

.fa-canadian-maple-leaf {
    --fa: "\\f785"
}

.fa-teamspeak {
    --fa: "\\f4f9"
}

.fa-pushed {
    --fa: "\\f3e1"
}

.fa-wordpress-simple {
    --fa: "\\f411"
}

.fa-nutritionix {
    --fa: "\\f3d6"
}

.fa-wodu {
    --fa: "\\e088"
}

.fa-google-pay {
    --fa: "\\e079"
}

.fa-intercom {
    --fa: "\\f7af"
}

.fa-zhihu {
    --fa: "\\f63f"
}

.fa-korvue {
    --fa: "\\f42f"
}

.fa-pix {
    --fa: "\\e43a"
}

.fa-steam-symbol {
    --fa: "\\f3f6"
}

:host,
:root {
    --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free"
}

@font-face {
    font-family: "Font Awesome 6 Free";
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype")
}

.fa-regular,
.far {
    font-weight: 400
}

:host,
:root {
    --fa-style-family-classic: "Font Awesome 6 Free";
    --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free"
}

@font-face {
    font-family: "Font Awesome 6 Free";
    font-style: normal;
    font-weight: 900;
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype")
}

.fa-solid,
.fas {
    font-weight: 900
}

@font-face {
    font-family: "Font Awesome 5 Brands";
    font-display: block;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype")
}

@font-face {
    font-family: "Font Awesome 5 Free";
    font-display: block;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype")
}

@font-face {
    font-family: "Font Awesome 5 Free";
    font-display: block;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype")
}

@font-face {
    font-family: "FontAwesome";
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype")
}

@font-face {
    font-family: "FontAwesome";
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype")
}

@font-face {
    font-family: "FontAwesome";
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
    unicode-range: u+f003, u+f006, u+f014, u+f016-f017, u+f01a-f01b, u+f01d, u+f022, u+f03e, u+f044, u+f046, u+f05c-f05d, u+f06e, u+f070, u+f087-f088, u+f08a, u+f094, u+f096-f097, u+f09d, u+f0a0, u+f0a2, u+f0a4-f0a7, u+f0c5, u+f0c7, u+f0e5-f0e6, u+f0eb, u+f0f6-f0f8, u+f10c, u+f114-f115, u+f118-f11a, u+f11c-f11d, u+f133, u+f147, u+f14e, u+f150-f152, u+f185-f186, u+f18e, u+f190-f192, u+f196, u+f1c1-f1c9, u+f1d9, u+f1db, u+f1e3, u+f1ea, u+f1f7, u+f1f9, u+f20a, u+f247-f248, u+f24a, u+f24d, u+f255-f25b, u+f25d, u+f271-f274, u+f278, u+f27b, u+f28c, u+f28e, u+f29c, u+f2b5, u+f2b7, u+f2ba, u+f2bc, u+f2be, u+f2c0-f2c1, u+f2c3, u+f2d0, u+f2d2, u+f2d4, u+f2dc
}

@font-face {
    font-family: "FontAwesome";
    font-display: block;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
    unicode-range: u+f041, u+f047, u+f065-f066, u+f07d-f07e, u+f080, u+f08b, u+f08e, u+f090, u+f09a, u+f0ac, u+f0ae, u+f0b2, u+f0d0, u+f0d6, u+f0e4, u+f0ec, u+f10a-f10b, u+f123, u+f13e, u+f148-f149, u+f14c, u+f156, u+f15e, u+f160-f161, u+f163, u+f175-f178, u+f195, u+f1f8, u+f219, u+f27a
}`, "",{"version":3,"sources":["webpack://./src/statics/css/all.min.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,0DAA0D;IAC1D;AACJ;;AAEA;;;;;;;IAOI,kCAAkC;IAClC,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,uCAAuC;IACvC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,4CAA4C;IAC5C,gGAAgG;IAChG;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,0DAA0D;IAC1D,oDAAoD;IACpD,wEAAwE;IACxE;AACJ;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,0DAA0D;IAC1D,oDAAoD;IACpD,wEAAwE;IACxE;AACJ;;AAEA;IACI,uBAAuB;IACvB,wEAAwE;IACxE;AACJ;;AAEA;;IAEI,8CAA8C;IAC9C,0DAA0D;IAC1D;AACJ;;AAEA;IACI,4BAA4B;IAC5B,wEAAwE;IACxE;AACJ;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,0DAA0D;IAC1D,oDAAoD;IACpD,wEAAwE;IACxE;AACJ;;AAEA;IACI,wBAAwB;IACxB,oDAAoD;IACpD,wEAAwE;IACxE;AACJ;;AAEA;;IAEI,8CAA8C;IAC9C;AACJ;;AAEA;IACI,uBAAuB;IACvB,oDAAoD;IACpD,wEAAwE;IACxE;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,uBAAuB;IACvB,0DAA0D;IAC1D,oDAAoD;IACpD,wEAAwE;IACxE;AACJ;;AAEA;;IAEI;;;;;;;;;QASI,qBAAqB;QACrB,uBAAuB;QACvB,4BAA4B;QAC5B,oBAAoB;QACpB;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI,wCAAwC;QACxC;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,OAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;;IAKI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;;IAKI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;;IAKI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;;IAKI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;;IAII,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;;IAGI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;;;;IAKI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,iDAAiD;IACjD;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gDAAgD;IAChD;AACJ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,wHAAkH;IAClH;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,wHAA0H;IAC1H;AACJ","sourcesContent":["/*!\n * Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n.fa {\n    font-family: var(--fa-style-family, \"Font Awesome 6 Free\");\n    font-weight: var(--fa-style, 900)\n}\n\n.fa,\n.fa-brands,\n.fa-regular,\n.fa-solid,\n.fab,\n.far,\n.fas {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    display: var(--fa-display, inline-block);\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n    text-rendering: auto\n}\n\n.fa-brands:before,\n.fa-regular:before,\n.fa-solid:before,\n.fa:before,\n.fab:before,\n.far:before,\n.fas:before {\n    content: var(--fa)\n}\n\n.fa-classic,\n.fa-regular,\n.fa-solid,\n.far,\n.fas {\n    font-family: \"Font Awesome 6 Free\"\n}\n\n.fa-brands,\n.fab {\n    font-family: \"Font Awesome 6 Brands\"\n}\n\n.fa-1x {\n    font-size: 1em\n}\n\n.fa-2x {\n    font-size: 2em\n}\n\n.fa-3x {\n    font-size: 3em\n}\n\n.fa-4x {\n    font-size: 4em\n}\n\n.fa-5x {\n    font-size: 5em\n}\n\n.fa-6x {\n    font-size: 6em\n}\n\n.fa-7x {\n    font-size: 7em\n}\n\n.fa-8x {\n    font-size: 8em\n}\n\n.fa-9x {\n    font-size: 9em\n}\n\n.fa-10x {\n    font-size: 10em\n}\n\n.fa-2xs {\n    font-size: .625em;\n    line-height: .1em;\n    vertical-align: .225em\n}\n\n.fa-xs {\n    font-size: .75em;\n    line-height: .08333em;\n    vertical-align: .125em\n}\n\n.fa-sm {\n    font-size: .875em;\n    line-height: .07143em;\n    vertical-align: .05357em\n}\n\n.fa-lg {\n    font-size: 1.25em;\n    line-height: .05em;\n    vertical-align: -.075em\n}\n\n.fa-xl {\n    font-size: 1.5em;\n    line-height: .04167em;\n    vertical-align: -.125em\n}\n\n.fa-2xl {\n    font-size: 2em;\n    line-height: .03125em;\n    vertical-align: -.1875em\n}\n\n.fa-fw {\n    text-align: center;\n    width: 1.25em\n}\n\n.fa-ul {\n    list-style-type: none;\n    margin-left: var(--fa-li-margin, 2.5em);\n    padding-left: 0\n}\n\n.fa-ul>li {\n    position: relative\n}\n\n.fa-li {\n    left: calc(var(--fa-li-width, 2em)*-1);\n    position: absolute;\n    text-align: center;\n    width: var(--fa-li-width, 2em);\n    line-height: inherit\n}\n\n.fa-border {\n    border-radius: var(--fa-border-radius, .1em);\n    border: var(--fa-border-width, .08em) var(--fa-border-style, solid) var(--fa-border-color, #eee);\n    padding: var(--fa-border-padding, .2em .25em .15em)\n}\n\n.fa-pull-left {\n    float: left;\n    margin-right: var(--fa-pull-margin, .3em)\n}\n\n.fa-pull-right {\n    float: right;\n    margin-left: var(--fa-pull-margin, .3em)\n}\n\n.fa-beat {\n    animation-name: fa-beat;\n    animation-delay: var(--fa-animation-delay, 0s);\n    animation-direction: var(--fa-animation-direction, normal);\n    animation-duration: var(--fa-animation-duration, 1s);\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, ease-in-out)\n}\n\n.fa-bounce {\n    animation-name: fa-bounce;\n    animation-delay: var(--fa-animation-delay, 0s);\n    animation-direction: var(--fa-animation-direction, normal);\n    animation-duration: var(--fa-animation-duration, 1s);\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, cubic-bezier(.28, .84, .42, 1))\n}\n\n.fa-fade {\n    animation-name: fa-fade;\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, cubic-bezier(.4, 0, .6, 1))\n}\n\n.fa-beat-fade,\n.fa-fade {\n    animation-delay: var(--fa-animation-delay, 0s);\n    animation-direction: var(--fa-animation-direction, normal);\n    animation-duration: var(--fa-animation-duration, 1s)\n}\n\n.fa-beat-fade {\n    animation-name: fa-beat-fade;\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, cubic-bezier(.4, 0, .6, 1))\n}\n\n.fa-flip {\n    animation-name: fa-flip;\n    animation-delay: var(--fa-animation-delay, 0s);\n    animation-direction: var(--fa-animation-direction, normal);\n    animation-duration: var(--fa-animation-duration, 1s);\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, ease-in-out)\n}\n\n.fa-shake {\n    animation-name: fa-shake;\n    animation-duration: var(--fa-animation-duration, 1s);\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, linear)\n}\n\n.fa-shake,\n.fa-spin {\n    animation-delay: var(--fa-animation-delay, 0s);\n    animation-direction: var(--fa-animation-direction, normal)\n}\n\n.fa-spin {\n    animation-name: fa-spin;\n    animation-duration: var(--fa-animation-duration, 2s);\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, linear)\n}\n\n.fa-spin-reverse {\n    --fa-animation-direction: reverse\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n    animation-name: fa-spin;\n    animation-direction: var(--fa-animation-direction, normal);\n    animation-duration: var(--fa-animation-duration, 1s);\n    animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n    animation-timing-function: var(--fa-animation-timing, steps(8))\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .fa-beat,\n    .fa-beat-fade,\n    .fa-bounce,\n    .fa-fade,\n    .fa-flip,\n    .fa-pulse,\n    .fa-shake,\n    .fa-spin,\n    .fa-spin-pulse {\n        animation-delay: -1ms;\n        animation-duration: 1ms;\n        animation-iteration-count: 1;\n        transition-delay: 0s;\n        transition-duration: 0s\n    }\n}\n\n@keyframes fa-beat {\n\n    0%,\n    90% {\n        transform: scale(1)\n    }\n\n    45% {\n        transform: scale(var(--fa-beat-scale, 1.25))\n    }\n}\n\n@keyframes fa-bounce {\n    0% {\n        transform: scale(1) translateY(0)\n    }\n\n    10% {\n        transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, .9)) translateY(0)\n    }\n\n    30% {\n        transform: scale(var(--fa-bounce-jump-scale-x, .9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -.5em))\n    }\n\n    50% {\n        transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, .95)) translateY(0)\n    }\n\n    57% {\n        transform: scale(1) translateY(var(--fa-bounce-rebound, -.125em))\n    }\n\n    64% {\n        transform: scale(1) translateY(0)\n    }\n\n    to {\n        transform: scale(1) translateY(0)\n    }\n}\n\n@keyframes fa-fade {\n    50% {\n        opacity: var(--fa-fade-opacity, .4)\n    }\n}\n\n@keyframes fa-beat-fade {\n\n    0%,\n    to {\n        opacity: var(--fa-beat-fade-opacity, .4);\n        transform: scale(1)\n    }\n\n    50% {\n        opacity: 1;\n        transform: scale(var(--fa-beat-fade-scale, 1.125))\n    }\n}\n\n@keyframes fa-flip {\n    50% {\n        transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg))\n    }\n}\n\n@keyframes fa-shake {\n    0% {\n        transform: rotate(-15deg)\n    }\n\n    4% {\n        transform: rotate(15deg)\n    }\n\n    8%,\n    24% {\n        transform: rotate(-18deg)\n    }\n\n    12%,\n    28% {\n        transform: rotate(18deg)\n    }\n\n    16% {\n        transform: rotate(-22deg)\n    }\n\n    20% {\n        transform: rotate(22deg)\n    }\n\n    32% {\n        transform: rotate(-12deg)\n    }\n\n    36% {\n        transform: rotate(12deg)\n    }\n\n    40%,\n    to {\n        transform: rotate(0deg)\n    }\n}\n\n@keyframes fa-spin {\n    0% {\n        transform: rotate(0deg)\n    }\n\n    to {\n        transform: rotate(1turn)\n    }\n}\n\n.fa-rotate-90 {\n    transform: rotate(90deg)\n}\n\n.fa-rotate-180 {\n    transform: rotate(180deg)\n}\n\n.fa-rotate-270 {\n    transform: rotate(270deg)\n}\n\n.fa-flip-horizontal {\n    transform: scaleX(-1)\n}\n\n.fa-flip-vertical {\n    transform: scaleY(-1)\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n    transform: scale(-1)\n}\n\n.fa-rotate-by {\n    transform: rotate(var(--fa-rotate-angle, 0))\n}\n\n.fa-stack {\n    display: inline-block;\n    height: 2em;\n    line-height: 2em;\n    position: relative;\n    vertical-align: middle;\n    width: 2.5em\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n    left: 0;\n    position: absolute;\n    text-align: center;\n    width: 100%;\n    z-index: var(--fa-stack-z-index, auto)\n}\n\n.fa-stack-1x {\n    line-height: inherit\n}\n\n.fa-stack-2x {\n    font-size: 2em\n}\n\n.fa-inverse {\n    color: var(--fa-inverse, #fff)\n}\n\n.fa-0 {\n    --fa: \"\\30\";\n    --fa--fa: \"\\30\\30\"\n}\n\n.fa-1 {\n    --fa: \"\\31\";\n    --fa--fa: \"\\31\\31\"\n}\n\n.fa-2 {\n    --fa: \"\\32\";\n    --fa--fa: \"\\32\\32\"\n}\n\n.fa-3 {\n    --fa: \"\\33\";\n    --fa--fa: \"\\33\\33\"\n}\n\n.fa-4 {\n    --fa: \"\\34\";\n    --fa--fa: \"\\34\\34\"\n}\n\n.fa-5 {\n    --fa: \"\\35\";\n    --fa--fa: \"\\35\\35\"\n}\n\n.fa-6 {\n    --fa: \"\\36\";\n    --fa--fa: \"\\36\\36\"\n}\n\n.fa-7 {\n    --fa: \"\\37\";\n    --fa--fa: \"\\37\\37\"\n}\n\n.fa-8 {\n    --fa: \"\\38\";\n    --fa--fa: \"\\38\\38\"\n}\n\n.fa-9 {\n    --fa: \"\\39\";\n    --fa--fa: \"\\39\\39\"\n}\n\n.fa-fill-drip {\n    --fa: \"\\f576\";\n    --fa--fa: \"\\f576\\f576\"\n}\n\n.fa-arrows-to-circle {\n    --fa: \"\\e4bd\";\n    --fa--fa: \"\\e4bd\\e4bd\"\n}\n\n.fa-chevron-circle-right,\n.fa-circle-chevron-right {\n    --fa: \"\\f138\";\n    --fa--fa: \"\\f138\\f138\"\n}\n\n.fa-at {\n    --fa: \"\\40\";\n    --fa--fa: \"\\40\\40\"\n}\n\n.fa-trash-alt,\n.fa-trash-can {\n    --fa: \"\\f2ed\";\n    --fa--fa: \"\\f2ed\\f2ed\"\n}\n\n.fa-text-height {\n    --fa: \"\\f034\";\n    --fa--fa: \"\\f034\\f034\"\n}\n\n.fa-user-times,\n.fa-user-xmark {\n    --fa: \"\\f235\";\n    --fa--fa: \"\\f235\\f235\"\n}\n\n.fa-stethoscope {\n    --fa: \"\\f0f1\";\n    --fa--fa: \"\\f0f1\\f0f1\"\n}\n\n.fa-comment-alt,\n.fa-message {\n    --fa: \"\\f27a\";\n    --fa--fa: \"\\f27a\\f27a\"\n}\n\n.fa-info {\n    --fa: \"\\f129\";\n    --fa--fa: \"\\f129\\f129\"\n}\n\n.fa-compress-alt,\n.fa-down-left-and-up-right-to-center {\n    --fa: \"\\f422\";\n    --fa--fa: \"\\f422\\f422\"\n}\n\n.fa-explosion {\n    --fa: \"\\e4e9\";\n    --fa--fa: \"\\e4e9\\e4e9\"\n}\n\n.fa-file-alt,\n.fa-file-lines,\n.fa-file-text {\n    --fa: \"\\f15c\";\n    --fa--fa: \"\\f15c\\f15c\"\n}\n\n.fa-wave-square {\n    --fa: \"\\f83e\";\n    --fa--fa: \"\\f83e\\f83e\"\n}\n\n.fa-ring {\n    --fa: \"\\f70b\";\n    --fa--fa: \"\\f70b\\f70b\"\n}\n\n.fa-building-un {\n    --fa: \"\\e4d9\";\n    --fa--fa: \"\\e4d9\\e4d9\"\n}\n\n.fa-dice-three {\n    --fa: \"\\f527\";\n    --fa--fa: \"\\f527\\f527\"\n}\n\n.fa-calendar-alt,\n.fa-calendar-days {\n    --fa: \"\\f073\";\n    --fa--fa: \"\\f073\\f073\"\n}\n\n.fa-anchor-circle-check {\n    --fa: \"\\e4aa\";\n    --fa--fa: \"\\e4aa\\e4aa\"\n}\n\n.fa-building-circle-arrow-right {\n    --fa: \"\\e4d1\";\n    --fa--fa: \"\\e4d1\\e4d1\"\n}\n\n.fa-volleyball,\n.fa-volleyball-ball {\n    --fa: \"\\f45f\";\n    --fa--fa: \"\\f45f\\f45f\"\n}\n\n.fa-arrows-up-to-line {\n    --fa: \"\\e4c2\";\n    --fa--fa: \"\\e4c2\\e4c2\"\n}\n\n.fa-sort-desc,\n.fa-sort-down {\n    --fa: \"\\f0dd\";\n    --fa--fa: \"\\f0dd\\f0dd\"\n}\n\n.fa-circle-minus,\n.fa-minus-circle {\n    --fa: \"\\f056\";\n    --fa--fa: \"\\f056\\f056\"\n}\n\n.fa-door-open {\n    --fa: \"\\f52b\";\n    --fa--fa: \"\\f52b\\f52b\"\n}\n\n.fa-right-from-bracket,\n.fa-sign-out-alt {\n    --fa: \"\\f2f5\";\n    --fa--fa: \"\\f2f5\\f2f5\"\n}\n\n.fa-atom {\n    --fa: \"\\f5d2\";\n    --fa--fa: \"\\f5d2\\f5d2\"\n}\n\n.fa-soap {\n    --fa: \"\\e06e\";\n    --fa--fa: \"\\e06e\\e06e\"\n}\n\n.fa-heart-music-camera-bolt,\n.fa-icons {\n    --fa: \"\\f86d\";\n    --fa--fa: \"\\f86d\\f86d\"\n}\n\n.fa-microphone-alt-slash,\n.fa-microphone-lines-slash {\n    --fa: \"\\f539\";\n    --fa--fa: \"\\f539\\f539\"\n}\n\n.fa-bridge-circle-check {\n    --fa: \"\\e4c9\";\n    --fa--fa: \"\\e4c9\\e4c9\"\n}\n\n.fa-pump-medical {\n    --fa: \"\\e06a\";\n    --fa--fa: \"\\e06a\\e06a\"\n}\n\n.fa-fingerprint {\n    --fa: \"\\f577\";\n    --fa--fa: \"\\f577\\f577\"\n}\n\n.fa-hand-point-right {\n    --fa: \"\\f0a4\";\n    --fa--fa: \"\\f0a4\\f0a4\"\n}\n\n.fa-magnifying-glass-location,\n.fa-search-location {\n    --fa: \"\\f689\";\n    --fa--fa: \"\\f689\\f689\"\n}\n\n.fa-forward-step,\n.fa-step-forward {\n    --fa: \"\\f051\";\n    --fa--fa: \"\\f051\\f051\"\n}\n\n.fa-face-smile-beam,\n.fa-smile-beam {\n    --fa: \"\\f5b8\";\n    --fa--fa: \"\\f5b8\\f5b8\"\n}\n\n.fa-flag-checkered {\n    --fa: \"\\f11e\";\n    --fa--fa: \"\\f11e\\f11e\"\n}\n\n.fa-football,\n.fa-football-ball {\n    --fa: \"\\f44e\";\n    --fa--fa: \"\\f44e\\f44e\"\n}\n\n.fa-school-circle-exclamation {\n    --fa: \"\\e56c\";\n    --fa--fa: \"\\e56c\\e56c\"\n}\n\n.fa-crop {\n    --fa: \"\\f125\";\n    --fa--fa: \"\\f125\\f125\"\n}\n\n.fa-angle-double-down,\n.fa-angles-down {\n    --fa: \"\\f103\";\n    --fa--fa: \"\\f103\\f103\"\n}\n\n.fa-users-rectangle {\n    --fa: \"\\e594\";\n    --fa--fa: \"\\e594\\e594\"\n}\n\n.fa-people-roof {\n    --fa: \"\\e537\";\n    --fa--fa: \"\\e537\\e537\"\n}\n\n.fa-people-line {\n    --fa: \"\\e534\";\n    --fa--fa: \"\\e534\\e534\"\n}\n\n.fa-beer,\n.fa-beer-mug-empty {\n    --fa: \"\\f0fc\";\n    --fa--fa: \"\\f0fc\\f0fc\"\n}\n\n.fa-diagram-predecessor {\n    --fa: \"\\e477\";\n    --fa--fa: \"\\e477\\e477\"\n}\n\n.fa-arrow-up-long,\n.fa-long-arrow-up {\n    --fa: \"\\f176\";\n    --fa--fa: \"\\f176\\f176\"\n}\n\n.fa-burn,\n.fa-fire-flame-simple {\n    --fa: \"\\f46a\";\n    --fa--fa: \"\\f46a\\f46a\"\n}\n\n.fa-male,\n.fa-person {\n    --fa: \"\\f183\";\n    --fa--fa: \"\\f183\\f183\"\n}\n\n.fa-laptop {\n    --fa: \"\\f109\";\n    --fa--fa: \"\\f109\\f109\"\n}\n\n.fa-file-csv {\n    --fa: \"\\f6dd\";\n    --fa--fa: \"\\f6dd\\f6dd\"\n}\n\n.fa-menorah {\n    --fa: \"\\f676\";\n    --fa--fa: \"\\f676\\f676\"\n}\n\n.fa-truck-plane {\n    --fa: \"\\e58f\";\n    --fa--fa: \"\\e58f\\e58f\"\n}\n\n.fa-record-vinyl {\n    --fa: \"\\f8d9\";\n    --fa--fa: \"\\f8d9\\f8d9\"\n}\n\n.fa-face-grin-stars,\n.fa-grin-stars {\n    --fa: \"\\f587\";\n    --fa--fa: \"\\f587\\f587\"\n}\n\n.fa-bong {\n    --fa: \"\\f55c\";\n    --fa--fa: \"\\f55c\\f55c\"\n}\n\n.fa-pastafarianism,\n.fa-spaghetti-monster-flying {\n    --fa: \"\\f67b\";\n    --fa--fa: \"\\f67b\\f67b\"\n}\n\n.fa-arrow-down-up-across-line {\n    --fa: \"\\e4af\";\n    --fa--fa: \"\\e4af\\e4af\"\n}\n\n.fa-spoon,\n.fa-utensil-spoon {\n    --fa: \"\\f2e5\";\n    --fa--fa: \"\\f2e5\\f2e5\"\n}\n\n.fa-jar-wheat {\n    --fa: \"\\e517\";\n    --fa--fa: \"\\e517\\e517\"\n}\n\n.fa-envelopes-bulk,\n.fa-mail-bulk {\n    --fa: \"\\f674\";\n    --fa--fa: \"\\f674\\f674\"\n}\n\n.fa-file-circle-exclamation {\n    --fa: \"\\e4eb\";\n    --fa--fa: \"\\e4eb\\e4eb\"\n}\n\n.fa-circle-h,\n.fa-hospital-symbol {\n    --fa: \"\\f47e\";\n    --fa--fa: \"\\f47e\\f47e\"\n}\n\n.fa-pager {\n    --fa: \"\\f815\";\n    --fa--fa: \"\\f815\\f815\"\n}\n\n.fa-address-book,\n.fa-contact-book {\n    --fa: \"\\f2b9\";\n    --fa--fa: \"\\f2b9\\f2b9\"\n}\n\n.fa-strikethrough {\n    --fa: \"\\f0cc\";\n    --fa--fa: \"\\f0cc\\f0cc\"\n}\n\n.fa-k {\n    --fa: \"\\4b\";\n    --fa--fa: \"\\4b\\4b\"\n}\n\n.fa-landmark-flag {\n    --fa: \"\\e51c\";\n    --fa--fa: \"\\e51c\\e51c\"\n}\n\n.fa-pencil,\n.fa-pencil-alt {\n    --fa: \"\\f303\";\n    --fa--fa: \"\\f303\\f303\"\n}\n\n.fa-backward {\n    --fa: \"\\f04a\";\n    --fa--fa: \"\\f04a\\f04a\"\n}\n\n.fa-caret-right {\n    --fa: \"\\f0da\";\n    --fa--fa: \"\\f0da\\f0da\"\n}\n\n.fa-comments {\n    --fa: \"\\f086\";\n    --fa--fa: \"\\f086\\f086\"\n}\n\n.fa-file-clipboard,\n.fa-paste {\n    --fa: \"\\f0ea\";\n    --fa--fa: \"\\f0ea\\f0ea\"\n}\n\n.fa-code-pull-request {\n    --fa: \"\\e13c\";\n    --fa--fa: \"\\e13c\\e13c\"\n}\n\n.fa-clipboard-list {\n    --fa: \"\\f46d\";\n    --fa--fa: \"\\f46d\\f46d\"\n}\n\n.fa-truck-loading,\n.fa-truck-ramp-box {\n    --fa: \"\\f4de\";\n    --fa--fa: \"\\f4de\\f4de\"\n}\n\n.fa-user-check {\n    --fa: \"\\f4fc\";\n    --fa--fa: \"\\f4fc\\f4fc\"\n}\n\n.fa-vial-virus {\n    --fa: \"\\e597\";\n    --fa--fa: \"\\e597\\e597\"\n}\n\n.fa-sheet-plastic {\n    --fa: \"\\e571\";\n    --fa--fa: \"\\e571\\e571\"\n}\n\n.fa-blog {\n    --fa: \"\\f781\";\n    --fa--fa: \"\\f781\\f781\"\n}\n\n.fa-user-ninja {\n    --fa: \"\\f504\";\n    --fa--fa: \"\\f504\\f504\"\n}\n\n.fa-person-arrow-up-from-line {\n    --fa: \"\\e539\";\n    --fa--fa: \"\\e539\\e539\"\n}\n\n.fa-scroll-torah,\n.fa-torah {\n    --fa: \"\\f6a0\";\n    --fa--fa: \"\\f6a0\\f6a0\"\n}\n\n.fa-broom-ball,\n.fa-quidditch,\n.fa-quidditch-broom-ball {\n    --fa: \"\\f458\";\n    --fa--fa: \"\\f458\\f458\"\n}\n\n.fa-toggle-off {\n    --fa: \"\\f204\";\n    --fa--fa: \"\\f204\\f204\"\n}\n\n.fa-archive,\n.fa-box-archive {\n    --fa: \"\\f187\";\n    --fa--fa: \"\\f187\\f187\"\n}\n\n.fa-person-drowning {\n    --fa: \"\\e545\";\n    --fa--fa: \"\\e545\\e545\"\n}\n\n.fa-arrow-down-9-1,\n.fa-sort-numeric-desc,\n.fa-sort-numeric-down-alt {\n    --fa: \"\\f886\";\n    --fa--fa: \"\\f886\\f886\"\n}\n\n.fa-face-grin-tongue-squint,\n.fa-grin-tongue-squint {\n    --fa: \"\\f58a\";\n    --fa--fa: \"\\f58a\\f58a\"\n}\n\n.fa-spray-can {\n    --fa: \"\\f5bd\";\n    --fa--fa: \"\\f5bd\\f5bd\"\n}\n\n.fa-truck-monster {\n    --fa: \"\\f63b\";\n    --fa--fa: \"\\f63b\\f63b\"\n}\n\n.fa-w {\n    --fa: \"\\57\";\n    --fa--fa: \"\\57\\57\"\n}\n\n.fa-earth-africa,\n.fa-globe-africa {\n    --fa: \"\\f57c\";\n    --fa--fa: \"\\f57c\\f57c\"\n}\n\n.fa-rainbow {\n    --fa: \"\\f75b\";\n    --fa--fa: \"\\f75b\\f75b\"\n}\n\n.fa-circle-notch {\n    --fa: \"\\f1ce\";\n    --fa--fa: \"\\f1ce\\f1ce\"\n}\n\n.fa-tablet-alt,\n.fa-tablet-screen-button {\n    --fa: \"\\f3fa\";\n    --fa--fa: \"\\f3fa\\f3fa\"\n}\n\n.fa-paw {\n    --fa: \"\\f1b0\";\n    --fa--fa: \"\\f1b0\\f1b0\"\n}\n\n.fa-cloud {\n    --fa: \"\\f0c2\";\n    --fa--fa: \"\\f0c2\\f0c2\"\n}\n\n.fa-trowel-bricks {\n    --fa: \"\\e58a\";\n    --fa--fa: \"\\e58a\\e58a\"\n}\n\n.fa-face-flushed,\n.fa-flushed {\n    --fa: \"\\f579\";\n    --fa--fa: \"\\f579\\f579\"\n}\n\n.fa-hospital-user {\n    --fa: \"\\f80d\";\n    --fa--fa: \"\\f80d\\f80d\"\n}\n\n.fa-tent-arrow-left-right {\n    --fa: \"\\e57f\";\n    --fa--fa: \"\\e57f\\e57f\"\n}\n\n.fa-gavel,\n.fa-legal {\n    --fa: \"\\f0e3\";\n    --fa--fa: \"\\f0e3\\f0e3\"\n}\n\n.fa-binoculars {\n    --fa: \"\\f1e5\";\n    --fa--fa: \"\\f1e5\\f1e5\"\n}\n\n.fa-microphone-slash {\n    --fa: \"\\f131\";\n    --fa--fa: \"\\f131\\f131\"\n}\n\n.fa-box-tissue {\n    --fa: \"\\e05b\";\n    --fa--fa: \"\\e05b\\e05b\"\n}\n\n.fa-motorcycle {\n    --fa: \"\\f21c\";\n    --fa--fa: \"\\f21c\\f21c\"\n}\n\n.fa-bell-concierge,\n.fa-concierge-bell {\n    --fa: \"\\f562\";\n    --fa--fa: \"\\f562\\f562\"\n}\n\n.fa-pen-ruler,\n.fa-pencil-ruler {\n    --fa: \"\\f5ae\";\n    --fa--fa: \"\\f5ae\\f5ae\"\n}\n\n.fa-people-arrows,\n.fa-people-arrows-left-right {\n    --fa: \"\\e068\";\n    --fa--fa: \"\\e068\\e068\"\n}\n\n.fa-mars-and-venus-burst {\n    --fa: \"\\e523\";\n    --fa--fa: \"\\e523\\e523\"\n}\n\n.fa-caret-square-right,\n.fa-square-caret-right {\n    --fa: \"\\f152\";\n    --fa--fa: \"\\f152\\f152\"\n}\n\n.fa-cut,\n.fa-scissors {\n    --fa: \"\\f0c4\";\n    --fa--fa: \"\\f0c4\\f0c4\"\n}\n\n.fa-sun-plant-wilt {\n    --fa: \"\\e57a\";\n    --fa--fa: \"\\e57a\\e57a\"\n}\n\n.fa-toilets-portable {\n    --fa: \"\\e584\";\n    --fa--fa: \"\\e584\\e584\"\n}\n\n.fa-hockey-puck {\n    --fa: \"\\f453\";\n    --fa--fa: \"\\f453\\f453\"\n}\n\n.fa-table {\n    --fa: \"\\f0ce\";\n    --fa--fa: \"\\f0ce\\f0ce\"\n}\n\n.fa-magnifying-glass-arrow-right {\n    --fa: \"\\e521\";\n    --fa--fa: \"\\e521\\e521\"\n}\n\n.fa-digital-tachograph,\n.fa-tachograph-digital {\n    --fa: \"\\f566\";\n    --fa--fa: \"\\f566\\f566\"\n}\n\n.fa-users-slash {\n    --fa: \"\\e073\";\n    --fa--fa: \"\\e073\\e073\"\n}\n\n.fa-clover {\n    --fa: \"\\e139\";\n    --fa--fa: \"\\e139\\e139\"\n}\n\n.fa-mail-reply,\n.fa-reply {\n    --fa: \"\\f3e5\";\n    --fa--fa: \"\\f3e5\\f3e5\"\n}\n\n.fa-star-and-crescent {\n    --fa: \"\\f699\";\n    --fa--fa: \"\\f699\\f699\"\n}\n\n.fa-house-fire {\n    --fa: \"\\e50c\";\n    --fa--fa: \"\\e50c\\e50c\"\n}\n\n.fa-minus-square,\n.fa-square-minus {\n    --fa: \"\\f146\";\n    --fa--fa: \"\\f146\\f146\"\n}\n\n.fa-helicopter {\n    --fa: \"\\f533\";\n    --fa--fa: \"\\f533\\f533\"\n}\n\n.fa-compass {\n    --fa: \"\\f14e\";\n    --fa--fa: \"\\f14e\\f14e\"\n}\n\n.fa-caret-square-down,\n.fa-square-caret-down {\n    --fa: \"\\f150\";\n    --fa--fa: \"\\f150\\f150\"\n}\n\n.fa-file-circle-question {\n    --fa: \"\\e4ef\";\n    --fa--fa: \"\\e4ef\\e4ef\"\n}\n\n.fa-laptop-code {\n    --fa: \"\\f5fc\";\n    --fa--fa: \"\\f5fc\\f5fc\"\n}\n\n.fa-swatchbook {\n    --fa: \"\\f5c3\";\n    --fa--fa: \"\\f5c3\\f5c3\"\n}\n\n.fa-prescription-bottle {\n    --fa: \"\\f485\";\n    --fa--fa: \"\\f485\\f485\"\n}\n\n.fa-bars,\n.fa-navicon {\n    --fa: \"\\f0c9\";\n    --fa--fa: \"\\f0c9\\f0c9\"\n}\n\n.fa-people-group {\n    --fa: \"\\e533\";\n    --fa--fa: \"\\e533\\e533\"\n}\n\n.fa-hourglass-3,\n.fa-hourglass-end {\n    --fa: \"\\f253\";\n    --fa--fa: \"\\f253\\f253\"\n}\n\n.fa-heart-broken,\n.fa-heart-crack {\n    --fa: \"\\f7a9\";\n    --fa--fa: \"\\f7a9\\f7a9\"\n}\n\n.fa-external-link-square-alt,\n.fa-square-up-right {\n    --fa: \"\\f360\";\n    --fa--fa: \"\\f360\\f360\"\n}\n\n.fa-face-kiss-beam,\n.fa-kiss-beam {\n    --fa: \"\\f597\";\n    --fa--fa: \"\\f597\\f597\"\n}\n\n.fa-film {\n    --fa: \"\\f008\";\n    --fa--fa: \"\\f008\\f008\"\n}\n\n.fa-ruler-horizontal {\n    --fa: \"\\f547\";\n    --fa--fa: \"\\f547\\f547\"\n}\n\n.fa-people-robbery {\n    --fa: \"\\e536\";\n    --fa--fa: \"\\e536\\e536\"\n}\n\n.fa-lightbulb {\n    --fa: \"\\f0eb\";\n    --fa--fa: \"\\f0eb\\f0eb\"\n}\n\n.fa-caret-left {\n    --fa: \"\\f0d9\";\n    --fa--fa: \"\\f0d9\\f0d9\"\n}\n\n.fa-circle-exclamation,\n.fa-exclamation-circle {\n    --fa: \"\\f06a\";\n    --fa--fa: \"\\f06a\\f06a\"\n}\n\n.fa-school-circle-xmark {\n    --fa: \"\\e56d\";\n    --fa--fa: \"\\e56d\\e56d\"\n}\n\n.fa-arrow-right-from-bracket,\n.fa-sign-out {\n    --fa: \"\\f08b\";\n    --fa--fa: \"\\f08b\\f08b\"\n}\n\n.fa-chevron-circle-down,\n.fa-circle-chevron-down {\n    --fa: \"\\f13a\";\n    --fa--fa: \"\\f13a\\f13a\"\n}\n\n.fa-unlock-alt,\n.fa-unlock-keyhole {\n    --fa: \"\\f13e\";\n    --fa--fa: \"\\f13e\\f13e\"\n}\n\n.fa-cloud-showers-heavy {\n    --fa: \"\\f740\";\n    --fa--fa: \"\\f740\\f740\"\n}\n\n.fa-headphones-alt,\n.fa-headphones-simple {\n    --fa: \"\\f58f\";\n    --fa--fa: \"\\f58f\\f58f\"\n}\n\n.fa-sitemap {\n    --fa: \"\\f0e8\";\n    --fa--fa: \"\\f0e8\\f0e8\"\n}\n\n.fa-circle-dollar-to-slot,\n.fa-donate {\n    --fa: \"\\f4b9\";\n    --fa--fa: \"\\f4b9\\f4b9\"\n}\n\n.fa-memory {\n    --fa: \"\\f538\";\n    --fa--fa: \"\\f538\\f538\"\n}\n\n.fa-road-spikes {\n    --fa: \"\\e568\";\n    --fa--fa: \"\\e568\\e568\"\n}\n\n.fa-fire-burner {\n    --fa: \"\\e4f1\";\n    --fa--fa: \"\\e4f1\\e4f1\"\n}\n\n.fa-flag {\n    --fa: \"\\f024\";\n    --fa--fa: \"\\f024\\f024\"\n}\n\n.fa-hanukiah {\n    --fa: \"\\f6e6\";\n    --fa--fa: \"\\f6e6\\f6e6\"\n}\n\n.fa-feather {\n    --fa: \"\\f52d\";\n    --fa--fa: \"\\f52d\\f52d\"\n}\n\n.fa-volume-down,\n.fa-volume-low {\n    --fa: \"\\f027\";\n    --fa--fa: \"\\f027\\f027\"\n}\n\n.fa-comment-slash {\n    --fa: \"\\f4b3\";\n    --fa--fa: \"\\f4b3\\f4b3\"\n}\n\n.fa-cloud-sun-rain {\n    --fa: \"\\f743\";\n    --fa--fa: \"\\f743\\f743\"\n}\n\n.fa-compress {\n    --fa: \"\\f066\";\n    --fa--fa: \"\\f066\\f066\"\n}\n\n.fa-wheat-alt,\n.fa-wheat-awn {\n    --fa: \"\\e2cd\";\n    --fa--fa: \"\\e2cd\\e2cd\"\n}\n\n.fa-ankh {\n    --fa: \"\\f644\";\n    --fa--fa: \"\\f644\\f644\"\n}\n\n.fa-hands-holding-child {\n    --fa: \"\\e4fa\";\n    --fa--fa: \"\\e4fa\\e4fa\"\n}\n\n.fa-asterisk {\n    --fa: \"\\2a\";\n    --fa--fa: \"\\2a\\2a\"\n}\n\n.fa-check-square,\n.fa-square-check {\n    --fa: \"\\f14a\";\n    --fa--fa: \"\\f14a\\f14a\"\n}\n\n.fa-peseta-sign {\n    --fa: \"\\e221\";\n    --fa--fa: \"\\e221\\e221\"\n}\n\n.fa-header,\n.fa-heading {\n    --fa: \"\\f1dc\";\n    --fa--fa: \"\\f1dc\\f1dc\"\n}\n\n.fa-ghost {\n    --fa: \"\\f6e2\";\n    --fa--fa: \"\\f6e2\\f6e2\"\n}\n\n.fa-list,\n.fa-list-squares {\n    --fa: \"\\f03a\";\n    --fa--fa: \"\\f03a\\f03a\"\n}\n\n.fa-phone-square-alt,\n.fa-square-phone-flip {\n    --fa: \"\\f87b\";\n    --fa--fa: \"\\f87b\\f87b\"\n}\n\n.fa-cart-plus {\n    --fa: \"\\f217\";\n    --fa--fa: \"\\f217\\f217\"\n}\n\n.fa-gamepad {\n    --fa: \"\\f11b\";\n    --fa--fa: \"\\f11b\\f11b\"\n}\n\n.fa-circle-dot,\n.fa-dot-circle {\n    --fa: \"\\f192\";\n    --fa--fa: \"\\f192\\f192\"\n}\n\n.fa-dizzy,\n.fa-face-dizzy {\n    --fa: \"\\f567\";\n    --fa--fa: \"\\f567\\f567\"\n}\n\n.fa-egg {\n    --fa: \"\\f7fb\";\n    --fa--fa: \"\\f7fb\\f7fb\"\n}\n\n.fa-house-medical-circle-xmark {\n    --fa: \"\\e513\";\n    --fa--fa: \"\\e513\\e513\"\n}\n\n.fa-campground {\n    --fa: \"\\f6bb\";\n    --fa--fa: \"\\f6bb\\f6bb\"\n}\n\n.fa-folder-plus {\n    --fa: \"\\f65e\";\n    --fa--fa: \"\\f65e\\f65e\"\n}\n\n.fa-futbol,\n.fa-futbol-ball,\n.fa-soccer-ball {\n    --fa: \"\\f1e3\";\n    --fa--fa: \"\\f1e3\\f1e3\"\n}\n\n.fa-paint-brush,\n.fa-paintbrush {\n    --fa: \"\\f1fc\";\n    --fa--fa: \"\\f1fc\\f1fc\"\n}\n\n.fa-lock {\n    --fa: \"\\f023\";\n    --fa--fa: \"\\f023\\f023\"\n}\n\n.fa-gas-pump {\n    --fa: \"\\f52f\";\n    --fa--fa: \"\\f52f\\f52f\"\n}\n\n.fa-hot-tub,\n.fa-hot-tub-person {\n    --fa: \"\\f593\";\n    --fa--fa: \"\\f593\\f593\"\n}\n\n.fa-map-location,\n.fa-map-marked {\n    --fa: \"\\f59f\";\n    --fa--fa: \"\\f59f\\f59f\"\n}\n\n.fa-house-flood-water {\n    --fa: \"\\e50e\";\n    --fa--fa: \"\\e50e\\e50e\"\n}\n\n.fa-tree {\n    --fa: \"\\f1bb\";\n    --fa--fa: \"\\f1bb\\f1bb\"\n}\n\n.fa-bridge-lock {\n    --fa: \"\\e4cc\";\n    --fa--fa: \"\\e4cc\\e4cc\"\n}\n\n.fa-sack-dollar {\n    --fa: \"\\f81d\";\n    --fa--fa: \"\\f81d\\f81d\"\n}\n\n.fa-edit,\n.fa-pen-to-square {\n    --fa: \"\\f044\";\n    --fa--fa: \"\\f044\\f044\"\n}\n\n.fa-car-side {\n    --fa: \"\\f5e4\";\n    --fa--fa: \"\\f5e4\\f5e4\"\n}\n\n.fa-share-alt,\n.fa-share-nodes {\n    --fa: \"\\f1e0\";\n    --fa--fa: \"\\f1e0\\f1e0\"\n}\n\n.fa-heart-circle-minus {\n    --fa: \"\\e4ff\";\n    --fa--fa: \"\\e4ff\\e4ff\"\n}\n\n.fa-hourglass-2,\n.fa-hourglass-half {\n    --fa: \"\\f252\";\n    --fa--fa: \"\\f252\\f252\"\n}\n\n.fa-microscope {\n    --fa: \"\\f610\";\n    --fa--fa: \"\\f610\\f610\"\n}\n\n.fa-sink {\n    --fa: \"\\e06d\";\n    --fa--fa: \"\\e06d\\e06d\"\n}\n\n.fa-bag-shopping,\n.fa-shopping-bag {\n    --fa: \"\\f290\";\n    --fa--fa: \"\\f290\\f290\"\n}\n\n.fa-arrow-down-z-a,\n.fa-sort-alpha-desc,\n.fa-sort-alpha-down-alt {\n    --fa: \"\\f881\";\n    --fa--fa: \"\\f881\\f881\"\n}\n\n.fa-mitten {\n    --fa: \"\\f7b5\";\n    --fa--fa: \"\\f7b5\\f7b5\"\n}\n\n.fa-person-rays {\n    --fa: \"\\e54d\";\n    --fa--fa: \"\\e54d\\e54d\"\n}\n\n.fa-users {\n    --fa: \"\\f0c0\";\n    --fa--fa: \"\\f0c0\\f0c0\"\n}\n\n.fa-eye-slash {\n    --fa: \"\\f070\";\n    --fa--fa: \"\\f070\\f070\"\n}\n\n.fa-flask-vial {\n    --fa: \"\\e4f3\";\n    --fa--fa: \"\\e4f3\\e4f3\"\n}\n\n.fa-hand,\n.fa-hand-paper {\n    --fa: \"\\f256\";\n    --fa--fa: \"\\f256\\f256\"\n}\n\n.fa-om {\n    --fa: \"\\f679\";\n    --fa--fa: \"\\f679\\f679\"\n}\n\n.fa-worm {\n    --fa: \"\\e599\";\n    --fa--fa: \"\\e599\\e599\"\n}\n\n.fa-house-circle-xmark {\n    --fa: \"\\e50b\";\n    --fa--fa: \"\\e50b\\e50b\"\n}\n\n.fa-plug {\n    --fa: \"\\f1e6\";\n    --fa--fa: \"\\f1e6\\f1e6\"\n}\n\n.fa-chevron-up {\n    --fa: \"\\f077\";\n    --fa--fa: \"\\f077\\f077\"\n}\n\n.fa-hand-spock {\n    --fa: \"\\f259\";\n    --fa--fa: \"\\f259\\f259\"\n}\n\n.fa-stopwatch {\n    --fa: \"\\f2f2\";\n    --fa--fa: \"\\f2f2\\f2f2\"\n}\n\n.fa-face-kiss,\n.fa-kiss {\n    --fa: \"\\f596\";\n    --fa--fa: \"\\f596\\f596\"\n}\n\n.fa-bridge-circle-xmark {\n    --fa: \"\\e4cb\";\n    --fa--fa: \"\\e4cb\\e4cb\"\n}\n\n.fa-face-grin-tongue,\n.fa-grin-tongue {\n    --fa: \"\\f589\";\n    --fa--fa: \"\\f589\\f589\"\n}\n\n.fa-chess-bishop {\n    --fa: \"\\f43a\";\n    --fa--fa: \"\\f43a\\f43a\"\n}\n\n.fa-face-grin-wink,\n.fa-grin-wink {\n    --fa: \"\\f58c\";\n    --fa--fa: \"\\f58c\\f58c\"\n}\n\n.fa-deaf,\n.fa-deafness,\n.fa-ear-deaf,\n.fa-hard-of-hearing {\n    --fa: \"\\f2a4\";\n    --fa--fa: \"\\f2a4\\f2a4\"\n}\n\n.fa-road-circle-check {\n    --fa: \"\\e564\";\n    --fa--fa: \"\\e564\\e564\"\n}\n\n.fa-dice-five {\n    --fa: \"\\f523\";\n    --fa--fa: \"\\f523\\f523\"\n}\n\n.fa-rss-square,\n.fa-square-rss {\n    --fa: \"\\f143\";\n    --fa--fa: \"\\f143\\f143\"\n}\n\n.fa-land-mine-on {\n    --fa: \"\\e51b\";\n    --fa--fa: \"\\e51b\\e51b\"\n}\n\n.fa-i-cursor {\n    --fa: \"\\f246\";\n    --fa--fa: \"\\f246\\f246\"\n}\n\n.fa-stamp {\n    --fa: \"\\f5bf\";\n    --fa--fa: \"\\f5bf\\f5bf\"\n}\n\n.fa-stairs {\n    --fa: \"\\e289\";\n    --fa--fa: \"\\e289\\e289\"\n}\n\n.fa-i {\n    --fa: \"\\49\";\n    --fa--fa: \"\\49\\49\"\n}\n\n.fa-hryvnia,\n.fa-hryvnia-sign {\n    --fa: \"\\f6f2\";\n    --fa--fa: \"\\f6f2\\f6f2\"\n}\n\n.fa-pills {\n    --fa: \"\\f484\";\n    --fa--fa: \"\\f484\\f484\"\n}\n\n.fa-face-grin-wide,\n.fa-grin-alt {\n    --fa: \"\\f581\";\n    --fa--fa: \"\\f581\\f581\"\n}\n\n.fa-tooth {\n    --fa: \"\\f5c9\";\n    --fa--fa: \"\\f5c9\\f5c9\"\n}\n\n.fa-v {\n    --fa: \"\\56\";\n    --fa--fa: \"\\56\\56\"\n}\n\n.fa-bangladeshi-taka-sign {\n    --fa: \"\\e2e6\";\n    --fa--fa: \"\\e2e6\\e2e6\"\n}\n\n.fa-bicycle {\n    --fa: \"\\f206\";\n    --fa--fa: \"\\f206\\f206\"\n}\n\n.fa-rod-asclepius,\n.fa-rod-snake,\n.fa-staff-aesculapius,\n.fa-staff-snake {\n    --fa: \"\\e579\";\n    --fa--fa: \"\\e579\\e579\"\n}\n\n.fa-head-side-cough-slash {\n    --fa: \"\\e062\";\n    --fa--fa: \"\\e062\\e062\"\n}\n\n.fa-ambulance,\n.fa-truck-medical {\n    --fa: \"\\f0f9\";\n    --fa--fa: \"\\f0f9\\f0f9\"\n}\n\n.fa-wheat-awn-circle-exclamation {\n    --fa: \"\\e598\";\n    --fa--fa: \"\\e598\\e598\"\n}\n\n.fa-snowman {\n    --fa: \"\\f7d0\";\n    --fa--fa: \"\\f7d0\\f7d0\"\n}\n\n.fa-mortar-pestle {\n    --fa: \"\\f5a7\";\n    --fa--fa: \"\\f5a7\\f5a7\"\n}\n\n.fa-road-barrier {\n    --fa: \"\\e562\";\n    --fa--fa: \"\\e562\\e562\"\n}\n\n.fa-school {\n    --fa: \"\\f549\";\n    --fa--fa: \"\\f549\\f549\"\n}\n\n.fa-igloo {\n    --fa: \"\\f7ae\";\n    --fa--fa: \"\\f7ae\\f7ae\"\n}\n\n.fa-joint {\n    --fa: \"\\f595\";\n    --fa--fa: \"\\f595\\f595\"\n}\n\n.fa-angle-right {\n    --fa: \"\\f105\";\n    --fa--fa: \"\\f105\\f105\"\n}\n\n.fa-horse {\n    --fa: \"\\f6f0\";\n    --fa--fa: \"\\f6f0\\f6f0\"\n}\n\n.fa-q {\n    --fa: \"\\51\";\n    --fa--fa: \"\\51\\51\"\n}\n\n.fa-g {\n    --fa: \"\\47\";\n    --fa--fa: \"\\47\\47\"\n}\n\n.fa-notes-medical {\n    --fa: \"\\f481\";\n    --fa--fa: \"\\f481\\f481\"\n}\n\n.fa-temperature-2,\n.fa-temperature-half,\n.fa-thermometer-2,\n.fa-thermometer-half {\n    --fa: \"\\f2c9\";\n    --fa--fa: \"\\f2c9\\f2c9\"\n}\n\n.fa-dong-sign {\n    --fa: \"\\e169\";\n    --fa--fa: \"\\e169\\e169\"\n}\n\n.fa-capsules {\n    --fa: \"\\f46b\";\n    --fa--fa: \"\\f46b\\f46b\"\n}\n\n.fa-poo-bolt,\n.fa-poo-storm {\n    --fa: \"\\f75a\";\n    --fa--fa: \"\\f75a\\f75a\"\n}\n\n.fa-face-frown-open,\n.fa-frown-open {\n    --fa: \"\\f57a\";\n    --fa--fa: \"\\f57a\\f57a\"\n}\n\n.fa-hand-point-up {\n    --fa: \"\\f0a6\";\n    --fa--fa: \"\\f0a6\\f0a6\"\n}\n\n.fa-money-bill {\n    --fa: \"\\f0d6\";\n    --fa--fa: \"\\f0d6\\f0d6\"\n}\n\n.fa-bookmark {\n    --fa: \"\\f02e\";\n    --fa--fa: \"\\f02e\\f02e\"\n}\n\n.fa-align-justify {\n    --fa: \"\\f039\";\n    --fa--fa: \"\\f039\\f039\"\n}\n\n.fa-umbrella-beach {\n    --fa: \"\\f5ca\";\n    --fa--fa: \"\\f5ca\\f5ca\"\n}\n\n.fa-helmet-un {\n    --fa: \"\\e503\";\n    --fa--fa: \"\\e503\\e503\"\n}\n\n.fa-bullseye {\n    --fa: \"\\f140\";\n    --fa--fa: \"\\f140\\f140\"\n}\n\n.fa-bacon {\n    --fa: \"\\f7e5\";\n    --fa--fa: \"\\f7e5\\f7e5\"\n}\n\n.fa-hand-point-down {\n    --fa: \"\\f0a7\";\n    --fa--fa: \"\\f0a7\\f0a7\"\n}\n\n.fa-arrow-up-from-bracket {\n    --fa: \"\\e09a\";\n    --fa--fa: \"\\e09a\\e09a\"\n}\n\n.fa-folder,\n.fa-folder-blank {\n    --fa: \"\\f07b\";\n    --fa--fa: \"\\f07b\\f07b\"\n}\n\n.fa-file-medical-alt,\n.fa-file-waveform {\n    --fa: \"\\f478\";\n    --fa--fa: \"\\f478\\f478\"\n}\n\n.fa-radiation {\n    --fa: \"\\f7b9\";\n    --fa--fa: \"\\f7b9\\f7b9\"\n}\n\n.fa-chart-simple {\n    --fa: \"\\e473\";\n    --fa--fa: \"\\e473\\e473\"\n}\n\n.fa-mars-stroke {\n    --fa: \"\\f229\";\n    --fa--fa: \"\\f229\\f229\"\n}\n\n.fa-vial {\n    --fa: \"\\f492\";\n    --fa--fa: \"\\f492\\f492\"\n}\n\n.fa-dashboard,\n.fa-gauge,\n.fa-gauge-med,\n.fa-tachometer-alt-average {\n    --fa: \"\\f624\";\n    --fa--fa: \"\\f624\\f624\"\n}\n\n.fa-magic-wand-sparkles,\n.fa-wand-magic-sparkles {\n    --fa: \"\\e2ca\";\n    --fa--fa: \"\\e2ca\\e2ca\"\n}\n\n.fa-e {\n    --fa: \"\\45\";\n    --fa--fa: \"\\45\\45\"\n}\n\n.fa-pen-alt,\n.fa-pen-clip {\n    --fa: \"\\f305\";\n    --fa--fa: \"\\f305\\f305\"\n}\n\n.fa-bridge-circle-exclamation {\n    --fa: \"\\e4ca\";\n    --fa--fa: \"\\e4ca\\e4ca\"\n}\n\n.fa-user {\n    --fa: \"\\f007\";\n    --fa--fa: \"\\f007\\f007\"\n}\n\n.fa-school-circle-check {\n    --fa: \"\\e56b\";\n    --fa--fa: \"\\e56b\\e56b\"\n}\n\n.fa-dumpster {\n    --fa: \"\\f793\";\n    --fa--fa: \"\\f793\\f793\"\n}\n\n.fa-shuttle-van,\n.fa-van-shuttle {\n    --fa: \"\\f5b6\";\n    --fa--fa: \"\\f5b6\\f5b6\"\n}\n\n.fa-building-user {\n    --fa: \"\\e4da\";\n    --fa--fa: \"\\e4da\\e4da\"\n}\n\n.fa-caret-square-left,\n.fa-square-caret-left {\n    --fa: \"\\f191\";\n    --fa--fa: \"\\f191\\f191\"\n}\n\n.fa-highlighter {\n    --fa: \"\\f591\";\n    --fa--fa: \"\\f591\\f591\"\n}\n\n.fa-key {\n    --fa: \"\\f084\";\n    --fa--fa: \"\\f084\\f084\"\n}\n\n.fa-bullhorn {\n    --fa: \"\\f0a1\";\n    --fa--fa: \"\\f0a1\\f0a1\"\n}\n\n.fa-globe {\n    --fa: \"\\f0ac\";\n    --fa--fa: \"\\f0ac\\f0ac\"\n}\n\n.fa-synagogue {\n    --fa: \"\\f69b\";\n    --fa--fa: \"\\f69b\\f69b\"\n}\n\n.fa-person-half-dress {\n    --fa: \"\\e548\";\n    --fa--fa: \"\\e548\\e548\"\n}\n\n.fa-road-bridge {\n    --fa: \"\\e563\";\n    --fa--fa: \"\\e563\\e563\"\n}\n\n.fa-location-arrow {\n    --fa: \"\\f124\";\n    --fa--fa: \"\\f124\\f124\"\n}\n\n.fa-c {\n    --fa: \"\\43\";\n    --fa--fa: \"\\43\\43\"\n}\n\n.fa-tablet-button {\n    --fa: \"\\f10a\";\n    --fa--fa: \"\\f10a\\f10a\"\n}\n\n.fa-building-lock {\n    --fa: \"\\e4d6\";\n    --fa--fa: \"\\e4d6\\e4d6\"\n}\n\n.fa-pizza-slice {\n    --fa: \"\\f818\";\n    --fa--fa: \"\\f818\\f818\"\n}\n\n.fa-money-bill-wave {\n    --fa: \"\\f53a\";\n    --fa--fa: \"\\f53a\\f53a\"\n}\n\n.fa-area-chart,\n.fa-chart-area {\n    --fa: \"\\f1fe\";\n    --fa--fa: \"\\f1fe\\f1fe\"\n}\n\n.fa-house-flag {\n    --fa: \"\\e50d\";\n    --fa--fa: \"\\e50d\\e50d\"\n}\n\n.fa-person-circle-minus {\n    --fa: \"\\e540\";\n    --fa--fa: \"\\e540\\e540\"\n}\n\n.fa-ban,\n.fa-cancel {\n    --fa: \"\\f05e\";\n    --fa--fa: \"\\f05e\\f05e\"\n}\n\n.fa-camera-rotate {\n    --fa: \"\\e0d8\";\n    --fa--fa: \"\\e0d8\\e0d8\"\n}\n\n.fa-air-freshener,\n.fa-spray-can-sparkles {\n    --fa: \"\\f5d0\";\n    --fa--fa: \"\\f5d0\\f5d0\"\n}\n\n.fa-star {\n    --fa: \"\\f005\";\n    --fa--fa: \"\\f005\\f005\"\n}\n\n.fa-repeat {\n    --fa: \"\\f363\";\n    --fa--fa: \"\\f363\\f363\"\n}\n\n.fa-cross {\n    --fa: \"\\f654\";\n    --fa--fa: \"\\f654\\f654\"\n}\n\n.fa-box {\n    --fa: \"\\f466\";\n    --fa--fa: \"\\f466\\f466\"\n}\n\n.fa-venus-mars {\n    --fa: \"\\f228\";\n    --fa--fa: \"\\f228\\f228\"\n}\n\n.fa-arrow-pointer,\n.fa-mouse-pointer {\n    --fa: \"\\f245\";\n    --fa--fa: \"\\f245\\f245\"\n}\n\n.fa-expand-arrows-alt,\n.fa-maximize {\n    --fa: \"\\f31e\";\n    --fa--fa: \"\\f31e\\f31e\"\n}\n\n.fa-charging-station {\n    --fa: \"\\f5e7\";\n    --fa--fa: \"\\f5e7\\f5e7\"\n}\n\n.fa-shapes,\n.fa-triangle-circle-square {\n    --fa: \"\\f61f\";\n    --fa--fa: \"\\f61f\\f61f\"\n}\n\n.fa-random,\n.fa-shuffle {\n    --fa: \"\\f074\";\n    --fa--fa: \"\\f074\\f074\"\n}\n\n.fa-person-running,\n.fa-running {\n    --fa: \"\\f70c\";\n    --fa--fa: \"\\f70c\\f70c\"\n}\n\n.fa-mobile-retro {\n    --fa: \"\\e527\";\n    --fa--fa: \"\\e527\\e527\"\n}\n\n.fa-grip-lines-vertical {\n    --fa: \"\\f7a5\";\n    --fa--fa: \"\\f7a5\\f7a5\"\n}\n\n.fa-spider {\n    --fa: \"\\f717\";\n    --fa--fa: \"\\f717\\f717\"\n}\n\n.fa-hands-bound {\n    --fa: \"\\e4f9\";\n    --fa--fa: \"\\e4f9\\e4f9\"\n}\n\n.fa-file-invoice-dollar {\n    --fa: \"\\f571\";\n    --fa--fa: \"\\f571\\f571\"\n}\n\n.fa-plane-circle-exclamation {\n    --fa: \"\\e556\";\n    --fa--fa: \"\\e556\\e556\"\n}\n\n.fa-x-ray {\n    --fa: \"\\f497\";\n    --fa--fa: \"\\f497\\f497\"\n}\n\n.fa-spell-check {\n    --fa: \"\\f891\";\n    --fa--fa: \"\\f891\\f891\"\n}\n\n.fa-slash {\n    --fa: \"\\f715\";\n    --fa--fa: \"\\f715\\f715\"\n}\n\n.fa-computer-mouse,\n.fa-mouse {\n    --fa: \"\\f8cc\";\n    --fa--fa: \"\\f8cc\\f8cc\"\n}\n\n.fa-arrow-right-to-bracket,\n.fa-sign-in {\n    --fa: \"\\f090\";\n    --fa--fa: \"\\f090\\f090\"\n}\n\n.fa-shop-slash,\n.fa-store-alt-slash {\n    --fa: \"\\e070\";\n    --fa--fa: \"\\e070\\e070\"\n}\n\n.fa-server {\n    --fa: \"\\f233\";\n    --fa--fa: \"\\f233\\f233\"\n}\n\n.fa-virus-covid-slash {\n    --fa: \"\\e4a9\";\n    --fa--fa: \"\\e4a9\\e4a9\"\n}\n\n.fa-shop-lock {\n    --fa: \"\\e4a5\";\n    --fa--fa: \"\\e4a5\\e4a5\"\n}\n\n.fa-hourglass-1,\n.fa-hourglass-start {\n    --fa: \"\\f251\";\n    --fa--fa: \"\\f251\\f251\"\n}\n\n.fa-blender-phone {\n    --fa: \"\\f6b6\";\n    --fa--fa: \"\\f6b6\\f6b6\"\n}\n\n.fa-building-wheat {\n    --fa: \"\\e4db\";\n    --fa--fa: \"\\e4db\\e4db\"\n}\n\n.fa-person-breastfeeding {\n    --fa: \"\\e53a\";\n    --fa--fa: \"\\e53a\\e53a\"\n}\n\n.fa-right-to-bracket,\n.fa-sign-in-alt {\n    --fa: \"\\f2f6\";\n    --fa--fa: \"\\f2f6\\f2f6\"\n}\n\n.fa-venus {\n    --fa: \"\\f221\";\n    --fa--fa: \"\\f221\\f221\"\n}\n\n.fa-passport {\n    --fa: \"\\f5ab\";\n    --fa--fa: \"\\f5ab\\f5ab\"\n}\n\n.fa-thumb-tack-slash,\n.fa-thumbtack-slash {\n    --fa: \"\\e68f\";\n    --fa--fa: \"\\e68f\\e68f\"\n}\n\n.fa-heart-pulse,\n.fa-heartbeat {\n    --fa: \"\\f21e\";\n    --fa--fa: \"\\f21e\\f21e\"\n}\n\n.fa-people-carry,\n.fa-people-carry-box {\n    --fa: \"\\f4ce\";\n    --fa--fa: \"\\f4ce\\f4ce\"\n}\n\n.fa-temperature-high {\n    --fa: \"\\f769\";\n    --fa--fa: \"\\f769\\f769\"\n}\n\n.fa-microchip {\n    --fa: \"\\f2db\";\n    --fa--fa: \"\\f2db\\f2db\"\n}\n\n.fa-crown {\n    --fa: \"\\f521\";\n    --fa--fa: \"\\f521\\f521\"\n}\n\n.fa-weight-hanging {\n    --fa: \"\\f5cd\";\n    --fa--fa: \"\\f5cd\\f5cd\"\n}\n\n.fa-xmarks-lines {\n    --fa: \"\\e59a\";\n    --fa--fa: \"\\e59a\\e59a\"\n}\n\n.fa-file-prescription {\n    --fa: \"\\f572\";\n    --fa--fa: \"\\f572\\f572\"\n}\n\n.fa-weight,\n.fa-weight-scale {\n    --fa: \"\\f496\";\n    --fa--fa: \"\\f496\\f496\"\n}\n\n.fa-user-friends,\n.fa-user-group {\n    --fa: \"\\f500\";\n    --fa--fa: \"\\f500\\f500\"\n}\n\n.fa-arrow-up-a-z,\n.fa-sort-alpha-up {\n    --fa: \"\\f15e\";\n    --fa--fa: \"\\f15e\\f15e\"\n}\n\n.fa-chess-knight {\n    --fa: \"\\f441\";\n    --fa--fa: \"\\f441\\f441\"\n}\n\n.fa-face-laugh-squint,\n.fa-laugh-squint {\n    --fa: \"\\f59b\";\n    --fa--fa: \"\\f59b\\f59b\"\n}\n\n.fa-wheelchair {\n    --fa: \"\\f193\";\n    --fa--fa: \"\\f193\\f193\"\n}\n\n.fa-arrow-circle-up,\n.fa-circle-arrow-up {\n    --fa: \"\\f0aa\";\n    --fa--fa: \"\\f0aa\\f0aa\"\n}\n\n.fa-toggle-on {\n    --fa: \"\\f205\";\n    --fa--fa: \"\\f205\\f205\"\n}\n\n.fa-person-walking,\n.fa-walking {\n    --fa: \"\\f554\";\n    --fa--fa: \"\\f554\\f554\"\n}\n\n.fa-l {\n    --fa: \"\\4c\";\n    --fa--fa: \"\\4c\\4c\"\n}\n\n.fa-fire {\n    --fa: \"\\f06d\";\n    --fa--fa: \"\\f06d\\f06d\"\n}\n\n.fa-bed-pulse,\n.fa-procedures {\n    --fa: \"\\f487\";\n    --fa--fa: \"\\f487\\f487\"\n}\n\n.fa-shuttle-space,\n.fa-space-shuttle {\n    --fa: \"\\f197\";\n    --fa--fa: \"\\f197\\f197\"\n}\n\n.fa-face-laugh,\n.fa-laugh {\n    --fa: \"\\f599\";\n    --fa--fa: \"\\f599\\f599\"\n}\n\n.fa-folder-open {\n    --fa: \"\\f07c\";\n    --fa--fa: \"\\f07c\\f07c\"\n}\n\n.fa-heart-circle-plus {\n    --fa: \"\\e500\";\n    --fa--fa: \"\\e500\\e500\"\n}\n\n.fa-code-fork {\n    --fa: \"\\e13b\";\n    --fa--fa: \"\\e13b\\e13b\"\n}\n\n.fa-city {\n    --fa: \"\\f64f\";\n    --fa--fa: \"\\f64f\\f64f\"\n}\n\n.fa-microphone-alt,\n.fa-microphone-lines {\n    --fa: \"\\f3c9\";\n    --fa--fa: \"\\f3c9\\f3c9\"\n}\n\n.fa-pepper-hot {\n    --fa: \"\\f816\";\n    --fa--fa: \"\\f816\\f816\"\n}\n\n.fa-unlock {\n    --fa: \"\\f09c\";\n    --fa--fa: \"\\f09c\\f09c\"\n}\n\n.fa-colon-sign {\n    --fa: \"\\e140\";\n    --fa--fa: \"\\e140\\e140\"\n}\n\n.fa-headset {\n    --fa: \"\\f590\";\n    --fa--fa: \"\\f590\\f590\"\n}\n\n.fa-store-slash {\n    --fa: \"\\e071\";\n    --fa--fa: \"\\e071\\e071\"\n}\n\n.fa-road-circle-xmark {\n    --fa: \"\\e566\";\n    --fa--fa: \"\\e566\\e566\"\n}\n\n.fa-user-minus {\n    --fa: \"\\f503\";\n    --fa--fa: \"\\f503\\f503\"\n}\n\n.fa-mars-stroke-up,\n.fa-mars-stroke-v {\n    --fa: \"\\f22a\";\n    --fa--fa: \"\\f22a\\f22a\"\n}\n\n.fa-champagne-glasses,\n.fa-glass-cheers {\n    --fa: \"\\f79f\";\n    --fa--fa: \"\\f79f\\f79f\"\n}\n\n.fa-clipboard {\n    --fa: \"\\f328\";\n    --fa--fa: \"\\f328\\f328\"\n}\n\n.fa-house-circle-exclamation {\n    --fa: \"\\e50a\";\n    --fa--fa: \"\\e50a\\e50a\"\n}\n\n.fa-file-arrow-up,\n.fa-file-upload {\n    --fa: \"\\f574\";\n    --fa--fa: \"\\f574\\f574\"\n}\n\n.fa-wifi,\n.fa-wifi-3,\n.fa-wifi-strong {\n    --fa: \"\\f1eb\";\n    --fa--fa: \"\\f1eb\\f1eb\"\n}\n\n.fa-bath,\n.fa-bathtub {\n    --fa: \"\\f2cd\";\n    --fa--fa: \"\\f2cd\\f2cd\"\n}\n\n.fa-underline {\n    --fa: \"\\f0cd\";\n    --fa--fa: \"\\f0cd\\f0cd\"\n}\n\n.fa-user-edit,\n.fa-user-pen {\n    --fa: \"\\f4ff\";\n    --fa--fa: \"\\f4ff\\f4ff\"\n}\n\n.fa-signature {\n    --fa: \"\\f5b7\";\n    --fa--fa: \"\\f5b7\\f5b7\"\n}\n\n.fa-stroopwafel {\n    --fa: \"\\f551\";\n    --fa--fa: \"\\f551\\f551\"\n}\n\n.fa-bold {\n    --fa: \"\\f032\";\n    --fa--fa: \"\\f032\\f032\"\n}\n\n.fa-anchor-lock {\n    --fa: \"\\e4ad\";\n    --fa--fa: \"\\e4ad\\e4ad\"\n}\n\n.fa-building-ngo {\n    --fa: \"\\e4d7\";\n    --fa--fa: \"\\e4d7\\e4d7\"\n}\n\n.fa-manat-sign {\n    --fa: \"\\e1d5\";\n    --fa--fa: \"\\e1d5\\e1d5\"\n}\n\n.fa-not-equal {\n    --fa: \"\\f53e\";\n    --fa--fa: \"\\f53e\\f53e\"\n}\n\n.fa-border-style,\n.fa-border-top-left {\n    --fa: \"\\f853\";\n    --fa--fa: \"\\f853\\f853\"\n}\n\n.fa-map-location-dot,\n.fa-map-marked-alt {\n    --fa: \"\\f5a0\";\n    --fa--fa: \"\\f5a0\\f5a0\"\n}\n\n.fa-jedi {\n    --fa: \"\\f669\";\n    --fa--fa: \"\\f669\\f669\"\n}\n\n.fa-poll,\n.fa-square-poll-vertical {\n    --fa: \"\\f681\";\n    --fa--fa: \"\\f681\\f681\"\n}\n\n.fa-mug-hot {\n    --fa: \"\\f7b6\";\n    --fa--fa: \"\\f7b6\\f7b6\"\n}\n\n.fa-battery-car,\n.fa-car-battery {\n    --fa: \"\\f5df\";\n    --fa--fa: \"\\f5df\\f5df\"\n}\n\n.fa-gift {\n    --fa: \"\\f06b\";\n    --fa--fa: \"\\f06b\\f06b\"\n}\n\n.fa-dice-two {\n    --fa: \"\\f528\";\n    --fa--fa: \"\\f528\\f528\"\n}\n\n.fa-chess-queen {\n    --fa: \"\\f445\";\n    --fa--fa: \"\\f445\\f445\"\n}\n\n.fa-glasses {\n    --fa: \"\\f530\";\n    --fa--fa: \"\\f530\\f530\"\n}\n\n.fa-chess-board {\n    --fa: \"\\f43c\";\n    --fa--fa: \"\\f43c\\f43c\"\n}\n\n.fa-building-circle-check {\n    --fa: \"\\e4d2\";\n    --fa--fa: \"\\e4d2\\e4d2\"\n}\n\n.fa-person-chalkboard {\n    --fa: \"\\e53d\";\n    --fa--fa: \"\\e53d\\e53d\"\n}\n\n.fa-mars-stroke-h,\n.fa-mars-stroke-right {\n    --fa: \"\\f22b\";\n    --fa--fa: \"\\f22b\\f22b\"\n}\n\n.fa-hand-back-fist,\n.fa-hand-rock {\n    --fa: \"\\f255\";\n    --fa--fa: \"\\f255\\f255\"\n}\n\n.fa-caret-square-up,\n.fa-square-caret-up {\n    --fa: \"\\f151\";\n    --fa--fa: \"\\f151\\f151\"\n}\n\n.fa-cloud-showers-water {\n    --fa: \"\\e4e4\";\n    --fa--fa: \"\\e4e4\\e4e4\"\n}\n\n.fa-bar-chart,\n.fa-chart-bar {\n    --fa: \"\\f080\";\n    --fa--fa: \"\\f080\\f080\"\n}\n\n.fa-hands-bubbles,\n.fa-hands-wash {\n    --fa: \"\\e05e\";\n    --fa--fa: \"\\e05e\\e05e\"\n}\n\n.fa-less-than-equal {\n    --fa: \"\\f537\";\n    --fa--fa: \"\\f537\\f537\"\n}\n\n.fa-train {\n    --fa: \"\\f238\";\n    --fa--fa: \"\\f238\\f238\"\n}\n\n.fa-eye-low-vision,\n.fa-low-vision {\n    --fa: \"\\f2a8\";\n    --fa--fa: \"\\f2a8\\f2a8\"\n}\n\n.fa-crow {\n    --fa: \"\\f520\";\n    --fa--fa: \"\\f520\\f520\"\n}\n\n.fa-sailboat {\n    --fa: \"\\e445\";\n    --fa--fa: \"\\e445\\e445\"\n}\n\n.fa-window-restore {\n    --fa: \"\\f2d2\";\n    --fa--fa: \"\\f2d2\\f2d2\"\n}\n\n.fa-plus-square,\n.fa-square-plus {\n    --fa: \"\\f0fe\";\n    --fa--fa: \"\\f0fe\\f0fe\"\n}\n\n.fa-torii-gate {\n    --fa: \"\\f6a1\";\n    --fa--fa: \"\\f6a1\\f6a1\"\n}\n\n.fa-frog {\n    --fa: \"\\f52e\";\n    --fa--fa: \"\\f52e\\f52e\"\n}\n\n.fa-bucket {\n    --fa: \"\\e4cf\";\n    --fa--fa: \"\\e4cf\\e4cf\"\n}\n\n.fa-image {\n    --fa: \"\\f03e\";\n    --fa--fa: \"\\f03e\\f03e\"\n}\n\n.fa-microphone {\n    --fa: \"\\f130\";\n    --fa--fa: \"\\f130\\f130\"\n}\n\n.fa-cow {\n    --fa: \"\\f6c8\";\n    --fa--fa: \"\\f6c8\\f6c8\"\n}\n\n.fa-caret-up {\n    --fa: \"\\f0d8\";\n    --fa--fa: \"\\f0d8\\f0d8\"\n}\n\n.fa-screwdriver {\n    --fa: \"\\f54a\";\n    --fa--fa: \"\\f54a\\f54a\"\n}\n\n.fa-folder-closed {\n    --fa: \"\\e185\";\n    --fa--fa: \"\\e185\\e185\"\n}\n\n.fa-house-tsunami {\n    --fa: \"\\e515\";\n    --fa--fa: \"\\e515\\e515\"\n}\n\n.fa-square-nfi {\n    --fa: \"\\e576\";\n    --fa--fa: \"\\e576\\e576\"\n}\n\n.fa-arrow-up-from-ground-water {\n    --fa: \"\\e4b5\";\n    --fa--fa: \"\\e4b5\\e4b5\"\n}\n\n.fa-glass-martini-alt,\n.fa-martini-glass {\n    --fa: \"\\f57b\";\n    --fa--fa: \"\\f57b\\f57b\"\n}\n\n.fa-square-binary {\n    --fa: \"\\e69b\";\n    --fa--fa: \"\\e69b\\e69b\"\n}\n\n.fa-rotate-back,\n.fa-rotate-backward,\n.fa-rotate-left,\n.fa-undo-alt {\n    --fa: \"\\f2ea\";\n    --fa--fa: \"\\f2ea\\f2ea\"\n}\n\n.fa-columns,\n.fa-table-columns {\n    --fa: \"\\f0db\";\n    --fa--fa: \"\\f0db\\f0db\"\n}\n\n.fa-lemon {\n    --fa: \"\\f094\";\n    --fa--fa: \"\\f094\\f094\"\n}\n\n.fa-head-side-mask {\n    --fa: \"\\e063\";\n    --fa--fa: \"\\e063\\e063\"\n}\n\n.fa-handshake {\n    --fa: \"\\f2b5\";\n    --fa--fa: \"\\f2b5\\f2b5\"\n}\n\n.fa-gem {\n    --fa: \"\\f3a5\";\n    --fa--fa: \"\\f3a5\\f3a5\"\n}\n\n.fa-dolly,\n.fa-dolly-box {\n    --fa: \"\\f472\";\n    --fa--fa: \"\\f472\\f472\"\n}\n\n.fa-smoking {\n    --fa: \"\\f48d\";\n    --fa--fa: \"\\f48d\\f48d\"\n}\n\n.fa-compress-arrows-alt,\n.fa-minimize {\n    --fa: \"\\f78c\";\n    --fa--fa: \"\\f78c\\f78c\"\n}\n\n.fa-monument {\n    --fa: \"\\f5a6\";\n    --fa--fa: \"\\f5a6\\f5a6\"\n}\n\n.fa-snowplow {\n    --fa: \"\\f7d2\";\n    --fa--fa: \"\\f7d2\\f7d2\"\n}\n\n.fa-angle-double-right,\n.fa-angles-right {\n    --fa: \"\\f101\";\n    --fa--fa: \"\\f101\\f101\"\n}\n\n.fa-cannabis {\n    --fa: \"\\f55f\";\n    --fa--fa: \"\\f55f\\f55f\"\n}\n\n.fa-circle-play,\n.fa-play-circle {\n    --fa: \"\\f144\";\n    --fa--fa: \"\\f144\\f144\"\n}\n\n.fa-tablets {\n    --fa: \"\\f490\";\n    --fa--fa: \"\\f490\\f490\"\n}\n\n.fa-ethernet {\n    --fa: \"\\f796\";\n    --fa--fa: \"\\f796\\f796\"\n}\n\n.fa-eur,\n.fa-euro,\n.fa-euro-sign {\n    --fa: \"\\f153\";\n    --fa--fa: \"\\f153\\f153\"\n}\n\n.fa-chair {\n    --fa: \"\\f6c0\";\n    --fa--fa: \"\\f6c0\\f6c0\"\n}\n\n.fa-check-circle,\n.fa-circle-check {\n    --fa: \"\\f058\";\n    --fa--fa: \"\\f058\\f058\"\n}\n\n.fa-circle-stop,\n.fa-stop-circle {\n    --fa: \"\\f28d\";\n    --fa--fa: \"\\f28d\\f28d\"\n}\n\n.fa-compass-drafting,\n.fa-drafting-compass {\n    --fa: \"\\f568\";\n    --fa--fa: \"\\f568\\f568\"\n}\n\n.fa-plate-wheat {\n    --fa: \"\\e55a\";\n    --fa--fa: \"\\e55a\\e55a\"\n}\n\n.fa-icicles {\n    --fa: \"\\f7ad\";\n    --fa--fa: \"\\f7ad\\f7ad\"\n}\n\n.fa-person-shelter {\n    --fa: \"\\e54f\";\n    --fa--fa: \"\\e54f\\e54f\"\n}\n\n.fa-neuter {\n    --fa: \"\\f22c\";\n    --fa--fa: \"\\f22c\\f22c\"\n}\n\n.fa-id-badge {\n    --fa: \"\\f2c1\";\n    --fa--fa: \"\\f2c1\\f2c1\"\n}\n\n.fa-marker {\n    --fa: \"\\f5a1\";\n    --fa--fa: \"\\f5a1\\f5a1\"\n}\n\n.fa-face-laugh-beam,\n.fa-laugh-beam {\n    --fa: \"\\f59a\";\n    --fa--fa: \"\\f59a\\f59a\"\n}\n\n.fa-helicopter-symbol {\n    --fa: \"\\e502\";\n    --fa--fa: \"\\e502\\e502\"\n}\n\n.fa-universal-access {\n    --fa: \"\\f29a\";\n    --fa--fa: \"\\f29a\\f29a\"\n}\n\n.fa-chevron-circle-up,\n.fa-circle-chevron-up {\n    --fa: \"\\f139\";\n    --fa--fa: \"\\f139\\f139\"\n}\n\n.fa-lari-sign {\n    --fa: \"\\e1c8\";\n    --fa--fa: \"\\e1c8\\e1c8\"\n}\n\n.fa-volcano {\n    --fa: \"\\f770\";\n    --fa--fa: \"\\f770\\f770\"\n}\n\n.fa-person-walking-dashed-line-arrow-right {\n    --fa: \"\\e553\";\n    --fa--fa: \"\\e553\\e553\"\n}\n\n.fa-gbp,\n.fa-pound-sign,\n.fa-sterling-sign {\n    --fa: \"\\f154\";\n    --fa--fa: \"\\f154\\f154\"\n}\n\n.fa-viruses {\n    --fa: \"\\e076\";\n    --fa--fa: \"\\e076\\e076\"\n}\n\n.fa-square-person-confined {\n    --fa: \"\\e577\";\n    --fa--fa: \"\\e577\\e577\"\n}\n\n.fa-user-tie {\n    --fa: \"\\f508\";\n    --fa--fa: \"\\f508\\f508\"\n}\n\n.fa-arrow-down-long,\n.fa-long-arrow-down {\n    --fa: \"\\f175\";\n    --fa--fa: \"\\f175\\f175\"\n}\n\n.fa-tent-arrow-down-to-line {\n    --fa: \"\\e57e\";\n    --fa--fa: \"\\e57e\\e57e\"\n}\n\n.fa-certificate {\n    --fa: \"\\f0a3\";\n    --fa--fa: \"\\f0a3\\f0a3\"\n}\n\n.fa-mail-reply-all,\n.fa-reply-all {\n    --fa: \"\\f122\";\n    --fa--fa: \"\\f122\\f122\"\n}\n\n.fa-suitcase {\n    --fa: \"\\f0f2\";\n    --fa--fa: \"\\f0f2\\f0f2\"\n}\n\n.fa-person-skating,\n.fa-skating {\n    --fa: \"\\f7c5\";\n    --fa--fa: \"\\f7c5\\f7c5\"\n}\n\n.fa-filter-circle-dollar,\n.fa-funnel-dollar {\n    --fa: \"\\f662\";\n    --fa--fa: \"\\f662\\f662\"\n}\n\n.fa-camera-retro {\n    --fa: \"\\f083\";\n    --fa--fa: \"\\f083\\f083\"\n}\n\n.fa-arrow-circle-down,\n.fa-circle-arrow-down {\n    --fa: \"\\f0ab\";\n    --fa--fa: \"\\f0ab\\f0ab\"\n}\n\n.fa-arrow-right-to-file,\n.fa-file-import {\n    --fa: \"\\f56f\";\n    --fa--fa: \"\\f56f\\f56f\"\n}\n\n.fa-external-link-square,\n.fa-square-arrow-up-right {\n    --fa: \"\\f14c\";\n    --fa--fa: \"\\f14c\\f14c\"\n}\n\n.fa-box-open {\n    --fa: \"\\f49e\";\n    --fa--fa: \"\\f49e\\f49e\"\n}\n\n.fa-scroll {\n    --fa: \"\\f70e\";\n    --fa--fa: \"\\f70e\\f70e\"\n}\n\n.fa-spa {\n    --fa: \"\\f5bb\";\n    --fa--fa: \"\\f5bb\\f5bb\"\n}\n\n.fa-location-pin-lock {\n    --fa: \"\\e51f\";\n    --fa--fa: \"\\e51f\\e51f\"\n}\n\n.fa-pause {\n    --fa: \"\\f04c\";\n    --fa--fa: \"\\f04c\\f04c\"\n}\n\n.fa-hill-avalanche {\n    --fa: \"\\e507\";\n    --fa--fa: \"\\e507\\e507\"\n}\n\n.fa-temperature-0,\n.fa-temperature-empty,\n.fa-thermometer-0,\n.fa-thermometer-empty {\n    --fa: \"\\f2cb\";\n    --fa--fa: \"\\f2cb\\f2cb\"\n}\n\n.fa-bomb {\n    --fa: \"\\f1e2\";\n    --fa--fa: \"\\f1e2\\f1e2\"\n}\n\n.fa-registered {\n    --fa: \"\\f25d\";\n    --fa--fa: \"\\f25d\\f25d\"\n}\n\n.fa-address-card,\n.fa-contact-card,\n.fa-vcard {\n    --fa: \"\\f2bb\";\n    --fa--fa: \"\\f2bb\\f2bb\"\n}\n\n.fa-balance-scale-right,\n.fa-scale-unbalanced-flip {\n    --fa: \"\\f516\";\n    --fa--fa: \"\\f516\\f516\"\n}\n\n.fa-subscript {\n    --fa: \"\\f12c\";\n    --fa--fa: \"\\f12c\\f12c\"\n}\n\n.fa-diamond-turn-right,\n.fa-directions {\n    --fa: \"\\f5eb\";\n    --fa--fa: \"\\f5eb\\f5eb\"\n}\n\n.fa-burst {\n    --fa: \"\\e4dc\";\n    --fa--fa: \"\\e4dc\\e4dc\"\n}\n\n.fa-house-laptop,\n.fa-laptop-house {\n    --fa: \"\\e066\";\n    --fa--fa: \"\\e066\\e066\"\n}\n\n.fa-face-tired,\n.fa-tired {\n    --fa: \"\\f5c8\";\n    --fa--fa: \"\\f5c8\\f5c8\"\n}\n\n.fa-money-bills {\n    --fa: \"\\e1f3\";\n    --fa--fa: \"\\e1f3\\e1f3\"\n}\n\n.fa-smog {\n    --fa: \"\\f75f\";\n    --fa--fa: \"\\f75f\\f75f\"\n}\n\n.fa-crutch {\n    --fa: \"\\f7f7\";\n    --fa--fa: \"\\f7f7\\f7f7\"\n}\n\n.fa-cloud-arrow-up,\n.fa-cloud-upload,\n.fa-cloud-upload-alt {\n    --fa: \"\\f0ee\";\n    --fa--fa: \"\\f0ee\\f0ee\"\n}\n\n.fa-palette {\n    --fa: \"\\f53f\";\n    --fa--fa: \"\\f53f\\f53f\"\n}\n\n.fa-arrows-turn-right {\n    --fa: \"\\e4c0\";\n    --fa--fa: \"\\e4c0\\e4c0\"\n}\n\n.fa-vest {\n    --fa: \"\\e085\";\n    --fa--fa: \"\\e085\\e085\"\n}\n\n.fa-ferry {\n    --fa: \"\\e4ea\";\n    --fa--fa: \"\\e4ea\\e4ea\"\n}\n\n.fa-arrows-down-to-people {\n    --fa: \"\\e4b9\";\n    --fa--fa: \"\\e4b9\\e4b9\"\n}\n\n.fa-seedling,\n.fa-sprout {\n    --fa: \"\\f4d8\";\n    --fa--fa: \"\\f4d8\\f4d8\"\n}\n\n.fa-arrows-alt-h,\n.fa-left-right {\n    --fa: \"\\f337\";\n    --fa--fa: \"\\f337\\f337\"\n}\n\n.fa-boxes-packing {\n    --fa: \"\\e4c7\";\n    --fa--fa: \"\\e4c7\\e4c7\"\n}\n\n.fa-arrow-circle-left,\n.fa-circle-arrow-left {\n    --fa: \"\\f0a8\";\n    --fa--fa: \"\\f0a8\\f0a8\"\n}\n\n.fa-group-arrows-rotate {\n    --fa: \"\\e4f6\";\n    --fa--fa: \"\\e4f6\\e4f6\"\n}\n\n.fa-bowl-food {\n    --fa: \"\\e4c6\";\n    --fa--fa: \"\\e4c6\\e4c6\"\n}\n\n.fa-candy-cane {\n    --fa: \"\\f786\";\n    --fa--fa: \"\\f786\\f786\"\n}\n\n.fa-arrow-down-wide-short,\n.fa-sort-amount-asc,\n.fa-sort-amount-down {\n    --fa: \"\\f160\";\n    --fa--fa: \"\\f160\\f160\"\n}\n\n.fa-cloud-bolt,\n.fa-thunderstorm {\n    --fa: \"\\f76c\";\n    --fa--fa: \"\\f76c\\f76c\"\n}\n\n.fa-remove-format,\n.fa-text-slash {\n    --fa: \"\\f87d\";\n    --fa--fa: \"\\f87d\\f87d\"\n}\n\n.fa-face-smile-wink,\n.fa-smile-wink {\n    --fa: \"\\f4da\";\n    --fa--fa: \"\\f4da\\f4da\"\n}\n\n.fa-file-word {\n    --fa: \"\\f1c2\";\n    --fa--fa: \"\\f1c2\\f1c2\"\n}\n\n.fa-file-powerpoint {\n    --fa: \"\\f1c4\";\n    --fa--fa: \"\\f1c4\\f1c4\"\n}\n\n.fa-arrows-h,\n.fa-arrows-left-right {\n    --fa: \"\\f07e\";\n    --fa--fa: \"\\f07e\\f07e\"\n}\n\n.fa-house-lock {\n    --fa: \"\\e510\";\n    --fa--fa: \"\\e510\\e510\"\n}\n\n.fa-cloud-arrow-down,\n.fa-cloud-download,\n.fa-cloud-download-alt {\n    --fa: \"\\f0ed\";\n    --fa--fa: \"\\f0ed\\f0ed\"\n}\n\n.fa-children {\n    --fa: \"\\e4e1\";\n    --fa--fa: \"\\e4e1\\e4e1\"\n}\n\n.fa-blackboard,\n.fa-chalkboard {\n    --fa: \"\\f51b\";\n    --fa--fa: \"\\f51b\\f51b\"\n}\n\n.fa-user-alt-slash,\n.fa-user-large-slash {\n    --fa: \"\\f4fa\";\n    --fa--fa: \"\\f4fa\\f4fa\"\n}\n\n.fa-envelope-open {\n    --fa: \"\\f2b6\";\n    --fa--fa: \"\\f2b6\\f2b6\"\n}\n\n.fa-handshake-alt-slash,\n.fa-handshake-simple-slash {\n    --fa: \"\\e05f\";\n    --fa--fa: \"\\e05f\\e05f\"\n}\n\n.fa-mattress-pillow {\n    --fa: \"\\e525\";\n    --fa--fa: \"\\e525\\e525\"\n}\n\n.fa-guarani-sign {\n    --fa: \"\\e19a\";\n    --fa--fa: \"\\e19a\\e19a\"\n}\n\n.fa-arrows-rotate,\n.fa-refresh,\n.fa-sync {\n    --fa: \"\\f021\";\n    --fa--fa: \"\\f021\\f021\"\n}\n\n.fa-fire-extinguisher {\n    --fa: \"\\f134\";\n    --fa--fa: \"\\f134\\f134\"\n}\n\n.fa-cruzeiro-sign {\n    --fa: \"\\e152\";\n    --fa--fa: \"\\e152\\e152\"\n}\n\n.fa-greater-than-equal {\n    --fa: \"\\f532\";\n    --fa--fa: \"\\f532\\f532\"\n}\n\n.fa-shield-alt,\n.fa-shield-halved {\n    --fa: \"\\f3ed\";\n    --fa--fa: \"\\f3ed\\f3ed\"\n}\n\n.fa-atlas,\n.fa-book-atlas {\n    --fa: \"\\f558\";\n    --fa--fa: \"\\f558\\f558\"\n}\n\n.fa-virus {\n    --fa: \"\\e074\";\n    --fa--fa: \"\\e074\\e074\"\n}\n\n.fa-envelope-circle-check {\n    --fa: \"\\e4e8\";\n    --fa--fa: \"\\e4e8\\e4e8\"\n}\n\n.fa-layer-group {\n    --fa: \"\\f5fd\";\n    --fa--fa: \"\\f5fd\\f5fd\"\n}\n\n.fa-arrows-to-dot {\n    --fa: \"\\e4be\";\n    --fa--fa: \"\\e4be\\e4be\"\n}\n\n.fa-archway {\n    --fa: \"\\f557\";\n    --fa--fa: \"\\f557\\f557\"\n}\n\n.fa-heart-circle-check {\n    --fa: \"\\e4fd\";\n    --fa--fa: \"\\e4fd\\e4fd\"\n}\n\n.fa-house-chimney-crack,\n.fa-house-damage {\n    --fa: \"\\f6f1\";\n    --fa--fa: \"\\f6f1\\f6f1\"\n}\n\n.fa-file-archive,\n.fa-file-zipper {\n    --fa: \"\\f1c6\";\n    --fa--fa: \"\\f1c6\\f1c6\"\n}\n\n.fa-square {\n    --fa: \"\\f0c8\";\n    --fa--fa: \"\\f0c8\\f0c8\"\n}\n\n.fa-glass-martini,\n.fa-martini-glass-empty {\n    --fa: \"\\f000\";\n    --fa--fa: \"\\f000\\f000\"\n}\n\n.fa-couch {\n    --fa: \"\\f4b8\";\n    --fa--fa: \"\\f4b8\\f4b8\"\n}\n\n.fa-cedi-sign {\n    --fa: \"\\e0df\";\n    --fa--fa: \"\\e0df\\e0df\"\n}\n\n.fa-italic {\n    --fa: \"\\f033\";\n    --fa--fa: \"\\f033\\f033\"\n}\n\n.fa-table-cells-column-lock {\n    --fa: \"\\e678\";\n    --fa--fa: \"\\e678\\e678\"\n}\n\n.fa-church {\n    --fa: \"\\f51d\";\n    --fa--fa: \"\\f51d\\f51d\"\n}\n\n.fa-comments-dollar {\n    --fa: \"\\f653\";\n    --fa--fa: \"\\f653\\f653\"\n}\n\n.fa-democrat {\n    --fa: \"\\f747\";\n    --fa--fa: \"\\f747\\f747\"\n}\n\n.fa-z {\n    --fa: \"\\5a\";\n    --fa--fa: \"\\5a\\5a\"\n}\n\n.fa-person-skiing,\n.fa-skiing {\n    --fa: \"\\f7c9\";\n    --fa--fa: \"\\f7c9\\f7c9\"\n}\n\n.fa-road-lock {\n    --fa: \"\\e567\";\n    --fa--fa: \"\\e567\\e567\"\n}\n\n.fa-a {\n    --fa: \"\\41\";\n    --fa--fa: \"\\41\\41\"\n}\n\n.fa-temperature-arrow-down,\n.fa-temperature-down {\n    --fa: \"\\e03f\";\n    --fa--fa: \"\\e03f\\e03f\"\n}\n\n.fa-feather-alt,\n.fa-feather-pointed {\n    --fa: \"\\f56b\";\n    --fa--fa: \"\\f56b\\f56b\"\n}\n\n.fa-p {\n    --fa: \"\\50\";\n    --fa--fa: \"\\50\\50\"\n}\n\n.fa-snowflake {\n    --fa: \"\\f2dc\";\n    --fa--fa: \"\\f2dc\\f2dc\"\n}\n\n.fa-newspaper {\n    --fa: \"\\f1ea\";\n    --fa--fa: \"\\f1ea\\f1ea\"\n}\n\n.fa-ad,\n.fa-rectangle-ad {\n    --fa: \"\\f641\";\n    --fa--fa: \"\\f641\\f641\"\n}\n\n.fa-arrow-circle-right,\n.fa-circle-arrow-right {\n    --fa: \"\\f0a9\";\n    --fa--fa: \"\\f0a9\\f0a9\"\n}\n\n.fa-filter-circle-xmark {\n    --fa: \"\\e17b\";\n    --fa--fa: \"\\e17b\\e17b\"\n}\n\n.fa-locust {\n    --fa: \"\\e520\";\n    --fa--fa: \"\\e520\\e520\"\n}\n\n.fa-sort,\n.fa-unsorted {\n    --fa: \"\\f0dc\";\n    --fa--fa: \"\\f0dc\\f0dc\"\n}\n\n.fa-list-1-2,\n.fa-list-numeric,\n.fa-list-ol {\n    --fa: \"\\f0cb\";\n    --fa--fa: \"\\f0cb\\f0cb\"\n}\n\n.fa-person-dress-burst {\n    --fa: \"\\e544\";\n    --fa--fa: \"\\e544\\e544\"\n}\n\n.fa-money-check-alt,\n.fa-money-check-dollar {\n    --fa: \"\\f53d\";\n    --fa--fa: \"\\f53d\\f53d\"\n}\n\n.fa-vector-square {\n    --fa: \"\\f5cb\";\n    --fa--fa: \"\\f5cb\\f5cb\"\n}\n\n.fa-bread-slice {\n    --fa: \"\\f7ec\";\n    --fa--fa: \"\\f7ec\\f7ec\"\n}\n\n.fa-language {\n    --fa: \"\\f1ab\";\n    --fa--fa: \"\\f1ab\\f1ab\"\n}\n\n.fa-face-kiss-wink-heart,\n.fa-kiss-wink-heart {\n    --fa: \"\\f598\";\n    --fa--fa: \"\\f598\\f598\"\n}\n\n.fa-filter {\n    --fa: \"\\f0b0\";\n    --fa--fa: \"\\f0b0\\f0b0\"\n}\n\n.fa-question {\n    --fa: \"\\3f\";\n    --fa--fa: \"\\3f\\3f\"\n}\n\n.fa-file-signature {\n    --fa: \"\\f573\";\n    --fa--fa: \"\\f573\\f573\"\n}\n\n.fa-arrows-alt,\n.fa-up-down-left-right {\n    --fa: \"\\f0b2\";\n    --fa--fa: \"\\f0b2\\f0b2\"\n}\n\n.fa-house-chimney-user {\n    --fa: \"\\e065\";\n    --fa--fa: \"\\e065\\e065\"\n}\n\n.fa-hand-holding-heart {\n    --fa: \"\\f4be\";\n    --fa--fa: \"\\f4be\\f4be\"\n}\n\n.fa-puzzle-piece {\n    --fa: \"\\f12e\";\n    --fa--fa: \"\\f12e\\f12e\"\n}\n\n.fa-money-check {\n    --fa: \"\\f53c\";\n    --fa--fa: \"\\f53c\\f53c\"\n}\n\n.fa-star-half-alt,\n.fa-star-half-stroke {\n    --fa: \"\\f5c0\";\n    --fa--fa: \"\\f5c0\\f5c0\"\n}\n\n.fa-code {\n    --fa: \"\\f121\";\n    --fa--fa: \"\\f121\\f121\"\n}\n\n.fa-glass-whiskey,\n.fa-whiskey-glass {\n    --fa: \"\\f7a0\";\n    --fa--fa: \"\\f7a0\\f7a0\"\n}\n\n.fa-building-circle-exclamation {\n    --fa: \"\\e4d3\";\n    --fa--fa: \"\\e4d3\\e4d3\"\n}\n\n.fa-magnifying-glass-chart {\n    --fa: \"\\e522\";\n    --fa--fa: \"\\e522\\e522\"\n}\n\n.fa-arrow-up-right-from-square,\n.fa-external-link {\n    --fa: \"\\f08e\";\n    --fa--fa: \"\\f08e\\f08e\"\n}\n\n.fa-cubes-stacked {\n    --fa: \"\\e4e6\";\n    --fa--fa: \"\\e4e6\\e4e6\"\n}\n\n.fa-krw,\n.fa-won,\n.fa-won-sign {\n    --fa: \"\\f159\";\n    --fa--fa: \"\\f159\\f159\"\n}\n\n.fa-virus-covid {\n    --fa: \"\\e4a8\";\n    --fa--fa: \"\\e4a8\\e4a8\"\n}\n\n.fa-austral-sign {\n    --fa: \"\\e0a9\";\n    --fa--fa: \"\\e0a9\\e0a9\"\n}\n\n.fa-f {\n    --fa: \"\\46\";\n    --fa--fa: \"\\46\\46\"\n}\n\n.fa-leaf {\n    --fa: \"\\f06c\";\n    --fa--fa: \"\\f06c\\f06c\"\n}\n\n.fa-road {\n    --fa: \"\\f018\";\n    --fa--fa: \"\\f018\\f018\"\n}\n\n.fa-cab,\n.fa-taxi {\n    --fa: \"\\f1ba\";\n    --fa--fa: \"\\f1ba\\f1ba\"\n}\n\n.fa-person-circle-plus {\n    --fa: \"\\e541\";\n    --fa--fa: \"\\e541\\e541\"\n}\n\n.fa-chart-pie,\n.fa-pie-chart {\n    --fa: \"\\f200\";\n    --fa--fa: \"\\f200\\f200\"\n}\n\n.fa-bolt-lightning {\n    --fa: \"\\e0b7\";\n    --fa--fa: \"\\e0b7\\e0b7\"\n}\n\n.fa-sack-xmark {\n    --fa: \"\\e56a\";\n    --fa--fa: \"\\e56a\\e56a\"\n}\n\n.fa-file-excel {\n    --fa: \"\\f1c3\";\n    --fa--fa: \"\\f1c3\\f1c3\"\n}\n\n.fa-file-contract {\n    --fa: \"\\f56c\";\n    --fa--fa: \"\\f56c\\f56c\"\n}\n\n.fa-fish-fins {\n    --fa: \"\\e4f2\";\n    --fa--fa: \"\\e4f2\\e4f2\"\n}\n\n.fa-building-flag {\n    --fa: \"\\e4d5\";\n    --fa--fa: \"\\e4d5\\e4d5\"\n}\n\n.fa-face-grin-beam,\n.fa-grin-beam {\n    --fa: \"\\f582\";\n    --fa--fa: \"\\f582\\f582\"\n}\n\n.fa-object-ungroup {\n    --fa: \"\\f248\";\n    --fa--fa: \"\\f248\\f248\"\n}\n\n.fa-poop {\n    --fa: \"\\f619\";\n    --fa--fa: \"\\f619\\f619\"\n}\n\n.fa-location-pin,\n.fa-map-marker {\n    --fa: \"\\f041\";\n    --fa--fa: \"\\f041\\f041\"\n}\n\n.fa-kaaba {\n    --fa: \"\\f66b\";\n    --fa--fa: \"\\f66b\\f66b\"\n}\n\n.fa-toilet-paper {\n    --fa: \"\\f71e\";\n    --fa--fa: \"\\f71e\\f71e\"\n}\n\n.fa-hard-hat,\n.fa-hat-hard,\n.fa-helmet-safety {\n    --fa: \"\\f807\";\n    --fa--fa: \"\\f807\\f807\"\n}\n\n.fa-eject {\n    --fa: \"\\f052\";\n    --fa--fa: \"\\f052\\f052\"\n}\n\n.fa-arrow-alt-circle-right,\n.fa-circle-right {\n    --fa: \"\\f35a\";\n    --fa--fa: \"\\f35a\\f35a\"\n}\n\n.fa-plane-circle-check {\n    --fa: \"\\e555\";\n    --fa--fa: \"\\e555\\e555\"\n}\n\n.fa-face-rolling-eyes,\n.fa-meh-rolling-eyes {\n    --fa: \"\\f5a5\";\n    --fa--fa: \"\\f5a5\\f5a5\"\n}\n\n.fa-object-group {\n    --fa: \"\\f247\";\n    --fa--fa: \"\\f247\\f247\"\n}\n\n.fa-chart-line,\n.fa-line-chart {\n    --fa: \"\\f201\";\n    --fa--fa: \"\\f201\\f201\"\n}\n\n.fa-mask-ventilator {\n    --fa: \"\\e524\";\n    --fa--fa: \"\\e524\\e524\"\n}\n\n.fa-arrow-right {\n    --fa: \"\\f061\";\n    --fa--fa: \"\\f061\\f061\"\n}\n\n.fa-map-signs,\n.fa-signs-post {\n    --fa: \"\\f277\";\n    --fa--fa: \"\\f277\\f277\"\n}\n\n.fa-cash-register {\n    --fa: \"\\f788\";\n    --fa--fa: \"\\f788\\f788\"\n}\n\n.fa-person-circle-question {\n    --fa: \"\\e542\";\n    --fa--fa: \"\\e542\\e542\"\n}\n\n.fa-h {\n    --fa: \"\\48\";\n    --fa--fa: \"\\48\\48\"\n}\n\n.fa-tarp {\n    --fa: \"\\e57b\";\n    --fa--fa: \"\\e57b\\e57b\"\n}\n\n.fa-screwdriver-wrench,\n.fa-tools {\n    --fa: \"\\f7d9\";\n    --fa--fa: \"\\f7d9\\f7d9\"\n}\n\n.fa-arrows-to-eye {\n    --fa: \"\\e4bf\";\n    --fa--fa: \"\\e4bf\\e4bf\"\n}\n\n.fa-plug-circle-bolt {\n    --fa: \"\\e55b\";\n    --fa--fa: \"\\e55b\\e55b\"\n}\n\n.fa-heart {\n    --fa: \"\\f004\";\n    --fa--fa: \"\\f004\\f004\"\n}\n\n.fa-mars-and-venus {\n    --fa: \"\\f224\";\n    --fa--fa: \"\\f224\\f224\"\n}\n\n.fa-home-user,\n.fa-house-user {\n    --fa: \"\\e1b0\";\n    --fa--fa: \"\\e1b0\\e1b0\"\n}\n\n.fa-dumpster-fire {\n    --fa: \"\\f794\";\n    --fa--fa: \"\\f794\\f794\"\n}\n\n.fa-house-crack {\n    --fa: \"\\e3b1\";\n    --fa--fa: \"\\e3b1\\e3b1\"\n}\n\n.fa-cocktail,\n.fa-martini-glass-citrus {\n    --fa: \"\\f561\";\n    --fa--fa: \"\\f561\\f561\"\n}\n\n.fa-face-surprise,\n.fa-surprise {\n    --fa: \"\\f5c2\";\n    --fa--fa: \"\\f5c2\\f5c2\"\n}\n\n.fa-bottle-water {\n    --fa: \"\\e4c5\";\n    --fa--fa: \"\\e4c5\\e4c5\"\n}\n\n.fa-circle-pause,\n.fa-pause-circle {\n    --fa: \"\\f28b\";\n    --fa--fa: \"\\f28b\\f28b\"\n}\n\n.fa-toilet-paper-slash {\n    --fa: \"\\e072\";\n    --fa--fa: \"\\e072\\e072\"\n}\n\n.fa-apple-alt,\n.fa-apple-whole {\n    --fa: \"\\f5d1\";\n    --fa--fa: \"\\f5d1\\f5d1\"\n}\n\n.fa-kitchen-set {\n    --fa: \"\\e51a\";\n    --fa--fa: \"\\e51a\\e51a\"\n}\n\n.fa-r {\n    --fa: \"\\52\";\n    --fa--fa: \"\\52\\52\"\n}\n\n.fa-temperature-1,\n.fa-temperature-quarter,\n.fa-thermometer-1,\n.fa-thermometer-quarter {\n    --fa: \"\\f2ca\";\n    --fa--fa: \"\\f2ca\\f2ca\"\n}\n\n.fa-cube {\n    --fa: \"\\f1b2\";\n    --fa--fa: \"\\f1b2\\f1b2\"\n}\n\n.fa-bitcoin-sign {\n    --fa: \"\\e0b4\";\n    --fa--fa: \"\\e0b4\\e0b4\"\n}\n\n.fa-shield-dog {\n    --fa: \"\\e573\";\n    --fa--fa: \"\\e573\\e573\"\n}\n\n.fa-solar-panel {\n    --fa: \"\\f5ba\";\n    --fa--fa: \"\\f5ba\\f5ba\"\n}\n\n.fa-lock-open {\n    --fa: \"\\f3c1\";\n    --fa--fa: \"\\f3c1\\f3c1\"\n}\n\n.fa-elevator {\n    --fa: \"\\e16d\";\n    --fa--fa: \"\\e16d\\e16d\"\n}\n\n.fa-money-bill-transfer {\n    --fa: \"\\e528\";\n    --fa--fa: \"\\e528\\e528\"\n}\n\n.fa-money-bill-trend-up {\n    --fa: \"\\e529\";\n    --fa--fa: \"\\e529\\e529\"\n}\n\n.fa-house-flood-water-circle-arrow-right {\n    --fa: \"\\e50f\";\n    --fa--fa: \"\\e50f\\e50f\"\n}\n\n.fa-poll-h,\n.fa-square-poll-horizontal {\n    --fa: \"\\f682\";\n    --fa--fa: \"\\f682\\f682\"\n}\n\n.fa-circle {\n    --fa: \"\\f111\";\n    --fa--fa: \"\\f111\\f111\"\n}\n\n.fa-backward-fast,\n.fa-fast-backward {\n    --fa: \"\\f049\";\n    --fa--fa: \"\\f049\\f049\"\n}\n\n.fa-recycle {\n    --fa: \"\\f1b8\";\n    --fa--fa: \"\\f1b8\\f1b8\"\n}\n\n.fa-user-astronaut {\n    --fa: \"\\f4fb\";\n    --fa--fa: \"\\f4fb\\f4fb\"\n}\n\n.fa-plane-slash {\n    --fa: \"\\e069\";\n    --fa--fa: \"\\e069\\e069\"\n}\n\n.fa-trademark {\n    --fa: \"\\f25c\";\n    --fa--fa: \"\\f25c\\f25c\"\n}\n\n.fa-basketball,\n.fa-basketball-ball {\n    --fa: \"\\f434\";\n    --fa--fa: \"\\f434\\f434\"\n}\n\n.fa-satellite-dish {\n    --fa: \"\\f7c0\";\n    --fa--fa: \"\\f7c0\\f7c0\"\n}\n\n.fa-arrow-alt-circle-up,\n.fa-circle-up {\n    --fa: \"\\f35b\";\n    --fa--fa: \"\\f35b\\f35b\"\n}\n\n.fa-mobile-alt,\n.fa-mobile-screen-button {\n    --fa: \"\\f3cd\";\n    --fa--fa: \"\\f3cd\\f3cd\"\n}\n\n.fa-volume-high,\n.fa-volume-up {\n    --fa: \"\\f028\";\n    --fa--fa: \"\\f028\\f028\"\n}\n\n.fa-users-rays {\n    --fa: \"\\e593\";\n    --fa--fa: \"\\e593\\e593\"\n}\n\n.fa-wallet {\n    --fa: \"\\f555\";\n    --fa--fa: \"\\f555\\f555\"\n}\n\n.fa-clipboard-check {\n    --fa: \"\\f46c\";\n    --fa--fa: \"\\f46c\\f46c\"\n}\n\n.fa-file-audio {\n    --fa: \"\\f1c7\";\n    --fa--fa: \"\\f1c7\\f1c7\"\n}\n\n.fa-burger,\n.fa-hamburger {\n    --fa: \"\\f805\";\n    --fa--fa: \"\\f805\\f805\"\n}\n\n.fa-wrench {\n    --fa: \"\\f0ad\";\n    --fa--fa: \"\\f0ad\\f0ad\"\n}\n\n.fa-bugs {\n    --fa: \"\\e4d0\";\n    --fa--fa: \"\\e4d0\\e4d0\"\n}\n\n.fa-rupee,\n.fa-rupee-sign {\n    --fa: \"\\f156\";\n    --fa--fa: \"\\f156\\f156\"\n}\n\n.fa-file-image {\n    --fa: \"\\f1c5\";\n    --fa--fa: \"\\f1c5\\f1c5\"\n}\n\n.fa-circle-question,\n.fa-question-circle {\n    --fa: \"\\f059\";\n    --fa--fa: \"\\f059\\f059\"\n}\n\n.fa-plane-departure {\n    --fa: \"\\f5b0\";\n    --fa--fa: \"\\f5b0\\f5b0\"\n}\n\n.fa-handshake-slash {\n    --fa: \"\\e060\";\n    --fa--fa: \"\\e060\\e060\"\n}\n\n.fa-book-bookmark {\n    --fa: \"\\e0bb\";\n    --fa--fa: \"\\e0bb\\e0bb\"\n}\n\n.fa-code-branch {\n    --fa: \"\\f126\";\n    --fa--fa: \"\\f126\\f126\"\n}\n\n.fa-hat-cowboy {\n    --fa: \"\\f8c0\";\n    --fa--fa: \"\\f8c0\\f8c0\"\n}\n\n.fa-bridge {\n    --fa: \"\\e4c8\";\n    --fa--fa: \"\\e4c8\\e4c8\"\n}\n\n.fa-phone-alt,\n.fa-phone-flip {\n    --fa: \"\\f879\";\n    --fa--fa: \"\\f879\\f879\"\n}\n\n.fa-truck-front {\n    --fa: \"\\e2b7\";\n    --fa--fa: \"\\e2b7\\e2b7\"\n}\n\n.fa-cat {\n    --fa: \"\\f6be\";\n    --fa--fa: \"\\f6be\\f6be\"\n}\n\n.fa-anchor-circle-exclamation {\n    --fa: \"\\e4ab\";\n    --fa--fa: \"\\e4ab\\e4ab\"\n}\n\n.fa-truck-field {\n    --fa: \"\\e58d\";\n    --fa--fa: \"\\e58d\\e58d\"\n}\n\n.fa-route {\n    --fa: \"\\f4d7\";\n    --fa--fa: \"\\f4d7\\f4d7\"\n}\n\n.fa-clipboard-question {\n    --fa: \"\\e4e3\";\n    --fa--fa: \"\\e4e3\\e4e3\"\n}\n\n.fa-panorama {\n    --fa: \"\\e209\";\n    --fa--fa: \"\\e209\\e209\"\n}\n\n.fa-comment-medical {\n    --fa: \"\\f7f5\";\n    --fa--fa: \"\\f7f5\\f7f5\"\n}\n\n.fa-teeth-open {\n    --fa: \"\\f62f\";\n    --fa--fa: \"\\f62f\\f62f\"\n}\n\n.fa-file-circle-minus {\n    --fa: \"\\e4ed\";\n    --fa--fa: \"\\e4ed\\e4ed\"\n}\n\n.fa-tags {\n    --fa: \"\\f02c\";\n    --fa--fa: \"\\f02c\\f02c\"\n}\n\n.fa-wine-glass {\n    --fa: \"\\f4e3\";\n    --fa--fa: \"\\f4e3\\f4e3\"\n}\n\n.fa-fast-forward,\n.fa-forward-fast {\n    --fa: \"\\f050\";\n    --fa--fa: \"\\f050\\f050\"\n}\n\n.fa-face-meh-blank,\n.fa-meh-blank {\n    --fa: \"\\f5a4\";\n    --fa--fa: \"\\f5a4\\f5a4\"\n}\n\n.fa-parking,\n.fa-square-parking {\n    --fa: \"\\f540\";\n    --fa--fa: \"\\f540\\f540\"\n}\n\n.fa-house-signal {\n    --fa: \"\\e012\";\n    --fa--fa: \"\\e012\\e012\"\n}\n\n.fa-bars-progress,\n.fa-tasks-alt {\n    --fa: \"\\f828\";\n    --fa--fa: \"\\f828\\f828\"\n}\n\n.fa-faucet-drip {\n    --fa: \"\\e006\";\n    --fa--fa: \"\\e006\\e006\"\n}\n\n.fa-cart-flatbed,\n.fa-dolly-flatbed {\n    --fa: \"\\f474\";\n    --fa--fa: \"\\f474\\f474\"\n}\n\n.fa-ban-smoking,\n.fa-smoking-ban {\n    --fa: \"\\f54d\";\n    --fa--fa: \"\\f54d\\f54d\"\n}\n\n.fa-terminal {\n    --fa: \"\\f120\";\n    --fa--fa: \"\\f120\\f120\"\n}\n\n.fa-mobile-button {\n    --fa: \"\\f10b\";\n    --fa--fa: \"\\f10b\\f10b\"\n}\n\n.fa-house-medical-flag {\n    --fa: \"\\e514\";\n    --fa--fa: \"\\e514\\e514\"\n}\n\n.fa-basket-shopping,\n.fa-shopping-basket {\n    --fa: \"\\f291\";\n    --fa--fa: \"\\f291\\f291\"\n}\n\n.fa-tape {\n    --fa: \"\\f4db\";\n    --fa--fa: \"\\f4db\\f4db\"\n}\n\n.fa-bus-alt,\n.fa-bus-simple {\n    --fa: \"\\f55e\";\n    --fa--fa: \"\\f55e\\f55e\"\n}\n\n.fa-eye {\n    --fa: \"\\f06e\";\n    --fa--fa: \"\\f06e\\f06e\"\n}\n\n.fa-face-sad-cry,\n.fa-sad-cry {\n    --fa: \"\\f5b3\";\n    --fa--fa: \"\\f5b3\\f5b3\"\n}\n\n.fa-audio-description {\n    --fa: \"\\f29e\";\n    --fa--fa: \"\\f29e\\f29e\"\n}\n\n.fa-person-military-to-person {\n    --fa: \"\\e54c\";\n    --fa--fa: \"\\e54c\\e54c\"\n}\n\n.fa-file-shield {\n    --fa: \"\\e4f0\";\n    --fa--fa: \"\\e4f0\\e4f0\"\n}\n\n.fa-user-slash {\n    --fa: \"\\f506\";\n    --fa--fa: \"\\f506\\f506\"\n}\n\n.fa-pen {\n    --fa: \"\\f304\";\n    --fa--fa: \"\\f304\\f304\"\n}\n\n.fa-tower-observation {\n    --fa: \"\\e586\";\n    --fa--fa: \"\\e586\\e586\"\n}\n\n.fa-file-code {\n    --fa: \"\\f1c9\";\n    --fa--fa: \"\\f1c9\\f1c9\"\n}\n\n.fa-signal,\n.fa-signal-5,\n.fa-signal-perfect {\n    --fa: \"\\f012\";\n    --fa--fa: \"\\f012\\f012\"\n}\n\n.fa-bus {\n    --fa: \"\\f207\";\n    --fa--fa: \"\\f207\\f207\"\n}\n\n.fa-heart-circle-xmark {\n    --fa: \"\\e501\";\n    --fa--fa: \"\\e501\\e501\"\n}\n\n.fa-home-lg,\n.fa-house-chimney {\n    --fa: \"\\e3af\";\n    --fa--fa: \"\\e3af\\e3af\"\n}\n\n.fa-window-maximize {\n    --fa: \"\\f2d0\";\n    --fa--fa: \"\\f2d0\\f2d0\"\n}\n\n.fa-face-frown,\n.fa-frown {\n    --fa: \"\\f119\";\n    --fa--fa: \"\\f119\\f119\"\n}\n\n.fa-prescription {\n    --fa: \"\\f5b1\";\n    --fa--fa: \"\\f5b1\\f5b1\"\n}\n\n.fa-shop,\n.fa-store-alt {\n    --fa: \"\\f54f\";\n    --fa--fa: \"\\f54f\\f54f\"\n}\n\n.fa-floppy-disk,\n.fa-save {\n    --fa: \"\\f0c7\";\n    --fa--fa: \"\\f0c7\\f0c7\"\n}\n\n.fa-vihara {\n    --fa: \"\\f6a7\";\n    --fa--fa: \"\\f6a7\\f6a7\"\n}\n\n.fa-balance-scale-left,\n.fa-scale-unbalanced {\n    --fa: \"\\f515\";\n    --fa--fa: \"\\f515\\f515\"\n}\n\n.fa-sort-asc,\n.fa-sort-up {\n    --fa: \"\\f0de\";\n    --fa--fa: \"\\f0de\\f0de\"\n}\n\n.fa-comment-dots,\n.fa-commenting {\n    --fa: \"\\f4ad\";\n    --fa--fa: \"\\f4ad\\f4ad\"\n}\n\n.fa-plant-wilt {\n    --fa: \"\\e5aa\";\n    --fa--fa: \"\\e5aa\\e5aa\"\n}\n\n.fa-diamond {\n    --fa: \"\\f219\";\n    --fa--fa: \"\\f219\\f219\"\n}\n\n.fa-face-grin-squint,\n.fa-grin-squint {\n    --fa: \"\\f585\";\n    --fa--fa: \"\\f585\\f585\"\n}\n\n.fa-hand-holding-dollar,\n.fa-hand-holding-usd {\n    --fa: \"\\f4c0\";\n    --fa--fa: \"\\f4c0\\f4c0\"\n}\n\n.fa-chart-diagram {\n    --fa: \"\\e695\";\n    --fa--fa: \"\\e695\\e695\"\n}\n\n.fa-bacterium {\n    --fa: \"\\e05a\";\n    --fa--fa: \"\\e05a\\e05a\"\n}\n\n.fa-hand-pointer {\n    --fa: \"\\f25a\";\n    --fa--fa: \"\\f25a\\f25a\"\n}\n\n.fa-drum-steelpan {\n    --fa: \"\\f56a\";\n    --fa--fa: \"\\f56a\\f56a\"\n}\n\n.fa-hand-scissors {\n    --fa: \"\\f257\";\n    --fa--fa: \"\\f257\\f257\"\n}\n\n.fa-hands-praying,\n.fa-praying-hands {\n    --fa: \"\\f684\";\n    --fa--fa: \"\\f684\\f684\"\n}\n\n.fa-arrow-right-rotate,\n.fa-arrow-rotate-forward,\n.fa-arrow-rotate-right,\n.fa-redo {\n    --fa: \"\\f01e\";\n    --fa--fa: \"\\f01e\\f01e\"\n}\n\n.fa-biohazard {\n    --fa: \"\\f780\";\n    --fa--fa: \"\\f780\\f780\"\n}\n\n.fa-location,\n.fa-location-crosshairs {\n    --fa: \"\\f601\";\n    --fa--fa: \"\\f601\\f601\"\n}\n\n.fa-mars-double {\n    --fa: \"\\f227\";\n    --fa--fa: \"\\f227\\f227\"\n}\n\n.fa-child-dress {\n    --fa: \"\\e59c\";\n    --fa--fa: \"\\e59c\\e59c\"\n}\n\n.fa-users-between-lines {\n    --fa: \"\\e591\";\n    --fa--fa: \"\\e591\\e591\"\n}\n\n.fa-lungs-virus {\n    --fa: \"\\e067\";\n    --fa--fa: \"\\e067\\e067\"\n}\n\n.fa-face-grin-tears,\n.fa-grin-tears {\n    --fa: \"\\f588\";\n    --fa--fa: \"\\f588\\f588\"\n}\n\n.fa-phone {\n    --fa: \"\\f095\";\n    --fa--fa: \"\\f095\\f095\"\n}\n\n.fa-calendar-times,\n.fa-calendar-xmark {\n    --fa: \"\\f273\";\n    --fa--fa: \"\\f273\\f273\"\n}\n\n.fa-child-reaching {\n    --fa: \"\\e59d\";\n    --fa--fa: \"\\e59d\\e59d\"\n}\n\n.fa-head-side-virus {\n    --fa: \"\\e064\";\n    --fa--fa: \"\\e064\\e064\"\n}\n\n.fa-user-cog,\n.fa-user-gear {\n    --fa: \"\\f4fe\";\n    --fa--fa: \"\\f4fe\\f4fe\"\n}\n\n.fa-arrow-up-1-9,\n.fa-sort-numeric-up {\n    --fa: \"\\f163\";\n    --fa--fa: \"\\f163\\f163\"\n}\n\n.fa-door-closed {\n    --fa: \"\\f52a\";\n    --fa--fa: \"\\f52a\\f52a\"\n}\n\n.fa-shield-virus {\n    --fa: \"\\e06c\";\n    --fa--fa: \"\\e06c\\e06c\"\n}\n\n.fa-dice-six {\n    --fa: \"\\f526\";\n    --fa--fa: \"\\f526\\f526\"\n}\n\n.fa-mosquito-net {\n    --fa: \"\\e52c\";\n    --fa--fa: \"\\e52c\\e52c\"\n}\n\n.fa-file-fragment {\n    --fa: \"\\e697\";\n    --fa--fa: \"\\e697\\e697\"\n}\n\n.fa-bridge-water {\n    --fa: \"\\e4ce\";\n    --fa--fa: \"\\e4ce\\e4ce\"\n}\n\n.fa-person-booth {\n    --fa: \"\\f756\";\n    --fa--fa: \"\\f756\\f756\"\n}\n\n.fa-text-width {\n    --fa: \"\\f035\";\n    --fa--fa: \"\\f035\\f035\"\n}\n\n.fa-hat-wizard {\n    --fa: \"\\f6e8\";\n    --fa--fa: \"\\f6e8\\f6e8\"\n}\n\n.fa-pen-fancy {\n    --fa: \"\\f5ac\";\n    --fa--fa: \"\\f5ac\\f5ac\"\n}\n\n.fa-digging,\n.fa-person-digging {\n    --fa: \"\\f85e\";\n    --fa--fa: \"\\f85e\\f85e\"\n}\n\n.fa-trash {\n    --fa: \"\\f1f8\";\n    --fa--fa: \"\\f1f8\\f1f8\"\n}\n\n.fa-gauge-simple,\n.fa-gauge-simple-med,\n.fa-tachometer-average {\n    --fa: \"\\f629\";\n    --fa--fa: \"\\f629\\f629\"\n}\n\n.fa-book-medical {\n    --fa: \"\\f7e6\";\n    --fa--fa: \"\\f7e6\\f7e6\"\n}\n\n.fa-poo {\n    --fa: \"\\f2fe\";\n    --fa--fa: \"\\f2fe\\f2fe\"\n}\n\n.fa-quote-right,\n.fa-quote-right-alt {\n    --fa: \"\\f10e\";\n    --fa--fa: \"\\f10e\\f10e\"\n}\n\n.fa-shirt,\n.fa-t-shirt,\n.fa-tshirt {\n    --fa: \"\\f553\";\n    --fa--fa: \"\\f553\\f553\"\n}\n\n.fa-cubes {\n    --fa: \"\\f1b3\";\n    --fa--fa: \"\\f1b3\\f1b3\"\n}\n\n.fa-divide {\n    --fa: \"\\f529\";\n    --fa--fa: \"\\f529\\f529\"\n}\n\n.fa-tenge,\n.fa-tenge-sign {\n    --fa: \"\\f7d7\";\n    --fa--fa: \"\\f7d7\\f7d7\"\n}\n\n.fa-headphones {\n    --fa: \"\\f025\";\n    --fa--fa: \"\\f025\\f025\"\n}\n\n.fa-hands-holding {\n    --fa: \"\\f4c2\";\n    --fa--fa: \"\\f4c2\\f4c2\"\n}\n\n.fa-hands-clapping {\n    --fa: \"\\e1a8\";\n    --fa--fa: \"\\e1a8\\e1a8\"\n}\n\n.fa-republican {\n    --fa: \"\\f75e\";\n    --fa--fa: \"\\f75e\\f75e\"\n}\n\n.fa-arrow-left {\n    --fa: \"\\f060\";\n    --fa--fa: \"\\f060\\f060\"\n}\n\n.fa-person-circle-xmark {\n    --fa: \"\\e543\";\n    --fa--fa: \"\\e543\\e543\"\n}\n\n.fa-ruler {\n    --fa: \"\\f545\";\n    --fa--fa: \"\\f545\\f545\"\n}\n\n.fa-align-left {\n    --fa: \"\\f036\";\n    --fa--fa: \"\\f036\\f036\"\n}\n\n.fa-dice-d6 {\n    --fa: \"\\f6d1\";\n    --fa--fa: \"\\f6d1\\f6d1\"\n}\n\n.fa-restroom {\n    --fa: \"\\f7bd\";\n    --fa--fa: \"\\f7bd\\f7bd\"\n}\n\n.fa-j {\n    --fa: \"\\4a\";\n    --fa--fa: \"\\4a\\4a\"\n}\n\n.fa-users-viewfinder {\n    --fa: \"\\e595\";\n    --fa--fa: \"\\e595\\e595\"\n}\n\n.fa-file-video {\n    --fa: \"\\f1c8\";\n    --fa--fa: \"\\f1c8\\f1c8\"\n}\n\n.fa-external-link-alt,\n.fa-up-right-from-square {\n    --fa: \"\\f35d\";\n    --fa--fa: \"\\f35d\\f35d\"\n}\n\n.fa-table-cells,\n.fa-th {\n    --fa: \"\\f00a\";\n    --fa--fa: \"\\f00a\\f00a\"\n}\n\n.fa-file-pdf {\n    --fa: \"\\f1c1\";\n    --fa--fa: \"\\f1c1\\f1c1\"\n}\n\n.fa-bible,\n.fa-book-bible {\n    --fa: \"\\f647\";\n    --fa--fa: \"\\f647\\f647\"\n}\n\n.fa-o {\n    --fa: \"\\4f\";\n    --fa--fa: \"\\4f\\4f\"\n}\n\n.fa-medkit,\n.fa-suitcase-medical {\n    --fa: \"\\f0fa\";\n    --fa--fa: \"\\f0fa\\f0fa\"\n}\n\n.fa-user-secret {\n    --fa: \"\\f21b\";\n    --fa--fa: \"\\f21b\\f21b\"\n}\n\n.fa-otter {\n    --fa: \"\\f700\";\n    --fa--fa: \"\\f700\\f700\"\n}\n\n.fa-female,\n.fa-person-dress {\n    --fa: \"\\f182\";\n    --fa--fa: \"\\f182\\f182\"\n}\n\n.fa-comment-dollar {\n    --fa: \"\\f651\";\n    --fa--fa: \"\\f651\\f651\"\n}\n\n.fa-briefcase-clock,\n.fa-business-time {\n    --fa: \"\\f64a\";\n    --fa--fa: \"\\f64a\\f64a\"\n}\n\n.fa-table-cells-large,\n.fa-th-large {\n    --fa: \"\\f009\";\n    --fa--fa: \"\\f009\\f009\"\n}\n\n.fa-book-tanakh,\n.fa-tanakh {\n    --fa: \"\\f827\";\n    --fa--fa: \"\\f827\\f827\"\n}\n\n.fa-phone-volume,\n.fa-volume-control-phone {\n    --fa: \"\\f2a0\";\n    --fa--fa: \"\\f2a0\\f2a0\"\n}\n\n.fa-hat-cowboy-side {\n    --fa: \"\\f8c1\";\n    --fa--fa: \"\\f8c1\\f8c1\"\n}\n\n.fa-clipboard-user {\n    --fa: \"\\f7f3\";\n    --fa--fa: \"\\f7f3\\f7f3\"\n}\n\n.fa-child {\n    --fa: \"\\f1ae\";\n    --fa--fa: \"\\f1ae\\f1ae\"\n}\n\n.fa-lira-sign {\n    --fa: \"\\f195\";\n    --fa--fa: \"\\f195\\f195\"\n}\n\n.fa-satellite {\n    --fa: \"\\f7bf\";\n    --fa--fa: \"\\f7bf\\f7bf\"\n}\n\n.fa-plane-lock {\n    --fa: \"\\e558\";\n    --fa--fa: \"\\e558\\e558\"\n}\n\n.fa-tag {\n    --fa: \"\\f02b\";\n    --fa--fa: \"\\f02b\\f02b\"\n}\n\n.fa-comment {\n    --fa: \"\\f075\";\n    --fa--fa: \"\\f075\\f075\"\n}\n\n.fa-birthday-cake,\n.fa-cake,\n.fa-cake-candles {\n    --fa: \"\\f1fd\";\n    --fa--fa: \"\\f1fd\\f1fd\"\n}\n\n.fa-envelope {\n    --fa: \"\\f0e0\";\n    --fa--fa: \"\\f0e0\\f0e0\"\n}\n\n.fa-angle-double-up,\n.fa-angles-up {\n    --fa: \"\\f102\";\n    --fa--fa: \"\\f102\\f102\"\n}\n\n.fa-paperclip {\n    --fa: \"\\f0c6\";\n    --fa--fa: \"\\f0c6\\f0c6\"\n}\n\n.fa-arrow-right-to-city {\n    --fa: \"\\e4b3\";\n    --fa--fa: \"\\e4b3\\e4b3\"\n}\n\n.fa-ribbon {\n    --fa: \"\\f4d6\";\n    --fa--fa: \"\\f4d6\\f4d6\"\n}\n\n.fa-lungs {\n    --fa: \"\\f604\";\n    --fa--fa: \"\\f604\\f604\"\n}\n\n.fa-arrow-up-9-1,\n.fa-sort-numeric-up-alt {\n    --fa: \"\\f887\";\n    --fa--fa: \"\\f887\\f887\"\n}\n\n.fa-litecoin-sign {\n    --fa: \"\\e1d3\";\n    --fa--fa: \"\\e1d3\\e1d3\"\n}\n\n.fa-border-none {\n    --fa: \"\\f850\";\n    --fa--fa: \"\\f850\\f850\"\n}\n\n.fa-circle-nodes {\n    --fa: \"\\e4e2\";\n    --fa--fa: \"\\e4e2\\e4e2\"\n}\n\n.fa-parachute-box {\n    --fa: \"\\f4cd\";\n    --fa--fa: \"\\f4cd\\f4cd\"\n}\n\n.fa-indent {\n    --fa: \"\\f03c\";\n    --fa--fa: \"\\f03c\\f03c\"\n}\n\n.fa-truck-field-un {\n    --fa: \"\\e58e\";\n    --fa--fa: \"\\e58e\\e58e\"\n}\n\n.fa-hourglass,\n.fa-hourglass-empty {\n    --fa: \"\\f254\";\n    --fa--fa: \"\\f254\\f254\"\n}\n\n.fa-mountain {\n    --fa: \"\\f6fc\";\n    --fa--fa: \"\\f6fc\\f6fc\"\n}\n\n.fa-user-doctor,\n.fa-user-md {\n    --fa: \"\\f0f0\";\n    --fa--fa: \"\\f0f0\\f0f0\"\n}\n\n.fa-circle-info,\n.fa-info-circle {\n    --fa: \"\\f05a\";\n    --fa--fa: \"\\f05a\\f05a\"\n}\n\n.fa-cloud-meatball {\n    --fa: \"\\f73b\";\n    --fa--fa: \"\\f73b\\f73b\"\n}\n\n.fa-camera,\n.fa-camera-alt {\n    --fa: \"\\f030\";\n    --fa--fa: \"\\f030\\f030\"\n}\n\n.fa-square-virus {\n    --fa: \"\\e578\";\n    --fa--fa: \"\\e578\\e578\"\n}\n\n.fa-meteor {\n    --fa: \"\\f753\";\n    --fa--fa: \"\\f753\\f753\"\n}\n\n.fa-car-on {\n    --fa: \"\\e4dd\";\n    --fa--fa: \"\\e4dd\\e4dd\"\n}\n\n.fa-sleigh {\n    --fa: \"\\f7cc\";\n    --fa--fa: \"\\f7cc\\f7cc\"\n}\n\n.fa-arrow-down-1-9,\n.fa-sort-numeric-asc,\n.fa-sort-numeric-down {\n    --fa: \"\\f162\";\n    --fa--fa: \"\\f162\\f162\"\n}\n\n.fa-hand-holding-droplet,\n.fa-hand-holding-water {\n    --fa: \"\\f4c1\";\n    --fa--fa: \"\\f4c1\\f4c1\"\n}\n\n.fa-water {\n    --fa: \"\\f773\";\n    --fa--fa: \"\\f773\\f773\"\n}\n\n.fa-calendar-check {\n    --fa: \"\\f274\";\n    --fa--fa: \"\\f274\\f274\"\n}\n\n.fa-braille {\n    --fa: \"\\f2a1\";\n    --fa--fa: \"\\f2a1\\f2a1\"\n}\n\n.fa-prescription-bottle-alt,\n.fa-prescription-bottle-medical {\n    --fa: \"\\f486\";\n    --fa--fa: \"\\f486\\f486\"\n}\n\n.fa-landmark {\n    --fa: \"\\f66f\";\n    --fa--fa: \"\\f66f\\f66f\"\n}\n\n.fa-truck {\n    --fa: \"\\f0d1\";\n    --fa--fa: \"\\f0d1\\f0d1\"\n}\n\n.fa-crosshairs {\n    --fa: \"\\f05b\";\n    --fa--fa: \"\\f05b\\f05b\"\n}\n\n.fa-person-cane {\n    --fa: \"\\e53c\";\n    --fa--fa: \"\\e53c\\e53c\"\n}\n\n.fa-tent {\n    --fa: \"\\e57d\";\n    --fa--fa: \"\\e57d\\e57d\"\n}\n\n.fa-vest-patches {\n    --fa: \"\\e086\";\n    --fa--fa: \"\\e086\\e086\"\n}\n\n.fa-check-double {\n    --fa: \"\\f560\";\n    --fa--fa: \"\\f560\\f560\"\n}\n\n.fa-arrow-down-a-z,\n.fa-sort-alpha-asc,\n.fa-sort-alpha-down {\n    --fa: \"\\f15d\";\n    --fa--fa: \"\\f15d\\f15d\"\n}\n\n.fa-money-bill-wheat {\n    --fa: \"\\e52a\";\n    --fa--fa: \"\\e52a\\e52a\"\n}\n\n.fa-cookie {\n    --fa: \"\\f563\";\n    --fa--fa: \"\\f563\\f563\"\n}\n\n.fa-arrow-left-rotate,\n.fa-arrow-rotate-back,\n.fa-arrow-rotate-backward,\n.fa-arrow-rotate-left,\n.fa-undo {\n    --fa: \"\\f0e2\";\n    --fa--fa: \"\\f0e2\\f0e2\"\n}\n\n.fa-hard-drive,\n.fa-hdd {\n    --fa: \"\\f0a0\";\n    --fa--fa: \"\\f0a0\\f0a0\"\n}\n\n.fa-face-grin-squint-tears,\n.fa-grin-squint-tears {\n    --fa: \"\\f586\";\n    --fa--fa: \"\\f586\\f586\"\n}\n\n.fa-dumbbell {\n    --fa: \"\\f44b\";\n    --fa--fa: \"\\f44b\\f44b\"\n}\n\n.fa-list-alt,\n.fa-rectangle-list {\n    --fa: \"\\f022\";\n    --fa--fa: \"\\f022\\f022\"\n}\n\n.fa-tarp-droplet {\n    --fa: \"\\e57c\";\n    --fa--fa: \"\\e57c\\e57c\"\n}\n\n.fa-house-medical-circle-check {\n    --fa: \"\\e511\";\n    --fa--fa: \"\\e511\\e511\"\n}\n\n.fa-person-skiing-nordic,\n.fa-skiing-nordic {\n    --fa: \"\\f7ca\";\n    --fa--fa: \"\\f7ca\\f7ca\"\n}\n\n.fa-calendar-plus {\n    --fa: \"\\f271\";\n    --fa--fa: \"\\f271\\f271\"\n}\n\n.fa-plane-arrival {\n    --fa: \"\\f5af\";\n    --fa--fa: \"\\f5af\\f5af\"\n}\n\n.fa-arrow-alt-circle-left,\n.fa-circle-left {\n    --fa: \"\\f359\";\n    --fa--fa: \"\\f359\\f359\"\n}\n\n.fa-subway,\n.fa-train-subway {\n    --fa: \"\\f239\";\n    --fa--fa: \"\\f239\\f239\"\n}\n\n.fa-chart-gantt {\n    --fa: \"\\e0e4\";\n    --fa--fa: \"\\e0e4\\e0e4\"\n}\n\n.fa-indian-rupee,\n.fa-indian-rupee-sign,\n.fa-inr {\n    --fa: \"\\e1bc\";\n    --fa--fa: \"\\e1bc\\e1bc\"\n}\n\n.fa-crop-alt,\n.fa-crop-simple {\n    --fa: \"\\f565\";\n    --fa--fa: \"\\f565\\f565\"\n}\n\n.fa-money-bill-1,\n.fa-money-bill-alt {\n    --fa: \"\\f3d1\";\n    --fa--fa: \"\\f3d1\\f3d1\"\n}\n\n.fa-left-long,\n.fa-long-arrow-alt-left {\n    --fa: \"\\f30a\";\n    --fa--fa: \"\\f30a\\f30a\"\n}\n\n.fa-dna {\n    --fa: \"\\f471\";\n    --fa--fa: \"\\f471\\f471\"\n}\n\n.fa-virus-slash {\n    --fa: \"\\e075\";\n    --fa--fa: \"\\e075\\e075\"\n}\n\n.fa-minus,\n.fa-subtract {\n    --fa: \"\\f068\";\n    --fa--fa: \"\\f068\\f068\"\n}\n\n.fa-chess {\n    --fa: \"\\f439\";\n    --fa--fa: \"\\f439\\f439\"\n}\n\n.fa-arrow-left-long,\n.fa-long-arrow-left {\n    --fa: \"\\f177\";\n    --fa--fa: \"\\f177\\f177\"\n}\n\n.fa-plug-circle-check {\n    --fa: \"\\e55c\";\n    --fa--fa: \"\\e55c\\e55c\"\n}\n\n.fa-street-view {\n    --fa: \"\\f21d\";\n    --fa--fa: \"\\f21d\\f21d\"\n}\n\n.fa-franc-sign {\n    --fa: \"\\e18f\";\n    --fa--fa: \"\\e18f\\e18f\"\n}\n\n.fa-volume-off {\n    --fa: \"\\f026\";\n    --fa--fa: \"\\f026\\f026\"\n}\n\n.fa-american-sign-language-interpreting,\n.fa-asl-interpreting,\n.fa-hands-american-sign-language-interpreting,\n.fa-hands-asl-interpreting {\n    --fa: \"\\f2a3\";\n    --fa--fa: \"\\f2a3\\f2a3\"\n}\n\n.fa-cog,\n.fa-gear {\n    --fa: \"\\f013\";\n    --fa--fa: \"\\f013\\f013\"\n}\n\n.fa-droplet-slash,\n.fa-tint-slash {\n    --fa: \"\\f5c7\";\n    --fa--fa: \"\\f5c7\\f5c7\"\n}\n\n.fa-mosque {\n    --fa: \"\\f678\";\n    --fa--fa: \"\\f678\\f678\"\n}\n\n.fa-mosquito {\n    --fa: \"\\e52b\";\n    --fa--fa: \"\\e52b\\e52b\"\n}\n\n.fa-star-of-david {\n    --fa: \"\\f69a\";\n    --fa--fa: \"\\f69a\\f69a\"\n}\n\n.fa-person-military-rifle {\n    --fa: \"\\e54b\";\n    --fa--fa: \"\\e54b\\e54b\"\n}\n\n.fa-cart-shopping,\n.fa-shopping-cart {\n    --fa: \"\\f07a\";\n    --fa--fa: \"\\f07a\\f07a\"\n}\n\n.fa-vials {\n    --fa: \"\\f493\";\n    --fa--fa: \"\\f493\\f493\"\n}\n\n.fa-plug-circle-plus {\n    --fa: \"\\e55f\";\n    --fa--fa: \"\\e55f\\e55f\"\n}\n\n.fa-place-of-worship {\n    --fa: \"\\f67f\";\n    --fa--fa: \"\\f67f\\f67f\"\n}\n\n.fa-grip-vertical {\n    --fa: \"\\f58e\";\n    --fa--fa: \"\\f58e\\f58e\"\n}\n\n.fa-hexagon-nodes {\n    --fa: \"\\e699\";\n    --fa--fa: \"\\e699\\e699\"\n}\n\n.fa-arrow-turn-up,\n.fa-level-up {\n    --fa: \"\\f148\";\n    --fa--fa: \"\\f148\\f148\"\n}\n\n.fa-u {\n    --fa: \"\\55\";\n    --fa--fa: \"\\55\\55\"\n}\n\n.fa-square-root-alt,\n.fa-square-root-variable {\n    --fa: \"\\f698\";\n    --fa--fa: \"\\f698\\f698\"\n}\n\n.fa-clock,\n.fa-clock-four {\n    --fa: \"\\f017\";\n    --fa--fa: \"\\f017\\f017\"\n}\n\n.fa-backward-step,\n.fa-step-backward {\n    --fa: \"\\f048\";\n    --fa--fa: \"\\f048\\f048\"\n}\n\n.fa-pallet {\n    --fa: \"\\f482\";\n    --fa--fa: \"\\f482\\f482\"\n}\n\n.fa-faucet {\n    --fa: \"\\e005\";\n    --fa--fa: \"\\e005\\e005\"\n}\n\n.fa-baseball-bat-ball {\n    --fa: \"\\f432\";\n    --fa--fa: \"\\f432\\f432\"\n}\n\n.fa-s {\n    --fa: \"\\53\";\n    --fa--fa: \"\\53\\53\"\n}\n\n.fa-timeline {\n    --fa: \"\\e29c\";\n    --fa--fa: \"\\e29c\\e29c\"\n}\n\n.fa-keyboard {\n    --fa: \"\\f11c\";\n    --fa--fa: \"\\f11c\\f11c\"\n}\n\n.fa-caret-down {\n    --fa: \"\\f0d7\";\n    --fa--fa: \"\\f0d7\\f0d7\"\n}\n\n.fa-clinic-medical,\n.fa-house-chimney-medical {\n    --fa: \"\\f7f2\";\n    --fa--fa: \"\\f7f2\\f7f2\"\n}\n\n.fa-temperature-3,\n.fa-temperature-three-quarters,\n.fa-thermometer-3,\n.fa-thermometer-three-quarters {\n    --fa: \"\\f2c8\";\n    --fa--fa: \"\\f2c8\\f2c8\"\n}\n\n.fa-mobile-android-alt,\n.fa-mobile-screen {\n    --fa: \"\\f3cf\";\n    --fa--fa: \"\\f3cf\\f3cf\"\n}\n\n.fa-plane-up {\n    --fa: \"\\e22d\";\n    --fa--fa: \"\\e22d\\e22d\"\n}\n\n.fa-piggy-bank {\n    --fa: \"\\f4d3\";\n    --fa--fa: \"\\f4d3\\f4d3\"\n}\n\n.fa-battery-3,\n.fa-battery-half {\n    --fa: \"\\f242\";\n    --fa--fa: \"\\f242\\f242\"\n}\n\n.fa-mountain-city {\n    --fa: \"\\e52e\";\n    --fa--fa: \"\\e52e\\e52e\"\n}\n\n.fa-coins {\n    --fa: \"\\f51e\";\n    --fa--fa: \"\\f51e\\f51e\"\n}\n\n.fa-khanda {\n    --fa: \"\\f66d\";\n    --fa--fa: \"\\f66d\\f66d\"\n}\n\n.fa-sliders,\n.fa-sliders-h {\n    --fa: \"\\f1de\";\n    --fa--fa: \"\\f1de\\f1de\"\n}\n\n.fa-folder-tree {\n    --fa: \"\\f802\";\n    --fa--fa: \"\\f802\\f802\"\n}\n\n.fa-network-wired {\n    --fa: \"\\f6ff\";\n    --fa--fa: \"\\f6ff\\f6ff\"\n}\n\n.fa-map-pin {\n    --fa: \"\\f276\";\n    --fa--fa: \"\\f276\\f276\"\n}\n\n.fa-hamsa {\n    --fa: \"\\f665\";\n    --fa--fa: \"\\f665\\f665\"\n}\n\n.fa-cent-sign {\n    --fa: \"\\e3f5\";\n    --fa--fa: \"\\e3f5\\e3f5\"\n}\n\n.fa-flask {\n    --fa: \"\\f0c3\";\n    --fa--fa: \"\\f0c3\\f0c3\"\n}\n\n.fa-person-pregnant {\n    --fa: \"\\e31e\";\n    --fa--fa: \"\\e31e\\e31e\"\n}\n\n.fa-wand-sparkles {\n    --fa: \"\\f72b\";\n    --fa--fa: \"\\f72b\\f72b\"\n}\n\n.fa-ellipsis-v,\n.fa-ellipsis-vertical {\n    --fa: \"\\f142\";\n    --fa--fa: \"\\f142\\f142\"\n}\n\n.fa-ticket {\n    --fa: \"\\f145\";\n    --fa--fa: \"\\f145\\f145\"\n}\n\n.fa-power-off {\n    --fa: \"\\f011\";\n    --fa--fa: \"\\f011\\f011\"\n}\n\n.fa-long-arrow-alt-right,\n.fa-right-long {\n    --fa: \"\\f30b\";\n    --fa--fa: \"\\f30b\\f30b\"\n}\n\n.fa-flag-usa {\n    --fa: \"\\f74d\";\n    --fa--fa: \"\\f74d\\f74d\"\n}\n\n.fa-laptop-file {\n    --fa: \"\\e51d\";\n    --fa--fa: \"\\e51d\\e51d\"\n}\n\n.fa-teletype,\n.fa-tty {\n    --fa: \"\\f1e4\";\n    --fa--fa: \"\\f1e4\\f1e4\"\n}\n\n.fa-diagram-next {\n    --fa: \"\\e476\";\n    --fa--fa: \"\\e476\\e476\"\n}\n\n.fa-person-rifle {\n    --fa: \"\\e54e\";\n    --fa--fa: \"\\e54e\\e54e\"\n}\n\n.fa-house-medical-circle-exclamation {\n    --fa: \"\\e512\";\n    --fa--fa: \"\\e512\\e512\"\n}\n\n.fa-closed-captioning {\n    --fa: \"\\f20a\";\n    --fa--fa: \"\\f20a\\f20a\"\n}\n\n.fa-hiking,\n.fa-person-hiking {\n    --fa: \"\\f6ec\";\n    --fa--fa: \"\\f6ec\\f6ec\"\n}\n\n.fa-venus-double {\n    --fa: \"\\f226\";\n    --fa--fa: \"\\f226\\f226\"\n}\n\n.fa-images {\n    --fa: \"\\f302\";\n    --fa--fa: \"\\f302\\f302\"\n}\n\n.fa-calculator {\n    --fa: \"\\f1ec\";\n    --fa--fa: \"\\f1ec\\f1ec\"\n}\n\n.fa-people-pulling {\n    --fa: \"\\e535\";\n    --fa--fa: \"\\e535\\e535\"\n}\n\n.fa-n {\n    --fa: \"\\4e\";\n    --fa--fa: \"\\4e\\4e\"\n}\n\n.fa-cable-car,\n.fa-tram {\n    --fa: \"\\f7da\";\n    --fa--fa: \"\\f7da\\f7da\"\n}\n\n.fa-cloud-rain {\n    --fa: \"\\f73d\";\n    --fa--fa: \"\\f73d\\f73d\"\n}\n\n.fa-building-circle-xmark {\n    --fa: \"\\e4d4\";\n    --fa--fa: \"\\e4d4\\e4d4\"\n}\n\n.fa-ship {\n    --fa: \"\\f21a\";\n    --fa--fa: \"\\f21a\\f21a\"\n}\n\n.fa-arrows-down-to-line {\n    --fa: \"\\e4b8\";\n    --fa--fa: \"\\e4b8\\e4b8\"\n}\n\n.fa-download {\n    --fa: \"\\f019\";\n    --fa--fa: \"\\f019\\f019\"\n}\n\n.fa-face-grin,\n.fa-grin {\n    --fa: \"\\f580\";\n    --fa--fa: \"\\f580\\f580\"\n}\n\n.fa-backspace,\n.fa-delete-left {\n    --fa: \"\\f55a\";\n    --fa--fa: \"\\f55a\\f55a\"\n}\n\n.fa-eye-dropper,\n.fa-eye-dropper-empty,\n.fa-eyedropper {\n    --fa: \"\\f1fb\";\n    --fa--fa: \"\\f1fb\\f1fb\"\n}\n\n.fa-file-circle-check {\n    --fa: \"\\e5a0\";\n    --fa--fa: \"\\e5a0\\e5a0\"\n}\n\n.fa-forward {\n    --fa: \"\\f04e\";\n    --fa--fa: \"\\f04e\\f04e\"\n}\n\n.fa-mobile,\n.fa-mobile-android,\n.fa-mobile-phone {\n    --fa: \"\\f3ce\";\n    --fa--fa: \"\\f3ce\\f3ce\"\n}\n\n.fa-face-meh,\n.fa-meh {\n    --fa: \"\\f11a\";\n    --fa--fa: \"\\f11a\\f11a\"\n}\n\n.fa-align-center {\n    --fa: \"\\f037\";\n    --fa--fa: \"\\f037\\f037\"\n}\n\n.fa-book-dead,\n.fa-book-skull {\n    --fa: \"\\f6b7\";\n    --fa--fa: \"\\f6b7\\f6b7\"\n}\n\n.fa-drivers-license,\n.fa-id-card {\n    --fa: \"\\f2c2\";\n    --fa--fa: \"\\f2c2\\f2c2\"\n}\n\n.fa-dedent,\n.fa-outdent {\n    --fa: \"\\f03b\";\n    --fa--fa: \"\\f03b\\f03b\"\n}\n\n.fa-heart-circle-exclamation {\n    --fa: \"\\e4fe\";\n    --fa--fa: \"\\e4fe\\e4fe\"\n}\n\n.fa-home,\n.fa-home-alt,\n.fa-home-lg-alt,\n.fa-house {\n    --fa: \"\\f015\";\n    --fa--fa: \"\\f015\\f015\"\n}\n\n.fa-calendar-week {\n    --fa: \"\\f784\";\n    --fa--fa: \"\\f784\\f784\"\n}\n\n.fa-laptop-medical {\n    --fa: \"\\f812\";\n    --fa--fa: \"\\f812\\f812\"\n}\n\n.fa-b {\n    --fa: \"\\42\";\n    --fa--fa: \"\\42\\42\"\n}\n\n.fa-file-medical {\n    --fa: \"\\f477\";\n    --fa--fa: \"\\f477\\f477\"\n}\n\n.fa-dice-one {\n    --fa: \"\\f525\";\n    --fa--fa: \"\\f525\\f525\"\n}\n\n.fa-kiwi-bird {\n    --fa: \"\\f535\";\n    --fa--fa: \"\\f535\\f535\"\n}\n\n.fa-arrow-right-arrow-left,\n.fa-exchange {\n    --fa: \"\\f0ec\";\n    --fa--fa: \"\\f0ec\\f0ec\"\n}\n\n.fa-redo-alt,\n.fa-rotate-forward,\n.fa-rotate-right {\n    --fa: \"\\f2f9\";\n    --fa--fa: \"\\f2f9\\f2f9\"\n}\n\n.fa-cutlery,\n.fa-utensils {\n    --fa: \"\\f2e7\";\n    --fa--fa: \"\\f2e7\\f2e7\"\n}\n\n.fa-arrow-up-wide-short,\n.fa-sort-amount-up {\n    --fa: \"\\f161\";\n    --fa--fa: \"\\f161\\f161\"\n}\n\n.fa-mill-sign {\n    --fa: \"\\e1ed\";\n    --fa--fa: \"\\e1ed\\e1ed\"\n}\n\n.fa-bowl-rice {\n    --fa: \"\\e2eb\";\n    --fa--fa: \"\\e2eb\\e2eb\"\n}\n\n.fa-skull {\n    --fa: \"\\f54c\";\n    --fa--fa: \"\\f54c\\f54c\"\n}\n\n.fa-broadcast-tower,\n.fa-tower-broadcast {\n    --fa: \"\\f519\";\n    --fa--fa: \"\\f519\\f519\"\n}\n\n.fa-truck-pickup {\n    --fa: \"\\f63c\";\n    --fa--fa: \"\\f63c\\f63c\"\n}\n\n.fa-long-arrow-alt-up,\n.fa-up-long {\n    --fa: \"\\f30c\";\n    --fa--fa: \"\\f30c\\f30c\"\n}\n\n.fa-stop {\n    --fa: \"\\f04d\";\n    --fa--fa: \"\\f04d\\f04d\"\n}\n\n.fa-code-merge {\n    --fa: \"\\f387\";\n    --fa--fa: \"\\f387\\f387\"\n}\n\n.fa-upload {\n    --fa: \"\\f093\";\n    --fa--fa: \"\\f093\\f093\"\n}\n\n.fa-hurricane {\n    --fa: \"\\f751\";\n    --fa--fa: \"\\f751\\f751\"\n}\n\n.fa-mound {\n    --fa: \"\\e52d\";\n    --fa--fa: \"\\e52d\\e52d\"\n}\n\n.fa-toilet-portable {\n    --fa: \"\\e583\";\n    --fa--fa: \"\\e583\\e583\"\n}\n\n.fa-compact-disc {\n    --fa: \"\\f51f\";\n    --fa--fa: \"\\f51f\\f51f\"\n}\n\n.fa-file-arrow-down,\n.fa-file-download {\n    --fa: \"\\f56d\";\n    --fa--fa: \"\\f56d\\f56d\"\n}\n\n.fa-caravan {\n    --fa: \"\\f8ff\";\n    --fa--fa: \"\\f8ff\\f8ff\"\n}\n\n.fa-shield-cat {\n    --fa: \"\\e572\";\n    --fa--fa: \"\\e572\\e572\"\n}\n\n.fa-bolt,\n.fa-zap {\n    --fa: \"\\f0e7\";\n    --fa--fa: \"\\f0e7\\f0e7\"\n}\n\n.fa-glass-water {\n    --fa: \"\\e4f4\";\n    --fa--fa: \"\\e4f4\\e4f4\"\n}\n\n.fa-oil-well {\n    --fa: \"\\e532\";\n    --fa--fa: \"\\e532\\e532\"\n}\n\n.fa-vault {\n    --fa: \"\\e2c5\";\n    --fa--fa: \"\\e2c5\\e2c5\"\n}\n\n.fa-mars {\n    --fa: \"\\f222\";\n    --fa--fa: \"\\f222\\f222\"\n}\n\n.fa-toilet {\n    --fa: \"\\f7d8\";\n    --fa--fa: \"\\f7d8\\f7d8\"\n}\n\n.fa-plane-circle-xmark {\n    --fa: \"\\e557\";\n    --fa--fa: \"\\e557\\e557\"\n}\n\n.fa-cny,\n.fa-jpy,\n.fa-rmb,\n.fa-yen,\n.fa-yen-sign {\n    --fa: \"\\f157\";\n    --fa--fa: \"\\f157\\f157\"\n}\n\n.fa-rouble,\n.fa-rub,\n.fa-ruble,\n.fa-ruble-sign {\n    --fa: \"\\f158\";\n    --fa--fa: \"\\f158\\f158\"\n}\n\n.fa-sun {\n    --fa: \"\\f185\";\n    --fa--fa: \"\\f185\\f185\"\n}\n\n.fa-guitar {\n    --fa: \"\\f7a6\";\n    --fa--fa: \"\\f7a6\\f7a6\"\n}\n\n.fa-face-laugh-wink,\n.fa-laugh-wink {\n    --fa: \"\\f59c\";\n    --fa--fa: \"\\f59c\\f59c\"\n}\n\n.fa-horse-head {\n    --fa: \"\\f7ab\";\n    --fa--fa: \"\\f7ab\\f7ab\"\n}\n\n.fa-bore-hole {\n    --fa: \"\\e4c3\";\n    --fa--fa: \"\\e4c3\\e4c3\"\n}\n\n.fa-industry {\n    --fa: \"\\f275\";\n    --fa--fa: \"\\f275\\f275\"\n}\n\n.fa-arrow-alt-circle-down,\n.fa-circle-down {\n    --fa: \"\\f358\";\n    --fa--fa: \"\\f358\\f358\"\n}\n\n.fa-arrows-turn-to-dots {\n    --fa: \"\\e4c1\";\n    --fa--fa: \"\\e4c1\\e4c1\"\n}\n\n.fa-florin-sign {\n    --fa: \"\\e184\";\n    --fa--fa: \"\\e184\\e184\"\n}\n\n.fa-arrow-down-short-wide,\n.fa-sort-amount-desc,\n.fa-sort-amount-down-alt {\n    --fa: \"\\f884\";\n    --fa--fa: \"\\f884\\f884\"\n}\n\n.fa-less-than {\n    --fa: \"\\3c\";\n    --fa--fa: \"\\3c\\3c\"\n}\n\n.fa-angle-down {\n    --fa: \"\\f107\";\n    --fa--fa: \"\\f107\\f107\"\n}\n\n.fa-car-tunnel {\n    --fa: \"\\e4de\";\n    --fa--fa: \"\\e4de\\e4de\"\n}\n\n.fa-head-side-cough {\n    --fa: \"\\e061\";\n    --fa--fa: \"\\e061\\e061\"\n}\n\n.fa-grip-lines {\n    --fa: \"\\f7a4\";\n    --fa--fa: \"\\f7a4\\f7a4\"\n}\n\n.fa-thumbs-down {\n    --fa: \"\\f165\";\n    --fa--fa: \"\\f165\\f165\"\n}\n\n.fa-user-lock {\n    --fa: \"\\f502\";\n    --fa--fa: \"\\f502\\f502\"\n}\n\n.fa-arrow-right-long,\n.fa-long-arrow-right {\n    --fa: \"\\f178\";\n    --fa--fa: \"\\f178\\f178\"\n}\n\n.fa-anchor-circle-xmark {\n    --fa: \"\\e4ac\";\n    --fa--fa: \"\\e4ac\\e4ac\"\n}\n\n.fa-ellipsis,\n.fa-ellipsis-h {\n    --fa: \"\\f141\";\n    --fa--fa: \"\\f141\\f141\"\n}\n\n.fa-chess-pawn {\n    --fa: \"\\f443\";\n    --fa--fa: \"\\f443\\f443\"\n}\n\n.fa-first-aid,\n.fa-kit-medical {\n    --fa: \"\\f479\";\n    --fa--fa: \"\\f479\\f479\"\n}\n\n.fa-person-through-window {\n    --fa: \"\\e5a9\";\n    --fa--fa: \"\\e5a9\\e5a9\"\n}\n\n.fa-toolbox {\n    --fa: \"\\f552\";\n    --fa--fa: \"\\f552\\f552\"\n}\n\n.fa-hands-holding-circle {\n    --fa: \"\\e4fb\";\n    --fa--fa: \"\\e4fb\\e4fb\"\n}\n\n.fa-bug {\n    --fa: \"\\f188\";\n    --fa--fa: \"\\f188\\f188\"\n}\n\n.fa-credit-card,\n.fa-credit-card-alt {\n    --fa: \"\\f09d\";\n    --fa--fa: \"\\f09d\\f09d\"\n}\n\n.fa-automobile,\n.fa-car {\n    --fa: \"\\f1b9\";\n    --fa--fa: \"\\f1b9\\f1b9\"\n}\n\n.fa-hand-holding-hand {\n    --fa: \"\\e4f7\";\n    --fa--fa: \"\\e4f7\\e4f7\"\n}\n\n.fa-book-open-reader,\n.fa-book-reader {\n    --fa: \"\\f5da\";\n    --fa--fa: \"\\f5da\\f5da\"\n}\n\n.fa-mountain-sun {\n    --fa: \"\\e52f\";\n    --fa--fa: \"\\e52f\\e52f\"\n}\n\n.fa-arrows-left-right-to-line {\n    --fa: \"\\e4ba\";\n    --fa--fa: \"\\e4ba\\e4ba\"\n}\n\n.fa-dice-d20 {\n    --fa: \"\\f6cf\";\n    --fa--fa: \"\\f6cf\\f6cf\"\n}\n\n.fa-truck-droplet {\n    --fa: \"\\e58c\";\n    --fa--fa: \"\\e58c\\e58c\"\n}\n\n.fa-file-circle-xmark {\n    --fa: \"\\e5a1\";\n    --fa--fa: \"\\e5a1\\e5a1\"\n}\n\n.fa-temperature-arrow-up,\n.fa-temperature-up {\n    --fa: \"\\e040\";\n    --fa--fa: \"\\e040\\e040\"\n}\n\n.fa-medal {\n    --fa: \"\\f5a2\";\n    --fa--fa: \"\\f5a2\\f5a2\"\n}\n\n.fa-bed {\n    --fa: \"\\f236\";\n    --fa--fa: \"\\f236\\f236\"\n}\n\n.fa-h-square,\n.fa-square-h {\n    --fa: \"\\f0fd\";\n    --fa--fa: \"\\f0fd\\f0fd\"\n}\n\n.fa-podcast {\n    --fa: \"\\f2ce\";\n    --fa--fa: \"\\f2ce\\f2ce\"\n}\n\n.fa-temperature-4,\n.fa-temperature-full,\n.fa-thermometer-4,\n.fa-thermometer-full {\n    --fa: \"\\f2c7\";\n    --fa--fa: \"\\f2c7\\f2c7\"\n}\n\n.fa-bell {\n    --fa: \"\\f0f3\";\n    --fa--fa: \"\\f0f3\\f0f3\"\n}\n\n.fa-superscript {\n    --fa: \"\\f12b\";\n    --fa--fa: \"\\f12b\\f12b\"\n}\n\n.fa-plug-circle-xmark {\n    --fa: \"\\e560\";\n    --fa--fa: \"\\e560\\e560\"\n}\n\n.fa-star-of-life {\n    --fa: \"\\f621\";\n    --fa--fa: \"\\f621\\f621\"\n}\n\n.fa-phone-slash {\n    --fa: \"\\f3dd\";\n    --fa--fa: \"\\f3dd\\f3dd\"\n}\n\n.fa-paint-roller {\n    --fa: \"\\f5aa\";\n    --fa--fa: \"\\f5aa\\f5aa\"\n}\n\n.fa-hands-helping,\n.fa-handshake-angle {\n    --fa: \"\\f4c4\";\n    --fa--fa: \"\\f4c4\\f4c4\"\n}\n\n.fa-location-dot,\n.fa-map-marker-alt {\n    --fa: \"\\f3c5\";\n    --fa--fa: \"\\f3c5\\f3c5\"\n}\n\n.fa-file {\n    --fa: \"\\f15b\";\n    --fa--fa: \"\\f15b\\f15b\"\n}\n\n.fa-greater-than {\n    --fa: \"\\3e\";\n    --fa--fa: \"\\3e\\3e\"\n}\n\n.fa-person-swimming,\n.fa-swimmer {\n    --fa: \"\\f5c4\";\n    --fa--fa: \"\\f5c4\\f5c4\"\n}\n\n.fa-arrow-down {\n    --fa: \"\\f063\";\n    --fa--fa: \"\\f063\\f063\"\n}\n\n.fa-droplet,\n.fa-tint {\n    --fa: \"\\f043\";\n    --fa--fa: \"\\f043\\f043\"\n}\n\n.fa-eraser {\n    --fa: \"\\f12d\";\n    --fa--fa: \"\\f12d\\f12d\"\n}\n\n.fa-earth,\n.fa-earth-america,\n.fa-earth-americas,\n.fa-globe-americas {\n    --fa: \"\\f57d\";\n    --fa--fa: \"\\f57d\\f57d\"\n}\n\n.fa-person-burst {\n    --fa: \"\\e53b\";\n    --fa--fa: \"\\e53b\\e53b\"\n}\n\n.fa-dove {\n    --fa: \"\\f4ba\";\n    --fa--fa: \"\\f4ba\\f4ba\"\n}\n\n.fa-battery-0,\n.fa-battery-empty {\n    --fa: \"\\f244\";\n    --fa--fa: \"\\f244\\f244\"\n}\n\n.fa-socks {\n    --fa: \"\\f696\";\n    --fa--fa: \"\\f696\\f696\"\n}\n\n.fa-inbox {\n    --fa: \"\\f01c\";\n    --fa--fa: \"\\f01c\\f01c\"\n}\n\n.fa-section {\n    --fa: \"\\e447\";\n    --fa--fa: \"\\e447\\e447\"\n}\n\n.fa-gauge-high,\n.fa-tachometer-alt,\n.fa-tachometer-alt-fast {\n    --fa: \"\\f625\";\n    --fa--fa: \"\\f625\\f625\"\n}\n\n.fa-envelope-open-text {\n    --fa: \"\\f658\";\n    --fa--fa: \"\\f658\\f658\"\n}\n\n.fa-hospital,\n.fa-hospital-alt,\n.fa-hospital-wide {\n    --fa: \"\\f0f8\";\n    --fa--fa: \"\\f0f8\\f0f8\"\n}\n\n.fa-wine-bottle {\n    --fa: \"\\f72f\";\n    --fa--fa: \"\\f72f\\f72f\"\n}\n\n.fa-chess-rook {\n    --fa: \"\\f447\";\n    --fa--fa: \"\\f447\\f447\"\n}\n\n.fa-bars-staggered,\n.fa-reorder,\n.fa-stream {\n    --fa: \"\\f550\";\n    --fa--fa: \"\\f550\\f550\"\n}\n\n.fa-dharmachakra {\n    --fa: \"\\f655\";\n    --fa--fa: \"\\f655\\f655\"\n}\n\n.fa-hotdog {\n    --fa: \"\\f80f\";\n    --fa--fa: \"\\f80f\\f80f\"\n}\n\n.fa-blind,\n.fa-person-walking-with-cane {\n    --fa: \"\\f29d\";\n    --fa--fa: \"\\f29d\\f29d\"\n}\n\n.fa-drum {\n    --fa: \"\\f569\";\n    --fa--fa: \"\\f569\\f569\"\n}\n\n.fa-ice-cream {\n    --fa: \"\\f810\";\n    --fa--fa: \"\\f810\\f810\"\n}\n\n.fa-heart-circle-bolt {\n    --fa: \"\\e4fc\";\n    --fa--fa: \"\\e4fc\\e4fc\"\n}\n\n.fa-fax {\n    --fa: \"\\f1ac\";\n    --fa--fa: \"\\f1ac\\f1ac\"\n}\n\n.fa-paragraph {\n    --fa: \"\\f1dd\";\n    --fa--fa: \"\\f1dd\\f1dd\"\n}\n\n.fa-check-to-slot,\n.fa-vote-yea {\n    --fa: \"\\f772\";\n    --fa--fa: \"\\f772\\f772\"\n}\n\n.fa-star-half {\n    --fa: \"\\f089\";\n    --fa--fa: \"\\f089\\f089\"\n}\n\n.fa-boxes,\n.fa-boxes-alt,\n.fa-boxes-stacked {\n    --fa: \"\\f468\";\n    --fa--fa: \"\\f468\\f468\"\n}\n\n.fa-chain,\n.fa-link {\n    --fa: \"\\f0c1\";\n    --fa--fa: \"\\f0c1\\f0c1\"\n}\n\n.fa-assistive-listening-systems,\n.fa-ear-listen {\n    --fa: \"\\f2a2\";\n    --fa--fa: \"\\f2a2\\f2a2\"\n}\n\n.fa-tree-city {\n    --fa: \"\\e587\";\n    --fa--fa: \"\\e587\\e587\"\n}\n\n.fa-play {\n    --fa: \"\\f04b\";\n    --fa--fa: \"\\f04b\\f04b\"\n}\n\n.fa-font {\n    --fa: \"\\f031\";\n    --fa--fa: \"\\f031\\f031\"\n}\n\n.fa-table-cells-row-lock {\n    --fa: \"\\e67a\";\n    --fa--fa: \"\\e67a\\e67a\"\n}\n\n.fa-rupiah-sign {\n    --fa: \"\\e23d\";\n    --fa--fa: \"\\e23d\\e23d\"\n}\n\n.fa-magnifying-glass,\n.fa-search {\n    --fa: \"\\f002\";\n    --fa--fa: \"\\f002\\f002\"\n}\n\n.fa-ping-pong-paddle-ball,\n.fa-table-tennis,\n.fa-table-tennis-paddle-ball {\n    --fa: \"\\f45d\";\n    --fa--fa: \"\\f45d\\f45d\"\n}\n\n.fa-diagnoses,\n.fa-person-dots-from-line {\n    --fa: \"\\f470\";\n    --fa--fa: \"\\f470\\f470\"\n}\n\n.fa-trash-can-arrow-up,\n.fa-trash-restore-alt {\n    --fa: \"\\f82a\";\n    --fa--fa: \"\\f82a\\f82a\"\n}\n\n.fa-naira-sign {\n    --fa: \"\\e1f6\";\n    --fa--fa: \"\\e1f6\\e1f6\"\n}\n\n.fa-cart-arrow-down {\n    --fa: \"\\f218\";\n    --fa--fa: \"\\f218\\f218\"\n}\n\n.fa-walkie-talkie {\n    --fa: \"\\f8ef\";\n    --fa--fa: \"\\f8ef\\f8ef\"\n}\n\n.fa-file-edit,\n.fa-file-pen {\n    --fa: \"\\f31c\";\n    --fa--fa: \"\\f31c\\f31c\"\n}\n\n.fa-receipt {\n    --fa: \"\\f543\";\n    --fa--fa: \"\\f543\\f543\"\n}\n\n.fa-pen-square,\n.fa-pencil-square,\n.fa-square-pen {\n    --fa: \"\\f14b\";\n    --fa--fa: \"\\f14b\\f14b\"\n}\n\n.fa-suitcase-rolling {\n    --fa: \"\\f5c1\";\n    --fa--fa: \"\\f5c1\\f5c1\"\n}\n\n.fa-person-circle-exclamation {\n    --fa: \"\\e53f\";\n    --fa--fa: \"\\e53f\\e53f\"\n}\n\n.fa-chevron-down {\n    --fa: \"\\f078\";\n    --fa--fa: \"\\f078\\f078\"\n}\n\n.fa-battery,\n.fa-battery-5,\n.fa-battery-full {\n    --fa: \"\\f240\";\n    --fa--fa: \"\\f240\\f240\"\n}\n\n.fa-skull-crossbones {\n    --fa: \"\\f714\";\n    --fa--fa: \"\\f714\\f714\"\n}\n\n.fa-code-compare {\n    --fa: \"\\e13a\";\n    --fa--fa: \"\\e13a\\e13a\"\n}\n\n.fa-list-dots,\n.fa-list-ul {\n    --fa: \"\\f0ca\";\n    --fa--fa: \"\\f0ca\\f0ca\"\n}\n\n.fa-school-lock {\n    --fa: \"\\e56f\";\n    --fa--fa: \"\\e56f\\e56f\"\n}\n\n.fa-tower-cell {\n    --fa: \"\\e585\";\n    --fa--fa: \"\\e585\\e585\"\n}\n\n.fa-down-long,\n.fa-long-arrow-alt-down {\n    --fa: \"\\f309\";\n    --fa--fa: \"\\f309\\f309\"\n}\n\n.fa-ranking-star {\n    --fa: \"\\e561\";\n    --fa--fa: \"\\e561\\e561\"\n}\n\n.fa-chess-king {\n    --fa: \"\\f43f\";\n    --fa--fa: \"\\f43f\\f43f\"\n}\n\n.fa-person-harassing {\n    --fa: \"\\e549\";\n    --fa--fa: \"\\e549\\e549\"\n}\n\n.fa-brazilian-real-sign {\n    --fa: \"\\e46c\";\n    --fa--fa: \"\\e46c\\e46c\"\n}\n\n.fa-landmark-alt,\n.fa-landmark-dome {\n    --fa: \"\\f752\";\n    --fa--fa: \"\\f752\\f752\"\n}\n\n.fa-arrow-up {\n    --fa: \"\\f062\";\n    --fa--fa: \"\\f062\\f062\"\n}\n\n.fa-television,\n.fa-tv,\n.fa-tv-alt {\n    --fa: \"\\f26c\";\n    --fa--fa: \"\\f26c\\f26c\"\n}\n\n.fa-shrimp {\n    --fa: \"\\e448\";\n    --fa--fa: \"\\e448\\e448\"\n}\n\n.fa-list-check,\n.fa-tasks {\n    --fa: \"\\f0ae\";\n    --fa--fa: \"\\f0ae\\f0ae\"\n}\n\n.fa-jug-detergent {\n    --fa: \"\\e519\";\n    --fa--fa: \"\\e519\\e519\"\n}\n\n.fa-circle-user,\n.fa-user-circle {\n    --fa: \"\\f2bd\";\n    --fa--fa: \"\\f2bd\\f2bd\"\n}\n\n.fa-user-shield {\n    --fa: \"\\f505\";\n    --fa--fa: \"\\f505\\f505\"\n}\n\n.fa-wind {\n    --fa: \"\\f72e\";\n    --fa--fa: \"\\f72e\\f72e\"\n}\n\n.fa-car-burst,\n.fa-car-crash {\n    --fa: \"\\f5e1\";\n    --fa--fa: \"\\f5e1\\f5e1\"\n}\n\n.fa-y {\n    --fa: \"\\59\";\n    --fa--fa: \"\\59\\59\"\n}\n\n.fa-person-snowboarding,\n.fa-snowboarding {\n    --fa: \"\\f7ce\";\n    --fa--fa: \"\\f7ce\\f7ce\"\n}\n\n.fa-shipping-fast,\n.fa-truck-fast {\n    --fa: \"\\f48b\";\n    --fa--fa: \"\\f48b\\f48b\"\n}\n\n.fa-fish {\n    --fa: \"\\f578\";\n    --fa--fa: \"\\f578\\f578\"\n}\n\n.fa-user-graduate {\n    --fa: \"\\f501\";\n    --fa--fa: \"\\f501\\f501\"\n}\n\n.fa-adjust,\n.fa-circle-half-stroke {\n    --fa: \"\\f042\";\n    --fa--fa: \"\\f042\\f042\"\n}\n\n.fa-clapperboard {\n    --fa: \"\\e131\";\n    --fa--fa: \"\\e131\\e131\"\n}\n\n.fa-circle-radiation,\n.fa-radiation-alt {\n    --fa: \"\\f7ba\";\n    --fa--fa: \"\\f7ba\\f7ba\"\n}\n\n.fa-baseball,\n.fa-baseball-ball {\n    --fa: \"\\f433\";\n    --fa--fa: \"\\f433\\f433\"\n}\n\n.fa-jet-fighter-up {\n    --fa: \"\\e518\";\n    --fa--fa: \"\\e518\\e518\"\n}\n\n.fa-diagram-project,\n.fa-project-diagram {\n    --fa: \"\\f542\";\n    --fa--fa: \"\\f542\\f542\"\n}\n\n.fa-copy {\n    --fa: \"\\f0c5\";\n    --fa--fa: \"\\f0c5\\f0c5\"\n}\n\n.fa-volume-mute,\n.fa-volume-times,\n.fa-volume-xmark {\n    --fa: \"\\f6a9\";\n    --fa--fa: \"\\f6a9\\f6a9\"\n}\n\n.fa-hand-sparkles {\n    --fa: \"\\e05d\";\n    --fa--fa: \"\\e05d\\e05d\"\n}\n\n.fa-grip,\n.fa-grip-horizontal {\n    --fa: \"\\f58d\";\n    --fa--fa: \"\\f58d\\f58d\"\n}\n\n.fa-share-from-square,\n.fa-share-square {\n    --fa: \"\\f14d\";\n    --fa--fa: \"\\f14d\\f14d\"\n}\n\n.fa-child-combatant,\n.fa-child-rifle {\n    --fa: \"\\e4e0\";\n    --fa--fa: \"\\e4e0\\e4e0\"\n}\n\n.fa-gun {\n    --fa: \"\\e19b\";\n    --fa--fa: \"\\e19b\\e19b\"\n}\n\n.fa-phone-square,\n.fa-square-phone {\n    --fa: \"\\f098\";\n    --fa--fa: \"\\f098\\f098\"\n}\n\n.fa-add,\n.fa-plus {\n    --fa: \"\\2b\";\n    --fa--fa: \"\\2b\\2b\"\n}\n\n.fa-expand {\n    --fa: \"\\f065\";\n    --fa--fa: \"\\f065\\f065\"\n}\n\n.fa-computer {\n    --fa: \"\\e4e5\";\n    --fa--fa: \"\\e4e5\\e4e5\"\n}\n\n.fa-close,\n.fa-multiply,\n.fa-remove,\n.fa-times,\n.fa-xmark {\n    --fa: \"\\f00d\";\n    --fa--fa: \"\\f00d\\f00d\"\n}\n\n.fa-arrows,\n.fa-arrows-up-down-left-right {\n    --fa: \"\\f047\";\n    --fa--fa: \"\\f047\\f047\"\n}\n\n.fa-chalkboard-teacher,\n.fa-chalkboard-user {\n    --fa: \"\\f51c\";\n    --fa--fa: \"\\f51c\\f51c\"\n}\n\n.fa-peso-sign {\n    --fa: \"\\e222\";\n    --fa--fa: \"\\e222\\e222\"\n}\n\n.fa-building-shield {\n    --fa: \"\\e4d8\";\n    --fa--fa: \"\\e4d8\\e4d8\"\n}\n\n.fa-baby {\n    --fa: \"\\f77c\";\n    --fa--fa: \"\\f77c\\f77c\"\n}\n\n.fa-users-line {\n    --fa: \"\\e592\";\n    --fa--fa: \"\\e592\\e592\"\n}\n\n.fa-quote-left,\n.fa-quote-left-alt {\n    --fa: \"\\f10d\";\n    --fa--fa: \"\\f10d\\f10d\"\n}\n\n.fa-tractor {\n    --fa: \"\\f722\";\n    --fa--fa: \"\\f722\\f722\"\n}\n\n.fa-trash-arrow-up,\n.fa-trash-restore {\n    --fa: \"\\f829\";\n    --fa--fa: \"\\f829\\f829\"\n}\n\n.fa-arrow-down-up-lock {\n    --fa: \"\\e4b0\";\n    --fa--fa: \"\\e4b0\\e4b0\"\n}\n\n.fa-lines-leaning {\n    --fa: \"\\e51e\";\n    --fa--fa: \"\\e51e\\e51e\"\n}\n\n.fa-ruler-combined {\n    --fa: \"\\f546\";\n    --fa--fa: \"\\f546\\f546\"\n}\n\n.fa-copyright {\n    --fa: \"\\f1f9\";\n    --fa--fa: \"\\f1f9\\f1f9\"\n}\n\n.fa-equals {\n    --fa: \"\\3d\";\n    --fa--fa: \"\\3d\\3d\"\n}\n\n.fa-blender {\n    --fa: \"\\f517\";\n    --fa--fa: \"\\f517\\f517\"\n}\n\n.fa-teeth {\n    --fa: \"\\f62e\";\n    --fa--fa: \"\\f62e\\f62e\"\n}\n\n.fa-ils,\n.fa-shekel,\n.fa-shekel-sign,\n.fa-sheqel,\n.fa-sheqel-sign {\n    --fa: \"\\f20b\";\n    --fa--fa: \"\\f20b\\f20b\"\n}\n\n.fa-map {\n    --fa: \"\\f279\";\n    --fa--fa: \"\\f279\\f279\"\n}\n\n.fa-rocket {\n    --fa: \"\\f135\";\n    --fa--fa: \"\\f135\\f135\"\n}\n\n.fa-photo-film,\n.fa-photo-video {\n    --fa: \"\\f87c\";\n    --fa--fa: \"\\f87c\\f87c\"\n}\n\n.fa-folder-minus {\n    --fa: \"\\f65d\";\n    --fa--fa: \"\\f65d\\f65d\"\n}\n\n.fa-hexagon-nodes-bolt {\n    --fa: \"\\e69a\";\n    --fa--fa: \"\\e69a\\e69a\"\n}\n\n.fa-store {\n    --fa: \"\\f54e\";\n    --fa--fa: \"\\f54e\\f54e\"\n}\n\n.fa-arrow-trend-up {\n    --fa: \"\\e098\";\n    --fa--fa: \"\\e098\\e098\"\n}\n\n.fa-plug-circle-minus {\n    --fa: \"\\e55e\";\n    --fa--fa: \"\\e55e\\e55e\"\n}\n\n.fa-sign,\n.fa-sign-hanging {\n    --fa: \"\\f4d9\";\n    --fa--fa: \"\\f4d9\\f4d9\"\n}\n\n.fa-bezier-curve {\n    --fa: \"\\f55b\";\n    --fa--fa: \"\\f55b\\f55b\"\n}\n\n.fa-bell-slash {\n    --fa: \"\\f1f6\";\n    --fa--fa: \"\\f1f6\\f1f6\"\n}\n\n.fa-tablet,\n.fa-tablet-android {\n    --fa: \"\\f3fb\";\n    --fa--fa: \"\\f3fb\\f3fb\"\n}\n\n.fa-school-flag {\n    --fa: \"\\e56e\";\n    --fa--fa: \"\\e56e\\e56e\"\n}\n\n.fa-fill {\n    --fa: \"\\f575\";\n    --fa--fa: \"\\f575\\f575\"\n}\n\n.fa-angle-up {\n    --fa: \"\\f106\";\n    --fa--fa: \"\\f106\\f106\"\n}\n\n.fa-drumstick-bite {\n    --fa: \"\\f6d7\";\n    --fa--fa: \"\\f6d7\\f6d7\"\n}\n\n.fa-holly-berry {\n    --fa: \"\\f7aa\";\n    --fa--fa: \"\\f7aa\\f7aa\"\n}\n\n.fa-chevron-left {\n    --fa: \"\\f053\";\n    --fa--fa: \"\\f053\\f053\"\n}\n\n.fa-bacteria {\n    --fa: \"\\e059\";\n    --fa--fa: \"\\e059\\e059\"\n}\n\n.fa-hand-lizard {\n    --fa: \"\\f258\";\n    --fa--fa: \"\\f258\\f258\"\n}\n\n.fa-notdef {\n    --fa: \"\\e1fe\";\n    --fa--fa: \"\\e1fe\\e1fe\"\n}\n\n.fa-disease {\n    --fa: \"\\f7fa\";\n    --fa--fa: \"\\f7fa\\f7fa\"\n}\n\n.fa-briefcase-medical {\n    --fa: \"\\f469\";\n    --fa--fa: \"\\f469\\f469\"\n}\n\n.fa-genderless {\n    --fa: \"\\f22d\";\n    --fa--fa: \"\\f22d\\f22d\"\n}\n\n.fa-chevron-right {\n    --fa: \"\\f054\";\n    --fa--fa: \"\\f054\\f054\"\n}\n\n.fa-retweet {\n    --fa: \"\\f079\";\n    --fa--fa: \"\\f079\\f079\"\n}\n\n.fa-car-alt,\n.fa-car-rear {\n    --fa: \"\\f5de\";\n    --fa--fa: \"\\f5de\\f5de\"\n}\n\n.fa-pump-soap {\n    --fa: \"\\e06b\";\n    --fa--fa: \"\\e06b\\e06b\"\n}\n\n.fa-video-slash {\n    --fa: \"\\f4e2\";\n    --fa--fa: \"\\f4e2\\f4e2\"\n}\n\n.fa-battery-2,\n.fa-battery-quarter {\n    --fa: \"\\f243\";\n    --fa--fa: \"\\f243\\f243\"\n}\n\n.fa-radio {\n    --fa: \"\\f8d7\";\n    --fa--fa: \"\\f8d7\\f8d7\"\n}\n\n.fa-baby-carriage,\n.fa-carriage-baby {\n    --fa: \"\\f77d\";\n    --fa--fa: \"\\f77d\\f77d\"\n}\n\n.fa-traffic-light {\n    --fa: \"\\f637\";\n    --fa--fa: \"\\f637\\f637\"\n}\n\n.fa-thermometer {\n    --fa: \"\\f491\";\n    --fa--fa: \"\\f491\\f491\"\n}\n\n.fa-vr-cardboard {\n    --fa: \"\\f729\";\n    --fa--fa: \"\\f729\\f729\"\n}\n\n.fa-hand-middle-finger {\n    --fa: \"\\f806\";\n    --fa--fa: \"\\f806\\f806\"\n}\n\n.fa-percent,\n.fa-percentage {\n    --fa: \"\\25\";\n    --fa--fa: \"\\25\\25\"\n}\n\n.fa-truck-moving {\n    --fa: \"\\f4df\";\n    --fa--fa: \"\\f4df\\f4df\"\n}\n\n.fa-glass-water-droplet {\n    --fa: \"\\e4f5\";\n    --fa--fa: \"\\e4f5\\e4f5\"\n}\n\n.fa-display {\n    --fa: \"\\e163\";\n    --fa--fa: \"\\e163\\e163\"\n}\n\n.fa-face-smile,\n.fa-smile {\n    --fa: \"\\f118\";\n    --fa--fa: \"\\f118\\f118\"\n}\n\n.fa-thumb-tack,\n.fa-thumbtack {\n    --fa: \"\\f08d\";\n    --fa--fa: \"\\f08d\\f08d\"\n}\n\n.fa-trophy {\n    --fa: \"\\f091\";\n    --fa--fa: \"\\f091\\f091\"\n}\n\n.fa-person-praying,\n.fa-pray {\n    --fa: \"\\f683\";\n    --fa--fa: \"\\f683\\f683\"\n}\n\n.fa-hammer {\n    --fa: \"\\f6e3\";\n    --fa--fa: \"\\f6e3\\f6e3\"\n}\n\n.fa-hand-peace {\n    --fa: \"\\f25b\";\n    --fa--fa: \"\\f25b\\f25b\"\n}\n\n.fa-rotate,\n.fa-sync-alt {\n    --fa: \"\\f2f1\";\n    --fa--fa: \"\\f2f1\\f2f1\"\n}\n\n.fa-spinner {\n    --fa: \"\\f110\";\n    --fa--fa: \"\\f110\\f110\"\n}\n\n.fa-robot {\n    --fa: \"\\f544\";\n    --fa--fa: \"\\f544\\f544\"\n}\n\n.fa-peace {\n    --fa: \"\\f67c\";\n    --fa--fa: \"\\f67c\\f67c\"\n}\n\n.fa-cogs,\n.fa-gears {\n    --fa: \"\\f085\";\n    --fa--fa: \"\\f085\\f085\"\n}\n\n.fa-warehouse {\n    --fa: \"\\f494\";\n    --fa--fa: \"\\f494\\f494\"\n}\n\n.fa-arrow-up-right-dots {\n    --fa: \"\\e4b7\";\n    --fa--fa: \"\\e4b7\\e4b7\"\n}\n\n.fa-splotch {\n    --fa: \"\\f5bc\";\n    --fa--fa: \"\\f5bc\\f5bc\"\n}\n\n.fa-face-grin-hearts,\n.fa-grin-hearts {\n    --fa: \"\\f584\";\n    --fa--fa: \"\\f584\\f584\"\n}\n\n.fa-dice-four {\n    --fa: \"\\f524\";\n    --fa--fa: \"\\f524\\f524\"\n}\n\n.fa-sim-card {\n    --fa: \"\\f7c4\";\n    --fa--fa: \"\\f7c4\\f7c4\"\n}\n\n.fa-transgender,\n.fa-transgender-alt {\n    --fa: \"\\f225\";\n    --fa--fa: \"\\f225\\f225\"\n}\n\n.fa-mercury {\n    --fa: \"\\f223\";\n    --fa--fa: \"\\f223\\f223\"\n}\n\n.fa-arrow-turn-down,\n.fa-level-down {\n    --fa: \"\\f149\";\n    --fa--fa: \"\\f149\\f149\"\n}\n\n.fa-person-falling-burst {\n    --fa: \"\\e547\";\n    --fa--fa: \"\\e547\\e547\"\n}\n\n.fa-award {\n    --fa: \"\\f559\";\n    --fa--fa: \"\\f559\\f559\"\n}\n\n.fa-ticket-alt,\n.fa-ticket-simple {\n    --fa: \"\\f3ff\";\n    --fa--fa: \"\\f3ff\\f3ff\"\n}\n\n.fa-building {\n    --fa: \"\\f1ad\";\n    --fa--fa: \"\\f1ad\\f1ad\"\n}\n\n.fa-angle-double-left,\n.fa-angles-left {\n    --fa: \"\\f100\";\n    --fa--fa: \"\\f100\\f100\"\n}\n\n.fa-qrcode {\n    --fa: \"\\f029\";\n    --fa--fa: \"\\f029\\f029\"\n}\n\n.fa-clock-rotate-left,\n.fa-history {\n    --fa: \"\\f1da\";\n    --fa--fa: \"\\f1da\\f1da\"\n}\n\n.fa-face-grin-beam-sweat,\n.fa-grin-beam-sweat {\n    --fa: \"\\f583\";\n    --fa--fa: \"\\f583\\f583\"\n}\n\n.fa-arrow-right-from-file,\n.fa-file-export {\n    --fa: \"\\f56e\";\n    --fa--fa: \"\\f56e\\f56e\"\n}\n\n.fa-shield,\n.fa-shield-blank {\n    --fa: \"\\f132\";\n    --fa--fa: \"\\f132\\f132\"\n}\n\n.fa-arrow-up-short-wide,\n.fa-sort-amount-up-alt {\n    --fa: \"\\f885\";\n    --fa--fa: \"\\f885\\f885\"\n}\n\n.fa-comment-nodes {\n    --fa: \"\\e696\";\n    --fa--fa: \"\\e696\\e696\"\n}\n\n.fa-house-medical {\n    --fa: \"\\e3b2\";\n    --fa--fa: \"\\e3b2\\e3b2\"\n}\n\n.fa-golf-ball,\n.fa-golf-ball-tee {\n    --fa: \"\\f450\";\n    --fa--fa: \"\\f450\\f450\"\n}\n\n.fa-chevron-circle-left,\n.fa-circle-chevron-left {\n    --fa: \"\\f137\";\n    --fa--fa: \"\\f137\\f137\"\n}\n\n.fa-house-chimney-window {\n    --fa: \"\\e00d\";\n    --fa--fa: \"\\e00d\\e00d\"\n}\n\n.fa-pen-nib {\n    --fa: \"\\f5ad\";\n    --fa--fa: \"\\f5ad\\f5ad\"\n}\n\n.fa-tent-arrow-turn-left {\n    --fa: \"\\e580\";\n    --fa--fa: \"\\e580\\e580\"\n}\n\n.fa-tents {\n    --fa: \"\\e582\";\n    --fa--fa: \"\\e582\\e582\"\n}\n\n.fa-magic,\n.fa-wand-magic {\n    --fa: \"\\f0d0\";\n    --fa--fa: \"\\f0d0\\f0d0\"\n}\n\n.fa-dog {\n    --fa: \"\\f6d3\";\n    --fa--fa: \"\\f6d3\\f6d3\"\n}\n\n.fa-carrot {\n    --fa: \"\\f787\";\n    --fa--fa: \"\\f787\\f787\"\n}\n\n.fa-moon {\n    --fa: \"\\f186\";\n    --fa--fa: \"\\f186\\f186\"\n}\n\n.fa-wine-glass-alt,\n.fa-wine-glass-empty {\n    --fa: \"\\f5ce\";\n    --fa--fa: \"\\f5ce\\f5ce\"\n}\n\n.fa-cheese {\n    --fa: \"\\f7ef\";\n    --fa--fa: \"\\f7ef\\f7ef\"\n}\n\n.fa-yin-yang {\n    --fa: \"\\f6ad\";\n    --fa--fa: \"\\f6ad\\f6ad\"\n}\n\n.fa-music {\n    --fa: \"\\f001\";\n    --fa--fa: \"\\f001\\f001\"\n}\n\n.fa-code-commit {\n    --fa: \"\\f386\";\n    --fa--fa: \"\\f386\\f386\"\n}\n\n.fa-temperature-low {\n    --fa: \"\\f76b\";\n    --fa--fa: \"\\f76b\\f76b\"\n}\n\n.fa-biking,\n.fa-person-biking {\n    --fa: \"\\f84a\";\n    --fa--fa: \"\\f84a\\f84a\"\n}\n\n.fa-broom {\n    --fa: \"\\f51a\";\n    --fa--fa: \"\\f51a\\f51a\"\n}\n\n.fa-shield-heart {\n    --fa: \"\\e574\";\n    --fa--fa: \"\\e574\\e574\"\n}\n\n.fa-gopuram {\n    --fa: \"\\f664\";\n    --fa--fa: \"\\f664\\f664\"\n}\n\n.fa-earth-oceania,\n.fa-globe-oceania {\n    --fa: \"\\e47b\";\n    --fa--fa: \"\\e47b\\e47b\"\n}\n\n.fa-square-xmark,\n.fa-times-square,\n.fa-xmark-square {\n    --fa: \"\\f2d3\";\n    --fa--fa: \"\\f2d3\\f2d3\"\n}\n\n.fa-hashtag {\n    --fa: \"\\23\";\n    --fa--fa: \"\\23\\23\"\n}\n\n.fa-expand-alt,\n.fa-up-right-and-down-left-from-center {\n    --fa: \"\\f424\";\n    --fa--fa: \"\\f424\\f424\"\n}\n\n.fa-oil-can {\n    --fa: \"\\f613\";\n    --fa--fa: \"\\f613\\f613\"\n}\n\n.fa-t {\n    --fa: \"\\54\";\n    --fa--fa: \"\\54\\54\"\n}\n\n.fa-hippo {\n    --fa: \"\\f6ed\";\n    --fa--fa: \"\\f6ed\\f6ed\"\n}\n\n.fa-chart-column {\n    --fa: \"\\e0e3\";\n    --fa--fa: \"\\e0e3\\e0e3\"\n}\n\n.fa-infinity {\n    --fa: \"\\f534\";\n    --fa--fa: \"\\f534\\f534\"\n}\n\n.fa-vial-circle-check {\n    --fa: \"\\e596\";\n    --fa--fa: \"\\e596\\e596\"\n}\n\n.fa-person-arrow-down-to-line {\n    --fa: \"\\e538\";\n    --fa--fa: \"\\e538\\e538\"\n}\n\n.fa-voicemail {\n    --fa: \"\\f897\";\n    --fa--fa: \"\\f897\\f897\"\n}\n\n.fa-fan {\n    --fa: \"\\f863\";\n    --fa--fa: \"\\f863\\f863\"\n}\n\n.fa-person-walking-luggage {\n    --fa: \"\\e554\";\n    --fa--fa: \"\\e554\\e554\"\n}\n\n.fa-arrows-alt-v,\n.fa-up-down {\n    --fa: \"\\f338\";\n    --fa--fa: \"\\f338\\f338\"\n}\n\n.fa-cloud-moon-rain {\n    --fa: \"\\f73c\";\n    --fa--fa: \"\\f73c\\f73c\"\n}\n\n.fa-calendar {\n    --fa: \"\\f133\";\n    --fa--fa: \"\\f133\\f133\"\n}\n\n.fa-trailer {\n    --fa: \"\\e041\";\n    --fa--fa: \"\\e041\\e041\"\n}\n\n.fa-bahai,\n.fa-haykal {\n    --fa: \"\\f666\";\n    --fa--fa: \"\\f666\\f666\"\n}\n\n.fa-sd-card {\n    --fa: \"\\f7c2\";\n    --fa--fa: \"\\f7c2\\f7c2\"\n}\n\n.fa-dragon {\n    --fa: \"\\f6d5\";\n    --fa--fa: \"\\f6d5\\f6d5\"\n}\n\n.fa-shoe-prints {\n    --fa: \"\\f54b\";\n    --fa--fa: \"\\f54b\\f54b\"\n}\n\n.fa-circle-plus,\n.fa-plus-circle {\n    --fa: \"\\f055\";\n    --fa--fa: \"\\f055\\f055\"\n}\n\n.fa-face-grin-tongue-wink,\n.fa-grin-tongue-wink {\n    --fa: \"\\f58b\";\n    --fa--fa: \"\\f58b\\f58b\"\n}\n\n.fa-hand-holding {\n    --fa: \"\\f4bd\";\n    --fa--fa: \"\\f4bd\\f4bd\"\n}\n\n.fa-plug-circle-exclamation {\n    --fa: \"\\e55d\";\n    --fa--fa: \"\\e55d\\e55d\"\n}\n\n.fa-chain-broken,\n.fa-chain-slash,\n.fa-link-slash,\n.fa-unlink {\n    --fa: \"\\f127\";\n    --fa--fa: \"\\f127\\f127\"\n}\n\n.fa-clone {\n    --fa: \"\\f24d\";\n    --fa--fa: \"\\f24d\\f24d\"\n}\n\n.fa-person-walking-arrow-loop-left {\n    --fa: \"\\e551\";\n    --fa--fa: \"\\e551\\e551\"\n}\n\n.fa-arrow-up-z-a,\n.fa-sort-alpha-up-alt {\n    --fa: \"\\f882\";\n    --fa--fa: \"\\f882\\f882\"\n}\n\n.fa-fire-alt,\n.fa-fire-flame-curved {\n    --fa: \"\\f7e4\";\n    --fa--fa: \"\\f7e4\\f7e4\"\n}\n\n.fa-tornado {\n    --fa: \"\\f76f\";\n    --fa--fa: \"\\f76f\\f76f\"\n}\n\n.fa-file-circle-plus {\n    --fa: \"\\e494\";\n    --fa--fa: \"\\e494\\e494\"\n}\n\n.fa-book-quran,\n.fa-quran {\n    --fa: \"\\f687\";\n    --fa--fa: \"\\f687\\f687\"\n}\n\n.fa-anchor {\n    --fa: \"\\f13d\";\n    --fa--fa: \"\\f13d\\f13d\"\n}\n\n.fa-border-all {\n    --fa: \"\\f84c\";\n    --fa--fa: \"\\f84c\\f84c\"\n}\n\n.fa-angry,\n.fa-face-angry {\n    --fa: \"\\f556\";\n    --fa--fa: \"\\f556\\f556\"\n}\n\n.fa-cookie-bite {\n    --fa: \"\\f564\";\n    --fa--fa: \"\\f564\\f564\"\n}\n\n.fa-arrow-trend-down {\n    --fa: \"\\e097\";\n    --fa--fa: \"\\e097\\e097\"\n}\n\n.fa-feed,\n.fa-rss {\n    --fa: \"\\f09e\";\n    --fa--fa: \"\\f09e\\f09e\"\n}\n\n.fa-draw-polygon {\n    --fa: \"\\f5ee\";\n    --fa--fa: \"\\f5ee\\f5ee\"\n}\n\n.fa-balance-scale,\n.fa-scale-balanced {\n    --fa: \"\\f24e\";\n    --fa--fa: \"\\f24e\\f24e\"\n}\n\n.fa-gauge-simple-high,\n.fa-tachometer,\n.fa-tachometer-fast {\n    --fa: \"\\f62a\";\n    --fa--fa: \"\\f62a\\f62a\"\n}\n\n.fa-shower {\n    --fa: \"\\f2cc\";\n    --fa--fa: \"\\f2cc\\f2cc\"\n}\n\n.fa-desktop,\n.fa-desktop-alt {\n    --fa: \"\\f390\";\n    --fa--fa: \"\\f390\\f390\"\n}\n\n.fa-m {\n    --fa: \"\\4d\";\n    --fa--fa: \"\\4d\\4d\"\n}\n\n.fa-table-list,\n.fa-th-list {\n    --fa: \"\\f00b\";\n    --fa--fa: \"\\f00b\\f00b\"\n}\n\n.fa-comment-sms,\n.fa-sms {\n    --fa: \"\\f7cd\";\n    --fa--fa: \"\\f7cd\\f7cd\"\n}\n\n.fa-book {\n    --fa: \"\\f02d\";\n    --fa--fa: \"\\f02d\\f02d\"\n}\n\n.fa-user-plus {\n    --fa: \"\\f234\";\n    --fa--fa: \"\\f234\\f234\"\n}\n\n.fa-check {\n    --fa: \"\\f00c\";\n    --fa--fa: \"\\f00c\\f00c\"\n}\n\n.fa-battery-4,\n.fa-battery-three-quarters {\n    --fa: \"\\f241\";\n    --fa--fa: \"\\f241\\f241\"\n}\n\n.fa-house-circle-check {\n    --fa: \"\\e509\";\n    --fa--fa: \"\\e509\\e509\"\n}\n\n.fa-angle-left {\n    --fa: \"\\f104\";\n    --fa--fa: \"\\f104\\f104\"\n}\n\n.fa-diagram-successor {\n    --fa: \"\\e47a\";\n    --fa--fa: \"\\e47a\\e47a\"\n}\n\n.fa-truck-arrow-right {\n    --fa: \"\\e58b\";\n    --fa--fa: \"\\e58b\\e58b\"\n}\n\n.fa-arrows-split-up-and-left {\n    --fa: \"\\e4bc\";\n    --fa--fa: \"\\e4bc\\e4bc\"\n}\n\n.fa-fist-raised,\n.fa-hand-fist {\n    --fa: \"\\f6de\";\n    --fa--fa: \"\\f6de\\f6de\"\n}\n\n.fa-cloud-moon {\n    --fa: \"\\f6c3\";\n    --fa--fa: \"\\f6c3\\f6c3\"\n}\n\n.fa-briefcase {\n    --fa: \"\\f0b1\";\n    --fa--fa: \"\\f0b1\\f0b1\"\n}\n\n.fa-person-falling {\n    --fa: \"\\e546\";\n    --fa--fa: \"\\e546\\e546\"\n}\n\n.fa-image-portrait,\n.fa-portrait {\n    --fa: \"\\f3e0\";\n    --fa--fa: \"\\f3e0\\f3e0\"\n}\n\n.fa-user-tag {\n    --fa: \"\\f507\";\n    --fa--fa: \"\\f507\\f507\"\n}\n\n.fa-rug {\n    --fa: \"\\e569\";\n    --fa--fa: \"\\e569\\e569\"\n}\n\n.fa-earth-europe,\n.fa-globe-europe {\n    --fa: \"\\f7a2\";\n    --fa--fa: \"\\f7a2\\f7a2\"\n}\n\n.fa-cart-flatbed-suitcase,\n.fa-luggage-cart {\n    --fa: \"\\f59d\";\n    --fa--fa: \"\\f59d\\f59d\"\n}\n\n.fa-rectangle-times,\n.fa-rectangle-xmark,\n.fa-times-rectangle,\n.fa-window-close {\n    --fa: \"\\f410\";\n    --fa--fa: \"\\f410\\f410\"\n}\n\n.fa-baht-sign {\n    --fa: \"\\e0ac\";\n    --fa--fa: \"\\e0ac\\e0ac\"\n}\n\n.fa-book-open {\n    --fa: \"\\f518\";\n    --fa--fa: \"\\f518\\f518\"\n}\n\n.fa-book-journal-whills,\n.fa-journal-whills {\n    --fa: \"\\f66a\";\n    --fa--fa: \"\\f66a\\f66a\"\n}\n\n.fa-handcuffs {\n    --fa: \"\\e4f8\";\n    --fa--fa: \"\\e4f8\\e4f8\"\n}\n\n.fa-exclamation-triangle,\n.fa-triangle-exclamation,\n.fa-warning {\n    --fa: \"\\f071\";\n    --fa--fa: \"\\f071\\f071\"\n}\n\n.fa-database {\n    --fa: \"\\f1c0\";\n    --fa--fa: \"\\f1c0\\f1c0\"\n}\n\n.fa-mail-forward,\n.fa-share {\n    --fa: \"\\f064\";\n    --fa--fa: \"\\f064\\f064\"\n}\n\n.fa-bottle-droplet {\n    --fa: \"\\e4c4\";\n    --fa--fa: \"\\e4c4\\e4c4\"\n}\n\n.fa-mask-face {\n    --fa: \"\\e1d7\";\n    --fa--fa: \"\\e1d7\\e1d7\"\n}\n\n.fa-hill-rockslide {\n    --fa: \"\\e508\";\n    --fa--fa: \"\\e508\\e508\"\n}\n\n.fa-exchange-alt,\n.fa-right-left {\n    --fa: \"\\f362\";\n    --fa--fa: \"\\f362\\f362\"\n}\n\n.fa-paper-plane {\n    --fa: \"\\f1d8\";\n    --fa--fa: \"\\f1d8\\f1d8\"\n}\n\n.fa-road-circle-exclamation {\n    --fa: \"\\e565\";\n    --fa--fa: \"\\e565\\e565\"\n}\n\n.fa-dungeon {\n    --fa: \"\\f6d9\";\n    --fa--fa: \"\\f6d9\\f6d9\"\n}\n\n.fa-align-right {\n    --fa: \"\\f038\";\n    --fa--fa: \"\\f038\\f038\"\n}\n\n.fa-money-bill-1-wave,\n.fa-money-bill-wave-alt {\n    --fa: \"\\f53b\";\n    --fa--fa: \"\\f53b\\f53b\"\n}\n\n.fa-life-ring {\n    --fa: \"\\f1cd\";\n    --fa--fa: \"\\f1cd\\f1cd\"\n}\n\n.fa-hands,\n.fa-sign-language,\n.fa-signing {\n    --fa: \"\\f2a7\";\n    --fa--fa: \"\\f2a7\\f2a7\"\n}\n\n.fa-calendar-day {\n    --fa: \"\\f783\";\n    --fa--fa: \"\\f783\\f783\"\n}\n\n.fa-ladder-water,\n.fa-swimming-pool,\n.fa-water-ladder {\n    --fa: \"\\f5c5\";\n    --fa--fa: \"\\f5c5\\f5c5\"\n}\n\n.fa-arrows-up-down,\n.fa-arrows-v {\n    --fa: \"\\f07d\";\n    --fa--fa: \"\\f07d\\f07d\"\n}\n\n.fa-face-grimace,\n.fa-grimace {\n    --fa: \"\\f57f\";\n    --fa--fa: \"\\f57f\\f57f\"\n}\n\n.fa-wheelchair-alt,\n.fa-wheelchair-move {\n    --fa: \"\\e2ce\";\n    --fa--fa: \"\\e2ce\\e2ce\"\n}\n\n.fa-level-down-alt,\n.fa-turn-down {\n    --fa: \"\\f3be\";\n    --fa--fa: \"\\f3be\\f3be\"\n}\n\n.fa-person-walking-arrow-right {\n    --fa: \"\\e552\";\n    --fa--fa: \"\\e552\\e552\"\n}\n\n.fa-envelope-square,\n.fa-square-envelope {\n    --fa: \"\\f199\";\n    --fa--fa: \"\\f199\\f199\"\n}\n\n.fa-dice {\n    --fa: \"\\f522\";\n    --fa--fa: \"\\f522\\f522\"\n}\n\n.fa-bowling-ball {\n    --fa: \"\\f436\";\n    --fa--fa: \"\\f436\\f436\"\n}\n\n.fa-brain {\n    --fa: \"\\f5dc\";\n    --fa--fa: \"\\f5dc\\f5dc\"\n}\n\n.fa-band-aid,\n.fa-bandage {\n    --fa: \"\\f462\";\n    --fa--fa: \"\\f462\\f462\"\n}\n\n.fa-calendar-minus {\n    --fa: \"\\f272\";\n    --fa--fa: \"\\f272\\f272\"\n}\n\n.fa-circle-xmark,\n.fa-times-circle,\n.fa-xmark-circle {\n    --fa: \"\\f057\";\n    --fa--fa: \"\\f057\\f057\"\n}\n\n.fa-gifts {\n    --fa: \"\\f79c\";\n    --fa--fa: \"\\f79c\\f79c\"\n}\n\n.fa-hotel {\n    --fa: \"\\f594\";\n    --fa--fa: \"\\f594\\f594\"\n}\n\n.fa-earth-asia,\n.fa-globe-asia {\n    --fa: \"\\f57e\";\n    --fa--fa: \"\\f57e\\f57e\"\n}\n\n.fa-id-card-alt,\n.fa-id-card-clip {\n    --fa: \"\\f47f\";\n    --fa--fa: \"\\f47f\\f47f\"\n}\n\n.fa-magnifying-glass-plus,\n.fa-search-plus {\n    --fa: \"\\f00e\";\n    --fa--fa: \"\\f00e\\f00e\"\n}\n\n.fa-thumbs-up {\n    --fa: \"\\f164\";\n    --fa--fa: \"\\f164\\f164\"\n}\n\n.fa-user-clock {\n    --fa: \"\\f4fd\";\n    --fa--fa: \"\\f4fd\\f4fd\"\n}\n\n.fa-allergies,\n.fa-hand-dots {\n    --fa: \"\\f461\";\n    --fa--fa: \"\\f461\\f461\"\n}\n\n.fa-file-invoice {\n    --fa: \"\\f570\";\n    --fa--fa: \"\\f570\\f570\"\n}\n\n.fa-window-minimize {\n    --fa: \"\\f2d1\";\n    --fa--fa: \"\\f2d1\\f2d1\"\n}\n\n.fa-coffee,\n.fa-mug-saucer {\n    --fa: \"\\f0f4\";\n    --fa--fa: \"\\f0f4\\f0f4\"\n}\n\n.fa-brush {\n    --fa: \"\\f55d\";\n    --fa--fa: \"\\f55d\\f55d\"\n}\n\n.fa-file-half-dashed {\n    --fa: \"\\e698\";\n    --fa--fa: \"\\e698\\e698\"\n}\n\n.fa-mask {\n    --fa: \"\\f6fa\";\n    --fa--fa: \"\\f6fa\\f6fa\"\n}\n\n.fa-magnifying-glass-minus,\n.fa-search-minus {\n    --fa: \"\\f010\";\n    --fa--fa: \"\\f010\\f010\"\n}\n\n.fa-ruler-vertical {\n    --fa: \"\\f548\";\n    --fa--fa: \"\\f548\\f548\"\n}\n\n.fa-user-alt,\n.fa-user-large {\n    --fa: \"\\f406\";\n    --fa--fa: \"\\f406\\f406\"\n}\n\n.fa-train-tram {\n    --fa: \"\\e5b4\";\n    --fa--fa: \"\\e5b4\\e5b4\"\n}\n\n.fa-user-nurse {\n    --fa: \"\\f82f\";\n    --fa--fa: \"\\f82f\\f82f\"\n}\n\n.fa-syringe {\n    --fa: \"\\f48e\";\n    --fa--fa: \"\\f48e\\f48e\"\n}\n\n.fa-cloud-sun {\n    --fa: \"\\f6c4\";\n    --fa--fa: \"\\f6c4\\f6c4\"\n}\n\n.fa-stopwatch-20 {\n    --fa: \"\\e06f\";\n    --fa--fa: \"\\e06f\\e06f\"\n}\n\n.fa-square-full {\n    --fa: \"\\f45c\";\n    --fa--fa: \"\\f45c\\f45c\"\n}\n\n.fa-magnet {\n    --fa: \"\\f076\";\n    --fa--fa: \"\\f076\\f076\"\n}\n\n.fa-jar {\n    --fa: \"\\e516\";\n    --fa--fa: \"\\e516\\e516\"\n}\n\n.fa-note-sticky,\n.fa-sticky-note {\n    --fa: \"\\f249\";\n    --fa--fa: \"\\f249\\f249\"\n}\n\n.fa-bug-slash {\n    --fa: \"\\e490\";\n    --fa--fa: \"\\e490\\e490\"\n}\n\n.fa-arrow-up-from-water-pump {\n    --fa: \"\\e4b6\";\n    --fa--fa: \"\\e4b6\\e4b6\"\n}\n\n.fa-bone {\n    --fa: \"\\f5d7\";\n    --fa--fa: \"\\f5d7\\f5d7\"\n}\n\n.fa-table-cells-row-unlock {\n    --fa: \"\\e691\";\n    --fa--fa: \"\\e691\\e691\"\n}\n\n.fa-user-injured {\n    --fa: \"\\f728\";\n    --fa--fa: \"\\f728\\f728\"\n}\n\n.fa-face-sad-tear,\n.fa-sad-tear {\n    --fa: \"\\f5b4\";\n    --fa--fa: \"\\f5b4\\f5b4\"\n}\n\n.fa-plane {\n    --fa: \"\\f072\";\n    --fa--fa: \"\\f072\\f072\"\n}\n\n.fa-tent-arrows-down {\n    --fa: \"\\e581\";\n    --fa--fa: \"\\e581\\e581\"\n}\n\n.fa-exclamation {\n    --fa: \"\\21\";\n    --fa--fa: \"\\21\\21\"\n}\n\n.fa-arrows-spin {\n    --fa: \"\\e4bb\";\n    --fa--fa: \"\\e4bb\\e4bb\"\n}\n\n.fa-print {\n    --fa: \"\\f02f\";\n    --fa--fa: \"\\f02f\\f02f\"\n}\n\n.fa-try,\n.fa-turkish-lira,\n.fa-turkish-lira-sign {\n    --fa: \"\\e2bb\";\n    --fa--fa: \"\\e2bb\\e2bb\"\n}\n\n.fa-dollar,\n.fa-dollar-sign,\n.fa-usd {\n    --fa: \"\\24\";\n    --fa--fa: \"\\24\\24\"\n}\n\n.fa-x {\n    --fa: \"\\58\";\n    --fa--fa: \"\\58\\58\"\n}\n\n.fa-magnifying-glass-dollar,\n.fa-search-dollar {\n    --fa: \"\\f688\";\n    --fa--fa: \"\\f688\\f688\"\n}\n\n.fa-users-cog,\n.fa-users-gear {\n    --fa: \"\\f509\";\n    --fa--fa: \"\\f509\\f509\"\n}\n\n.fa-person-military-pointing {\n    --fa: \"\\e54a\";\n    --fa--fa: \"\\e54a\\e54a\"\n}\n\n.fa-bank,\n.fa-building-columns,\n.fa-institution,\n.fa-museum,\n.fa-university {\n    --fa: \"\\f19c\";\n    --fa--fa: \"\\f19c\\f19c\"\n}\n\n.fa-umbrella {\n    --fa: \"\\f0e9\";\n    --fa--fa: \"\\f0e9\\f0e9\"\n}\n\n.fa-trowel {\n    --fa: \"\\e589\";\n    --fa--fa: \"\\e589\\e589\"\n}\n\n.fa-d {\n    --fa: \"\\44\";\n    --fa--fa: \"\\44\\44\"\n}\n\n.fa-stapler {\n    --fa: \"\\e5af\";\n    --fa--fa: \"\\e5af\\e5af\"\n}\n\n.fa-masks-theater,\n.fa-theater-masks {\n    --fa: \"\\f630\";\n    --fa--fa: \"\\f630\\f630\"\n}\n\n.fa-kip-sign {\n    --fa: \"\\e1c4\";\n    --fa--fa: \"\\e1c4\\e1c4\"\n}\n\n.fa-hand-point-left {\n    --fa: \"\\f0a5\";\n    --fa--fa: \"\\f0a5\\f0a5\"\n}\n\n.fa-handshake-alt,\n.fa-handshake-simple {\n    --fa: \"\\f4c6\";\n    --fa--fa: \"\\f4c6\\f4c6\"\n}\n\n.fa-fighter-jet,\n.fa-jet-fighter {\n    --fa: \"\\f0fb\";\n    --fa--fa: \"\\f0fb\\f0fb\"\n}\n\n.fa-share-alt-square,\n.fa-square-share-nodes {\n    --fa: \"\\f1e1\";\n    --fa--fa: \"\\f1e1\\f1e1\"\n}\n\n.fa-barcode {\n    --fa: \"\\f02a\";\n    --fa--fa: \"\\f02a\\f02a\"\n}\n\n.fa-plus-minus {\n    --fa: \"\\e43c\";\n    --fa--fa: \"\\e43c\\e43c\"\n}\n\n.fa-video,\n.fa-video-camera {\n    --fa: \"\\f03d\";\n    --fa--fa: \"\\f03d\\f03d\"\n}\n\n.fa-graduation-cap,\n.fa-mortar-board {\n    --fa: \"\\f19d\";\n    --fa--fa: \"\\f19d\\f19d\"\n}\n\n.fa-hand-holding-medical {\n    --fa: \"\\e05c\";\n    --fa--fa: \"\\e05c\\e05c\"\n}\n\n.fa-person-circle-check {\n    --fa: \"\\e53e\";\n    --fa--fa: \"\\e53e\\e53e\"\n}\n\n.fa-level-up-alt,\n.fa-turn-up {\n    --fa: \"\\f3bf\";\n    --fa--fa: \"\\f3bf\\f3bf\"\n}\n\n.fa-sr-only,\n.fa-sr-only-focusable:not(:focus),\n.sr-only,\n.sr-only-focusable:not(:focus) {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0\n}\n\n:host,\n:root {\n    --fa-style-family-brands: \"Font Awesome 6 Brands\";\n    --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\"\n}\n\n@font-face {\n    font-family: \"Font Awesome 6 Brands\";\n    font-style: normal;\n    font-weight: 400;\n    font-display: block;\n    src: url(../webfonts/fa-brands-400.woff2) format(\"woff2\"), url(../webfonts/fa-brands-400.ttf) format(\"truetype\")\n}\n\n.fa-brands,\n.fab {\n    font-weight: 400\n}\n\n.fa-monero {\n    --fa: \"\\f3d0\"\n}\n\n.fa-hooli {\n    --fa: \"\\f427\"\n}\n\n.fa-yelp {\n    --fa: \"\\f1e9\"\n}\n\n.fa-cc-visa {\n    --fa: \"\\f1f0\"\n}\n\n.fa-lastfm {\n    --fa: \"\\f202\"\n}\n\n.fa-shopware {\n    --fa: \"\\f5b5\"\n}\n\n.fa-creative-commons-nc {\n    --fa: \"\\f4e8\"\n}\n\n.fa-aws {\n    --fa: \"\\f375\"\n}\n\n.fa-redhat {\n    --fa: \"\\f7bc\"\n}\n\n.fa-yoast {\n    --fa: \"\\f2b1\"\n}\n\n.fa-cloudflare {\n    --fa: \"\\e07d\"\n}\n\n.fa-ups {\n    --fa: \"\\f7e0\"\n}\n\n.fa-pixiv {\n    --fa: \"\\e640\"\n}\n\n.fa-wpexplorer {\n    --fa: \"\\f2de\"\n}\n\n.fa-dyalog {\n    --fa: \"\\f399\"\n}\n\n.fa-bity {\n    --fa: \"\\f37a\"\n}\n\n.fa-stackpath {\n    --fa: \"\\f842\"\n}\n\n.fa-buysellads {\n    --fa: \"\\f20d\"\n}\n\n.fa-first-order {\n    --fa: \"\\f2b0\"\n}\n\n.fa-modx {\n    --fa: \"\\f285\"\n}\n\n.fa-guilded {\n    --fa: \"\\e07e\"\n}\n\n.fa-vnv {\n    --fa: \"\\f40b\"\n}\n\n.fa-js-square,\n.fa-square-js {\n    --fa: \"\\f3b9\"\n}\n\n.fa-microsoft {\n    --fa: \"\\f3ca\"\n}\n\n.fa-qq {\n    --fa: \"\\f1d6\"\n}\n\n.fa-orcid {\n    --fa: \"\\f8d2\"\n}\n\n.fa-java {\n    --fa: \"\\f4e4\"\n}\n\n.fa-invision {\n    --fa: \"\\f7b0\"\n}\n\n.fa-creative-commons-pd-alt {\n    --fa: \"\\f4ed\"\n}\n\n.fa-centercode {\n    --fa: \"\\f380\"\n}\n\n.fa-glide-g {\n    --fa: \"\\f2a6\"\n}\n\n.fa-drupal {\n    --fa: \"\\f1a9\"\n}\n\n.fa-jxl {\n    --fa: \"\\e67b\"\n}\n\n.fa-dart-lang {\n    --fa: \"\\e693\"\n}\n\n.fa-hire-a-helper {\n    --fa: \"\\f3b0\"\n}\n\n.fa-creative-commons-by {\n    --fa: \"\\f4e7\"\n}\n\n.fa-unity {\n    --fa: \"\\e049\"\n}\n\n.fa-whmcs {\n    --fa: \"\\f40d\"\n}\n\n.fa-rocketchat {\n    --fa: \"\\f3e8\"\n}\n\n.fa-vk {\n    --fa: \"\\f189\"\n}\n\n.fa-untappd {\n    --fa: \"\\f405\"\n}\n\n.fa-mailchimp {\n    --fa: \"\\f59e\"\n}\n\n.fa-css3-alt {\n    --fa: \"\\f38b\"\n}\n\n.fa-reddit-square,\n.fa-square-reddit {\n    --fa: \"\\f1a2\"\n}\n\n.fa-vimeo-v {\n    --fa: \"\\f27d\"\n}\n\n.fa-contao {\n    --fa: \"\\f26d\"\n}\n\n.fa-square-font-awesome {\n    --fa: \"\\e5ad\"\n}\n\n.fa-deskpro {\n    --fa: \"\\f38f\"\n}\n\n.fa-brave {\n    --fa: \"\\e63c\"\n}\n\n.fa-sistrix {\n    --fa: \"\\f3ee\"\n}\n\n.fa-instagram-square,\n.fa-square-instagram {\n    --fa: \"\\e055\"\n}\n\n.fa-battle-net {\n    --fa: \"\\f835\"\n}\n\n.fa-the-red-yeti {\n    --fa: \"\\f69d\"\n}\n\n.fa-hacker-news-square,\n.fa-square-hacker-news {\n    --fa: \"\\f3af\"\n}\n\n.fa-edge {\n    --fa: \"\\f282\"\n}\n\n.fa-threads {\n    --fa: \"\\e618\"\n}\n\n.fa-napster {\n    --fa: \"\\f3d2\"\n}\n\n.fa-snapchat-square,\n.fa-square-snapchat {\n    --fa: \"\\f2ad\"\n}\n\n.fa-google-plus-g {\n    --fa: \"\\f0d5\"\n}\n\n.fa-artstation {\n    --fa: \"\\f77a\"\n}\n\n.fa-markdown {\n    --fa: \"\\f60f\"\n}\n\n.fa-sourcetree {\n    --fa: \"\\f7d3\"\n}\n\n.fa-google-plus {\n    --fa: \"\\f2b3\"\n}\n\n.fa-diaspora {\n    --fa: \"\\f791\"\n}\n\n.fa-foursquare {\n    --fa: \"\\f180\"\n}\n\n.fa-stack-overflow {\n    --fa: \"\\f16c\"\n}\n\n.fa-github-alt {\n    --fa: \"\\f113\"\n}\n\n.fa-phoenix-squadron {\n    --fa: \"\\f511\"\n}\n\n.fa-pagelines {\n    --fa: \"\\f18c\"\n}\n\n.fa-algolia {\n    --fa: \"\\f36c\"\n}\n\n.fa-red-river {\n    --fa: \"\\f3e3\"\n}\n\n.fa-creative-commons-sa {\n    --fa: \"\\f4ef\"\n}\n\n.fa-safari {\n    --fa: \"\\f267\"\n}\n\n.fa-google {\n    --fa: \"\\f1a0\"\n}\n\n.fa-font-awesome-alt,\n.fa-square-font-awesome-stroke {\n    --fa: \"\\f35c\"\n}\n\n.fa-atlassian {\n    --fa: \"\\f77b\"\n}\n\n.fa-linkedin-in {\n    --fa: \"\\f0e1\"\n}\n\n.fa-digital-ocean {\n    --fa: \"\\f391\"\n}\n\n.fa-nimblr {\n    --fa: \"\\f5a8\"\n}\n\n.fa-chromecast {\n    --fa: \"\\f838\"\n}\n\n.fa-evernote {\n    --fa: \"\\f839\"\n}\n\n.fa-hacker-news {\n    --fa: \"\\f1d4\"\n}\n\n.fa-creative-commons-sampling {\n    --fa: \"\\f4f0\"\n}\n\n.fa-adversal {\n    --fa: \"\\f36a\"\n}\n\n.fa-creative-commons {\n    --fa: \"\\f25e\"\n}\n\n.fa-watchman-monitoring {\n    --fa: \"\\e087\"\n}\n\n.fa-fonticons {\n    --fa: \"\\f280\"\n}\n\n.fa-weixin {\n    --fa: \"\\f1d7\"\n}\n\n.fa-shirtsinbulk {\n    --fa: \"\\f214\"\n}\n\n.fa-codepen {\n    --fa: \"\\f1cb\"\n}\n\n.fa-git-alt {\n    --fa: \"\\f841\"\n}\n\n.fa-lyft {\n    --fa: \"\\f3c3\"\n}\n\n.fa-rev {\n    --fa: \"\\f5b2\"\n}\n\n.fa-windows {\n    --fa: \"\\f17a\"\n}\n\n.fa-wizards-of-the-coast {\n    --fa: \"\\f730\"\n}\n\n.fa-square-viadeo,\n.fa-viadeo-square {\n    --fa: \"\\f2aa\"\n}\n\n.fa-meetup {\n    --fa: \"\\f2e0\"\n}\n\n.fa-centos {\n    --fa: \"\\f789\"\n}\n\n.fa-adn {\n    --fa: \"\\f170\"\n}\n\n.fa-cloudsmith {\n    --fa: \"\\f384\"\n}\n\n.fa-opensuse {\n    --fa: \"\\e62b\"\n}\n\n.fa-pied-piper-alt {\n    --fa: \"\\f1a8\"\n}\n\n.fa-dribbble-square,\n.fa-square-dribbble {\n    --fa: \"\\f397\"\n}\n\n.fa-codiepie {\n    --fa: \"\\f284\"\n}\n\n.fa-node {\n    --fa: \"\\f419\"\n}\n\n.fa-mix {\n    --fa: \"\\f3cb\"\n}\n\n.fa-steam {\n    --fa: \"\\f1b6\"\n}\n\n.fa-cc-apple-pay {\n    --fa: \"\\f416\"\n}\n\n.fa-scribd {\n    --fa: \"\\f28a\"\n}\n\n.fa-debian {\n    --fa: \"\\e60b\"\n}\n\n.fa-openid {\n    --fa: \"\\f19b\"\n}\n\n.fa-instalod {\n    --fa: \"\\e081\"\n}\n\n.fa-files-pinwheel {\n    --fa: \"\\e69f\"\n}\n\n.fa-expeditedssl {\n    --fa: \"\\f23e\"\n}\n\n.fa-sellcast {\n    --fa: \"\\f2da\"\n}\n\n.fa-square-twitter,\n.fa-twitter-square {\n    --fa: \"\\f081\"\n}\n\n.fa-r-project {\n    --fa: \"\\f4f7\"\n}\n\n.fa-delicious {\n    --fa: \"\\f1a5\"\n}\n\n.fa-freebsd {\n    --fa: \"\\f3a4\"\n}\n\n.fa-vuejs {\n    --fa: \"\\f41f\"\n}\n\n.fa-accusoft {\n    --fa: \"\\f369\"\n}\n\n.fa-ioxhost {\n    --fa: \"\\f208\"\n}\n\n.fa-fonticons-fi {\n    --fa: \"\\f3a2\"\n}\n\n.fa-app-store {\n    --fa: \"\\f36f\"\n}\n\n.fa-cc-mastercard {\n    --fa: \"\\f1f1\"\n}\n\n.fa-itunes-note {\n    --fa: \"\\f3b5\"\n}\n\n.fa-golang {\n    --fa: \"\\e40f\"\n}\n\n.fa-kickstarter,\n.fa-square-kickstarter {\n    --fa: \"\\f3bb\"\n}\n\n.fa-grav {\n    --fa: \"\\f2d6\"\n}\n\n.fa-weibo {\n    --fa: \"\\f18a\"\n}\n\n.fa-uncharted {\n    --fa: \"\\e084\"\n}\n\n.fa-firstdraft {\n    --fa: \"\\f3a1\"\n}\n\n.fa-square-youtube,\n.fa-youtube-square {\n    --fa: \"\\f431\"\n}\n\n.fa-wikipedia-w {\n    --fa: \"\\f266\"\n}\n\n.fa-rendact,\n.fa-wpressr {\n    --fa: \"\\f3e4\"\n}\n\n.fa-angellist {\n    --fa: \"\\f209\"\n}\n\n.fa-galactic-republic {\n    --fa: \"\\f50c\"\n}\n\n.fa-nfc-directional {\n    --fa: \"\\e530\"\n}\n\n.fa-skype {\n    --fa: \"\\f17e\"\n}\n\n.fa-joget {\n    --fa: \"\\f3b7\"\n}\n\n.fa-fedora {\n    --fa: \"\\f798\"\n}\n\n.fa-stripe-s {\n    --fa: \"\\f42a\"\n}\n\n.fa-meta {\n    --fa: \"\\e49b\"\n}\n\n.fa-laravel {\n    --fa: \"\\f3bd\"\n}\n\n.fa-hotjar {\n    --fa: \"\\f3b1\"\n}\n\n.fa-bluetooth-b {\n    --fa: \"\\f294\"\n}\n\n.fa-square-letterboxd {\n    --fa: \"\\e62e\"\n}\n\n.fa-sticker-mule {\n    --fa: \"\\f3f7\"\n}\n\n.fa-creative-commons-zero {\n    --fa: \"\\f4f3\"\n}\n\n.fa-hips {\n    --fa: \"\\f452\"\n}\n\n.fa-css {\n    --fa: \"\\e6a2\"\n}\n\n.fa-behance {\n    --fa: \"\\f1b4\"\n}\n\n.fa-reddit {\n    --fa: \"\\f1a1\"\n}\n\n.fa-discord {\n    --fa: \"\\f392\"\n}\n\n.fa-chrome {\n    --fa: \"\\f268\"\n}\n\n.fa-app-store-ios {\n    --fa: \"\\f370\"\n}\n\n.fa-cc-discover {\n    --fa: \"\\f1f2\"\n}\n\n.fa-wpbeginner {\n    --fa: \"\\f297\"\n}\n\n.fa-confluence {\n    --fa: \"\\f78d\"\n}\n\n.fa-shoelace {\n    --fa: \"\\e60c\"\n}\n\n.fa-mdb {\n    --fa: \"\\f8ca\"\n}\n\n.fa-dochub {\n    --fa: \"\\f394\"\n}\n\n.fa-accessible-icon {\n    --fa: \"\\f368\"\n}\n\n.fa-ebay {\n    --fa: \"\\f4f4\"\n}\n\n.fa-amazon {\n    --fa: \"\\f270\"\n}\n\n.fa-unsplash {\n    --fa: \"\\e07c\"\n}\n\n.fa-yarn {\n    --fa: \"\\f7e3\"\n}\n\n.fa-square-steam,\n.fa-steam-square {\n    --fa: \"\\f1b7\"\n}\n\n.fa-500px {\n    --fa: \"\\f26e\"\n}\n\n.fa-square-vimeo,\n.fa-vimeo-square {\n    --fa: \"\\f194\"\n}\n\n.fa-asymmetrik {\n    --fa: \"\\f372\"\n}\n\n.fa-font-awesome,\n.fa-font-awesome-flag,\n.fa-font-awesome-logo-full {\n    --fa: \"\\f2b4\"\n}\n\n.fa-gratipay {\n    --fa: \"\\f184\"\n}\n\n.fa-apple {\n    --fa: \"\\f179\"\n}\n\n.fa-hive {\n    --fa: \"\\e07f\"\n}\n\n.fa-gitkraken {\n    --fa: \"\\f3a6\"\n}\n\n.fa-keybase {\n    --fa: \"\\f4f5\"\n}\n\n.fa-apple-pay {\n    --fa: \"\\f415\"\n}\n\n.fa-padlet {\n    --fa: \"\\e4a0\"\n}\n\n.fa-amazon-pay {\n    --fa: \"\\f42c\"\n}\n\n.fa-github-square,\n.fa-square-github {\n    --fa: \"\\f092\"\n}\n\n.fa-stumbleupon {\n    --fa: \"\\f1a4\"\n}\n\n.fa-fedex {\n    --fa: \"\\f797\"\n}\n\n.fa-phoenix-framework {\n    --fa: \"\\f3dc\"\n}\n\n.fa-shopify {\n    --fa: \"\\e057\"\n}\n\n.fa-neos {\n    --fa: \"\\f612\"\n}\n\n.fa-square-threads {\n    --fa: \"\\e619\"\n}\n\n.fa-hackerrank {\n    --fa: \"\\f5f7\"\n}\n\n.fa-researchgate {\n    --fa: \"\\f4f8\"\n}\n\n.fa-swift {\n    --fa: \"\\f8e1\"\n}\n\n.fa-angular {\n    --fa: \"\\f420\"\n}\n\n.fa-speakap {\n    --fa: \"\\f3f3\"\n}\n\n.fa-angrycreative {\n    --fa: \"\\f36e\"\n}\n\n.fa-y-combinator {\n    --fa: \"\\f23b\"\n}\n\n.fa-empire {\n    --fa: \"\\f1d1\"\n}\n\n.fa-envira {\n    --fa: \"\\f299\"\n}\n\n.fa-google-scholar {\n    --fa: \"\\e63b\"\n}\n\n.fa-gitlab-square,\n.fa-square-gitlab {\n    --fa: \"\\e5ae\"\n}\n\n.fa-studiovinari {\n    --fa: \"\\f3f8\"\n}\n\n.fa-pied-piper {\n    --fa: \"\\f2ae\"\n}\n\n.fa-wordpress {\n    --fa: \"\\f19a\"\n}\n\n.fa-product-hunt {\n    --fa: \"\\f288\"\n}\n\n.fa-firefox {\n    --fa: \"\\f269\"\n}\n\n.fa-linode {\n    --fa: \"\\f2b8\"\n}\n\n.fa-goodreads {\n    --fa: \"\\f3a8\"\n}\n\n.fa-odnoklassniki-square,\n.fa-square-odnoklassniki {\n    --fa: \"\\f264\"\n}\n\n.fa-jsfiddle {\n    --fa: \"\\f1cc\"\n}\n\n.fa-sith {\n    --fa: \"\\f512\"\n}\n\n.fa-themeisle {\n    --fa: \"\\f2b2\"\n}\n\n.fa-page4 {\n    --fa: \"\\f3d7\"\n}\n\n.fa-hashnode {\n    --fa: \"\\e499\"\n}\n\n.fa-react {\n    --fa: \"\\f41b\"\n}\n\n.fa-cc-paypal {\n    --fa: \"\\f1f4\"\n}\n\n.fa-squarespace {\n    --fa: \"\\f5be\"\n}\n\n.fa-cc-stripe {\n    --fa: \"\\f1f5\"\n}\n\n.fa-creative-commons-share {\n    --fa: \"\\f4f2\"\n}\n\n.fa-bitcoin {\n    --fa: \"\\f379\"\n}\n\n.fa-keycdn {\n    --fa: \"\\f3ba\"\n}\n\n.fa-opera {\n    --fa: \"\\f26a\"\n}\n\n.fa-itch-io {\n    --fa: \"\\f83a\"\n}\n\n.fa-umbraco {\n    --fa: \"\\f8e8\"\n}\n\n.fa-galactic-senate {\n    --fa: \"\\f50d\"\n}\n\n.fa-ubuntu {\n    --fa: \"\\f7df\"\n}\n\n.fa-draft2digital {\n    --fa: \"\\f396\"\n}\n\n.fa-stripe {\n    --fa: \"\\f429\"\n}\n\n.fa-houzz {\n    --fa: \"\\f27c\"\n}\n\n.fa-gg {\n    --fa: \"\\f260\"\n}\n\n.fa-dhl {\n    --fa: \"\\f790\"\n}\n\n.fa-pinterest-square,\n.fa-square-pinterest {\n    --fa: \"\\f0d3\"\n}\n\n.fa-xing {\n    --fa: \"\\f168\"\n}\n\n.fa-blackberry {\n    --fa: \"\\f37b\"\n}\n\n.fa-creative-commons-pd {\n    --fa: \"\\f4ec\"\n}\n\n.fa-playstation {\n    --fa: \"\\f3df\"\n}\n\n.fa-quinscape {\n    --fa: \"\\f459\"\n}\n\n.fa-less {\n    --fa: \"\\f41d\"\n}\n\n.fa-blogger-b {\n    --fa: \"\\f37d\"\n}\n\n.fa-opencart {\n    --fa: \"\\f23d\"\n}\n\n.fa-vine {\n    --fa: \"\\f1ca\"\n}\n\n.fa-signal-messenger {\n    --fa: \"\\e663\"\n}\n\n.fa-paypal {\n    --fa: \"\\f1ed\"\n}\n\n.fa-gitlab {\n    --fa: \"\\f296\"\n}\n\n.fa-typo3 {\n    --fa: \"\\f42b\"\n}\n\n.fa-reddit-alien {\n    --fa: \"\\f281\"\n}\n\n.fa-yahoo {\n    --fa: \"\\f19e\"\n}\n\n.fa-dailymotion {\n    --fa: \"\\e052\"\n}\n\n.fa-affiliatetheme {\n    --fa: \"\\f36b\"\n}\n\n.fa-pied-piper-pp {\n    --fa: \"\\f1a7\"\n}\n\n.fa-bootstrap {\n    --fa: \"\\f836\"\n}\n\n.fa-odnoklassniki {\n    --fa: \"\\f263\"\n}\n\n.fa-nfc-symbol {\n    --fa: \"\\e531\"\n}\n\n.fa-mintbit {\n    --fa: \"\\e62f\"\n}\n\n.fa-ethereum {\n    --fa: \"\\f42e\"\n}\n\n.fa-speaker-deck {\n    --fa: \"\\f83c\"\n}\n\n.fa-creative-commons-nc-eu {\n    --fa: \"\\f4e9\"\n}\n\n.fa-patreon {\n    --fa: \"\\f3d9\"\n}\n\n.fa-avianex {\n    --fa: \"\\f374\"\n}\n\n.fa-ello {\n    --fa: \"\\f5f1\"\n}\n\n.fa-gofore {\n    --fa: \"\\f3a7\"\n}\n\n.fa-bimobject {\n    --fa: \"\\f378\"\n}\n\n.fa-brave-reverse {\n    --fa: \"\\e63d\"\n}\n\n.fa-facebook-f {\n    --fa: \"\\f39e\"\n}\n\n.fa-google-plus-square,\n.fa-square-google-plus {\n    --fa: \"\\f0d4\"\n}\n\n.fa-web-awesome {\n    --fa: \"\\e682\"\n}\n\n.fa-mandalorian {\n    --fa: \"\\f50f\"\n}\n\n.fa-first-order-alt {\n    --fa: \"\\f50a\"\n}\n\n.fa-osi {\n    --fa: \"\\f41a\"\n}\n\n.fa-google-wallet {\n    --fa: \"\\f1ee\"\n}\n\n.fa-d-and-d-beyond {\n    --fa: \"\\f6ca\"\n}\n\n.fa-periscope {\n    --fa: \"\\f3da\"\n}\n\n.fa-fulcrum {\n    --fa: \"\\f50b\"\n}\n\n.fa-cloudscale {\n    --fa: \"\\f383\"\n}\n\n.fa-forumbee {\n    --fa: \"\\f211\"\n}\n\n.fa-mizuni {\n    --fa: \"\\f3cc\"\n}\n\n.fa-schlix {\n    --fa: \"\\f3ea\"\n}\n\n.fa-square-xing,\n.fa-xing-square {\n    --fa: \"\\f169\"\n}\n\n.fa-bandcamp {\n    --fa: \"\\f2d5\"\n}\n\n.fa-wpforms {\n    --fa: \"\\f298\"\n}\n\n.fa-cloudversify {\n    --fa: \"\\f385\"\n}\n\n.fa-usps {\n    --fa: \"\\f7e1\"\n}\n\n.fa-megaport {\n    --fa: \"\\f5a3\"\n}\n\n.fa-magento {\n    --fa: \"\\f3c4\"\n}\n\n.fa-spotify {\n    --fa: \"\\f1bc\"\n}\n\n.fa-optin-monster {\n    --fa: \"\\f23c\"\n}\n\n.fa-fly {\n    --fa: \"\\f417\"\n}\n\n.fa-square-bluesky {\n    --fa: \"\\e6a3\"\n}\n\n.fa-aviato {\n    --fa: \"\\f421\"\n}\n\n.fa-itunes {\n    --fa: \"\\f3b4\"\n}\n\n.fa-cuttlefish {\n    --fa: \"\\f38c\"\n}\n\n.fa-blogger {\n    --fa: \"\\f37c\"\n}\n\n.fa-flickr {\n    --fa: \"\\f16e\"\n}\n\n.fa-viber {\n    --fa: \"\\f409\"\n}\n\n.fa-soundcloud {\n    --fa: \"\\f1be\"\n}\n\n.fa-digg {\n    --fa: \"\\f1a6\"\n}\n\n.fa-tencent-weibo {\n    --fa: \"\\f1d5\"\n}\n\n.fa-letterboxd {\n    --fa: \"\\e62d\"\n}\n\n.fa-symfony {\n    --fa: \"\\f83d\"\n}\n\n.fa-maxcdn {\n    --fa: \"\\f136\"\n}\n\n.fa-etsy {\n    --fa: \"\\f2d7\"\n}\n\n.fa-facebook-messenger {\n    --fa: \"\\f39f\"\n}\n\n.fa-audible {\n    --fa: \"\\f373\"\n}\n\n.fa-think-peaks {\n    --fa: \"\\f731\"\n}\n\n.fa-bilibili {\n    --fa: \"\\e3d9\"\n}\n\n.fa-erlang {\n    --fa: \"\\f39d\"\n}\n\n.fa-x-twitter {\n    --fa: \"\\e61b\"\n}\n\n.fa-cotton-bureau {\n    --fa: \"\\f89e\"\n}\n\n.fa-dashcube {\n    --fa: \"\\f210\"\n}\n\n.fa-42-group,\n.fa-innosoft {\n    --fa: \"\\e080\"\n}\n\n.fa-stack-exchange {\n    --fa: \"\\f18d\"\n}\n\n.fa-elementor {\n    --fa: \"\\f430\"\n}\n\n.fa-pied-piper-square,\n.fa-square-pied-piper {\n    --fa: \"\\e01e\"\n}\n\n.fa-creative-commons-nd {\n    --fa: \"\\f4eb\"\n}\n\n.fa-palfed {\n    --fa: \"\\f3d8\"\n}\n\n.fa-superpowers {\n    --fa: \"\\f2dd\"\n}\n\n.fa-resolving {\n    --fa: \"\\f3e7\"\n}\n\n.fa-xbox {\n    --fa: \"\\f412\"\n}\n\n.fa-square-web-awesome-stroke {\n    --fa: \"\\e684\"\n}\n\n.fa-searchengin {\n    --fa: \"\\f3eb\"\n}\n\n.fa-tiktok {\n    --fa: \"\\e07b\"\n}\n\n.fa-facebook-square,\n.fa-square-facebook {\n    --fa: \"\\f082\"\n}\n\n.fa-renren {\n    --fa: \"\\f18b\"\n}\n\n.fa-linux {\n    --fa: \"\\f17c\"\n}\n\n.fa-glide {\n    --fa: \"\\f2a5\"\n}\n\n.fa-linkedin {\n    --fa: \"\\f08c\"\n}\n\n.fa-hubspot {\n    --fa: \"\\f3b2\"\n}\n\n.fa-deploydog {\n    --fa: \"\\f38e\"\n}\n\n.fa-twitch {\n    --fa: \"\\f1e8\"\n}\n\n.fa-flutter {\n    --fa: \"\\e694\"\n}\n\n.fa-ravelry {\n    --fa: \"\\f2d9\"\n}\n\n.fa-mixer {\n    --fa: \"\\e056\"\n}\n\n.fa-lastfm-square,\n.fa-square-lastfm {\n    --fa: \"\\f203\"\n}\n\n.fa-vimeo {\n    --fa: \"\\f40a\"\n}\n\n.fa-mendeley {\n    --fa: \"\\f7b3\"\n}\n\n.fa-uniregistry {\n    --fa: \"\\f404\"\n}\n\n.fa-figma {\n    --fa: \"\\f799\"\n}\n\n.fa-creative-commons-remix {\n    --fa: \"\\f4ee\"\n}\n\n.fa-cc-amazon-pay {\n    --fa: \"\\f42d\"\n}\n\n.fa-dropbox {\n    --fa: \"\\f16b\"\n}\n\n.fa-instagram {\n    --fa: \"\\f16d\"\n}\n\n.fa-cmplid {\n    --fa: \"\\e360\"\n}\n\n.fa-upwork {\n    --fa: \"\\e641\"\n}\n\n.fa-facebook {\n    --fa: \"\\f09a\"\n}\n\n.fa-gripfire {\n    --fa: \"\\f3ac\"\n}\n\n.fa-jedi-order {\n    --fa: \"\\f50e\"\n}\n\n.fa-uikit {\n    --fa: \"\\f403\"\n}\n\n.fa-fort-awesome-alt {\n    --fa: \"\\f3a3\"\n}\n\n.fa-phabricator {\n    --fa: \"\\f3db\"\n}\n\n.fa-ussunnah {\n    --fa: \"\\f407\"\n}\n\n.fa-earlybirds {\n    --fa: \"\\f39a\"\n}\n\n.fa-trade-federation {\n    --fa: \"\\f513\"\n}\n\n.fa-autoprefixer {\n    --fa: \"\\f41c\"\n}\n\n.fa-whatsapp {\n    --fa: \"\\f232\"\n}\n\n.fa-square-upwork {\n    --fa: \"\\e67c\"\n}\n\n.fa-slideshare {\n    --fa: \"\\f1e7\"\n}\n\n.fa-google-play {\n    --fa: \"\\f3ab\"\n}\n\n.fa-viadeo {\n    --fa: \"\\f2a9\"\n}\n\n.fa-line {\n    --fa: \"\\f3c0\"\n}\n\n.fa-google-drive {\n    --fa: \"\\f3aa\"\n}\n\n.fa-servicestack {\n    --fa: \"\\f3ec\"\n}\n\n.fa-simplybuilt {\n    --fa: \"\\f215\"\n}\n\n.fa-bitbucket {\n    --fa: \"\\f171\"\n}\n\n.fa-imdb {\n    --fa: \"\\f2d8\"\n}\n\n.fa-deezer {\n    --fa: \"\\e077\"\n}\n\n.fa-raspberry-pi {\n    --fa: \"\\f7bb\"\n}\n\n.fa-jira {\n    --fa: \"\\f7b1\"\n}\n\n.fa-docker {\n    --fa: \"\\f395\"\n}\n\n.fa-screenpal {\n    --fa: \"\\e570\"\n}\n\n.fa-bluetooth {\n    --fa: \"\\f293\"\n}\n\n.fa-gitter {\n    --fa: \"\\f426\"\n}\n\n.fa-d-and-d {\n    --fa: \"\\f38d\"\n}\n\n.fa-microblog {\n    --fa: \"\\e01a\"\n}\n\n.fa-cc-diners-club {\n    --fa: \"\\f24c\"\n}\n\n.fa-gg-circle {\n    --fa: \"\\f261\"\n}\n\n.fa-pied-piper-hat {\n    --fa: \"\\f4e5\"\n}\n\n.fa-kickstarter-k {\n    --fa: \"\\f3bc\"\n}\n\n.fa-yandex {\n    --fa: \"\\f413\"\n}\n\n.fa-readme {\n    --fa: \"\\f4d5\"\n}\n\n.fa-html5 {\n    --fa: \"\\f13b\"\n}\n\n.fa-sellsy {\n    --fa: \"\\f213\"\n}\n\n.fa-square-web-awesome {\n    --fa: \"\\e683\"\n}\n\n.fa-sass {\n    --fa: \"\\f41e\"\n}\n\n.fa-wirsindhandwerk,\n.fa-wsh {\n    --fa: \"\\e2d0\"\n}\n\n.fa-buromobelexperte {\n    --fa: \"\\f37f\"\n}\n\n.fa-salesforce {\n    --fa: \"\\f83b\"\n}\n\n.fa-octopus-deploy {\n    --fa: \"\\e082\"\n}\n\n.fa-medapps {\n    --fa: \"\\f3c6\"\n}\n\n.fa-ns8 {\n    --fa: \"\\f3d5\"\n}\n\n.fa-pinterest-p {\n    --fa: \"\\f231\"\n}\n\n.fa-apper {\n    --fa: \"\\f371\"\n}\n\n.fa-fort-awesome {\n    --fa: \"\\f286\"\n}\n\n.fa-waze {\n    --fa: \"\\f83f\"\n}\n\n.fa-bluesky {\n    --fa: \"\\e671\"\n}\n\n.fa-cc-jcb {\n    --fa: \"\\f24b\"\n}\n\n.fa-snapchat,\n.fa-snapchat-ghost {\n    --fa: \"\\f2ab\"\n}\n\n.fa-fantasy-flight-games {\n    --fa: \"\\f6dc\"\n}\n\n.fa-rust {\n    --fa: \"\\e07a\"\n}\n\n.fa-wix {\n    --fa: \"\\f5cf\"\n}\n\n.fa-behance-square,\n.fa-square-behance {\n    --fa: \"\\f1b5\"\n}\n\n.fa-supple {\n    --fa: \"\\f3f9\"\n}\n\n.fa-webflow {\n    --fa: \"\\e65c\"\n}\n\n.fa-rebel {\n    --fa: \"\\f1d0\"\n}\n\n.fa-css3 {\n    --fa: \"\\f13c\"\n}\n\n.fa-staylinked {\n    --fa: \"\\f3f5\"\n}\n\n.fa-kaggle {\n    --fa: \"\\f5fa\"\n}\n\n.fa-space-awesome {\n    --fa: \"\\e5ac\"\n}\n\n.fa-deviantart {\n    --fa: \"\\f1bd\"\n}\n\n.fa-cpanel {\n    --fa: \"\\f388\"\n}\n\n.fa-goodreads-g {\n    --fa: \"\\f3a9\"\n}\n\n.fa-git-square,\n.fa-square-git {\n    --fa: \"\\f1d2\"\n}\n\n.fa-square-tumblr,\n.fa-tumblr-square {\n    --fa: \"\\f174\"\n}\n\n.fa-trello {\n    --fa: \"\\f181\"\n}\n\n.fa-creative-commons-nc-jp {\n    --fa: \"\\f4ea\"\n}\n\n.fa-get-pocket {\n    --fa: \"\\f265\"\n}\n\n.fa-perbyte {\n    --fa: \"\\e083\"\n}\n\n.fa-grunt {\n    --fa: \"\\f3ad\"\n}\n\n.fa-weebly {\n    --fa: \"\\f5cc\"\n}\n\n.fa-connectdevelop {\n    --fa: \"\\f20e\"\n}\n\n.fa-leanpub {\n    --fa: \"\\f212\"\n}\n\n.fa-black-tie {\n    --fa: \"\\f27e\"\n}\n\n.fa-themeco {\n    --fa: \"\\f5c6\"\n}\n\n.fa-python {\n    --fa: \"\\f3e2\"\n}\n\n.fa-android {\n    --fa: \"\\f17b\"\n}\n\n.fa-bots {\n    --fa: \"\\e340\"\n}\n\n.fa-free-code-camp {\n    --fa: \"\\f2c5\"\n}\n\n.fa-hornbill {\n    --fa: \"\\f592\"\n}\n\n.fa-js {\n    --fa: \"\\f3b8\"\n}\n\n.fa-ideal {\n    --fa: \"\\e013\"\n}\n\n.fa-git {\n    --fa: \"\\f1d3\"\n}\n\n.fa-dev {\n    --fa: \"\\f6cc\"\n}\n\n.fa-sketch {\n    --fa: \"\\f7c6\"\n}\n\n.fa-yandex-international {\n    --fa: \"\\f414\"\n}\n\n.fa-cc-amex {\n    --fa: \"\\f1f3\"\n}\n\n.fa-uber {\n    --fa: \"\\f402\"\n}\n\n.fa-github {\n    --fa: \"\\f09b\"\n}\n\n.fa-php {\n    --fa: \"\\f457\"\n}\n\n.fa-alipay {\n    --fa: \"\\f642\"\n}\n\n.fa-youtube {\n    --fa: \"\\f167\"\n}\n\n.fa-skyatlas {\n    --fa: \"\\f216\"\n}\n\n.fa-firefox-browser {\n    --fa: \"\\e007\"\n}\n\n.fa-replyd {\n    --fa: \"\\f3e6\"\n}\n\n.fa-suse {\n    --fa: \"\\f7d6\"\n}\n\n.fa-jenkins {\n    --fa: \"\\f3b6\"\n}\n\n.fa-twitter {\n    --fa: \"\\f099\"\n}\n\n.fa-rockrms {\n    --fa: \"\\f3e9\"\n}\n\n.fa-pinterest {\n    --fa: \"\\f0d2\"\n}\n\n.fa-buffer {\n    --fa: \"\\f837\"\n}\n\n.fa-npm {\n    --fa: \"\\f3d4\"\n}\n\n.fa-yammer {\n    --fa: \"\\f840\"\n}\n\n.fa-btc {\n    --fa: \"\\f15a\"\n}\n\n.fa-dribbble {\n    --fa: \"\\f17d\"\n}\n\n.fa-stumbleupon-circle {\n    --fa: \"\\f1a3\"\n}\n\n.fa-internet-explorer {\n    --fa: \"\\f26b\"\n}\n\n.fa-stubber {\n    --fa: \"\\e5c7\"\n}\n\n.fa-telegram,\n.fa-telegram-plane {\n    --fa: \"\\f2c6\"\n}\n\n.fa-old-republic {\n    --fa: \"\\f510\"\n}\n\n.fa-odysee {\n    --fa: \"\\e5c6\"\n}\n\n.fa-square-whatsapp,\n.fa-whatsapp-square {\n    --fa: \"\\f40c\"\n}\n\n.fa-node-js {\n    --fa: \"\\f3d3\"\n}\n\n.fa-edge-legacy {\n    --fa: \"\\e078\"\n}\n\n.fa-slack,\n.fa-slack-hash {\n    --fa: \"\\f198\"\n}\n\n.fa-medrt {\n    --fa: \"\\f3c8\"\n}\n\n.fa-usb {\n    --fa: \"\\f287\"\n}\n\n.fa-tumblr {\n    --fa: \"\\f173\"\n}\n\n.fa-vaadin {\n    --fa: \"\\f408\"\n}\n\n.fa-quora {\n    --fa: \"\\f2c4\"\n}\n\n.fa-square-x-twitter {\n    --fa: \"\\e61a\"\n}\n\n.fa-reacteurope {\n    --fa: \"\\f75d\"\n}\n\n.fa-medium,\n.fa-medium-m {\n    --fa: \"\\f23a\"\n}\n\n.fa-amilia {\n    --fa: \"\\f36d\"\n}\n\n.fa-mixcloud {\n    --fa: \"\\f289\"\n}\n\n.fa-flipboard {\n    --fa: \"\\f44d\"\n}\n\n.fa-viacoin {\n    --fa: \"\\f237\"\n}\n\n.fa-critical-role {\n    --fa: \"\\f6c9\"\n}\n\n.fa-sitrox {\n    --fa: \"\\e44a\"\n}\n\n.fa-discourse {\n    --fa: \"\\f393\"\n}\n\n.fa-joomla {\n    --fa: \"\\f1aa\"\n}\n\n.fa-mastodon {\n    --fa: \"\\f4f6\"\n}\n\n.fa-airbnb {\n    --fa: \"\\f834\"\n}\n\n.fa-wolf-pack-battalion {\n    --fa: \"\\f514\"\n}\n\n.fa-buy-n-large {\n    --fa: \"\\f8a6\"\n}\n\n.fa-gulp {\n    --fa: \"\\f3ae\"\n}\n\n.fa-creative-commons-sampling-plus {\n    --fa: \"\\f4f1\"\n}\n\n.fa-strava {\n    --fa: \"\\f428\"\n}\n\n.fa-ember {\n    --fa: \"\\f423\"\n}\n\n.fa-canadian-maple-leaf {\n    --fa: \"\\f785\"\n}\n\n.fa-teamspeak {\n    --fa: \"\\f4f9\"\n}\n\n.fa-pushed {\n    --fa: \"\\f3e1\"\n}\n\n.fa-wordpress-simple {\n    --fa: \"\\f411\"\n}\n\n.fa-nutritionix {\n    --fa: \"\\f3d6\"\n}\n\n.fa-wodu {\n    --fa: \"\\e088\"\n}\n\n.fa-google-pay {\n    --fa: \"\\e079\"\n}\n\n.fa-intercom {\n    --fa: \"\\f7af\"\n}\n\n.fa-zhihu {\n    --fa: \"\\f63f\"\n}\n\n.fa-korvue {\n    --fa: \"\\f42f\"\n}\n\n.fa-pix {\n    --fa: \"\\e43a\"\n}\n\n.fa-steam-symbol {\n    --fa: \"\\f3f6\"\n}\n\n:host,\n:root {\n    --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\"\n}\n\n@font-face {\n    font-family: \"Font Awesome 6 Free\";\n    font-style: normal;\n    font-weight: 400;\n    font-display: block;\n    src: url(../webfonts/fa-regular-400.woff2) format(\"woff2\"), url(../webfonts/fa-regular-400.ttf) format(\"truetype\")\n}\n\n.fa-regular,\n.far {\n    font-weight: 400\n}\n\n:host,\n:root {\n    --fa-style-family-classic: \"Font Awesome 6 Free\";\n    --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\"\n}\n\n@font-face {\n    font-family: \"Font Awesome 6 Free\";\n    font-style: normal;\n    font-weight: 900;\n    font-display: block;\n    src: url(../webfonts/fa-solid-900.woff2) format(\"woff2\"), url(../webfonts/fa-solid-900.ttf) format(\"truetype\")\n}\n\n.fa-solid,\n.fas {\n    font-weight: 900\n}\n\n@font-face {\n    font-family: \"Font Awesome 5 Brands\";\n    font-display: block;\n    font-weight: 400;\n    src: url(../webfonts/fa-brands-400.woff2) format(\"woff2\"), url(../webfonts/fa-brands-400.ttf) format(\"truetype\")\n}\n\n@font-face {\n    font-family: \"Font Awesome 5 Free\";\n    font-display: block;\n    font-weight: 900;\n    src: url(../webfonts/fa-solid-900.woff2) format(\"woff2\"), url(../webfonts/fa-solid-900.ttf) format(\"truetype\")\n}\n\n@font-face {\n    font-family: \"Font Awesome 5 Free\";\n    font-display: block;\n    font-weight: 400;\n    src: url(../webfonts/fa-regular-400.woff2) format(\"woff2\"), url(../webfonts/fa-regular-400.ttf) format(\"truetype\")\n}\n\n@font-face {\n    font-family: \"FontAwesome\";\n    font-display: block;\n    src: url(../webfonts/fa-solid-900.woff2) format(\"woff2\"), url(../webfonts/fa-solid-900.ttf) format(\"truetype\")\n}\n\n@font-face {\n    font-family: \"FontAwesome\";\n    font-display: block;\n    src: url(../webfonts/fa-brands-400.woff2) format(\"woff2\"), url(../webfonts/fa-brands-400.ttf) format(\"truetype\")\n}\n\n@font-face {\n    font-family: \"FontAwesome\";\n    font-display: block;\n    src: url(../webfonts/fa-regular-400.woff2) format(\"woff2\"), url(../webfonts/fa-regular-400.ttf) format(\"truetype\");\n    unicode-range: u+f003, u+f006, u+f014, u+f016-f017, u+f01a-f01b, u+f01d, u+f022, u+f03e, u+f044, u+f046, u+f05c-f05d, u+f06e, u+f070, u+f087-f088, u+f08a, u+f094, u+f096-f097, u+f09d, u+f0a0, u+f0a2, u+f0a4-f0a7, u+f0c5, u+f0c7, u+f0e5-f0e6, u+f0eb, u+f0f6-f0f8, u+f10c, u+f114-f115, u+f118-f11a, u+f11c-f11d, u+f133, u+f147, u+f14e, u+f150-f152, u+f185-f186, u+f18e, u+f190-f192, u+f196, u+f1c1-f1c9, u+f1d9, u+f1db, u+f1e3, u+f1ea, u+f1f7, u+f1f9, u+f20a, u+f247-f248, u+f24a, u+f24d, u+f255-f25b, u+f25d, u+f271-f274, u+f278, u+f27b, u+f28c, u+f28e, u+f29c, u+f2b5, u+f2b7, u+f2ba, u+f2bc, u+f2be, u+f2c0-f2c1, u+f2c3, u+f2d0, u+f2d2, u+f2d4, u+f2dc\n}\n\n@font-face {\n    font-family: \"FontAwesome\";\n    font-display: block;\n    src: url(../webfonts/fa-v4compatibility.woff2) format(\"woff2\"), url(../webfonts/fa-v4compatibility.ttf) format(\"truetype\");\n    unicode-range: u+f041, u+f047, u+f065-f066, u+f07d-f07e, u+f080, u+f08b, u+f08e, u+f090, u+f09a, u+f0ac, u+f0ae, u+f0b2, u+f0d0, u+f0d6, u+f0e4, u+f0ec, u+f10a-f10b, u+f123, u+f13e, u+f148-f149, u+f14c, u+f156, u+f15e, u+f160-f161, u+f163, u+f175-f178, u+f195, u+f1f8, u+f219, u+f27a\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
